webpackJsonp([1],{

/***/ "++SX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artefacts_vue__ = __webpack_require__("5ze5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90e6fc0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artefacts_vue__ = __webpack_require__("eXT4");
function injectStyle (ssrContext) {
  __webpack_require__("kVU0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90e6fc0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artefacts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90e6fc0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artefacts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+HfS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6-min[cropped].4da9068.jpg";

/***/ }),

/***/ "+RHE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/google.d7701b9.png";

/***/ }),

/***/ "+aa+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8-min[cropped].aed3106.jpg";

/***/ }),

/***/ "/H3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showFailAlreadyRequested: false,
      showFailRoleAlready: false,
      timeout: 6000,
      colorS: "info",
      colorF: "red",
      mode: true,
      showSucces: false,
      showFail: false,
      dialog: false,
      password: "",
      email: "",
      name: "",
      upgradeDialog: false,
      e1: true,
      fling: false,
      hover: false,
      tabs: null,
      // Timisoara:'Timisoara',
      //       testIssues : [
      // {
      //     img: "http://www.telegrafonline.ro/imagini/mari/61705369-1465412591.jpg", title: 'Groapa Strada Tapia', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      // {
      //     img: "http://stiri.botosani.ro/media/images/articles/big/bancile-din-botosani-distractie-pentru-vandali-OK7nDf.jpg", title: 'Banca rupta in Parcul Rozelor', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      // {
      //     img: "http://www.reporterntv.ro/imagini/2015/09/09/big/imagini-de-cosmar-intr-o-scoala-din-constanta-copii-asteptati-in-clasa-i-cu-banci-si-scaune-rupte-128426.jpg", title: 'Conditii primitive la Politehnica', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      // {
      //     img: "http://www.reporterntv.ro/imagini/2015/09/09/big/imagini-de-cosmar-intr-o-scoala-din-constanta-copii-asteptati-in-clasa-i-cu-banci-si-scaune-rupte-128426.jpg", title: 'Conditii primitive la Politehnica', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      // {
      //     img: "http://stiri.botosani.ro/media/images/articles/big/bancile-din-botosani-distractie-pentru-vandali-OK7nDf.jpg", title: 'Banca rupta in Parcul Rozelor', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      // {
      //     img: "http://www.telegrafonline.ro/imagini/mari/61705369-1465412591.jpg", title: 'Groapa Strada Tapia', description:"BĂTAIE DE JOC PE DN1 C – Zeci de șoferi și-au distrus cauciucurile într-o groapă apărută la podul de la Lăpușel (GALERIE FOTO) groapa in sosea (5). groapa in sosea (5). Crap Art. Stiri recente. MAE VERIFICĂ SITUAȚIA – Trei români aflați pe insula Saint Martin au dispărut în urma uraganului Irma."
      // },
      //    ],
      items: ["Added Artefacts", "My Issues"]
      // text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      // days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
      // months:[ "Jan", "Feb", "Mar", "Apr",
      // 	    "May", "Jun", "July", "Aug",
      //     "Sep", "Oct", "Nov", "Dec"]
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.getUser;
    },
    artefacts: function artefacts() {
      return this.$store.getters.loadFavoriteArtefacts(this.user._id);
    },
    collections: function collections() {
      return this.$store.getters.loadFavoriteCollections(this.user._id);
    },
    groups: function groups() {
      return this.$store.getters.loadFavoriteGroups(this.user._id);
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    artefactsAll: function artefactsAll() {
      return this.$store.getters.loadArtefacts;
    },
    collectionsAll: function collectionsAll() {
      return this.$store.getters.loadAllCollections;
    },
    artefactsAdded: function artefactsAdded() {
      return this.$store.getters.loadAddedArtefacts(this.user._id);
    }
  },
  methods: {
    sendMessage: function sendMessage() {
      var _this = this;

      if (this.select == this.user.role) {
        this.showFailRoleAlready = true;
        this.upgradeDialog = false;
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/requests", { user: this.user, role: this.select }).then(function (response) {
          _this.showSucces = true;
          _this.upgradeDialog = false;
        }).catch(function (err) {
          if (err.response.status == 409) {
            _this.showFailAlreadyRequested = true;
            _this.upgradeDialog = false;
          } else {
            _this.showFail = true;
            _this.upgradeDialog = false;
          }
        });
      }

      // var concatMessage =
      //   this.user.displayName +
      //   " requests rights for the role: \n" +
      //   this.select +
      //   " \n";
      // axios
      //   .post("/api/messages/email", {
      //     message: concatMessage,
      //     email: "hera.restore@gmail.com"
      //   })
      //   .then(response => {
      // this.showSucces = true;
      // this.upgradeDialog = false;
      //   })
      //   .catch(err => {
      // this.showFail = true;
      // this.upgradeDialog = false;
      //   });
    },
    provider: function provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";else if (user.hasOwnProperty("google")) return "Google";else if (user.hasOwnProperty("live")) return "Microsoft Live";else return "Local Register";
    },
    clickInputMain: function clickInputMain() {
      this.$refs.fileInput1.click();
    }
    //    createYears() {
    //         var currentYear = 2010;
    //         var startYear = 1950;
    //         var yearss = [];
    //         while ( startYear <= currentYear ) {
    //           yearss.push(startYear++);
    //         }
    //         return yearss;
    // },
    // changeLocation()
    // {
    //   this.$store.dispatch('updateUser',this.user);
    // }

  },
  mounted: function mounted() {
    document.title = "My Account";
    window.scrollTo(0, 0);
  },
  created: function created() {
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
  }
});

/***/ }),

/***/ "/I3z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      relatedArtefacts: [],
      allRelated: [],
      place: {
        formatted_address: "Add a location or drag marker."
      }
    };
  },

  props: ['groupTitle'],
  methods: {
    addRelatedArtefacts: function addRelatedArtefacts() {
      var i = 0;
      for (i in this.related) {
        this.relatedArtefacts.push(this.$store.getters.loadRelatedArtefacts(this.related[i].title));
      }
      var j = 0,
          k = 0,
          z = 0;
      for (k = 0; k <= i; k++) {
        for (j = 0; j < this.relatedArtefacts[k].length; j++) {
          this.allRelated.push(this.relatedArtefacts[k][j]);
        }
      }this.allRelated = this.allRelated.filter(function (allRelated, index, self) {
        return self.findIndex(function (t) {
          return t.title === allRelated.title || t.description === allRelated.description;
        }) === index;
      });
    }
  },
  update: function update() {
    this.$refs.map.resize();
  },

  computed: {
    related: function related() {
      return this.$store.getters.loadRelatedCollections(this.groupTitle);
    },
    center: function center() {
      return this.allRelated[0].location.geometry.location;
    }
  },
  created: function created() {
    this.addRelatedArtefacts();
  }
});

/***/ }),

/***/ "/sqp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("vaPR");
function injectStyle (ssrContext) {
  __webpack_require__("lk2w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "02s1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0IOo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-tabs',{attrs:{"fixed":"","icons":"","centered":""}},[_c('v-tabs-bar',{staticClass:"primary"},[_c('v-tabs-slider',{staticClass:"white"}),_vm._v(" "),_c('v-tabs-item',{staticClass:"tbList",staticStyle:{"color":"white"},attrs:{"lazy":true,"href":"#tab-3"}},[_c('v-icon',[_vm._v("bar_chart")]),_vm._v("Statistics\n        "),_c('br')],1),_vm._v(" "),_c('v-tabs-item',{staticClass:"tbList",staticStyle:{"color":"white"},attrs:{"href":"#tab-1"}},[_c('v-icon',[_vm._v("cloud")]),_vm._v("Transfers\n        "),_c('br')],1),_vm._v(" "),_c('v-tabs-item',{staticClass:"tbList",staticStyle:{"color":"white"},attrs:{"lazy":true,"href":"#tab-2"}},[_c('v-icon',[_vm._v("event")]),_vm._v("Content\n        "),_c('br')],1)],1),_vm._v(" "),_c('v-tabs-items',{},[_c('v-tabs-content',{attrs:{"id":"tab-3"}},[_c('div',{staticClass:"statsContainer"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"statsValue"},[_vm._v(_vm._s(_vm.users.length))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('span',{staticClass:"statsLabel"},[_vm._v("network members")]),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"statsValue"},[_vm._v(_vm._s(_vm.allArtefacts.reduce(function (acc,cur){return acc = acc+cur.uniqueVisits.length},0)))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('span',{staticClass:"statsLabel"},[_vm._v("Visits")]),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"statsValue"},[_vm._v(_vm._s(_vm.users.filter(function (user){ return user.role=="Contributor"; }).length))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('span',{staticClass:"statsLabel"},[_vm._v("Contributors")]),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"statsValue"},[_vm._v(_vm._s(_vm.allArtefacts.length))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('span',{staticClass:"statsLabel"},[_vm._v("Posts")]),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"statsValue"},[_vm._v(_vm._s(_vm.collections.length))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('span',{staticClass:"statsLabel"},[_vm._v("Collections")]),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"statsValue"},[_vm._v(_vm._s(_vm.groups.length))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('span',{staticClass:"statsLabel"},[_vm._v("Groups")]),_vm._v(" "),_c('br')])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"statsTitle"},[_vm._v("Top 10 favourited artefacts")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((10),function(i){return (_vm.favart.length>i)?_c('v-flex',{key:i,attrs:{"md6":"","sm12":""}},[_c('div',{staticClass:"miniCard",on:{"click":function($event){_vm.goTo(_vm.favart[i-1]._id,'artefacts')}}},[_vm._v(_vm._s(i)+".  "+_vm._s(_vm.favart[i-1].title[_vm.lang])+" "),_c('span',{staticClass:"favouriteState"},[_vm._v(_vm._s(_vm.favart[i-1].favorite.length)+" ")])])]):_vm._e()}),1),_vm._v(" "),_c('p',{staticClass:"statsTitle"},[_vm._v("Top 10 artefacts")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((10),function(i){return (_vm.artefacts.length>i)?_c('v-flex',{key:i,attrs:{"md6":"","sm12":""}},[_c('div',{staticClass:"miniCard",on:{"click":function($event){_vm.goTo(_vm.artefacts[i-1]._id,'artefacts')}}},[_vm._v(_vm._s(i)+".  "+_vm._s(_vm.artefacts[i-1].title[_vm.lang])+" "),_c('span',{staticClass:"favouriteState"},[_vm._v(_vm._s(_vm.artefacts[i-1].uniqueVisits.length)+" ")])])]):_vm._e()}),1),_vm._v(" "),_c('p',{staticClass:"statsTitle"},[_vm._v("Top 10 collections")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((10),function(i){return (_vm.collections.length>i)?_c('v-flex',{key:i,attrs:{"md6":"","sm12":""}},[_c('div',{staticClass:"miniCard",on:{"click":function($event){_vm.goTo(_vm.collections[i-1]._id,'collections')}}},[_vm._v(_vm._s(i)+".  "+_vm._s(_vm.collections[i-1].title[_vm.lang])+" "),_c('span',{staticClass:"favouriteState"},[_vm._v(_vm._s(_vm.collections[i-1].uniqueVisits.length)+" ")])])]):_vm._e()}),1),_vm._v(" "),_c('p',{staticClass:"statsTitle"},[_vm._v("top 10 groups")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((10),function(i){return (_vm.groups.length>i)?_c('v-flex',{key:i,attrs:{"md6":"","sm12":""}},[_c('div',{staticClass:"miniCard",on:{"click":function($event){_vm.goTo(_vm.groups[i-1]._id,'groups')}}},[_vm._v(_vm._s(i)+".  "+_vm._s(_vm.groups[i-1].title[_vm.lang])+" "),_c('span',{staticClass:"favouriteState"},[_vm._v(_vm._s(_vm.groups[i-1].uniqueVisits.length)+" ")])])]):_vm._e()}),1)],1)]),_vm._v(" "),_c('v-tabs-content',{staticClass:"white",attrs:{"id":"tab-1"}},[_c('v-layout',{staticStyle:{"border":"1px solid #efefef"},attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-btn',{staticClass:"ma-3 pa-2",attrs:{"href":"/api/restore/export","download":""}},[_vm._v("Export Database\n            "),_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-3 pa-2",class:{ 'green darken-3' : _vm.status },staticStyle:{"width":"300px"},attrs:{"color":"primary","loading":_vm.loading},on:{"click":function($event){_vm.clickInputMain()}}},[_vm._v("Import Database as Json\n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput1",staticClass:"input-file",staticStyle:{"display":"none"},attrs:{"type":"file","name":"exports","disabled":_vm.isSaving,"accept":"application/json"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, -1); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"ma-3 pa-2",attrs:{"href":"/api/restore/exportfiles","download":""},on:{"click":function($event){_vm.alertit()}}},[_vm._v("Export User Uploads\n            "),_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("file_download")])],1)],1)],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"tab-2"}},[_c('div',{staticClass:"masonry1",attrs:{"row":"","wrap":""}},_vm._l((_vm.gLang[_vm.lang]),function(element,i){return _c('div',{key:i,staticClass:"item1",attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{staticClass:"pa-3 ma-1 variableWidth",attrs:{"elevation-4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h3',[_vm._v(_vm._s(i.toUpperCase()))])]),_vm._v(" "),_vm._l((element),function(field,i){return _c('div',{key:i},[_c('v-text-field',{attrs:{"label":i},model:{value:(element[i]),callback:function ($$v) {_vm.$set(element, i, $$v)},expression:"element[i]"}})],1)})],2)],1)})),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{attrs:{"large":"","round":"","primary":""},on:{"click":function($event){_vm.saveLanguage(_vm.gLang)}}},[_vm._v("Save")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.colorS,"multi-line":_vm.mode,"vertical":!_vm.mode},model:{value:(_vm.snackbarS),callback:function ($$v) {_vm.snackbarS=$$v},expression:"snackbarS"}},[_vm._v("Language updated successfully!\n          "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarS = false}}},[_vm._v("Close")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.colorF,"multi-line":_vm.mode,"vertical":!_vm.mode},model:{value:(_vm.snackbarF),callback:function ($$v) {_vm.snackbarF=$$v},expression:"snackbarF"}},[_vm._v("Language update failed!\n          "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbarF = false}}},[_vm._v("Close")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0PtN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0hj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1+jb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__("vBWZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["a" /* default */] },
  data: function data() {
    return {
      slickOptions: {
        dots: true,
        // centerMode: true,
        infinite: true,
        arrows: true,
        speed: 1400,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        // {
        //   breakpoint: 1224,
        //   settings: {
        //     slidesToShow: 3,
        //     slidesToScroll: 3,
        //     arrows: false,
        //     infinite: true,
        //     dots: false
        //   }
        // },
        {
          breakpoint: 1380,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2

          }
        }, {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
            infinite: true,
            arrows: false
          }
        }, {
          breakpoint: 530,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            arrows: false
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        }]
      }
    };
  },

  methods: {
    next: function next() {
      this.$refs.slick.next();
    },
    prev: function prev() {
      this.$refs.slick.prev();
    },
    reInit: function reInit() {
      var _this = this;

      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(function () {
        _this.$refs.slick.reSlick();
      });
    }
  },
  mounted: function mounted() {
    // this.moveButton(this.isAdmin);
    this.reInit();
  },
  updated: function updated() {
    this.reInit();
  }
});

/***/ }),

/***/ "14vu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "15vm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogIn_vue__ = __webpack_require__("4P0K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3e1cc8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogIn_vue__ = __webpack_require__("6GfV");
function injectStyle (ssrContext) {
  __webpack_require__("qoNP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a3e1cc8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3e1cc8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1elO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["place", "center", "marker", "new"],
  data: function data() {
    return {
      statusText: null,
      opened: false
    };
  },

  methods: {
    updateChild: function updateChild(object, field, event) {
      if (field === "position") {
        object.position = {
          lat: event.lat(),
          lng: event.lng()
        };
        this.opened = true;
      }
    },
    setPlace: function setPlace(place) {
      this.$emit("newLocation", place);
      this.marker.ifw = place.formatted_address;
      this.usePlace(place);
      this.opened = true;
    },
    usePlace: function usePlace(place) {
      this.$emit("newLocation", place);
      this.$emit("newMarker", {
        position: {
          lat: parseFloat(place.geometry.location.lat()),
          lng: parseFloat(place.geometry.location.lng())
        }
      });
      this.center.lat = parseFloat(place.geometry.location.lat());
      this.center.lng = parseFloat(place.geometry.location.lng());
    },
    getLocation: function getLocation() {
      var scope = this;
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        location: {
          lat: parseFloat(this.marker.position.lat),
          lng: parseFloat(this.marker.position.lng)
        }
      }, function (results, status) {
        if (status === "OK") {
          if (results[0]) {
            scope.marker.ifw = results[0].formatted_address;
            scope.$emit("newLocation", results[0]);
            this.opened = true;
          } else {
            console.log("No results found");
          }
        }
      });
    }
  },
  update: function update() {
    this.$refs.map.resize();
  },

  computed: {
    ifw: function ifw() {
      return this.place.formatted_address;
    }
  },
  mounted: function mounted() {
    if (navigator.geolocation && this.new == true) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var pos = {
          lat: parseFloat(position.coords.latitude),
          lng: parseFloat(position.coords.longitude)
        };
        this.center.lat = parseFloat(pos.lat);
        this.center.lng = parseFloat(pos.lng);
        this.marker.position.lat = parseFloat(pos.lat);
        this.marker.position.lng = parseFloat(pos.lng);
        this.getLocation();
        this.new = false;
      }.bind(this));
    } else {}
  }
});

/***/ }),

/***/ "1foC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dialog_vue__ = __webpack_require__("Nf+A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49944e9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__ = __webpack_require__("s9Gz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49944e9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1ghq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1m/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"fixed":"","centered":""}},[_c('v-tabs-bar',{class:{ 'grey darken-3':!_vm.light, 'white':_vm.light },attrs:{"dark":""}},[_c('v-tabs-slider',{staticClass:"blue"}),_vm._v(" "),_c('v-tabs-item',{attrs:{"href":'#tab-' + 1}},[_c('span',{class:{ 'white--text':!_vm.light, 'black--text':_vm.light }},[_vm._v("Overview")])]),_vm._v(" "),_c('v-tabs-item',{attrs:{"href":'#tab-' + 2}},[_c('span',{class:{ 'white--text':!_vm.light, 'black--text':_vm.light }},[_vm._v(" Location")])])],1),_vm._v(" "),_c('v-tabs-items',{attrs:{"touchless":true,"cycle":false}},[_c('v-tabs-content',{attrs:{"id":'tab-' + 1,"lazy":true}},[_c('v-card',{staticStyle:{"background-color":"white"},attrs:{"flat":""}},[_c('v-card-text',{staticClass:"pr-0 pl-0"},[_vm._t("default")],2)],1)],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":'tab-' + 2,"lazy":true}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(!_vm.isCollection && !_vm.isGroup)?_c('div',[_c('web-location-present-single',{attrs:{"location":_vm.artefact.location}})],1):(_vm.isCollection && !_vm.isGroup)?_c('div',[_c('web-location-present-multiple',{attrs:{"groupTitle":_vm.artefact,"heightM":_vm.mapHeight}})],1):_c('div',[_c('web-location-present-multiple-groups',{attrs:{"groupTitle":_vm.artefact.title}})],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1vvD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[(_vm.lang == 'ro')?_c('div',{staticClass:"ro",attrs:{"elevation-2":""}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"logoParallax"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"western"},[_vm._v(" ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',{staticClass:"western"},[_vm._v(" ")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',{staticClass:"western"},[_vm._v(" ")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_c('p',{attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_c('p',{attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(34),_vm._v(" "),_c('div',{staticClass:"parallax"}),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(35),_vm._v(" "),_vm._m(36),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_vm._m(40),_vm._v(" "),_vm._m(41),_vm._v(" "),_vm._m(42),_vm._v(" "),_vm._m(43),_vm._v(" "),_vm._m(44),_vm._v(" "),_vm._m(45),_vm._v(" "),_vm._m(46),_vm._v(" "),_vm._m(47),_vm._v(" "),_vm._m(48),_vm._v(" "),_vm._m(49),_vm._v(" "),_vm._m(50)]):_vm._e(),_vm._v(" "),(_vm.lang =='en')?_c('div',{staticClass:"en"},[_vm._m(51),_c('p'),_vm._v(" "),_c('div',{staticClass:"logoParallax"}),_vm._v(" "),_vm._m(52),_vm._v(" "),_vm._m(53),_vm._v(" "),_vm._m(54),_vm._v(" "),_vm._m(55),_vm._v(" "),_vm._m(56),_vm._v(" "),_vm._m(57),_vm._v(" "),_vm._m(58),_vm._v(" "),_vm._m(59),_vm._v(" "),_vm._m(60),_vm._v(" "),_vm._m(61),_vm._v(" "),_vm._m(62),_vm._v(" "),_vm._m(63),_vm._v(" "),_vm._m(64),_vm._v(" "),_vm._m(65),_vm._v(" "),_vm._m(66),_vm._v(" "),_vm._m(67),_vm._v(" "),_vm._m(68),_vm._v(" "),_vm._m(69),_vm._v(" "),_vm._m(70),_vm._v(" "),_vm._m(71),_vm._v(" "),_vm._m(72),_vm._v(" "),_vm._m(73),_vm._v(" "),_vm._m(74),_vm._v(" "),_vm._m(75),_vm._v(" "),_vm._m(76),_vm._v(" "),_vm._m(77),_vm._v(" "),_vm._m(78),_vm._v(" "),_vm._m(79),_vm._v(" "),_vm._m(80),_vm._v(" "),_vm._m(81),_vm._v(" "),_vm._m(82),_vm._v(" "),_vm._m(83),_vm._v(" "),_vm._m(84),_vm._v(" "),_vm._m(85),_vm._v(" "),_vm._m(86),_vm._v(" "),_vm._m(87),_vm._v(" "),_vm._m(88),_vm._v(" "),_vm._m(89),_vm._v(" "),_vm._m(90),_vm._v(" "),_vm._m(91),_vm._v(" "),_vm._m(92),_vm._v(" "),_vm._m(93),_vm._v(" "),_vm._m(94),_vm._v(" "),_vm._m(95),_vm._v(" "),_vm._m(96),_vm._v(" "),_vm._m(97),_vm._v(" "),_vm._m(98),_vm._v(" "),_vm._m(99),_vm._v(" "),_vm._m(100),_vm._v(" "),_vm._m(101),_vm._v(" "),_vm._m(102),_vm._v(" "),_vm._m(103),_vm._v(" "),_vm._m(104),_vm._v(" "),_vm._m(105),_vm._v(" "),_vm._m(106),_vm._v(" "),_vm._m(107),_vm._v(" "),_c('div',{staticClass:"parallax"}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(108),_vm._v(" "),_vm._m(109),_vm._v(" "),_vm._m(110),_vm._v(" "),_vm._m(111),_vm._v(" "),_vm._m(112),_vm._v(" "),_vm._m(113),_vm._v(" "),_vm._m(114),_vm._v(" "),_vm._m(115),_vm._v(" "),_vm._m(116),_vm._v(" "),_vm._m(117),_vm._v(" "),_vm._m(118),_vm._v(" "),_vm._m(119),_vm._v(" "),_vm._m(120),_vm._v(" "),_vm._m(121),_vm._v(" "),_vm._m(122),_vm._v(" "),_vm._m(123)]):_vm._e(),_vm._v(" "),(_vm.lang == 'sr')?_c('div',{staticClass:"sr"},[_vm._m(124),_vm._v(" "),_c('div',{staticClass:"logoParallax"}),_vm._v(" "),_vm._m(125),_vm._v(" "),_vm._m(126),_vm._v(" "),_vm._m(127),_vm._v(" "),_vm._m(128),_vm._v(" "),_vm._m(129),_vm._v(" "),_vm._m(130),_vm._v(" "),_vm._m(131),_vm._v(" "),_vm._m(132),_vm._v(" "),_vm._m(133),_vm._v(" "),_vm._m(134),_vm._v(" "),_vm._m(135),_vm._v(" "),_vm._m(136),_vm._v(" "),_vm._m(137),_vm._v(" "),_vm._m(138),_vm._v(" "),_vm._m(139),_vm._v(" "),_vm._m(140),_vm._v(" "),_vm._m(141),_vm._v(" "),_vm._m(142),_vm._v(" "),_vm._m(143),_vm._v(" "),_vm._m(144),_vm._v(" "),_c('div',{staticClass:"parallax"}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(145),_vm._v(" "),_vm._m(146),_vm._v(" "),_vm._m(147),_vm._v(" "),_vm._m(148),_vm._v(" "),_vm._m(149),_vm._v(" "),_vm._m(150),_vm._v(" "),_vm._m(151),_vm._v(" "),_vm._m(152),_vm._v(" "),_vm._m(153),_vm._v(" "),_vm._m(154),_vm._v(" "),_vm._m(155),_vm._v(" "),_vm._m(156),_vm._v(" "),_vm._m(157),_vm._v(" "),_vm._m(158),_vm._v(" "),_vm._m(159),_vm._v(" "),_vm._m(160)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western"},[_c('span',{staticStyle:{"font-size":"large"}},[_c('em',[_c('strong',[_c('span',[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('span',[_vm._v("PLATFORMA:")])])])])])]),_vm._v(" ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('a',{attrs:{"name":"_Hlk528845847"}}),_vm._v(" "),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Platforma a fost dezvoltată în cadrul proiectului ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Local Heritage for Active Tourism in Banat")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(" – HerA (eMS RORS 20), implementat în perioada mai 2017 – noiembrie 2018 și finanțat de Uniunea Europeană în cadrul")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(" Programului INTERREG IPA de Cooperare Transfrontalieră România-Serbia. Inițial, platforma reunește, într-o variantă trilingvă, o serie de informații rezultate din cercetările de teren derulate în spațiul transfrontalier al Banatului și despre care comunitățile ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("cred că alcătuiesc, astăzi, patrimoniul cultural local. Gândită ca un instru")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("­")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("ment de promovare și indexare, platforma le oferă și utilizatorilor posibilitatea de a contribui la îmbogățirea permanentă a conținutului, fiind un website de tip UGC (conținut generat de utilizatori). ")])])]),_vm._v(" ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western"},[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_c('span',[_vm._v("PARTENERIATUL:")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Proiectul este rezultatul unui parteneriat de succes dintre "),_c('a',{attrs:{"href":"https://www.uvt.ro/"}},[_vm._v("Universitatea de Vest din Timișoara")]),_vm._v(", "),_c('a',{attrs:{"href":"http://www.kikinda.org.rs/"}},[_vm._v("Primăria Orașului Kikinda ")]),_vm._v(" și "),_c('a',{attrs:{"href":"http://www.muzejkikinda.com/"}},[_vm._v("Muzeul Național Kikinda")]),_vm._v(".")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western"},[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_c('span',[_vm._v("ECHIPA:")])])])])]),_vm._v(" ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Grupul care a realizat cercetarea, prelucrarea și sistematizarea de informațiilor din teren este alcătuit din membri ai echipei de proiect, la care se adaugă un mare număr de voluntari, fie doctoranzi și studenți ai Universității de Vest din Timișoara, fie persoane aparținând comunităților locale situate de cele două părți ale graniței, persoane preocupate de promovarea, prezervarea și valorificarea eficientă a resurselor patrimoniale locale. ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Grupul de lucru s-a coagulat în jurul Prof. Dr. Otiliei Hedeșan de la Universitatea de Vest din Timișoara, coordonatorul activității de cercetare și realizare a produselor din proiect. Nucleul acestui grup de cercetare este unul pluridisciplinar, format din membri ai ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Research Center for Heritage and Cultural Anthropology")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(" (RHeA) din cadrul Universitatății de Vest din Timișoara.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western"},[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_c('span',[_vm._v("Volume reprezentative ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Otilia Hedeșan, ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Luai Uzdinu de-amăruntul. Amintirile unei povestitoare prodigioase: Mărioara Sârbu")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(", Timișoara, Editura Universității de Vest, 2015, 233 p. + cd, ISBN 978-973-125-445-6")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Eliana Popeți, Miliana-Radmila Radan Uscatu, ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Pe sub drumu-al mare. Locuri şi poveşti din Banat. Поред великог пута. Места и приче из Баната")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(", Timişoara: Edidura Universităţii de Vest, 2015, 100 p., ISBN 978-973-125-446-3.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Nicoleta Mușat, Andreea Lișiță, ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Pocărăi și meșpaisuri, Pite i kolači: Slatka trpeza Banata")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(" (trad. Eufrozina Greoneanț), Timișoara, Editura Universității de Vest, 2015.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Otilia Hedeșan, Dana Percec, Corina- Eugenia Popa,")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v(" Ethnographic studies in the Banat multicultural rural communities. A digital approach")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(", Timișoara, Editura Universității de Vest, 2014.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Otilia Hedeșan,")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v(" Basme din Banat, Lecturi postcanonice")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(", Timișoara, Editura Universității de Vest, 2016, 209 p., ISBN 978-973-125-493-7.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Mihaela Bucin, Natalia Golant, Otilia Hedeșan (coord.), Diana Mihuț, Nicoleta Mușat, Liuba Petrenco, Corina Popa, Eliana Popeți, ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Mărțișorul. Ediție limitată")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(", Editura Universității de Vest, Timișoara, 2016.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Otilia Hedeșan, ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Folclorul. Ce facem cu el?, ")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("ediția a II-a, revizuită, Timișoara, Editura Universității de Vest, 2015, 293 p. ISBN 978-973-125-464-7")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_c('span',[_vm._v("Grupul de lucru:")])])])])]),_vm._v(" ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('strong',[_c('span',[_c('span',[_vm._v("Otilia Hedeșan:")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Otilia Hedeșan este profesor de civilizație românească la Universitatea de Vest din Timișoara, prorector, directorul Consiliului Studiilor Universitare de Doctorat din cadrul aceleiași instituții. Este etnolog, specializată în studiul populațiilor din Banat, Timoc, Ungaria, Valea Moravei precum și al populațiilor românești din Ungaria sau Republica Moldova. Temele sale de interes sunt: mitologia română în actualitate, practicile tradiționale și transformările lor, reinventarea tradițiilor, etnologia română în perioada comunistă și postcomunistă.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('strong',[_c('span',[_c('span',[_vm._v("Ioana Dorobanțu-Gordon:")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"color":"#222222"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Ioana Dorobanțu-Gordon este regizor de film, cu specializare în film documentar, obținută în cadrul studiilor de Masterat la London College of Communication, University of the Arts London. A regizat, a produs și a scris diverse programe pentru Televiziunea Română Publică (TVR), abordând subiecte variate din domeniul artelor, educației, istoriei, patrimoniului, migrației și documentarului de călătorie.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('strong',[_c('span',[_c('span',[_vm._v("Diana Mihuț:")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Diana Mihuț este doctor în filologie al Universității de Vest din Timișoara, cu o teză de doctorat care se concentrează pe forme moderne ale ritualurilor. În ultimii ani a realizat cercetări de teren în regiunea Banatului, îndeosebi în partea sârbească a acestuia. Cercetările sale focusează îndeosebi pe formele moderne de manifestare ale faptelor culturale. ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('strong',[_c('span',[_c('span',[_vm._v("Loredana Monenciu:")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"color":"#222222"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Loredana Monenciu este absolventă a programului Studii Culturale din cadrul Facultății de Litere, Istorie și Teologie a Universității de Vest și a masteratului Literatură și cultură: contexte românești, contexte europene din cadrul aceleiași instituții. Principalele domenii de interes țin de antropologia urbană, comunism și subculturi.")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('strong',[_c('span',[_c('span',[_vm._v("Alina Negru:")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Alina Negru a făcut studii de arhitectură și cercetează practicile constructive cu pământ în cadrul stagiului doctoral coordonat de prof. dr. Otilia Hedeșan, în domeniul antropologiei. ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("După ce s-a specializat în Arhitecturi din pământ, culturi constructive și dezvoltare durabilă în cadrul ")])])]),_c('a',{attrs:{"href":"http://craterre.org/enseignement:chaire-unesco/?new_lang=fr_FR"}},[_c('span',{staticStyle:{"color":"#00000a"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Catedrei UNESCO ")])])])]),_c('span',{staticStyle:{"color":"#00000a"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("CRAterre-ENSAG")])])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(", Alina Negru s-a ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("implicat în mai multe inițiative de identificare și ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("promovare a resurselor locale existente și a rolului acestora în dezvoltarea durabilă a Banatului rural, atât împreună cu echipa de cercetare RheA, cât și cu asociația culturală REcult. ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('strong',[_c('span',[_c('span',[_vm._v("Gabriela Panu:")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Gabriela Panu este cadru didactic asociat la Facultatea de Științe Politice și Științe ale Comunicării și șeful Biroului de relații cu publicul și promovare la Biblioteca Centrală Universitară „Eugen Todoran” Timișoara. Temele sale de cercetare focalizează pe studii de gen, antropologie, istoria comunismului, istorie educațională și biblioteconomie.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('strong',[_c('span',[_c('span',[_vm._v("Corina Popa:")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',{staticStyle:{"color":"#000000"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',[_vm._v("Corina Eugenia Popa este antropolog, specializat în cercetări de teren în comunitățile istorice românești din afara granițelor. Utilizând metode specifice antropologiei culturale și istoriei orale, a documentat, începând din 2006, practicile identitare asociate patrimoniului local al acestor comunități. Domeniile de cercetare de care este interesată sunt: antropologia culturală, patrimoniul cultural imaterial, studiile de gen, istoria orală și memoria colectivă, reprezentările autobiografice în discursul despre identitate, multiculturalism, transculturalism, post-socialism. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',{staticStyle:{"color":"#000000"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('strong',[_c('span',[_c('span',[_vm._v("Eliana Popeți:")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Eliana Popeți predă limba română ca limbă străină în cadrul Departamentului de Studii românești al Facultății de Litere, Istorie și Teologie. În ultimii ani, lucrează mai mult cu studenți din comunități românofone din Moldova, Serbia, Ucraina și Ungaria . ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("A elaborat o teză de doctorat pe marginea transmiterii basmului popular din perspectivă diacronică și efectuat mai multe studii despre povestitul oral contemporan. ")])])]),_vm._v(" ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('strong',[_c('span',[_c('span',[_vm._v("Raluca Rusu:")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Absolventă în peisagistică, Raluca Rusu se orientează spre științele umaniste datorită preocupărilor sale asupra temei construcției trecutului în prezent, din perspectiva studiilor pentru patrimoniu. Temele de interes se orientează spre problematica patrimonială a peisajului și a relației omului cu natura, cu cercetări în cadrul proiectelor ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Cimitire din Banat")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(" si ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Biserici înlemnite din Banat")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(", aflate sub egida Asociația Peisagiștilor din România-Asop.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_c('span',[_vm._v("III.4. Echipa de implementare a proiectului :")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Petru Ștefea")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v(" (Universitatea de Vest din Timișoara)")]),_vm._v("  –"),_c('span',{staticClass:"function"},[_vm._v(" manager")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Roxana Roiban / Sorina Păuțu")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v("(Universitatea de Vest din Timișoara)")]),_vm._v("  –"),_c('span',{staticClass:"function"},[_vm._v(" asistent de proiect")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("A")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Saša Tanackov")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v("(Primăria Orașului Kikinda)")]),_vm._v("  –"),_c('span',{staticClass:"function"},[_vm._v(" Coordonator activități")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Lidija Milasinovi")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("ć (")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"workPlace"},[_vm._v("Muzeul Național din Kikinda")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(")")]),_vm._v("  –"),_c('span',{staticClass:"function"},[_vm._v(" Coordonator local")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Andrei Pelin")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v("(Universitatea de Vest din Timișoara)")]),_vm._v("  –"),_c('span',{staticClass:"function"},[_vm._v(" manager financiar")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Andrei Tărăbîc")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v("(Universitatea de Vest din Timișoara)")]),_vm._v("  –"),_c('span',{staticClass:"function"},[_vm._v(" asistent tehnic")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Otilia Hedeșan")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v("(Universitatea de Vest din Timișoara)")]),_vm._v("  –"),_c('span',{staticClass:"function"},[_vm._v(" coordonator cercetare")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Diana Mihuț")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v("(Universitatea de Vest din Timișoara)")]),_vm._v("  –"),_c('span',{staticClass:"function"},[_vm._v(" expert comunicare")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Eliana Popeți")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v("(Universitatea de Vest din Timișoara)")]),_vm._v("  –"),_c('span',{staticClass:"function"},[_vm._v(" coordonator cercetare teren")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Corina Popa")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v("(Universitatea de Vest din Timișoara)")]),_vm._v("  –"),_c('span',{staticClass:"function"},[_vm._v(" coordonator cercetare teren")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Gabriela Panu")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v("(Universitatea de Vest din Timișoara) ")]),_vm._v(" – "),_c('span',{staticClass:"function"},[_vm._v("coordonator cercetare teren")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Cosmin Bonchiș")]),_c('span',{staticClass:"workPlace"},[_vm._v(" (Universitatea de Vest din Timișoara)")]),_vm._v("  – "),_c('span',{staticClass:"function"},[_vm._v("manager IT")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Marian Neagul")]),_vm._v(" "),_c('span',{staticClass:"workPlace"},[_vm._v("(Universitatea de Vest din Timișoara)")]),_vm._v("  – "),_c('span',{staticClass:"function"},[_vm._v("expert administrare IT")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Gabriel Iuhasz")]),_c('span',{staticClass:"workPlace"},[_vm._v(" (Universitatea de Vest din Timișoara)")]),_vm._v("  – "),_c('span',{staticClass:"function"},[_vm._v("expert GIS")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Miliana Uscatu")]),_c('span',{staticClass:"workPlace"},[_vm._v(" (Universitatea de Vest din Timișoara)")]),_vm._v("  – "),_c('span',{staticClass:"function"},[_vm._v("traducător")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Andreea Lișiță")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('span',{staticClass:"workPlace"},[_vm._v(" (Universitatea de Vest din Timișoara)")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(" –"),_c('span',{staticClass:"function"},[_vm._v(" traducător")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_vm._v("THE PLATFORM")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"font-size":"16px"}},[_c('span',[_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v("The platform has been developed in the project called")]),_c('span',[_c('em',[_vm._v(" Local Heritage for Active Tourism in Banat")])]),_c('span',[_vm._v(" – HerA (eMS RORS 20), implemented between May 2017 – November 2018 and financed by the Europen Union through")]),_vm._v(" Interreg-IPA Cross-border Cooperation Romania-Serbia Programme"),_c('span',[_vm._v(", ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"font-size":"16px"}},[_c('span',[_c('span',[_vm._v("Initially, the platform gathers, in a variant of three languages, the most diverse information which resulted at the end of the field researches carried out in the cross-border area of Banat and which were considered by the communities a part of Cultural heritage of Banat. The platform has been designed as an instrument for the promotion and indexation and offers the users the possibility to contribute to the continuous enriching of the content, considering the fact that it is a website type UGC (users generated content). ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_vm._v("THE PARTNERSHIP")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("The project is the result of a successful of partnership between the "),_c('a',{attrs:{"href":"https://www.uvt.ro/"}},[_vm._v("West University of Timisoara")]),_vm._v(", "),_c('a',{attrs:{"href":"http://www.kikinda.org.rs/"}},[_vm._v("Municipality of Kikinda")]),_vm._v(" and the "),_c('a',{attrs:{"href":"http://www.muzejkikinda.com/"}},[_vm._v("National Museum of Kikinda")]),_vm._v(".")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_vm._v("THE TEAM")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("The team which has actively involved in the researching, processing and organizing the information gathered on the field of research is made from a series of members of the project team and a large number of volunteers, who are students of the West University of Timisoara or persons from the local communities situated on the both sides of the border preoccupated by the promotion, preservation and the efficient capitalization of the local resources of the heritage. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("The working team gathered around Otilia Hedesan, Professor at the WUT and the coordinator of the research activities in the project. The core of this group is pluridisciplinar, formed from members of ")])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("Research Center for Heritage and Cultural Anthropology")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v(" (RHeA) from WUT. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_vm._v("SIMILAR PROJECTS: ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('a',{attrs:{"href":"http://www.creative-heritage.eu/creative-heritage.eu/index.html"}},[_vm._v("Creative Cooperation in Cultural Heritage")]),_vm._v(" (Creative CH, FP7-SCIENCE-IN SOCIETY contract 289 076; 2011-2014 )")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Living Heritage - an unlimited Resource for tourism development MIS ETC 1324; 2013-2015")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("”"),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("The exhibition of the naïve painters from Uzdin”, project financed by the agenda of the most important cultural and sportive manifestations of Council of the Timis County for the year 2015, November 2015. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_vm._v("REPRESENTATIVE VOLUMES: ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Otilia Hedeșan, ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Luai Uzdinu de-amăruntul. ")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("Amintirile unei povestitoare prodigioase: Mărioara Sârbu")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v(", /")])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v(" I took Uzdin step by step. The memories of a prodigy storyteller Marioara Sarbu")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v(", Timișoara, Editura Universității de Vest, 2015, 233 p. + cd, ISBN 978-973-125-445-6")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Eliana Popeți, Miliana-Radmila Radan Uscatu, ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Pe sub drumu-al mare. Locuri şi poveşti din Banat. ")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("Поред")])])]),_vm._v(" "),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("великог")])])]),_vm._v(" "),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("пута")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v(". ")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("Места")])])]),_vm._v(" "),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("и")])])]),_vm._v(" "),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("приче")])])]),_vm._v(" "),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("из")])])]),_vm._v(" "),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("Баната")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(", / ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Places and stories from Banat")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(", Timişoara: Edidura Universităţii de Vest, 2015, 100 p., ISBN 978-973-125-446-3.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"name":"_GoBack"}}),_vm._v(" "),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("Nicoleta Mușat, Andreea Lișiță, ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Pocărăi și meșpaisuri, Pite i kolači: Slatka trpeza Banata")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v(" / ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_c('em',[_vm._v("Cakes and cookies ")])])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',[_vm._v("(trad. ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Eufrozina Greoneanț), Timișoara, Editura Universității de Vest, 2015.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Otilia Hedeșan, Dana Percec, Corina- Eugenia Popa,")])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v(" Ethnographic studies in the Banat multicultural rural communities. A digital approach")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v(", Timișoara, Editura Universității de Vest, 2014.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Otilia Hedeșan,")])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v(" Basme din Banat, Lecturi postcanonice")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v(" / ")])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("Fairy-tales from Banat, ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v(" Timișoara, Editura Universității de Vest, 2016, 209 p., ISBN 978-973-125-493-7.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Mihaela Bucin, Natalia Golant, Otilia Hedeșan (coord.), Diana Mihuț, Nicoleta Mușat, Liuba Petrenco, Corina Popa, Eliana Popeți, ")])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("Mărțișorul. Ediție limitată")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v(" / ")])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("The Mărțișorul. Limited edition")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v(", Editura Universității de Vest, Timișoara, 2016.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Otilia Hedeșan, ")])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('em',[_vm._v("Folclorul. Ce facem cu el? / Folklore. What do we do with it?, ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("ediția a II-a, revizuită, Timișoara, Editura Universității de Vest, 2015, 293 p. ISBN 978-973-125-464-7")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_vm._v("THE WORKING GROUP: ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Otilia Hedeșan:")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Otilia Hedeșan is now Professor of Romanian Civilization at WUT and the manager of the Council of the Universitary Doctoral Studies in the same institution. She is ethnologist, specialized in the study of populations from Banat, Timoc, Hungary and the Valley of Morava. She also is specialized in the Romanian population from Hungary and the Republic of Moldova. Her themes of interest are: the Romanian mythology today, the traditional practices and their transformations, the reinvention of the traditions, Romanian Ethnology in the communist and post-communist period. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Ioana Dorobanțu-Gordon:")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_vm._v("Ioana Dorobanțu-Gordon is a film director, specialized in documentary, having a Master Degree at ")]),_c('span',{staticStyle:{"color":"#222222"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("London College of Communication, University of the Arts London. She has directed, produced and written diverse TV programs for the Romanian Public Television (TVR) discussing different subjects on arts, educations, history, heritage, migration and traveling. ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Diana Mihuț:")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Diana Mihuț is PHD in philology at WUT, with a thesis on modern forms of rituals. In the last years she carreied out fields of research in Banat, especially in the Serbian part. Her researchis are focused mostly on the modern forms of the manifestation of the cultural facts. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Loredana Monenciu:")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"color":"#222222"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Loredana Monenciu has graduated a program of Cultural Studies at the Faculty of Letters, History and Theology at WUT and the Master program called Literature and Culture in Romanian and European Contexts. Her maine domains of interest are urban antropology, communism and subcultures. ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Alina Negru:")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_vm._v("Alina Negru has graduated studies of architecture and is researching the practices of building with earth in the doctoral studies coordinated by Otilia Hedeșan, in the field of anthropology. After has specialized in Architecture of earth, building cultures and sustainable development in the ")]),_c('a',{attrs:{"href":"http://craterre.org/enseignement:chaire-unesco/?new_lang=fr_FR"}},[_c('span',{staticStyle:{"color":"#00000a"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Department of UNESCO ")])])]),_c('span',{staticStyle:{"color":"#00000a"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("CRAterre-ENSAG")])])])]),_c('span',{staticStyle:{"color":"#00000a"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v(". Alina Negru has involved in many initiatives for the identification and promotion of the local resources and of their role in the sustainable development of rural Banat. She has collaborated both with the team of ")])])]),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("RheA and the team of the cultural association REcult. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Gabriela Panu: ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Gabriela Panu is a associated lecturer at the Faculty of Political Sciences and the Sciences of Communication and the head of the Public Relations and Promotion at the University Central Library ”Eugen Todoran” Timișoara. Her domains of research is focused on Gender Studies, Anthropology, the History of communism, the History of education and Library management. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Corina Popa:")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Corina Eugenia Popa is an anthropologist specialized in field researches in historical Romanian communities outside the border. Using methods specific to the cultural Anthropology and of the oral History, she documented, starting on 2006, the identity practices associated to the local heritage. The domains of research which interest her are: cultural anthropology, intangible cultural heritage, genders studies, oral history, collective memory, transculturalism, post-socialism. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"color":"#000000"}},[_c('span',{staticStyle:{"font-size":"medium"}},[_c('strong',[_c('span',[_c('span',[_vm._v("Eliana Popeți:")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Eliana Popeți is teaching Romanian language as a foreign language in the Department of Romanian Studies of the Faculty of Letters, History and Theology of WUT. Lately, she is working with students from the language speaking communities of Moldova, Serbia, Ukraina and Hungary. She has written and published a PHD thesis on the way of transmitting of the popular fairytale from the diachronic perspective and she carried out many studies on contemporary oral story-telling. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Raluca Rusu:")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v("Raluca Rusu has graduated landscape studies and she reoriented to humanistic sciences because of her interest on the subject of building in the past and in the present, from the perspective of the studies of the heritage. Her domains of interest are the landscape perspective on the heritage and the relation of the man and nature. She was researcher in the projects ”Graveyards in Banat” and ”Woodened Churches in Banat”, developed by the ASOP – the Association of the landscape specialist. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_c('span',[_vm._v("III.4. ")])]),_c('span',[_vm._v("Implementation team:")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Petru Ștefea ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - manager")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Roxana Roiban / Sorina Păuțu ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - project manager")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Sasa Tanackov ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(Municipality of Kikinda)")]),_c('span',{staticClass:"function"},[_vm._v(" - activity coordinator")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Lidija Milasinović ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(National Museum of Kikinda)")]),_c('span',{staticClass:"function"},[_vm._v(" - local coordinator")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Andrei Pelin ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - financial manager")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Andrei Tărăbîc ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - technical assistant")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Otilia Hedeșan ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - research coordinator")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Diana Mihuț ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - communication expert")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Eliana Popeți ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - field research coordinator")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Corina Popa ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - field research coordinator")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Gabriele Panu ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - field research coordinator")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Cosmin Bonchiș ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - IT manager")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Marian Neagul ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - IT administration expert")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Gabriel Iuhasz ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - GIS expert")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Miliana Uscatu ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - interpretor")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Andreea Lișiță ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(West University of Timișoara)")]),_c('span',{staticClass:"function"},[_vm._v(" - text translator")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('strong',[_c('em',[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('span',[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Platforma: ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('a',{attrs:{"name":"_GoBack"}}),_vm._v(" "),_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Platforma je razvijena u okviru projekta pod nazivom Local Heritage for Active Tourism in Banat – HerA ( eMS RORS20), finansiran od strane "),_c('a',{attrs:{"href":"http://www.europa.eu/"}},[_vm._v("Evropske Unije")]),_vm._v(" putem programa "),_c('a',{attrs:{"href":"http://www.romania-serbia.net/"}},[_vm._v("Interreg-IPA Program prekogranične saradnje Rumunija- Srbija")]),_vm._v(". U početku ova platforma skuplja, u varijanti tri jezika, najraznovrsnije informacije koje se dale rezultat završetkom terenskih istraživanja koja su sprovedena u prekograničnom područiju Banata i koje su zajednice razmatrale delom kulturnog nasleđa Banata. Platforma je dizajnirana kao instrument za promociju i indeksaciju i nudi korisnicima mogućnost da doprinesu konstantnom obogaćivanju sadržaja, imajući u vidu činjenicu da je to tip veb sajta tipa UGC(sadržaj koji stvaraju korisnici).")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"lang":"ro-RO"}},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('span',[_c('span',{attrs:{"lang":"ro-RO"}},[_c('em',[_c('strong',[_vm._v("Prijateljstva:")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Projekat je rezultat jedne kolaboracije "),_c('a',{attrs:{"href":"https://www.uvt.ro/ro/"}},[_vm._v("Zapadnog univerziteta Temišvar")]),_vm._v(", "),_c('a',{attrs:{"href":"http://www.kikinda.org.rs/"}},[_vm._v("Grad Kikinda")]),_vm._v(" i "),_c('a',{attrs:{"href":"http://www.muzejkikinda.com/"}},[_vm._v("Narodni muzej Kikinda")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"lang":"ro-RO"}},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('span',[_c('span',{attrs:{"lang":"ro-RO"}},[_c('em',[_c('strong',[_vm._v("EKIPA:")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Tim koji je aktivno učestvovao u istraživanju, obradi i organizaciji informacija prikupljenih na polju istraživanja vrši se iz serije članova projektnog tima i velikog broja volontera koji su studenti na Zapadnom univerzitetu u Temišvaru ili osobama iz lokalnih zajednica koje se nalaze na obe strane granice preokupirane promocijom, očuvanjem i efikasnom kapitalizacijom lokalnih resursa nasleđa.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Radni tim okupio se oko Otile Hedesan, profesora na Zapadnom univerzitetu u Temišvaru i koordinatora istraživačkih aktivnosti u projektu. Srž te grupe je poluridisciplinar, formiran od članova Istraživačkog centra za Baštinu i kulturnu antropologiju (RheA) iz Zapadnom univerzitetu u Temišvaru.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"lang":"ro-RO"}},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Radna grupa:")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Otilia Hedeșan")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Ioana Dorobanțu-Gordon")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Diana Mihuț")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Loredana Monenciu")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Alina Negru")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Gabriela Panu ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Corina Popa")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',[_c('span',{staticStyle:{"font-size":"medium"}},[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Raluca Rusu")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"lang":"ro-RO","align":"justify"}},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"x-large","text-transform":"uppercase"}},[_c('em',[_c('strong',[_c('span',[_c('span',{attrs:{"lang":"ro-RO"}},[_vm._v("Tim za implementaciju projekta :")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Petru Ștefea ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - menadžer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Roxana Roiban / Sorina Păuțu ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - projektni asistent")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Sasa Tanackov ")]),_c('span',{staticClass:"workPlace"},[_vm._v(" (Gradska skupština Kikinda)")]),_c('span',{staticClass:"function"},[_vm._v(" - Koordinator aktivnosti")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Lidija Milasinovi ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(Narodni muzej Kikinde)")]),_c('span',{staticClass:"function"},[_vm._v(" - Lokalni koordinator")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Andrei Pelin ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - finansijski menadžer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Andrei Tărăbîc ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v("  - tehnički asistent")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Otilia Hedeșan ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - koordinator za istraživanje")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Diana Mihuț ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - stručnjak za komunikaciju")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Eliana Popeți ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - koordinator na terenu")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Corina Popa ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - koordinator na terenu")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Gabriele Panu ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - koordinator na terenu")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Cosmin Bonchiș ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - IT menadžer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Marian Neagul ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - kspert za IT administraciju")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Gabriel Iuhasz ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - stručnjak za GIS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Miliana Uscatu ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - prevodilac")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"teamMemberName"},[_vm._v("Andreea Lișiță ")]),_c('span',{staticClass:"workPlace"},[_vm._v("(zapadni univerzitet Temišvar)")]),_c('span',{staticClass:"function"},[_vm._v(" - prevodilac")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1zxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "26bw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2D3t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Grs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var date = new Date(value);
  return date.toLocaleString(['en-US'], { month: 'short', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
});

/***/ }),

/***/ "2L6M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2MPe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banda_traditionala.6ffd365.png";

/***/ }),

/***/ "2PF0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('info-window-dialog',{attrs:{"marker":_vm.infoWindowMarker,"opened":_vm.infoWindowBoolMobile},on:{"close":function($event){_vm.infoWindowBoolMobile = !_vm.infoWindowBoolMobile}}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"map",attrs:{"elevation-1":""}},[_c('Gmap-Map',{ref:"map",staticStyle:{"width":"100%","margin-top":"20px"},attrs:{"zoom":7,"center":_vm.center,"id":"mapHgt"}},[_vm._l((_vm.relatedArtefacts),function(marker){return _c('Gmap-Marker',{key:marker.location.place_id,attrs:{"position":{
          lng: parseFloat(marker.location.geometry.location.lng),
          lat: parseFloat(marker.location.geometry.location.lat)},"clickable":true,"draggable":false},on:{"click":function($event){_vm.openInfoWindow(marker)}}})}),_vm._v(" "),_vm._t("visible",[_c('div',{staticStyle:{"top":"60px","left":"15px","background-color":"#0000FF","color":"white","position":"absolute","z-index":"100"}},[_c('info-window',{staticClass:"map-info ",attrs:{"marker":_vm.infoWindowMarker,"opened":_vm.infoWindowBoolDesktop},on:{"close":function($event){_vm.infoWindowBoolDesktop = !_vm.infoWindowBoolDesktop}}})],1)])],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ezj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2phk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3+AC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/17-min[cropped].6d7010a.jpg";

/***/ }),

/***/ "3IMY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['term'],
  data: function data() {
    return {
      //term: "",
      index: 0,
      options: {
        ro: {
          keys: ["title.ro", "description.ro"],
          includeMatches: true
        },
        en: {
          keys: ["title.en", "description.en"],
          includeMatches: true
        },
        sr: {
          keys: ["title.sr", "description.sr"],
          includeMatches: true
        }
      },
      methodResultsArtefacts: [],
      methodResultsGroups: [],
      methodResultsCollections: []
    };
  },

  computed: {
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    condition: function condition() {
      return this.methodResultsGroups.length == 0 && this.methodResultsCollections.length == 0 && this.methodResultsArtefacts.length == 0;
    },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    groups: function groups() {
      return this.$store.getters.loadGroups;
    },
    collections: function collections() {
      return this.$store.getters.loadAllCollections;
    }
  },
  methods: {
    max: function max(array) {
      array.sort(function (a, b) {
        return -(a[1] - a[0]) + (b[1] - b[0]);
      });
      return array[0];
    },
    highlighter: function highlighter(object, match) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(match), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var mat = _step.value;

          var i = this.max(mat.indices);
          var keys = mat.key.split('.');
          object[keys[0]][keys[1]] = object[keys[0]][keys[1]].substr(0, i[0]) + "<b>" + object[keys[0]][keys[1]].substr(i[0], i[1] - i[0] + 1) + "</b>" + object[keys[0]][keys[1]].substr(i[1] + 1);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return object;
    },
    toArtefact: function toArtefact(artefactID) {
      this.$router.push("/artefacts/" + artefactID);
      this.$emit('success');
    },
    toGroup: function toGroup(groupID) {
      this.$router.push("/groups/" + groupID);
      this.$emit('success');
    },
    toCollection: function toCollection(collectionID) {
      this.$router.push("/collections/" + collectionID);
      this.$emit('success');
    }
  },
  mounted: function mounted() {
    this.term = "";
    window.scrollTo(0, 0);
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
  },


  watch: {
    term: function term() {
      var _this = this;

      this.$search(this.term, this.artefacts, this.options[this.lang]).then(function (results) {
        _this.methodResultsArtefacts = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(results));
        _this.methodResultsArtefacts = _this.methodResultsArtefacts.map(function (x) {
          return _this.highlighter(x.item, x.matches);
        });
      });
      this.$search(this.term, this.groups, this.options[this.lang]).then(function (results) {
        _this.methodResultsGroups = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(results));
        _this.methodResultsGroups = _this.methodResultsGroups.map(function (x) {
          return _this.highlighter(x.item, x.matches);
        });
      });
      this.$search(this.term, this.collections, this.options[this.lang]).then(function (results) {
        _this.methodResultsCollections = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(results));
        _this.methodResultsCollections = _this.methodResultsCollections.map(function (x) {
          return _this.highlighter(x.item, x.matches);
        });
      });
    }
  }
});

/***/ }),

/***/ "3fpn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-0 pa-0",staticStyle:{"width":"100%","min-height":"90vh","background-color":"#FAFAFA","box-shadow":"none"}},[_c('v-layout',{staticClass:" primary pl-2 pr-2 ",attrs:{"row":""}},[_c('v-flex',{staticClass:" mr-3 ml-3 white hidden-md-and-up",attrs:{"xs12":"","sm12":"","offset-sm2":""}},[_c('h3',{staticClass:"mb-1 text-xs-center",staticStyle:{"color":"grey"}},[_vm._v("  MANAGE TAGS")])])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',{staticClass:"mt-2 pt-2",staticStyle:{"min-height":"40vh"}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"ma-1 ",attrs:{"xs12":"","md10":"","offset-md1":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.onCreateCollection($event)}}},[_c('v-layout',{staticClass:"white",staticStyle:{"box-shadow":"0 1px 5px rgba(0,0,0,0.2), 0 2px 2px rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12)","min-height":"40vh"},attrs:{"elevation-1":"","wrap":""}},[_c('v-flex',{staticStyle:{"border-right":"1px solid #eeeeee"},attrs:{"xs12":"","md4":""}},[_c('h3',{staticClass:"hidden-sm-and-down pl-2 mb-0 pt-1 text-xs-center",staticStyle:{"color":"grey","height":"67px","font-size":"2.3em"}},[_vm._v("MANAGE TAGS")]),_vm._v(" "),_c('div',[_c('v-divider'),_vm._v(" "),(_vm.showOnSmallScreen())?_c('v-layout',{staticClass:"mt-2  pl-2 pr-2 pt-2 pb-2 ",attrs:{"row":""}},[(_vm.preview == 0)?_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('v-text-field',{staticClass:"searchBar ",attrs:{"append-icon":"search","label":"Find a collection","hide-details":""},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}}),_vm._v(" "),(_vm.isNew(_vm.term.toUpperCase()))?_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{on:{"click":function($event){_vm.addNew(); _vm.isReallyOld = '3'; _vm.edit = false}}},[_vm._v("Add New Collection")])],1):_vm._e(),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.methodResults),function(collection){return _c('div',{key:collection._id},[_c('v-divider'),_vm._v(" "),_c('v-list-tile',{staticClass:"pt-2 pb-0",attrs:{"avatar":""},on:{"click":function($event){_vm.preview = 1; _vm.isReallyOld='1' ; _vm.previewCollection=collection}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":collection.imgUrl[0].url + '_profile'}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie pt-1"},[_c('v-list-tile-title',{staticClass:"artTitle",domProps:{"innerHTML":_vm._s(collection.title[_vm.lang])}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s( collection.description[_vm.lang] )}})],1)],1),_vm._v(" "),_c('v-divider')],1)})],2)],1):_vm._e(),_vm._v(" "),(_vm.preview == 1)?_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('v-btn',{attrs:{"block":""},on:{"click":function($event){_vm.preview = 0; _vm.isReallyOld='1'}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v(" GO BACK\n                    ")],1),_vm._v(" "),_c('div',{staticClass:"pt-4 mt-4  pl-2 pr-2",staticStyle:{"width":"100%"}},[_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-layout',{staticClass:"pt-3",attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"grey lighten-2 ma-3",attrs:{"block":""},on:{"click":function($event){_vm.editCollection(_vm.previewCollection._id); _vm.isReallyOld= '2';}}},[_c('b',[_vm._v("Edit Tag")])]),_vm._v(" "),_c('v-btn',{staticClass:"grey lighten-2 ma-3",attrs:{"block":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('b',[_vm._v("Delete Tag")])]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v("Are you sure you want to delete this collection?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":function($event){_vm.deleteCollection(_vm.selectedId)}}},[_vm._v("Yes")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:" pl-4",staticStyle:{"position":"relative"},attrs:{"md12":""}},[_c('p',{staticStyle:{"color":"grey","position":"relative","top":"20%","margin":"0px","white-space":"nowrap","text-indent":"20"}},[_c('v-icon',[_vm._v("view_day")]),_vm._v(" More in this Collection")],1)]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-container',{staticClass:"artefact-list pl-0 pr-0"},[_c('v-list',{attrs:{"three-line":""}},[_vm._l((_vm.artefacts),function(artefact){return ((artefact.collectionId.indexOf(_vm.previewCollection.title.en) > -1))?_c('div',{key:artefact._id},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.toArtefact(artefact._id)}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":artefact.mainImg[0].url + '_profile'}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(artefact.title[_vm.lang])}}),_vm._v(" "),_vm._l((_vm.users),function(user){return ((artefact.userId.indexOf(user._id) > -1))?_c('v-list-tile-sub-title',{key:user._id,domProps:{"innerHTML":_vm._s(user.displayName + ' - ' + artefact.description[_vm.lang] )}}):_vm._e()})],2)],1),_vm._v(" "),_c('v-divider')],1):_vm._e()})],2)],1)],1)],1):_vm._e()],1):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{staticStyle:{"position":"relative"},attrs:{"xs12":"","md8":""}},[_c('div',{staticClass:" ",staticStyle:{"height":"100%","position":"relative"}},[_c('v-layout',{staticClass:"hidden-sm-and-down pl-3 pt-3",staticStyle:{"height":"67px"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticStyle:{"color":"grey","font-size":"1.1em"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("info ")]),_vm._v(" "),_c('i',[_vm._v("Complete these fields to add/change the tag: "),(_vm.term && !_vm.preview)?_c('span',[_vm._v(_vm._s(_vm.term))]):(_vm.previewCollection.title[_vm.lang] && _vm.preview)?_c('span',[_vm._v(_vm._s(_vm.previewCollection.title[_vm.lang]))]):_vm._e()])],1)])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),((_vm.isReallyOld=='2' && _vm.edit == true))?_c('div',{staticStyle:{"width":"100%"}},[_c('v-form',{ref:"form2",on:{"submit":function($event){$event.preventDefault();_vm.onUpdateCollection(_vm.selectedId)}}},[_c('v-flex',{staticClass:"hidden-md-and-up",attrs:{"xs12":"","sm12":"","offset-sm2":""}},[_c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative","background-color":"white"},attrs:{"elevation-3":""}},[_c('v-flex',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative"},attrs:{"sm12":"","xs12":"","offset-sm2":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":"dark"}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(this.term))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-container',{staticClass:"pa-13 "},[_c('v-stepper',{attrs:{"non-linear":""}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"En","editable":""}},[_vm._v("English")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Ro","editable":""}},[_vm._v("Romana")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Sr","editable":""}},[_vm._v("Српски")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"En"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titleen","label":"Title","id":"titleen","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.en),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "en", $$v)},expression:"uploadEdit.title.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.en),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "en", $$v)},expression:"uploadEdit.description.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":"","persistent-hint":""},model:{value:(_vm.uploadEdit.groups),callback:function ($$v) {_vm.$set(_vm.uploadEdit, "groups", $$v)},expression:"uploadEdit.groups"}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Ro"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titlero","label":"Title","id":"titlero","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.ro),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "ro", $$v)},expression:"uploadEdit.title.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.ro),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "ro", $$v)},expression:"uploadEdit.description.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":"","persistent-hint":""},model:{value:(_vm.uploadEdit.groups),callback:function ($$v) {_vm.$set(_vm.uploadEdit, "groups", $$v)},expression:"uploadEdit.groups"}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Sr"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titlesr","label":"Title","id":"titlesr","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.sr),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "sr", $$v)},expression:"uploadEdit.title.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.sr),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "sr", $$v)},expression:"uploadEdit.description.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":"","persistent-hint":""},model:{value:(_vm.uploadEdit.groups),callback:function ($$v) {_vm.$set(_vm.uploadEdit, "groups", $$v)},expression:"uploadEdit.groups"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.uploadEdit.title.en.length > 0 && _vm.uploadEdit.title.ro.length > 0 && _vm.uploadEdit.title.sr.length > 0 && _vm.uploadEdit.description.en.length > 0 &&_vm.uploadEdit.description.ro.length > 0 &&_vm.uploadEdit.description.sr.length > 0 && _vm.uploadEdit.imgUrl[0]!= null)?_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-btn',{attrs:{"type":"submit","color":"primary"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}}},[_vm._v("Update Tag\n                          ")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.preview = 0; _vm.isReallyOld='1'}}},[_vm._v("\n                      Cancel\n                    ")])],1):_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-btn',{attrs:{"disabled":""}},[_vm._v("Update Tag\n                          ")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.preview = 0; _vm.isReallyOld='1'}}},[_vm._v("\n                      Cancel\n                    ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"xs12":"","sm12":"","pb-4":""}},[_c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative","background-color":"white"}},[_c('v-flex',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative"},attrs:{"sm12":"","xs12":"","offset-sm2":""}},[_c('v-container',{staticClass:" "},[_c('v-stepper',{attrs:{"non-linear":""}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"En","editable":""}},[_vm._v("English")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Ro","editable":""}},[_vm._v("Romana")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Sr","editable":""}},[_vm._v("Српски")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"En"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titleen","label":"Title","id":"titleen","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.en),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "en", $$v)},expression:"uploadEdit.title.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.en),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "en", $$v)},expression:"uploadEdit.description.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":""},model:{value:(_vm.uploadEdit.groups),callback:function ($$v) {_vm.$set(_vm.uploadEdit, "groups", $$v)},expression:"uploadEdit.groups"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Ro"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titlero","label":"Title","id":"titlero","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.ro),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "ro", $$v)},expression:"uploadEdit.title.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.ro),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "ro", $$v)},expression:"uploadEdit.description.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":""},model:{value:(_vm.uploadEdit.groups),callback:function ($$v) {_vm.$set(_vm.uploadEdit, "groups", $$v)},expression:"uploadEdit.groups"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Sr"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titlesr","label":"Title","id":"titlesr","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.sr),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "sr", $$v)},expression:"uploadEdit.title.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.sr),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "sr", $$v)},expression:"uploadEdit.description.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":""},model:{value:(_vm.uploadEdit.groups),callback:function ($$v) {_vm.$set(_vm.uploadEdit, "groups", $$v)},expression:"uploadEdit.groups"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.uploadEdit.title.en.length > 0 && _vm.uploadEdit.title.ro.length > 0 && _vm.uploadEdit.title.sr.length > 0 && _vm.uploadEdit.description.en.length > 0 &&_vm.uploadEdit.description.ro.length > 0 &&_vm.uploadEdit.description.sr.length > 0 && _vm.uploadEdit.imgUrl[0]!= null)?_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"color":"red darken-1","dark":"","medium":"","fixed":"","bottom":"","right":"","fab":"","type":"submit"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("save")])],1):_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"color":"grey","dark":"","medium":"","fixed":"","bottom":"","right":"","fab":""},nativeOn:{"click":function($event){_vm.snackbar = true}}},[_c('v-icon',[_vm._v("save")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":"red","multi-line":_vm.mode === 'multi-line',"vertical":_vm.mode === 'vertical'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      All fields must be completed\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1)],1):_vm._e(),_vm._v(" "),((_vm.isReallyOld=='3') && this.edit==false)?_c('div',{staticClass:" ",staticStyle:{"width":"100%"}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.onCreateCollection($event)}}},[_c('v-flex',{staticClass:"hidden-md-and-up",attrs:{"xs12":"","sm12":"","offset-sm2":"","md10":"","offset-md1":"","pb-4":""}},[_c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative","background-color":"white"},attrs:{"elevation-3":""}},[_c('v-flex',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative"},attrs:{"sm12":"","xs12":"","offset-sm2":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":"dark"}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v("add_circle")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(this.term))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-container',{staticClass:" "},[_c('v-stepper',{attrs:{"non-linear":""}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"En","editable":""}},[_vm._v("English")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Ro","editable":""}},[_vm._v("Romana")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Sr","editable":""}},[_vm._v("Српски")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"En"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titleen","label":"Title","id":"titleen","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.en),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "en", $$v)},expression:"uploadAdd.title.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.en),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "en", $$v)},expression:"uploadAdd.description.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":"","persistent-hint":""},model:{value:(_vm.uploadAdd.groups),callback:function ($$v) {_vm.$set(_vm.uploadAdd, "groups", $$v)},expression:"uploadAdd.groups"}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Ro"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titlero","label":"Title","id":"titlero","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.ro),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "ro", $$v)},expression:"uploadAdd.title.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.ro),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "ro", $$v)},expression:"uploadAdd.description.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":"","persistent-hint":""},model:{value:(_vm.uploadAdd.groups),callback:function ($$v) {_vm.$set(_vm.uploadAdd, "groups", $$v)},expression:"uploadAdd.groups"}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Sr"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titlero","label":"Title","id":"titlero","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.sr),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "sr", $$v)},expression:"uploadAdd.title.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.sr),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "sr", $$v)},expression:"uploadAdd.description.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":"","persistent-hint":""},model:{value:(_vm.uploadAdd.groups),callback:function ($$v) {_vm.$set(_vm.uploadAdd, "groups", $$v)},expression:"uploadAdd.groups"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.uploadAdd.title.en.length > 0 && _vm.uploadAdd.title.ro.length > 0 && _vm.uploadAdd.title.sr.length > 0 && _vm.uploadAdd.description.en.length > 0 &&_vm.uploadAdd.description.ro.length > 0 &&_vm.uploadAdd.description.sr.length > 0 && _vm.uploadAdd.imgUrl[0]!= null)?_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-btn',{attrs:{"type":"submit","color":"primary"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}}},[_vm._v("Add Tag\n                          ")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.preview = 0; _vm.isReallyOld='1'}}},[_vm._v("\n                      Cancel\n                    ")])],1):_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-btn',{attrs:{"disabled":""}},[_vm._v("Add Tag\n                          ")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.preview = 0; _vm.isReallyOld='1'}}},[_vm._v("\n                      Cancel\n                    ")])],1)],1)],1)],1)],1),_vm._v(" "),(_vm.term)?_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"xs12":"","sm12":"","pb-4":""}},[_c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative","background-color":"white"}},[_c('v-flex',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative"},attrs:{"sm12":"","xs12":"","offset-sm2":""}},[_c('v-container',{staticClass:" "},[_c('v-stepper',{attrs:{"non-linear":""}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"En","editable":""}},[_vm._v("English")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Ro","editable":""}},[_vm._v("Romana")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Sr","editable":""}},[_vm._v("Српски")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"En"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titleen","label":"Title","id":"titleen","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.en),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "en", $$v)},expression:"uploadAdd.title.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.en),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "en", $$v)},expression:"uploadAdd.description.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":""},model:{value:(_vm.uploadAdd.groups),callback:function ($$v) {_vm.$set(_vm.uploadAdd, "groups", $$v)},expression:"uploadAdd.groups"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Ro"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titlero","label":"Title","id":"titlero","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.ro),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "ro", $$v)},expression:"uploadAdd.title.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.ro),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "ro", $$v)},expression:"uploadAdd.description.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":""},model:{value:(_vm.uploadAdd.groups),callback:function ($$v) {_vm.$set(_vm.uploadAdd, "groups", $$v)},expression:"uploadAdd.groups"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Sr"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titlesr","label":"Title","id":"titlesr","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.sr),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "sr", $$v)},expression:"uploadAdd.title.sr"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.sr),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "sr", $$v)},expression:"uploadAdd.description.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.groups,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":""},model:{value:(_vm.uploadAdd.groups),callback:function ($$v) {_vm.$set(_vm.uploadAdd, "groups", $$v)},expression:"uploadAdd.groups"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.uploadAdd.title.en.length > 0 && _vm.uploadAdd.title.ro.length > 0 && _vm.uploadAdd.title.sr.length > 0 && _vm.uploadAdd.description.en.length > 0 &&_vm.uploadAdd.description.ro.length > 0 &&_vm.uploadAdd.description.sr.length > 0 && _vm.uploadAdd.imgUrl[0]!= null)?_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"color":"red darken-1","dark":"","medium":"","fixed":"","bottom":"","right":"","fab":"","type":"submit"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("save")])],1):_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"color":"grey","dark":"","medium":"","fixed":"","bottom":"","right":"","fab":""},nativeOn:{"click":function($event){_vm.snackbar = true}}},[_c('v-icon',[_vm._v("save")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":"red","multi-line":_vm.mode === 'multi-line',"vertical":_vm.mode === 'vertical'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      All fields must be completed\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1)],1):_vm._e()],1)])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"container"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3mok":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [
        // {
        //   title: "European Union",
        //   href:"http://europa.eu/",
        //   avatar:"../../assets/link-logo/ec-logo-horiz-web_en.jpg"
        // },
        // {
        //     title:"Interreg-IPA CBC Romania-Serbia",
        //     href:"http://www.romania-serbia.net/"
        // },
        // {
        //     title:"The Government of Romania",
        //     href:"http://www.gov.ro/"
        // },
        // {
        //     title:"The Government of The Republic of Serbia",
        //     href:"https://www.srbija.gov.rs/"
        // },
        // {
        //     title:"West University of Timișoara",
        //     href:"https://www.uvt.ro/ro/"
        // },
        // {
        //     title:"City of Kikinda",
        //     href:"http://www.kikinda.org.rs"
        // },
        // {
        //     title:"The Kikinda National Museum",
        //     href:"http://www.muzejkikinda.com"
        // }
      ]
    };
  },

  methods: {
    redirect: function redirect(href) {
      window.location.href = href;
    }
  }
});

/***/ }),

/***/ "4P0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_Dialog_vue__ = __webpack_require__("1foC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  validations: {
    name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(10) },
    email: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"] },
    select: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
    checkbox: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(8) }
    // repeatPassword: {sameAsPassword: sameAs('password')}
  },
  data: function data() {
    return {
      register_boolean: true,
      e1: true,
      dialog: false,
      password: "",
      first: "John",
      email: "",
      name: "",
      errorMessage: "",
      //rules: {
      //required: (value) => !!value || 'This field is required.',
      //email: (value) => {
      //const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      //return pattern.test(value) || 'Invalid e-mail.'
      //}
      //},
      checkbox: false
    };
  },

  components: {
    'web-dialog': __WEBPACK_IMPORTED_MODULE_0__components_Partials_Dialog_vue__["a" /* default */]
  },
  methods: {
    submit: function submit() {
      this.$v.$touch();
      this.emailErrors.length == 0 && this.passwordErrors.length == 0 && this.login();
    },


    authenticate: function authenticate(provider) {
      var _this = this;

      this.$auth.authenticate(provider).then(function (response) {
        // Execute application logic after successful social authentication
        _this.$store.dispatch("createToken", response.data.token);
        _this.$store.dispatch("getSocialUser", response.data.token);
        console.log(response);
        _this.$router.push("/");
      }).catch(function (err) {
        console.log(err);
      });
    },
    login: function login() {
      var _this2 = this;

      this.$auth.login({ email: this.email, password: this.password }).then(function (token) {
        _this2.$store.dispatch("createToken", token.data.token);
        _this2.$store.dispatch("createUser", token.data.user);
        _this2.$router.push("/");
      }).catch(function (err) {
        _this2.errorMessage = "Email and/or Password incorrect";
      });
    },

    register: function register() {
      this.$auth.register({
        displayName: this.name,
        email: this.email,
        password: this.password
      }).then(function (token) {}).catch(function (err) {
        console.log(err);
      });
    },
    onCreateToken: function onCreateToken() {
      this.$store.dispatch("createToken", this.formUpload);
      this.$router.push("/artefacts");
    },
    isAuthenticated: function isAuthenticated() {
      if (token != "") return true;
      return false;
    },
    getScreenWidth: function getScreenWidth() {
      return screen.width;
      console.log(screen.width);
      console.log(screen.availWidth);
      console.log(screen.systemXDPI);
    }
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    gLang: function gLang() {
      return this.$store.getters.loadGlobLang;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength && errors.push("Must be at least 8 characters");
      !this.$v.password.required && errors.push("Password is required");
      return errors;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  created: function created() {
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
  },
  mounted: function mounted() {
    document.title = "Log in";
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4hcK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('v-stepper',{attrs:{"non-linear":""}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"En","editable":"","rules":[function () { return _vm.rulesEn; }]}},[_vm._v("English")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Ro","editable":"","rules":[function () { return _vm.rulesRo; }]}},[_vm._v("Romana")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Sr","editable":"","rules":[function () { return _vm.rulesSr; }]}},[_vm._v("Српски")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"En"}},[_c('keep-alive',[_c('web-add-artefact',{attrs:{"formUpload":_vm.formUpload,"place":_vm.place,"marker":_vm.marker,"center":_vm.center,"newLocation":_vm.newLocation,"lang":'en'},on:{"newMarker":function($event){_vm.marker = $event},"newLocation":function($event){_vm.place = $event},"save":function($event){_vm.changeEn($event)},"createMaybe":function($event){_vm.openDialog()}}})],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Ro"}},[_c('keep-alive',[_c('web-add-artefact',{attrs:{"formUpload":_vm.formUpload,"place":_vm.place,"marker":_vm.marker,"center":_vm.center,"newLocation":_vm.newLocation,"lang":'ro'},on:{"newMarker":function($event){_vm.marker = $event},"newLocation":function($event){_vm.place = $event},"isMirror":function($event){_vm.showEnglish('ro')},"save":function($event){_vm.changeRo($event)},"createMaybe":function($event){_vm.openDialog()}}})],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Sr"}},[_c('keep-alive',[_c('web-add-artefact',{attrs:{"formUpload":_vm.formUpload,"place":_vm.place,"marker":_vm.marker,"center":_vm.center,"newLocation":_vm.newLocation,"lang":'sr'},on:{"newMarker":function($event){_vm.marker = $event},"newLocation":function($event){_vm.place = $event},"isMirror":function($event){_vm.showEnglish('sr')},"save":function($event){_vm.changeSr($event)},"createMaybe":function($event){_vm.openDialog()}}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialogOpen),callback:function ($$v) {_vm.dialogOpen=$$v},expression:"dialogOpen"}},[_c('v-card',[_c('v-card-title',[(!_vm.rulesEn && !_vm.rulesRo && !_vm.rulesSr)?_c('p',[_vm._v("\n              Your artefact won't be visible in any language please complete all fields(including text-fields for the desired language)\n              "),_c('br'),_vm._v("\n              By continuing you're saving your artefacts to your drafts , visible only to your account!\n            ")]):_c('p',[_vm._v("You can change the visibility of your artefacts by adding language versions, your artefact will be visible in:")])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[(_vm.rulesEn)?_c('p',[_vm._v("English ")]):_vm._e(),_vm._v(" "),(_vm.rulesRo)?_c('p',[_vm._v(" Romana")]):_vm._e(),_vm._v(" "),(_vm.rulesSr)?_c('p',[_vm._v(" Српски")]):_vm._e(),_vm._v(" "),(_vm.rulesEn && !_vm.rulesRo && !_vm.rulesSr )?_c('p',[_vm._v("The Serbian and Romanian versions will be shown in English")]):_vm._e(),_vm._v(" "),(_vm.rulesEn && !_vm.rulesRo && _vm.rulesSr )?_c('p',[_vm._v("The Romanian version will be shown in English")]):_vm._e(),_vm._v(" "),(_vm.rulesEn && _vm.rulesRo && !_vm.rulesSr )?_c('p',[_vm._v("The Serbian version will be shown in English")]):_vm._e()]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();return _vm.createArtefact($event)}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogOpen=false}}},[_vm._v("Change")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5M5d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("0hj2");
function injectStyle (ssrContext) {
  __webpack_require__("FFvd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5bxU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("Nk69");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5lCu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fundal.f34690e.png";

/***/ }),

/***/ "5ze5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_0_vue_infinite_loading___default.a
  },
  data: function data() {
    return {
      end: 12,
      list: [],
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      gradient: "to top right, rgba(63,81,181, .7), rgba(25,32,72, .0)"
    };
  },

  computed: {
    artefacts_scroll: function artefacts_scroll() {
      return this.artefacts.slice(0, this.end);
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    collectionName: function collectionName() {
      return this.$store.getters.getCollectionName(this.id);
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    isContrib: function isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  mounted: function mounted() {
    document.title = "Artefacts";
    window.scrollTo(0, 0);
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadUsers");
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {
      var elem = document.getElementById("getNewArtefacts");
      if (this.isScrolledIntoView(elem) && this.artefacts_scroll.length < this.artefacts.length) {
        this.end = this.end + 6;
      }
    },
    isScrolledIntoView: function isScrolledIntoView(el) {
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top;
      var elemBottom = rect.bottom;

      // Only completely visible elements return true:
      var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
      // Partially visible elements return true:
      //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
      return isVisible;
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this = this;

      setTimeout(function () {
        var temp = [];
        var a = 0;
        if (_this.artefacts.length != _this.list.length) {
          if (_this.artefacts.length - _this.list.length < 2) {
            a = _this.artefacts.length - _this.list.length - 1;
          } else {
            a = _this.list.length + 2;
          }
          for (var i = _this.list.length; i <= a; i++) {
            temp.push(_this.artefacts[i]);
          }
          _this.list = _this.list.concat(temp);
          $state.loaded();
        } else {
          $state.complete();
        }
      }, 1000);
    }
    //   moveButton(admin) {
    //       if(admin) {
    //         var btn = document.getElementById('bottom_button');
    //         btn.style.bottom = '65px';

    //       }
    //       else
    //       {
    //         var btn = document.getElementById('bottom_button');
    //         btn.style.bottom = '15px';
    //       }

    //     }

  }

});

/***/ }),

/***/ "69YC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Mixins_fileUploader_import_js__ = __webpack_require__("erLt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_Mixins_fileUploader_import_js__["a" /* Uploader */]],
  data: function data() {
    return {
      errorMessage: "",
      e1: true,
      status: 0,
      loading: false,
      timeout: 6000,
      colorS: "info",
      colorF: "red",
      mode: true,
      snackbarF: false,
      snackbarS: false
    };
  },

  computed: {
    favart: function favart() {
      return this.$store.getters.getFavoriteArtefacts;
    },
    users: function users() {
      return this.$store.getters.loadUsers;
    },
    artefacts: function artefacts() {
      return this.$store.getters.loadPopularArtefacts;
    },
    collections: function collections() {
      return this.$store.getters.loadAllCollections;
    },
    groups: function groups() {
      return this.$store.getters.loadGroups;
    },
    allArtefacts: function allArtefacts() {
      return this.$store.getters.loadArtefacts;
    }
  },
  methods: {
    goTo: function goTo(link, object) {
      console.log("hboefvwemrbevfn");
      this.$router.push("/" + object + "/" + link);
    },
    alertit: function alertit() {
      alert("we're is archiving user uploaded files, it may take a while");
    },
    downloadDatabase: function downloadDatabase() {},
    saveLanguage: function saveLanguage(lang) {
      var _this = this;

      console.log(lang);
      this.$store.dispatch("updateLang", { lang: lang }).then(function (response) {
        if (response.data) {
          _this.snackbarS = true;
        } else {
          _this.snackbarF = true;
        }
      });
    }
  }
});

/***/ }),

/***/ "6GfV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'pa-0 ma-0 background-container' : _vm.getScreenWidth() < 900, ' background-container-md' : _vm.getScreenWidth() > 900},staticStyle:{"height":"100vh","width":"100%","max-width":"100%"},attrs:{"xs12":"","sm10":"","md4":"","offset-md3":"","offset-sm2":""}},[_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"justify-center":""}},[_c('h4',{staticStyle:{"color":"grey"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].signIn.signIn))])]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"ml-2 mr-2 mt-4",attrs:{"sm8":"","md4":""}},[_c('v-layout',{staticStyle:{"background-color":"white","border-radius":"2px"},attrs:{"justify-center":"","elevation-2":""}},[_c('form',{staticStyle:{"width":"94%"}},[(_vm.errorMessage != '')?_c('p',{staticClass:"mt-4 caption red--text text--darken-4"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),_c('v-text-field',{staticClass:"mt-2",attrs:{"label":"E-mail","error-messages":_vm.emailErrors,"required":""},on:{"input":function($event){_vm.$v.email.$touch()},"blur":function($event){_vm.$v.email.$touch()},"keydown":function($event){_vm.errorMessage=''},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-10-1","label":"Password","type":"password","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){_vm.$v.password.$touch()},"blur":function($event){_vm.$v.password.$touch()},"keydown":function($event){_vm.errorMessage=''},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-checkbox',{attrs:{"label":"Remember me"},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}}),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":_vm.submit}},[_vm._v("\n                     "+_vm._s(_vm.gLang[_vm.lang].signIn.signIn)+"\n                 ")])],1)],1)]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.dialog=!_vm.dialog}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].signIn.forgotPassword))])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"mt-4",attrs:{"xs10":"","sm6":"","md3":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"primary",staticStyle:{"width":"100%"},attrs:{"to":"/signup"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n                          mail \n                      ")]),_vm._v("\n                      "+_vm._s(_vm.gLang[_vm.lang].signIn.createAccount)+"\n                  ")],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"width":"100%","background-color":"#3b5998"},attrs:{"dark":""},on:{"click":function($event){_vm.authenticate('facebook')}}},[_c('img',{staticClass:"socialImage mr-2",attrs:{"src":__webpack_require__("p8ve"),"alt":""}}),_vm._v("\n                      "+_vm._s(_vm.gLang[_vm.lang].signIn.signInFb)+"\n                  ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"width":"100%","background-color":"#dd4b39"},attrs:{"dark":""},on:{"click":function($event){_vm.authenticate('google')}}},[_c('img',{staticClass:"socialImage mr-2",attrs:{"src":__webpack_require__("+RHE"),"alt":""}}),_vm._v("\n                      "+_vm._s(_vm.gLang[_vm.lang].signIn.signInG)+"\n                  ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"width":"100%","background-color":"#2672EC"},attrs:{"dark":""},on:{"click":function($event){_vm.authenticate('live')}}},[_c('img',{staticClass:"socialImage mr-2",attrs:{"src":__webpack_require__("VjV7"),"alt":""}}),_vm._v("\n                      "+_vm._s(_vm.gLang[_vm.lang].signIn.signInM)+"\n                  ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"xs10":"","offset-xs1":"","sm6":"","offset-sm3":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('a',{staticClass:"terms",attrs:{"href":""}},[_vm._v("Terms And Conditions  ")])])],1),_vm._v(" "),_c('web-dialog',{attrs:{"dialog":_vm.dialog},on:{"clicked":function($event){_vm.dialog = !_vm.dialog}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6WvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAccount_vue__ = __webpack_require__("/H3p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_deef8288_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAccount_vue__ = __webpack_require__("xCC6");
function injectStyle (ssrContext) {
  __webpack_require__("srxf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-deef8288"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_deef8288_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6vsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['opened', 'marker'],
  methods: {
    close: function close() {
      this.$emit('close');
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    }
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.loadLang;
    }
  }
});

/***/ }),

/***/ "7MOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider1_vue__ = __webpack_require__("1+jb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cca64f3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider1_vue__ = __webpack_require__("EEv3");
function injectStyle (ssrContext) {
  __webpack_require__("pb6Y")
  __webpack_require__("2phk")
  __webpack_require__("5M5d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cca64f3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cca64f3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7lVZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7nbu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreeArtefactsCard_vue__ = __webpack_require__("ThKu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b713e11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreeArtefactsCard_vue__ = __webpack_require__("lSHQ");
function injectStyle (ssrContext) {
  __webpack_require__("2ezj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b713e11"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreeArtefactsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b713e11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreeArtefactsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8IwL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8uwh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9FaI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Gk3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Partials_ConversationTemplate_vue__ = __webpack_require__("nXSR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Partials_NewMessage_vue__ = __webpack_require__("eHBn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__ = __webpack_require__("G0J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    if (!this.isLoggedIn) this.$router.push("/signin");
  },
  data: function data() {
    var _ref;

    return _ref = {
      NewMessageBool: false,
      reciever: "",
      subject: "",
      newMessageQuill: "",
      editorOption: {
        theme: "snow",
        placeholder: "Send a new Message",
        modules: {
          toolbar: [["bold", "italic"], [{ list: "ordered" }, { list: "bullet" }], ["clean"]]
        }
      },
      selectedUsers: [],
      newMessage: false,
      conversationBool: false,
      conversationId: ""
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "subject", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "messages", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "conversations", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "preview", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "term", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "defaultAllToggle", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "UserOptions", {
      keys: ["displayName", "email"]
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "notifications", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "methodResults", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "items", ["Read", "Write"]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "text", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "options", {
      toolbar: {
        buttons: ["bold", "italic", "underline", "strikethrough", "h4", "h3", "h2", "justifyRight", "justifyLeft", "justifyCenter", "orderedlist", "unorderedlist"]
      },
      anchor: {
        /* These are the default options for anchor form,
         if nothing is passed this is what it used */
        // customClassOption: 'alink',
        // customClassOptionText: 'Button',
        // linkValidation: false,
        // placeholderText: 'YOYOYO',
        // targetCheckbox: false,
        // targetCheckboxText: 'Open in new window'
      }
    }), _ref;
  },

  computed: {
    checkIfMobile: function checkIfMobile() {
      var isMobile = window.matchMedia("only screen and (max-width: 760px)");

      if (isMobile.matches && (this.conversationBool || this.selectedUsers.length > 0 && this.NewMessageBool)) {
        return true;
      } else return false;
    },
    token: function token() {
      return this.$store.getters.getToken;
    },
    editor: function editor() {
      return this.$refs.myTextEditor.quill;
    },
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    gLang: function gLang() {
      return this.$store.getters.loadGlobLang;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    // artefacts() {
    //   return this.$store.getters.loadUnreviewdArtefacts;
    // },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    collectionName: function collectionName() {
      return this.$store.getters.getCollectionName(this.id);
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    isContrib: function isContrib() {
      return this.$store.getters.isContrib;
    },
    users: function users() {
      return this.$store.getters.loadUsers;
    },
    unreviewedArtefacts: function unreviewedArtefacts() {
      return this.$store.getters.loadUnreviewedArtefacts;
    },
    user: function user() {
      return this.$store.getters.getUser;
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("/api/messages/" + this.user._id).then(function (response) {
      _this.conversations = response.data;
    });

    document.title = "Messaging";
    window.scrollTo(0, 0);
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadUsers");
  },

  methods: {
    sendMessage: function sendMessage() {
      var _this2 = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedUsers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var selectedUser = _step.value;

          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post("/api/messages", {
            subject: this.subject,
            message: this.newMessageQuill,
            sender: this.user._id,
            reciever: selectedUser,
            token: this.token
          }).then(function (response) {
            _this2.updateConversations();
            _this2.newMessageQuill = "";
            _this2.subject = "";
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    addUser: function addUser(id) {
      if (this.selectedUsers.includes(id)) {
        var index = this.selectedUsers.indexOf(id); // <-- Not supported in <IE9
        this.selectedUsers.splice(index, 1);
      } else this.selectedUsers.push(id);
    },
    openNew: function openNew() {
      this.newMessage = true;
    },
    strip: function strip(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    },
    updateConversation: function updateConversation(conversationId) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("/api/messages/" + this.user._id).then(function (response) {
        _this3.conversations = response.data;
        _this3.messages = _this3.conversations.find(function (conv) {
          return conv._id == conversationId;
        }).messages;
      });
    },
    updateConversations: function updateConversations(conversationId) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("/api/messages/" + this.user._id).then(function (response) {
        _this4.conversations = response.data;
      });
    },
    openConversation: function openConversation(conversation) {
      this.preview = 1;
      this.conversationId = conversation._id;
      this.conversationBool = true;
      this.messages = conversation.messages;
      this.subject = conversation.subject;
    },
    email: function email(userId) {
      return this.$store.getters.loadSingleUser(userId).email;
    },
    sender: function sender(userIds) {
      if (this.user._id == userIds[0]) return this.$store.getters.loadSingleUser(userIds[1]);else return this.$store.getters.loadSingleUser(userIds[0]);
    },
    previewOrRedirect: function previewOrRedirect(id) {
      if (screen.width > 960) {
        this.preview = id;
      } else {
        this.$router.push("/artefacts/" + id);
      }
    },
    applyTextEdit: function applyTextEdit(index, ev) {
      console.log(ev);

      if (ev.event.target) {
        console.log(ev.event.target.innerHTML);
        this.formUpload.uploads[index].value = ev.event.target.innerHTML;
      }
    },
    provider: function provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";else if (user.hasOwnProperty("google")) return "Google";else if (user.hasOwnProperty("live")) return "Microsoft Live";else return "Local Register";
    }
  },
  watch: {
    term: function term() {
      var _this5 = this;

      this.$search(this.term, this.users, this.UserOptions).then(function (results) {
        _this5.methodResults = results;
        if (_this5.term == "") {
          _this5.methodResults = _this5.users;
        }
      });
    }
  },
  components: {
    quillEditor: __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__["quillEditor"],
    "wb-conversation": __WEBPACK_IMPORTED_MODULE_2__components_Partials_ConversationTemplate_vue__["a" /* default */],
    "wb-new-message": __WEBPACK_IMPORTED_MODULE_3__components_Partials_NewMessage_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "9QXy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArtefact_vue__ = __webpack_require__("wBOt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a2ba0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArtefact_vue__ = __webpack_require__("hZfR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArtefact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a2ba0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArtefact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9T6f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9jGp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A+7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A7oI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"type":"search","placeholder":_vm.placeholder},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ADfN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupSingle_vue__ = __webpack_require__("zDyW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ca10d2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupSingle_vue__ = __webpack_require__("jY1m");
function injectStyle (ssrContext) {
  __webpack_require__("I/sA")
  __webpack_require__("1ghq")
  __webpack_require__("lmfV")
  __webpack_require__("uk87")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ca10d2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupSingle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ca10d2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupSingle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AU3f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-1 pt-3",staticStyle:{"text-align":"right"},attrs:{"xs2":""}},[_c('v-spacer'),_vm._v("\n                        "+_vm._s(_vm._f("date")(_vm.date))+"\n                      ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',{staticClass:"collection-list-ie"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(_vm.user.displayName)}}),_vm._v(" "),(_vm.user.email)?_c('v-list-tile-title',{staticClass:"grey--text text--lighten-1"},[_vm._v(_vm._s(_vm.user.email))]):_c('v-list-tile-title',{staticStyle:{"color":"white"},domProps:{"innerHTML":_vm._s( '  <span class=\'grey--text text--lighten-1\'> Connected with: ' + _vm.provider(_vm.user) + '</span>' )}})],1),_vm._v(" "),( _vm.user.picture)?_c('v-list-tile-avatar',[(_vm.user.picture.url)?_c('img',{attrs:{"src":_vm.user.picture.url+'_profile',"alt":"avatar"}}):_c('img',{attrs:{"src":_vm.user.picture,"alt":"avatar"}})]):_c('v-list-tile-avatar',[_c('img',{staticClass:"avatarImg1",attrs:{"src":__webpack_require__("JpW5"),"alt":""}})])],1)],1),_vm._v(" "),_c('v-container',[_c('div',{staticClass:"pl-4 ma-3 mb-5",staticStyle:{"width":"100%"}},[_c('p',{staticClass:"pl-5 pr-5",staticStyle:{"white-space":"pre-line","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.message)}})])]),_vm._v(" "),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AgIf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Aiq8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__ = __webpack_require__("G0J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highlight_js__ = __webpack_require__("V8mf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_highlight_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FileUpload_file_upload_service__ = __webpack_require__("rG9c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_aplayer__ = __webpack_require__("afmS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_dplayer__ = __webpack_require__("u+Ax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_dplayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_dplayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_medium_editor__ = __webpack_require__("66dk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_medium_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_medium_editor__);




var _watch;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3;
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["formUpload", "lang", "place", "center", "marker", "newLocation"],
  data: function data() {
    var _ref;

    return _ref = {
      datepickerbool: false,
      name: "02-example",
      content: "",
      editorOption: {
        theme: "bubble",
        placeholder: "Type your text",
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ color: [] }, { background: [] }], [{ align: [] }], ["clean"], ["link"]]
        }
      },
      mode: "",
      unsaved: false,
      goToNext: false,
      text: "asdsadas",
      dialog: false,
      options: {
        toolbar: {
          buttons: ["bold", "italic", "underline", "strikethrough", "h4", "h3", "h2", "justifyRight", "justifyLeft", "justifyCenter", "orderedlist", "unorderedlist"]
        },
        anchor: {
          /* These are the default options for anchor form,
           if nothing is passed this is what it used */
          // customClassOption: 'alink',
          // customClassOptionText: 'Button',
          // linkValidation: false,
          // placeholderText: 'YOYOYO',
          // targetCheckbox: false,
          // targetCheckboxText: 'Open in new window'
        }
      },
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      textval: "",
      i: -1,
      valid: true,
      title: "",
      location: "",
      description: "",
      imageUrl: "",
      youtubeLink: "",
      date: new Date(),
      time: new Date(),
      direction: "left",
      direction1: "right",
      fab: false,
      snackbar: false,
      timeout: 6000,

      y: "top",
      x: null
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "mode", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "fling", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "hover", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tabs", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "top", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "right", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "bottom", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "direction2", "right"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "fab2", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "fling2", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "hover2", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tabs2", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "top2", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "right2", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "bottom2", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "left2", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "transition2", "slide-y-reverse-transition"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "player", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "contextmenu", [{
      text: "Download Video",
      link: "https://github.com/MoePlayer/vue-dplayer"
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "fab1", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "fling1", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "hover1", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tabs1", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "top1", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "right1", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "bottom1", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "left1", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "transition1", "slide-y-reverse-transition"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "left", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "transition", "slide-y-reverse-transition"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "select", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tags", ["Programming", "Vue", "Vuex"]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "titleRules", [function (v) {
      return !!v || "Title is required";
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "descriptionRules", [function (v) {
      return !!v || "Description is required";
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectRules", [function (v) {
      return !!v || "Collections are required";
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "uploads", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "btnSubmit", false), _ref;
  },

  watch: (_watch = {
    formUpload: {
      handler: function handler(val, oldVal) {
        this.$emit("changeObj");
      },
      deep: true
    },
    top: function top(val) {
      this.bottom = !val;
    },
    right: function right(val) {
      this.left = !val;
    },
    bottom: function bottom(val) {
      this.top = !val;
    },
    left: function left(val) {
      this.right = !val;
    }
  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, "top", function top(val) {
    this.bottom1 = !val;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, "right", function right(val) {
    this.left1 = !val;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, "bottom", function bottom(val) {
    this.top1 = !val;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, "left", function left(val) {
    this.right1 = !val;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, "top", function top(val) {
    this.bottom2 = !val;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, "right", function right(val) {
    this.left2 = !val;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, "bottom", function bottom(val) {
    this.top2 = !val;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_watch, "left", function left(val) {
    this.right2 = !val;
  }), _watch),
  computed: {
    contentCode: function contentCode() {
      return __WEBPACK_IMPORTED_MODULE_4_highlight_js___default.a.highlightAuto(this.content).value;
    },
    editor: function editor() {
      return this.$refs.myTextEditor.quill;
    },
    isReady: function isReady() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.formUpload.uploads), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var files = _step.value;

          if (files.type != "text") if (!files.data[0]) return false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    token: function token() {
      return this.$store.getters.getToken;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    formIsValid: function formIsValid() {
      return this.formUpload.title[this.lang] !== "" && this.formUpload.description[this.lang] !== "" && this.formUpload.mainImg[0].url != "";
    },
    activeFab: function activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    isContrib: function isContrib() {
      return this.$store.getters.isContrib;
    },
    user: function user() {
      return this.$store.getters.getUser;
    },
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    collections: function collections() {
      return this.$store.getters.loadAllCollections;
    }
  },
  submittableDateTime: function submittableDateTime() {
    var date = new Date(this.date);

    return date;
  },

  methods: {
    newLocationMethod: function newLocationMethod(location) {
      this.formUpload.location = location;
      this.$emit("newLocation", location);
    },
    changeContent: function changeContent(value) {
      value = this.contentCode;
      console.log("am intrat in functie");
    },
    onEditorChange: function onEditorChange(_ref2) {
      var editor = _ref2.editor,
          html = _ref2.html,
          text = _ref2.text;

      console.log("editor change!", editor, html, text);
      this.content = "";
      this.content = html;
    },
    leaving: function leaving() {
      alert("Leaving...");
    },
    deleteUpload: function deleteUpload(position) {
      var index = this.formUpload.uploads.indexOf(position);

      this.formUpload.uploads.splice(position, 1);
    },
    addTextToUploads: function addTextToUploads() {
      this.unsaved = true;
      this.i++;
      var data = {
        position: this.i,
        positionRef: "ref" + this.i,
        type: "text",
        status: 0,
        loading: false,
        key: "",
        value: {
          en: "",
          sr: "",
          ro: ""
        }
      };
      this.formUpload.uploads.push(data);
    },
    addImageToUploads: function addImageToUploads() {
      this.unsaved = true;
      this.i++;
      var data = {
        position: this.i,
        positionRef: "ref" + this.i,
        type: "image",
        status: 0,
        loading: false,
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    addPdfToUploads: function addPdfToUploads() {
      this.unsaved = true;
      this.i++;
      var data = {
        position: this.i,
        positionRef: "ref" + this.i,
        status: 0,
        loading: false,
        type: "pdf",
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    addAudioToUploads: function addAudioToUploads() {
      this.unsaved = true;
      this.i++;
      var data = {
        status: 0,
        loading: false,
        position: this.i,
        positionRef: "ref" + this.i,
        type: "audio",
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    play: function play() {
      console.log("play callback");
    },
    addVideoToUploads: function addVideoToUploads() {
      this.unsaved = true;
      this.i++;
      var data = {
        position: this.i,
        positionRef: "ref" + this.i,
        type: "video",
        status: 0,
        loading: false,
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    clickInput: function clickInput(position) {
      var element = document.getElementById(position);
      element.click();
    },
    clickInputMain: function clickInputMain() {
      this.$refs.fileInput1.click();
    },
    reset: function reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save: function save(formData, position) {
      var _this = this;

      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      if (position == -1) this.formUpload.mainImg[0].loading = true;else this.formUpload.uploads[position].loading = true;
      this.unsaved = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__components_FileUpload_file_upload_service__["a" /* upload */])(formData, this.user._id).then(function (x) {
        if (position == -1) {
          _this.formUpload.mainImg = x;
          _this.formUpload.mainImg[0].status = 1;
          _this.formUpload.mainImg[0].loading = false;
        } else {
          if (x[0].originalName.includes(".pdf")) {
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get("/api/images/pdf/" + x[0].id).then(function (data) {
              _this.formUpload.pdfText = _this.formUpload.pdfText.concat(data.data);
            });
          }
          _this.formUpload.uploads[position].data = x;
          _this.formUpload.uploads[position].status = 1;
          _this.formUpload.uploads[position].loading = false;
        }
        _this.currentStatus = STATUS_SUCCESS;
      }).catch(function (err) {
        _this.uploadError = err.response;
        _this.currentStatus = STATUS_FAILED;
      });
    },
    filesChange: function filesChange(fieldName, fileList, position) {
      // handle file changes
      var formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });

      // save it
      this.save(formData, position);
    },
    onCreateArtefact: function onCreateArtefact() {
      this.formUpload.meta.author = this.user.displayName;
      this.$emit("createMaybe");
    },
    moveButton: function moveButton(admin) {
      // if (admin) {
      //   var btn = document.getElementsByClassName("bottom_button");
      //   foreach ( var b in btn){
      //   b.style.bottom = "65px";
      //   }
      // } else {
      //   var btn = document.getElementsByClassName("bottom_button");
      //   for(b in btn){
      //   b.style.bottom = "15px";
      //   }
      // }
    },
    applyTextEdit: function applyTextEdit(index, ev) {
      if (ev.event.target) {
        console.log(ev.event.target.innerHTML);
        this.formUpload.uploads[index].value = ev.event.target.innerHTML;
      }
    }
  },
  created: function created() {
    if (!this.isAdmin && !this.isContrib && !this.isMod) this.$router.push("/");
    this.moveButton(this.isAdmin);
  },
  mounted: function mounted() {
    document.title = "Add Artefact";
    window.scrollTo(0, 0);
    this.$store.dispatch("loadCollections");
    this.moveButton(this.isAdmin);
    this.reset();
    window.addEventListener("beforeunload", this.leaving);
  },

  components: {
    "a-player": __WEBPACK_IMPORTED_MODULE_6_vue_aplayer__["a" /* default */],
    "d-player": __WEBPACK_IMPORTED_MODULE_7_vue_dplayer___default.a,
    "medium-editor": __WEBPACK_IMPORTED_MODULE_9_vue2_medium_editor___default.a,
    quillEditor: __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__["quillEditor"]
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.unsaved) {
      var answer = window.confirm("Do you really want to leave? you have unsaved changes!");
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
});

/***/ }),

/***/ "BBKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ByAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__ = __webpack_require__("iwI9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000965df_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__ = __webpack_require__("koON");
function injectStyle (ssrContext) {
  __webpack_require__("gsKj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-000965df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000965df_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CFDl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"hidden-xs-only",staticStyle:{"height":"50px"}}),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",staticStyle:{"position":"relative"},attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-layout',{staticStyle:{"background-color":"white"},attrs:{"elevation-3":""}},[_c('v-flex',{staticStyle:{"height":"100%"},attrs:{"xs12":"","md4":"","sm6":""}},[_c('v-tabs',{attrs:{"fixed":"","centered":""}},[_c('v-tabs-bar',{staticClass:"primary",staticStyle:{"height":"6vh"},attrs:{"dark":""}},[_c('v-tabs-slider',{staticClass:"yellow"}),_vm._v(" "),_c('v-tabs-item',{attrs:{"href":"#tab-Read"},on:{"click":function($event){_vm.preview=0}}},[_c('p',{staticClass:"mb-0",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].messaging.tabRead))])]),_vm._v(" "),_c('v-tabs-item',{attrs:{"href":"#tab-Write"},on:{"click":function($event){_vm.preview=2}}},[_c('p',{staticClass:"mb-0",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].messaging.tabWrite))])])],1),_vm._v(" "),_c('v-tabs-items',[_c('v-tabs-content',{attrs:{"id":"tab-Read"}},[_c('v-list',[_c('wb-new-message',{attrs:{"users":_vm.users}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('v-list',{staticClass:"pt-0",attrs:{"three-line":""}},[_vm._l((_vm.conversations),function(conversation,i){return _c('div',{key:i},[_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.openConversation(conversation)}}},[(_vm.sender(conversation.userIds).picture)?_c('v-list-tile-avatar',[(_vm.sender(conversation.userIds).picture.url)?_c('img',{attrs:{"src":_vm.sender(conversation.userIds).picture.url+'_profile',"alt":"avatar"}}):_c('img',{attrs:{"src":_vm.sender(conversation.userIds).picture,"alt":"avatar"}})]):_c('v-list-tile-avatar',[_c('img',{staticClass:"avatarImg1",attrs:{"src":__webpack_require__("JpW5"),"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie mt-4"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(_vm.sender(conversation.userIds).displayName)}}),_vm._v(" "),_c('v-list-tile-sub-title',[_c('b',[_vm._v(_vm._s(conversation.subject))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.strip(conversation.messages[conversation.messages.length-1].message).slice(0,30))+"...")])],1)],1)],1)})],2)],1)],1)],1)],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"tab-Write"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('v-list',{staticClass:"pt-0",attrs:{"three-line":""}},[_c('v-text-field',{staticClass:"searchBar ",attrs:{"append-icon":"search","label":"Input a user name","hide-details":""},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}}),_vm._v(" "),[_vm._l((_vm.methodResults),function(user,i){return _c('div',{key:i},[_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-checkbox',{on:{"change":function($event){_vm.addUser(user._id)}},model:{value:(user.selected),callback:function ($$v) {_vm.$set(user, "selected", $$v)},expression:"user.selected"}})],1),_vm._v(" "),( user.picture)?_c('v-list-tile-avatar',[(user.picture.url)?_c('img',{attrs:{"src":user.picture.url+'_profile',"alt":"avatar"}}):_c('img',{attrs:{"src":user.picture,"alt":"avatar"}})]):_c('v-list-tile-avatar',[_c('img',{staticClass:"avatarImg1",attrs:{"src":__webpack_require__("JpW5"),"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(user.displayName)}}),_vm._v(" "),_c('v-list-tile-sub-title',[_c('b',[_vm._v(_vm._s(user.email))])])],1)],1)],1)}),_vm._v(" "),_c('v-btn',{staticClass:"mt-5 hidden-md-and-up",attrs:{"color":"primary"},on:{"click":function($event){_vm.NewMessageBool=true}}},[_vm._v(" Send")])]],2)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{staticClass:"hidden-md-and-up",attrs:{"fullscreen":""},model:{value:(_vm.checkIfMobile),callback:function ($$v) {_vm.checkIfMobile=$$v},expression:"checkIfMobile"}},[_c('v-flex',{staticStyle:{"margin-top":"98px","margin-bottom":"70px"},attrs:{"md8":""}},[(_vm.preview==0)?_c('v-container',{staticClass:"beginningContainer pa-5",attrs:{"fluid":""}},[_c('h5',[_c('i',[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].messaging.preview)+" frgefvdax")])])]):_vm._e(),_vm._v(" "),(_vm.selectedUsers.length==0 && _vm.preview == 2)?_c('v-container',{staticClass:"beginningContainer pa-5",attrs:{"fluid":""}},[_c('h5',[_c('i',[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].messaging.selectUsers)+" ")])])]):_vm._e(),_vm._v(" "),(_vm.conversationBool && _vm.preview == 1)?_c('wb-conversation',{attrs:{"subject":_vm.subject,"messages":_vm.messages,"conversationId":_vm.conversationId},on:{"newMessage":function($event){_vm.updateConversation($event)},"closed":function($event){_vm.conversationBool = false}}}):_vm._e(),_vm._v(" "),(_vm.selectedUsers.length>0 && _vm.preview == 2)?_c('v-container',{staticClass:"beginningContainer pa-0 pl-3 pr-4",attrs:{"fluid":""}},[_c('div',{staticClass:"pt-5 pl-5"},[_c('p',{staticClass:"title"},[_vm._v("To:")]),_vm._v(" "),_vm._l((_vm.selectedUsers),function(user){return _c('span',{key:user,staticClass:"pt-5"},[_vm._v(_vm._s(_vm.email(user))+"  ")])})],2),_vm._v(" "),_c('v-text-field',{staticStyle:{"height":"6vh"},attrs:{"name":"input-1-3","label":"Subject","single-line":"","light":"","required":"","prepend-icon":"chat"},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3 mt-4",attrs:{"xs12":"","sm12":""}},[_c('quill-editor',{ref:"myTextEditor",staticClass:"editor-example snow",attrs:{"options":_vm.editorOption},model:{value:(_vm.newMessage),callback:function ($$v) {_vm.newMessage=$$v},expression:"newMessage"}})],1),_vm._v(" "),_c('v-layout',{staticClass:"pt-3",attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mt-5",attrs:{"color":"primary"},on:{"click":_vm.sendMessage}},[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].messaging.send)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("send")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-5 hidden-md-and-up",attrs:{"color":"primary"},on:{"click":function($event){_vm.NewMessageBool=false}}},[_vm._v(" close")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-xs-only",attrs:{"md8":""}},[(_vm.preview==0)?_c('v-container',{staticClass:"beginningContainer pa-5",attrs:{"fluid":""}},[_c('h5',[_c('i',[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].messaging.preview)+" ")])])]):_vm._e(),_vm._v(" "),(_vm.selectedUsers.length==0 && _vm.preview == 2)?_c('v-container',{staticClass:"beginningContainer pa-5",attrs:{"fluid":""}},[_c('h5',[_c('i',[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].messaging.selectUsers)+" ")])])]):_vm._e(),_vm._v(" "),(_vm.conversationBool && _vm.preview == 1)?_c('wb-conversation',{attrs:{"subject":_vm.subject,"messages":_vm.messages,"conversationId":_vm.conversationId},on:{"newMessage":function($event){_vm.updateConversation($event)},"closed":function($event){_vm.conversationBool = false}}}):_vm._e(),_vm._v(" "),(_vm.selectedUsers.length>0 && _vm.preview == 2)?_c('v-container',{staticClass:"beginningContainer pa-0 pl-3 pr-4",attrs:{"fluid":""}},[_c('div',{staticClass:"pt-5 pl-5"},[_c('p',{staticClass:"title"},[_vm._v("To:")]),_vm._v(" "),_vm._l((_vm.selectedUsers),function(user){return _c('span',{key:user,staticClass:"pt-5"},[_vm._v(_vm._s(_vm.email(user))+"  ")])})],2),_vm._v(" "),_c('v-text-field',{staticStyle:{"height":"6vh"},attrs:{"name":"input-1-3","label":"Subject","single-line":"","light":"","required":"","prepend-icon":"chat"},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3 mt-4",attrs:{"xs12":"","sm12":""}},[_c('quill-editor',{ref:"myTextEditor",staticClass:"editor-example snow",attrs:{"options":_vm.editorOption},model:{value:(_vm.newMessageQuill),callback:function ($$v) {_vm.newMessageQuill=$$v},expression:"newMessageQuill"}})],1),_vm._v(" "),_c('v-layout',{staticClass:"pt-3",attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mt-5",attrs:{"color":"primary"},on:{"click":_vm.sendMessage}},[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].messaging.send)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("send")])],1)],1)],1):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CM8P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cn9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collections_vue__ = __webpack_require__("yd+f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45efe0ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Collections_vue__ = __webpack_require__("Y23B");
function injectStyle (ssrContext) {
  __webpack_require__("OXVe")
  __webpack_require__("Z8HW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45efe0ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Collections_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45efe0ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Collections_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CqXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'pa-0 ma-0 background-container' : _vm.getScreenWidth() < 900, ' background-container-md' : _vm.getScreenWidth() > 900},staticStyle:{"height":"100vh","width":"100%","max-width":"100%"},attrs:{"xs12":"","sm10":"","md4":"","offset-md3":"","offset-sm2":""}},[_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"justify-center":""}},[_c('h4',{staticStyle:{"color":"grey"}},[_vm._v("Sign Up")])]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"ml-2 mr-2",attrs:{"sm8":"","md4":""}},[_c('v-layout',{staticStyle:{"background-color":"white","border-radius":"2px"},attrs:{"justify-center":"","elevation-2":""}},[_c('form',{staticStyle:{"width":"94%"}},[(_vm.errorMessage != '')?_c('p',{staticClass:"mt-4 caption red--text text--darken-4"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-1","label":_vm.gLang[_vm.lang].myAccount.username,"id":"testing","error-messages":_vm.nameErrors,"required":""},on:{"input":function($event){_vm.$v.name.$touch()},"blur":function($event){_vm.$v.name.$touch()}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"E-mail","error-messages":_vm.emailErrors,"required":""},on:{"input":function($event){_vm.$v.email.$touch()},"blur":function($event){_vm.$v.email.$touch()},"keydown":function($event){_vm.errorMessage=''}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-10-1","label":_vm.gLang[_vm.lang].myAccount.password,"type":"password","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){_vm.$v.password.$touch()},"blur":function($event){_vm.$v.password.$touch()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-10-1","label":_vm.gLang[_vm.lang].myAccount.repeatPassword,"type":"password","error-messages":_vm.repeatPasswordErrors,"required":""},on:{"input":function($event){_vm.$v.repeatPassword.$touch()},"blur":function($event){_vm.$v.repeatPassword.$touch()}},model:{value:(_vm.repeatPassword),callback:function ($$v) {_vm.repeatPassword=$$v},expression:"repeatPassword"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":_vm.gLang[_vm.lang].signIn.termaConditionsAccept,"required":"","error-messages":_vm.checkboxErrors},on:{"input":function($event){_vm.$v.checkbox.$touch()},"blur":function($event){_vm.$v.checkbox.$touch()}},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.loading},on:{"click":function($event){_vm.clickInputMain()}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.profileImage)+"\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput1",staticClass:"input-file",staticStyle:{"display":"none"},attrs:{"type":"file","name":"avatar","disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, -1); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"red ",attrs:{"dark":"","disabled":_vm.loading},on:{"click":_vm.submit}},[_vm._v("\n                     Sign up\n                 ")])],1)],1)]),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","justify-center":""}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"xs10":"","offset-xs1":"","sm6":"","offset-sm3":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('a',{staticClass:"terms ",attrs:{"href":""}},[_vm._v("Terms And Conditions  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"terms"},[_vm._v("|")]),_vm._v(" "),_c('a',{staticClass:"terms",attrs:{"href":""}},[_vm._v("   Privacy Policy")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('p',{staticClass:"terms "},[_vm._v("LOGO ©2017")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"mt-3",attrs:{"xs10":"","sm6":"","md3":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"width":"100%","background-color":"#3b5998"},attrs:{"dark":""},on:{"click":function($event){_vm.authenticate('facebook')}}},[_c('img',{staticClass:"socialImage mr-2",attrs:{"src":__webpack_require__("p8ve"),"alt":""}}),_vm._v("\n                      "+_vm._s(_vm.gLang[_vm.lang].signIn.signInFb)+"\n                  ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"width":"100%","background-color":"#dd4b39"},attrs:{"dark":""},on:{"click":function($event){_vm.authenticate('google')}}},[_c('img',{staticClass:"socialImage mr-2",attrs:{"src":__webpack_require__("+RHE"),"alt":""}}),_vm._v("\n                      "+_vm._s(_vm.gLang[_vm.lang].signIn.signInG)+"\n                  ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"width":"100%","background-color":"#2672EC"},attrs:{"dark":""},on:{"click":function($event){_vm.authenticate('live')}}},[_c('img',{staticClass:"socialImage mr-2",attrs:{"src":__webpack_require__("VjV7"),"alt":""}}),_vm._v("\n                      "+_vm._s(_vm.gLang[_vm.lang].signIn.signInM)+"\n                  ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CzZM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return upload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__ = __webpack_require__("OEKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

// file-upload.service.js




var BASE_URL = __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__["IP_ADRESS"];

function upload(formData) {
  var url = BASE_URL + 'api/profile';
  return __WEBPACK_IMPORTED_MODULE_2_axios__["post"](url, formData)
  // get data
  .then(function (x) {
    return x.data;
  })
  // add url field
  .then(function (x) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, x, { url: '/api/images/' + x.id });
  });
}



/***/ }),

/***/ "D6TK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading == true)?_c('v-container',[_c('div',{attrs:{"id":"fb-root"}}),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"white-widget grey-bg author-area"},[_c('div',{staticClass:"auth-info row"},[_c('div',{staticClass:"timeline-wrapper"},[_c('div',{staticClass:"timeline-item"},[_c('div',{staticClass:"animated-background"},[_c('div',{staticClass:"background-masker header-top"}),_vm._v(" "),_c('div',{staticClass:"background-masker header-left"}),_vm._v(" "),_c('div',{staticClass:"background-masker header-right"}),_vm._v(" "),_c('div',{staticClass:"background-masker header-bottom"})])])])])])])],1):_c('v-container',{staticClass:"mb-5 pa-0",staticStyle:{"background-color":"#FAFAFA"},attrs:{"fluid":""}},[_c('div',{staticClass:"hidden-sm-and-down header_gray",staticStyle:{"position":"fixed","height":"30vh","width":"100vw"}}),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('v-card',{attrs:{"dark":""}},[_c('v-card-media',{staticClass:"white--text",class:{'largeScreenHeight' : _vm.getScreenWidth() > 900, 'smallScreenHeight' : _vm.getScreenWidth() < 900},attrs:{"src":_vm.artefact.mainImg[0].url+'_single'}},[_c('div',{staticClass:"mainImg-overlay"}),_vm._v(" "),_c('v-container',{staticClass:"pr-1 pl-1",attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{staticClass:"media",attrs:{"fill-height":"","column":""}},[_c('v-card-actions',[_c('v-layout',{attrs:{"row":""}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("view_carousel")]),_vm._v(" "),_c('v-icon',{staticClass:"ml-3",attrs:{"dark":""}},[_vm._v("remove_red_eye")]),_c('p',{staticStyle:{"font-size":"16px","margin-left":"6px","padding-top":"15px"}},[_vm._v(_vm._s(_vm.artefact.uniqueVisits.length))])],1),_vm._v(" "),(_vm.isAdmin && _vm.isAccepted)?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":"","to":'/artefacts/edit/' + _vm.artefact._id}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.delete))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnno))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnyes))])],1)],1)],1)],1):((_vm.isAdmin && !_vm.isAccepted) || (_vm.isMod && !_vm.isAccepted) )?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.acceptArtefact}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("check_circle")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":"","to":'/artefacts/edit/' + _vm.artefact._id}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.delete))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnno))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnyes))])],1)],1)],1)],1):(!_vm.isAdmin && !_vm.isAccepted )?_c('v-layout',[_c('v-spacer')],1):(!_vm.isAdmin && _vm.isAccepted && _vm.isAuthor )?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":"","to":'/artefacts/edit/' + _vm.artefact._id}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.delete))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnno))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnyes))])],1)],1)],1)],1):(!_vm.isAdmin && _vm.isAccepted && !_vm.isAuthor && _vm.isLoggedIn )?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1)],1):(!_vm.isAdmin && _vm.isAccepted && !_vm.isAuthor && !_vm.isLoggedIn )?_c('v-layout',[_c('v-spacer')],1):_vm._e()],1),_vm._v(" "),_c('v-card-title',[_c('v-layout',[_c('v-list-tile-content',[_c('div',{staticClass:"v-list-tile-content"},[_c('v-list-tile-title',{staticClass:"display-1 v-list-tile-title"},[_vm._v(_vm._s(_vm.artefact.title[_vm.lang].toUpperCase()))]),_vm._v(" "),_vm._l((_vm.users),function(user){return (user._id == _vm.artefact.userId )?_c('v-list-tile-sub-title',{key:user._id,staticClass:"pb-2 pt-2 caption"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.addedBy)+" "+_vm._s(user.displayName)+" at "+_vm._s(_vm._f("date")(_vm.artefact.meta.creationDate))+" ")]):_vm._e()}),_vm._v(" "),_c('hr',{attrs:{"width":"100%"}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"pb-2 pt-2 caption"},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.artefact.collectionId),function(col,i){return (i<7 && _vm.getLanguageTranslation(col)!=false)?_c('span',{key:i},[_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.goToCollectionByName(col)}}},[_vm._v("   "),_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("label")]),_vm._v(_vm._s(_vm.getLanguageTranslation(col)))],1)]):_vm._e()}))],1)],2)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"hidden-sm-and-down addBorder",staticStyle:{"background-color":"white"},attrs:{"flat":""}},[_c('v-card-text',{staticClass:"pr-0 pl-0"},[_c('div',{staticClass:"description pa-3"},[_c('p',[_vm._v(_vm._s(_vm.artefact.description[_vm.lang]))])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.artefact.uploads),function(media){return _c('div',{key:media._id,staticClass:"div1"},[(media.type ==='image')?_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('div',{staticClass:" position:relative"},[_c('img',{staticClass:"img1",attrs:{"src":media.data[0].url+'_single',"alt":""}})])]):(media.type === 'video')?_c('v-flex',{staticClass:"mt-3 mb-3",attrs:{"elevation-1":"","xs12":"","sm12":""}},[_c('v-card',[_c('div',[_c('v-card-media',[_c('v-layout',{attrs:{"justify-center":""}},[_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"src":media.data[0].url + '.mp4',"type":"video/mp4"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url + '.webm',"type":"video/webm"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url + '.m4v',"type":"video/m4v"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url + '.ogg',"type":"video/ogg"}}),_vm._v("\nYour browser does not support the video tag.\n")])])],1)],1)])],1):(media.type === 'audio')?_c('v-flex',{class:{ 'noBoxShadow' : _vm.getScreenWidth() > 900, 'mt-3 mb-3 img1' : true},attrs:{"xs12":""}},[(media.data.length != 0)?_c('div',{},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-layout',{staticClass:"pa-1",staticStyle:{"background-color":"#FAFAFA"},attrs:{"row":"","elevation-3":""}},[_c('div',{staticStyle:{"width":"100%","background-color":"#FAFAFA"}},[_c('v-layout',{staticStyle:{"width":"100%","white-space":"normal"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',[_c('i',[_vm._v(_vm._s(media.data[0].originalName))])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('audio',{staticStyle:{"width":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"src":media.data[0].url,"type":"audio/ogg"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url,"type":"audio/mpeg"}}),_vm._v("\n                                "+_vm._s(_vm.gLang[_vm.lang].artefactSingle.browser)+"\n                    ")])])],1)],1)])],1)],1)],1):_vm._e()]):(media.type === 'pdf')?_c('v-flex',{class:{ 'noBoxShadow' : _vm.getScreenWidth() > 900, 'mr-0  mt-2 mb-2  flex1' : true},attrs:{"xs12":"","sm12":""}},[(media.data.length != 0)?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md6":"","offset":""}},[_c('v-card',{staticStyle:{"box-shadow":"none","border-bottom":"1px solid #efefef"}},[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"blue white--text pt-2"},[_vm._v(" picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(media.data[0].originalName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("date")(_vm.artefact.meta.creationDate)))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"href":media.data[0].url,"download":"","icon":"","ripple":""}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","ripple":""},on:{"click":function($event){_vm.viewPDF = !_vm.viewPDF}}},[(!_vm.viewPDF)?_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("visibility")]):_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("visibility_off")])],1)],1)],1)],1),_vm._v(" "),(_vm.viewPDF)?_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":'http://docs.google.com/viewer?url=' + 'hera.uvt.ro' +  media.data[0].url   +  '.pdf' + '&embedded=true',"width":"600","height":"780"}}):_vm._e()],1)],1)],1)],1):_vm._e()]):(media.type === 'text')?_c('v-flex',{staticClass:"mt-2 mb-2 mr-1 ml-1 pt-1 pb-1",attrs:{"xs12":"","sm12":""}},[_c('div',{},[_c('div',{staticClass:"description pt-3 pl-3 pr-3 pb-0"},[_c('p',{staticStyle:{"word-break":"break-all"},domProps:{"innerHTML":_vm._s(media.value[_vm.lang])}})])])]):_vm._e()],1)})),_vm._v(" "),(_vm.isMod||_vm.isContrib)?_c('v-speed-dial',{staticClass:"app-vue-speeddial",attrs:{"id":"bottom_button","top":_vm.top,"bottom":_vm.bottom,"right":_vm.right,"left":_vm.left,"direction":_vm.direction,"hover":_vm.hover,"transition":_vm.transition,"fixed":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"primary","dark":"","fab":"","hover":"","to":"/artefacts/new"},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e()],1),_vm._v(" "),_c('web-location-present-single',{attrs:{"location":_vm.artefact.location}})],1),_vm._v(" "),_c('web-location-tab',{staticClass:"hidden-md-and-up ",attrs:{"artefact":_vm.artefact,"isCollection":false}},[_c('div',{staticClass:"description pa-3"},[_c('p',[_vm._v(_vm._s(_vm.artefact.description[_vm.lang]))])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.artefact.uploads),function(media){return _c('div',{key:media._id,staticClass:"div1"},[(media.type ==='image')?_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('div',{staticClass:" position:relative"},[_c('img',{staticClass:"img1",attrs:{"src":media.data[0].url+'_single',"alt":""}})])]):(media.type === 'video')?_c('v-flex',{staticClass:"mt-3 mb-3",attrs:{"elevation-1":"","xs12":"","sm12":""}},[_c('v-card',[_c('div',[_c('v-card-media',[_c('div',{},[_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"src":media.data[0].url + '.mp4',"type":"video/mp4"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url + '.webm',"type":"video/webm"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url + '.m4v',"type":"video/m4v"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url + '.ogg',"type":"video/ogg"}}),_vm._v("\nYour browser does not support the video tag.\n")])])])],1)])],1):(media.type === 'audio')?_c('v-flex',{class:{ 'noBoxShadow' : _vm.getScreenWidth() > 900, 'mt-3 mb-3 img1' : true},attrs:{"elevation-1":"","xs12":"","sm12":""}},[(media.data.length != 0)?_c('div',{staticClass:"ma-1 pa-3"},[_c('v-layout',{class:{ 'noBoxShadow' : _vm.getScreenWidth() > 900, 'pa-1' : true},staticStyle:{"background-color":"#FAFAFA"},attrs:{"row":"","elevation-3":""}},[_c('div',{staticStyle:{"width":"100%","background-color":"#FAFAFA"}},[_c('v-layout',{staticStyle:{"width":"100%","white-space":"normal"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',[_c('i',[_vm._v(_vm._s(media.data[0].originalName))])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('audio',{staticClass:"audioPlayer",staticStyle:{"width":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"src":media.data[0].url,"type":"audio/ogg"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url,"type":"audio/mpeg"}}),_vm._v("\n                                "+_vm._s(_vm.gLang[_vm.lang].artefactSingle.browser)+"\n                    ")])])],1)],1)])],1):_vm._e()]):(media.type === 'pdf')?_c('v-flex',{staticClass:"  mt-2 mb-2 ml-1 mr-1",attrs:{"xs12":"","sm12":""}},[(media.data.length != 0)?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md6":"","offset":""}},[_c('v-card',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"blue white--text pt-2"},[_vm._v(" picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(media.data[0].originalName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("date")(_vm.artefact.meta.creationDate)))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"href":media.data[0].url,"download":"","icon":"","ripple":""}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","ripple":""},on:{"click":function($event){_vm.viewPDF = !_vm.viewPDF}}},[(!_vm.viewPDF)?_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("visibility")]):_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("visibility_off")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[(_vm.viewPDF)?_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":'http://docs.google.com/viewer?url=' + 'hera.uvt.ro' + media.data[0].url  +  '.pdf' + '&embedded=true',"width":"320","height":"450"}}):_vm._e()])],1)],1)],1)],1):_vm._e()]):(media.type === 'text')?_c('v-flex',{staticClass:"mt-2 mb-2 mr-1 ml-1 pt-1 pb-1",attrs:{"xs12":"","sm12":""}},[_c('div',{},[_c('div',{staticClass:"description pt-3 pl-3 pr-3 pb-0"},[_c('p',{domProps:{"innerHTML":_vm._s(media.value[_vm.lang])}})])])]):_vm._e()],1)})),_vm._v(" "),(_vm.isMod||_vm.isContrib)?_c('web-speed-dial-add'):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DOhX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_swiper_css__ = __webpack_require__("s1hA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      previewArtefact: "",
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOption1: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOption2: {
        slidesPerView: 2,
        spaceBetween: 30,
        loop: true,
        centeredSlides: false,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiper: null
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
  },
  computed: {
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    users: function users() {
      return this.$store.getters.loadUsers;
    },
    description: function description() {
      var artefact = document.getElementsByClassName("swiper-slide-active");
    }
  },
  mounted: function mounted() {
    this.swiper = this.$refs.mySwiperA.swiper;
  }
});

/***/ }),

/***/ "DWUQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtefactCardMini_vue__ = __webpack_require__("Wrd8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c55afa38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtefactCardMini_vue__ = __webpack_require__("Mmyn");
function injectStyle (ssrContext) {
  __webpack_require__("GK/I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c55afa38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtefactCardMini_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c55afa38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtefactCardMini_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DZmE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DcYv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pa-3 map",attrs:{"elevation-1":""}},[_c('Gmap-Map',{ref:"map",staticStyle:{"width":"100%","height":"300px"},attrs:{"zoom":14,"center":_vm.center}},_vm._l((_vm.allRelated),function(marker){return _c('Gmap-Marker',{key:marker.location.place_id,attrs:{"position":marker.location.geometry.location,"clickable":true,"draggable":false},on:{"click":function($event){marker.opened = !marker.opened}}},[_c('gmap-info-window',{attrs:{"opened":marker.opened}},[_c('h6',[_vm._v(_vm._s(marker.title))]),_vm._v(" "),_c('img',{attrs:{"src":marker.mainImg[0].url,"alt":"","height":"60px"}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('p',[_vm._v(_vm._s(marker.description))])],1)],1)}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dx0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Links_vue__ = __webpack_require__("3mok");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a25072c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Links_vue__ = __webpack_require__("u+QE");
function injectStyle (ssrContext) {
  __webpack_require__("K5IR")
  __webpack_require__("qcsk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a25072c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Links_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a25072c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Links_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EEv3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slick',{ref:"slick",attrs:{"options":_vm.slickOptions}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FFvd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fo6k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresentMultipleLocations_vue__ = __webpack_require__("oH/t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47cd9f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PresentMultipleLocations_vue__ = __webpack_require__("bPGr");
function injectStyle (ssrContext) {
  __webpack_require__("MR55")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresentMultipleLocations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47cd9f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PresentMultipleLocations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fy7I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newLocation: true,
      center: { lat: 45.76204321990797, lng: 21.24094273988112 },
      marker: {
        position: { lat: 45.76204321990797, lng: 21.24094273988112 }
      },
      place: {
        formatted_address: ""
      },
      dialogOpen: false,
      formUpload: {
        pdfText: "",
        title: {
          en: "",
          ro: "",
          sr: ""
        },
        mainImg: [{
          fileName: "",
          id: "",
          originalName: "",
          url: ""
        }],
        description: {
          en: "",
          ro: "",
          sr: ""
        },
        location: "",
        meta: {
          title: {
            en: "",
            ro: "",
            sr: ""
          },
          description: {
            en: "",
            ro: "",
            sr: ""
          },
          location: {},
          author: "",
          type: "article",
          copyright: "",
          license: ""
        },
        uploads: [],
        collectionId: [],
        reviewed: false,
        userId: ""
      },
      en: true,
      sr: false,
      ro: false,
      addedEn: false,
      addedSr: false,
      addedRo: false
    };
  },

  methods: {
    showEnglish: function showEnglish(lang) {
      this.formUpload.title[lang] = this.formUpload.title.en;
      this.formUpload.description[lang] = this.formUpload.description.en;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.formUpload.uploads), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var media = _step.value;

          if (media.type == "text") media.value[lang] = media.value.en;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    openDialog: function openDialog() {
      this.dialogOpen = true;
    },
    createArtefact: function createArtefact() {
      var _this = this;

      this.dialogOpen = false;
      if (this.isAdmin || this.user.role == "Moderator") this.formUpload.reviewed = true;else this.formUpload.reviewed = false;
      this.formUpload.userId = this.user._id;
      if (this.rulesEn && !this.rulesRo) this.showEnglish("ro");
      if (this.rulesEn && !this.rulesSr) this.showEnglish("sr");
      this.$store.dispatch("createArtefact", this.formUpload).then(function (response) {
        _this.$router.push("/artefacts/" + response.data._id);
      }, function (error) {});
    },
    checkTextFields: function checkTextFields(lang) {
      var ok = true;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.formUpload.uploads), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var media = _step2.value;

          if (media.type == "text" && media.value[lang] == "") ok = false;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return ok;
    },
    changeEn: function changeEn(obj) {
      this.formUpload = obj;
      this.addedEn = true;
    },
    changeSr: function changeSr(obj) {
      this.formUpload = obj;
      this.addedSr = true;
    },
    changeRo: function changeRo(obj) {
      this.formUpload = obj;
      this.addedRo = true;
    },
    srm: function srm() {
      this.sr = true;
      this.en = false;
      this.ro = false;
    },
    rom: function rom() {
      this.ro = true;
      this.en = false;
      this.sr = false;
    },
    enm: function enm() {
      this.en = true;
      this.sr = false;
      this.ro = false;
    }
  },
  computed: {
    rulesEn: function rulesEn() {
      return this.formUpload.title.en != "" && this.formUpload.description.en != "" && this.formUpload.collectionId.length > 0 && this.checkTextFields("en");
    },
    rulesRo: function rulesRo() {
      return this.formUpload.title.ro != "" && this.formUpload.description.ro != "" && this.formUpload.collectionId.length > 0 && this.checkTextFields("ro");
    },
    rulesSr: function rulesSr() {
      return this.formUpload.title.sr != "" && this.formUpload.description.sr != "" && this.formUpload.collectionId.length > 0 && this.checkTextFields("sr");
    },
    checkLanguages: function checkLanguages() {
      if (this.addedEn | this.addedSr | this.addedRo) return false;else return true;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    isContrib: function isContrib() {
      return this.$store.getters.isContrib;
    },
    user: function user() {
      return this.$store.getters.getUser;
    }
  }
});

/***/ }),

/***/ "G+/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:{ 'show' : !_vm.opened},staticStyle:{"width":"300px"}},[_c('v-card-media',{staticClass:"white--text",attrs:{"height":"200px","src":_vm.marker.mainImg[0].url+'_card'}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs10":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.marker.title[_vm.lang]))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"small":"","fab":"","flat":""},on:{"click":_vm.close}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-title',[_c('div',[_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.minimize(_vm.marker.description[_vm.lang],20)))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.marker.location.formatted_address))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange","to":'/artefacts/'+_vm.marker._id}},[_vm._v("Explore")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G9TA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePersonalInfo_vue__ = __webpack_require__("ZXxQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1982b9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePersonalInfo_vue__ = __webpack_require__("fYaq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePersonalInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1982b9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePersonalInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GK/I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GLjB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GOUv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FileUpload_file_upload_service__ = __webpack_require__("rG9c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      direction: "left",
      preview: 0,
      previewCollection: {
        title: {
          en: "",
          ro: "",
          sr: ""
        }
      },
      methodResults: [],
      term: "",
      defaultAllToggle: false,
      options: {
        keys: ["title"]
      },
      fab: false,
      snackbar: false,
      y: 'top',
      x: null,
      mode: '',
      timeout: 6000,
      fling: false,
      hover: false,
      tabs: null,
      top: false
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "snackbar", ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "timeout", 6000), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "right", true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "bottom", true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "left", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "transition", "slide-y-reverse-transition"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "edit", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialog", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "uploadAdd", {
      title: {
        en: "",
        ro: "",
        sr: ""
      },
      description: {
        en: "",
        sr: "",
        ro: ""
      },
      imgUrl: [{ url: "" }],
      location: {},
      meta: {
        title: "",
        author: "",
        location: "",
        type: "",
        copyright: "",
        license: "",
        conentType: ""
      },
      adminId: "1",
      groups: [],
      status: 0,
      loading: 0
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "uploadEdit", {
      title: "",
      description: {
        en: "",
        sr: "",
        ro: ""
      },
      imgUrl: [{ url: "" }],
      location: {},
      meta: {
        title: "",
        author: "",
        location: "",
        type: "",
        copyright: "",
        license: "",
        conentType: ""
      },
      adminId: "1",
      groups: [],
      status: 0,
      loading: 0
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "uploadError", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "currentStatus", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "uploadFieldName", "photos"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "select", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "isReallyOld", '1'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "description", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "e6", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "e7", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "keyMessage", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "states", ["Timisoara", "Romania Culture"]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "activePlus", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "descriptionRules", [function (v) {
      return !!v || 'Description is required';
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "titleRules", [function (v) {
      return !!v || 'Title is required';
    }]), _ref;
  },


  computed: {
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    groups: function groups() {
      return this.$store.getters.loadGroups;
    },
    items: function items() {
      return this.$store.getters.loadAllCollections;
    },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },

    // collections() {
    //     return  this.$store.getters.loadAllCollections; 
    // },
    selectedId: function selectedId() {

      var i;
      for (i = 0; i < this.items.length; i++) {
        console.log(this.items);
        if (this.items[i].title === this.previewCollection.title) return this.items[i]._id;
      }
    },
    users: function users() {
      return this.$store.getters.loadUsers;
    }
  },
  watch: {
    lang: function lang(newV, oldV) {
      this.options.keys = [];
      this.options.keys.push('title.' + newV);
    },
    term: function term() {
      var _this = this;

      this.$search(this.term, this.items, this.options).then(function (results) {
        _this.methodResults = results;
        if (_this.term == "") {
          _this.methodResults = _this.items;
        }
      });
    }
  },
  methods: {
    showOnSmallScreen: function showOnSmallScreen() {
      return this.isReallyOld == 1 || window.innerWidth > 950;
    },
    toArtefact: function toArtefact(artefactID) {
      this.$router.push('/artefacts/' + artefactID);
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    },
    clickInputMain: function clickInputMain() {
      this.$refs.fileInput1.click();
    },
    reset: function reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    saveAdd: function saveAdd(formData) {
      var _this2 = this;

      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.uploadAdd.loading = 1;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_FileUpload_file_upload_service__["a" /* upload */])(formData).then(function (x) {
        _this2.uploadAdd.loading = 0;
        _this2.uploadAdd.status = 1;
        _this2.uploadAdd.imgUrl = x;
        _this2.currentStatus = STATUS_SUCCESS;
      }).catch(function (err) {
        _this2.uploadError = err.response;
        _this2.currentStatus = STATUS_FAILED;
      });
    },
    filesChangeAdd: function filesChangeAdd(fieldName, fileList) {
      // handle file changes
      var formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.saveAdd(formData);
    },
    saveEdit: function saveEdit(formData) {
      var _this3 = this;

      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.uploadEdit.loading = 1;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_FileUpload_file_upload_service__["a" /* upload */])(formData).then(function (x) {
        _this3.uploadEdit.loading = 0;
        _this3.uploadEdit.status = 1;
        _this3.uploadEdit.imgUrl = x;
        _this3.currentStatus = STATUS_SUCCESS;
      }).catch(function (err) {
        _this3.uploadError = err.response;
        _this3.currentStatus = STATUS_FAILED;
      });
    },
    filesChangeEdit: function filesChangeEdit(fieldName, fileList) {
      // handle file changes
      var formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.saveEdit(formData);
    },
    onCreateCollection: function onCreateCollection() {
      var _this4 = this;

      this.$store.dispatch("createCollection", this.uploadAdd).then(function (response) {
        _this4.$router.push('/collections/' + response.data._id);
      }, function (error) {});
    },
    onUpdateCollection: function onUpdateCollection(idval) {
      this.$store.dispatch("updateCollection", this.uploadEdit);
      this.$router.push({ path: "/collections" });
    },

    deleteCollection: function deleteCollection(idval) {
      var _this5 = this;

      // this.$store.dispatch("deleteCollection" ,{ _id:idval}).then(
      //   response => {
      //     this.$store.dispatch("loadCollections");
      //     this.$router.push("/collections/new");
      //   },
      //   err => {
      //     console.log(err);
      //   }
      // );

      // this.$store.dispatch('deleteCollection',{ _id:idval});
      // this.$store.dispatch("loadCollections");
      // this.dialog = false;
      // this.$router.push('/collections/new');


      this.$store.dispatch("deleteCollection", { _id: idval }).then(function (response) {
        _this5.$store.dispatch("loadCollection");
        _this5.dialog = false;
        _this5.$router.push("/collections/new");
      }, function (err) {
        console.log(err);
      });
    },
    editCollection: function editCollection(idval) {
      this.edit = true;
      var i = 0;
      for (i = 0; i < this.items.length; i++) {
        if (this.items[i]._id == idval) this.uploadEdit = this.items[i];
      }
    },
    clickInput2: function clickInput2() {
      this.$refs.fileInput2.click();
    },
    clickInput1: function clickInput1() {
      this.$refs.fileInput1.click();
    },
    addNew: function addNew() {

      this.isReallyOld = '3';
      this.uploadAdd.title.en = this.term;
      this.uploadAdd.title.sr = this.term;
      this.uploadAdd.title.ro = this.term;
      this.uploadAdd.description.en = '';
      this.uploadAdd.description.ro = '';
      this.uploadAdd.description.sr = '';
      this.edit = false;
    },
    isNew: function isNew(val) {
      if (val) {
        var i = 0;
        var k = 0;
        for (i = 0; i < this.items.length; i++) {
          if (this.items[i].title[this.lang].toUpperCase() == val) {
            k++;
          }
        }
        if (k > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {
    document.title = "Manage Collections";
    window.scrollTo(0, 0);
    this.reset();
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.methodResults = this.items;
    this.options.keys = [];
    this.options.keys.push('title.' + this.lang);
  },
  created: function created() {

    if (!this.isAdmin && !this.isLoggedIn) this.$router.push("/signin");else if (!this.isAdmin && this.isLoggedIn) this.$router.push("/");
  }
});

/***/ }),

/***/ "GOWV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GTNe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GZ5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:" primary pl-2 pr-2 ",attrs:{"row":""}},[_c('v-flex',{staticClass:" mr-3 ml-3 white hidden-md-and-up",attrs:{"xs12":"","sm12":"","offset-sm2":""}},[_c('h3',{staticClass:"mb-1 text-xs-center",staticStyle:{"color":"grey"}},[_vm._v("  Manage Users")])])],1),_vm._v(" "),_c('v-layout',{staticClass:" primary pl-2 mb-3  hidden-sm-and-down ",attrs:{"row":"","justify-center":""}},[_c('v-flex',{staticClass:" mr-3 ml-3 ",attrs:{"xs12":"","sm12":"","md6":"","offset-sm2":""}},[_c('p',{staticClass:"mb-1 mdHeaderText mt-4 mb-4  "},[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(" Admin Panel ")]),_vm._v("    >    Manage Users")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md8":""}},[_c('v-list',{staticClass:"list",attrs:{"two-line":""}},[_c('v-text-field',{staticClass:"searchBar ",attrs:{"append-icon":"search","label":"Input a user name","hide-details":""},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}}),_vm._v(" "),_vm._l((_vm.methodResults),function(item){return [_c('v-list-tile',{key:item.title,staticClass:"listTile",attrs:{"avatar":""}},[( item.picture)?_c('v-list-tile-avatar',[(item.picture.url)?_c('img',{attrs:{"src":item.picture.url + '_profile'}}):_c('img',{attrs:{"src":item.picture}})]):_c('v-list-tile-avatar',[_c('img',{staticClass:"avatarImg1",attrs:{"src":__webpack_require__("JpW5"),"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.displayName)}}),_vm._v(" "),(item.email)?_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s( '  <span class=\'grey--text text--lighten-1\'> ' + item.email + '</span>' )}}):_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s( '  <span class=\'grey--text text--lighten-1\'> Connected with: ' + _vm.provider(item) + '</span>' )}})],1),_vm._v(" "),_c('v-list-tile-action',{staticStyle:{"width":"130px"}},[_c('v-select',{attrs:{"items":_vm.items,"label":"Select","single-line":"","bottom":""},on:{"change":function($event){_vm.changeStatus(item,$event)}},model:{value:(item.role),callback:function ($$v) {_vm.$set(item, "role", $$v)},expression:"item.role"}})],1)],1)]})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GkqI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"transparent"}},[_c('v-layout',{staticClass:"hidden-sm-and-down"},[_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"pa-3",staticStyle:{"width":"100%","height":"100%","display":"table","text-align":"justify"}},[_c('p',{staticClass:"artefactDescription",domProps:{"innerHTML":_vm._s(_vm.gLang[_vm.lang].home.quoteFavourites)}})])]),_vm._v(" "),_c('v-flex',{staticClass:"mb-3 mt-3",attrs:{"xs8":""}},[_c('v-list',{staticStyle:{"background-color":"#FAFAFA","border":"1px solid #efefef"},attrs:{"three-line":""}},[[_c('swiper',{staticClass:"pa-2",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.artefacts.slice(0,10)),function(artefact){return _c('swiper-slide',{key:artefact._id},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.toArtefact(artefact._id)}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":artefact.mainImg[0].url + '_profile'}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie",staticStyle:{"border-bottom":"1px solid #efefef"}},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(artefact.title[_vm.lang])}}),_vm._v(" "),_vm._l((_vm.users),function(user){return ((artefact.userId.indexOf(user._id) > -1))?_c('v-list-tile-sub-title',{key:user._id,domProps:{"innerHTML":_vm._s(user.displayName + ' - ' + artefact.description[_vm.lang] )}}):_vm._e()})],2)],1)],1)}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2)]],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"hidden-md-and-up"},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"pa-3",staticStyle:{"width":"100%","height":"100%","display":"table","text-align":"justify"}},[_c('p',{staticClass:"artefactDescription",domProps:{"innerHTML":_vm._s(_vm.previewArtefact)}})])])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"mb-3 mt-3",attrs:{"xs12":""}},[_c('v-list',{staticStyle:{"background-color":"#FAFAFA","border":"1px solid #efefef"},attrs:{"three-line":""}},[[_c('swiper',{attrs:{"options":_vm.swiperOption1}},[_vm._l((_vm.artefacts.slice(0,10)),function(artefact){return _c('swiper-slide',{key:artefact._id},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.toArtefact(artefact._id)}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":artefact.mainImg[0].url + '_profile'}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie",staticStyle:{"border-bottom":"1px solid #efefef"}},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(artefact.title[_vm.lang])}}),_vm._v(" "),_vm._l((_vm.users),function(user){return ((artefact.userId.indexOf(user._id) > -1))?_c('v-list-tile-sub-title',{key:user._id,domProps:{"innerHTML":_vm._s(user.displayName + ' - ' + artefact.description[_vm.lang] )}}):_vm._e()})],2)],1)],1)}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2)]],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GyXq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H7H4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HDni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Send Message")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){return _vm.sendMessage($event)}}},[_vm._v("Send")])],1)],1),_vm._v(" "),_c('v-container',[_c('v-text-field',{attrs:{"name":"input-1-3","label":"To","single-line":""},model:{value:(_vm.reciever),callback:function ($$v) {_vm.reciever=$$v},expression:"reciever"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-1-3","label":"Subject","single-line":""},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}}),_vm._v(" "),_c('quill-editor',{ref:"myTextEditor",staticClass:"editor-example bubble",attrs:{"options":_vm.editorOption},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HFLA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HGno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionCard_vue__ = __webpack_require__("xAGa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5499c1d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionCard_vue__ = __webpack_require__("oWHl");
function injectStyle (ssrContext) {
  __webpack_require__("GTNe")
  __webpack_require__("nXyx")
  __webpack_require__("VM38")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5499c1d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5499c1d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HMUN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HPoU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aplayer__ = __webpack_require__("RvFq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aplayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aplayer__);
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        narrow: {
            type: Boolean,
            default: false
        },
        autoplay: {
            type: Boolean,
            default: false
        },
        showlrc: {
            type: Number,
            default: 0
        },
        mutex: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: '#b7daff'
        },
        mode: {
            type: String,
            default: 'circulation'
        },
        preload: {
            type: String,
            default: 'auto'
        },
        listmaxheight: String,
        music: {
            type: [Object, Array],
            required: true,
            validator: function validator(value) {
                var songs = void 0;
                if (!(value instanceof Array)) {
                    songs = [value];
                } else {
                    songs = value;
                }
                for (var i = 0; i < songs.length; i++) {
                    var song = songs[i];
                    if (!song.url || !song.title || !song.author) {
                        song.title = song.title || 'Untitled';
                        song.author = song.author || 'Unknown';
                        return false;
                    }
                }
                return true;
            }
        }
    },
    data: function data() {
        return {
            control: null
        };
    },

    watch: {
        music: function music(_music) {
            this.control.option.music = _music;
            this.control.setMusic(0);
            if (this.autoplay) {
                this.control.play();
            }
            this.$emit('change', _music);
        }
    },
    mounted: function mounted() {
        var _this = this;

        var player = this.control = new __WEBPACK_IMPORTED_MODULE_0_aplayer___default.a({
            element: this.$el,
            narrow: this.narrow,
            autoplay: this.autoplay,
            showlrc: this.showlrc,
            mutex: this.mutex,
            theme: this.theme,
            preload: this.preload,
            mode: this.mode,
            listmaxheight: this.listmaxheight,
            music: this.music
        });
        player.on('play', function () {
            _this.$emit('play');
        });
        player.on('pause', function () {
            _this.$emit('pause');
        });
        player.on('canplay', function () {
            _this.$emit('canplay');
        });
        player.on('playing', function () {
            _this.$emit('playing');
        });
        player.on('ended', function () {
            _this.$emit('ended');
        });
        player.on('error', function () {
            _this.$emit('error');
        });
    }
});

/***/ }),

/***/ "HTQ8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/14-min[cropped].c6224f8.jpg";

/***/ }),

/***/ "HTTh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hgic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__ = __webpack_require__("hYjn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25723284_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__ = __webpack_require__("sUW2");
function injectStyle (ssrContext) {
  __webpack_require__("HMUN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25723284"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25723284_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HsHu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I/Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddArtefact_vue__ = __webpack_require__("Fy7I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1326480f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArtefact_vue__ = __webpack_require__("4hcK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddArtefact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1326480f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArtefact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I/sA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I0BE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IRx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"m-5 ma-1 artcard"},[_c('v-card-media',{staticClass:"white--text cardCursor",attrs:{"gradient":_vm.gradient,"dark":"","height":"200px","src":_vm.artefact.mainImg[0].url+'_card'},on:{"click":function($event){_vm.toArtefact1(_vm.artefact._id)}}},[_c('v-container',{staticClass:"grayoverlay",attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{staticStyle:{"text-align":"left"},attrs:{"xs12":""}},[_c('span',{staticClass:"body-1 white--text",staticStyle:{"text-align":"left","white-space":"nowrap"}},[_c('v-icon',{staticClass:"body-1 white--text"},[_vm._v("view_carousel")]),_vm._v(" Added at "+_vm._s(_vm._f("date")(_vm.artefact.meta.creationDate))+" ")],1),_vm._v(" "),(_vm.showStatus==true)?_c('span',[_vm._v("Status: "+_vm._s(_vm.getStatus(_vm.artefact))+" ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","align-end":""}},[_c('a',{staticStyle:{"text-decoration":"none","color":"white","cursor":"pointer"},on:{"click":function($event){_vm.toArtefact(_vm.artefact._id)}}},[_c('p',{staticClass:"headline mb-1 ml-1"},[_vm._v(_vm._s(_vm.artefact.title[_vm.lang].slice(0,40).toUpperCase())+" "),(_vm.artefact.title[_vm.lang].length >40)?_c('span',[_vm._v("...")]):_vm._e()])])])],1)],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"pa-0 collection-list-ie",staticStyle:{"min-height":"100px"}},[_c('v-list',{staticStyle:{"background":"transparent"},attrs:{"three-line":""}},[_c('v-list-tile',{staticStyle:{"background":"transparent"},attrs:{"avatar":""}},[(_vm.artefactUser&&_vm.artefactUser.picture)?_c('v-list-tile-avatar',[(_vm.artefactUser.picture.url)?_c('img',{attrs:{"src":_vm.artefactUser.picture.url+'_profile'}}):_c('img',{attrs:{"src":_vm.artefactUser.picture}})]):_c('v-list-tile-avatar',[_c('img',{staticClass:"avatarImg1",attrs:{"src":__webpack_require__("JpW5"),"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',{attrs:{"dark":""}},[_c('v-list-tile-sub-title',[_vm._v(" "+_vm._s(_vm.artefact.description[_vm.lang])+" ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_authenticate__ = __webpack_require__("WrNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_medium_editor__ = __webpack_require__("66dk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_medium_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_medium_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__deploy_conf_js__ = __webpack_require__("OEKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__deploy_conf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__deploy_conf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_uuid__ = __webpack_require__("fzx2");










 // Import uuid

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_6_axios___default.a);
var base = __WEBPACK_IMPORTED_MODULE_9__deploy_conf_js__["IP_ADRESS"] + 'api/';

var vueAuth = new __WEBPACK_IMPORTED_MODULE_5_vue_authenticate__["b" /* VueAuthenticate */](__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$http, {
  baseUrl: __WEBPACK_IMPORTED_MODULE_9__deploy_conf_js__["IP_ADRESS"] + 'api/'
});

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  strict: false,
  state: {
    userIdentifier: "",
    artefacts: [],
    collections: [],
    groups: [],
    isAuthenticated: false,
    token: '',
    user: {},
    users: [],
    lang: 'ro',
    languages: {
      lang: {
        ro: {
          layout: {
            home: 'Acasa',
            explore: 'Cerceteaza',
            artefacts: 'Postari',
            collections: 'Colectii',
            groups: 'Grupuri',
            about: 'Despre noi',
            termsconditions: 'Termeni si conditii',
            language: 'Limba',
            search: 'Cauta',
            addartefact: 'Adauga Postare',
            managetags: 'Administreaza Colectii',
            managegroups: 'Administreaza Grupuri',
            tasks: 'Tasks',
            users: 'Utilizatori',
            settings: 'Setari',
            messaging: 'Mesaje',
            myaccount: 'Contul meu',
            logout: 'Delogheaza-te'
          },

          home: {
            quote: 'Mareste-ti barierele culturale',
            featuredArtefacts: 'Postari Prezentate',
            featuredArtefactParagraph: '',
            MostViewed: 'Cele mai Vizitate',
            MostFavourited: 'Favoritele Comunitatii',
            MostFavouritedQuote: ''
          },

          explore: {
            filterList: 'Filtreaza',
            artefacts: 'Postari',
            collections: 'Colectii',
            groups: 'Grupuri',
            byDate: 'Dupa data',
            startDate: 'Data inceput',
            endDate: 'Data sfarsit',
            byLocation: 'Dupa Locatie',
            insertLocation: 'Cauta locatia aici',
            sortBy: 'Sorteaza',
            mostPopular: 'Cele mai populare',
            newest: 'Cele mai noi',
            oldest: 'Cele mai vechi'
          },

          myAccount: {
            myArtefacts: 'Postarile Mele',
            favourites: 'Favoritele Mele',
            username: 'Username',
            password: 'Parola',
            repeatPassword: 'Repeta Parola',
            profileImage: 'Imagine de Profil',
            indicatesReqField: '*Indica informatiile obligatorii',
            close: 'Inchide',
            save: 'Salveaza'
          },

          tasks: {
            tasks: 'Taskuri',
            previewText: 'Selecteaza o postare pentru a vedea preview-ul...',
            newArtefacts: 'Postari Noi'
          },

          signIn: {
            signIn: 'Sign In',
            rememberMe: 'Tine-ma minte',
            forgotPassword: 'Ai uitat Parola?',
            createAccount: 'Creeaza-ti un cont',
            signInFb: 'Sign in cu Facebook',
            signInG: 'Sign in cu Google',
            signInM: 'Sign in cu Microsoft',
            termaConditionsAccept: 'Am citit si accept termenii si conditiile'
          },

          messaging: {
            tabRead: 'Citeste',
            tabWrite: 'Scrie',
            receiver: 'Mesaje primite',
            preview: 'Selectati un mesaj pentru a vedea un preview...',
            select: 'Selecteaza',
            compose: 'Compune',
            inputUser: 'Scrieti un usermane...',
            send: 'Trimite',
            selectUsers: 'Selecteaza utilizatori pentru a trimite mesaje...'
          },

          users: {
            contribuitor: 'Contribuitor',
            admin: 'Admin',
            moderator: 'Moderator',
            user: 'User',
            inputUser: 'Scrieti un usermane...'
          },

          collectionCard: {
            expansion: 'Artefacte in aceasta colectie'
          },

          groupCard: {
            expansion: 'Colectii in aceast grup'
          },

          artefactSingle: {
            delete: 'Esti sigur ca vrei sa stergi acest artefact?',
            btnyes: 'Da',
            btnno: 'Nu',
            addedBy: 'Adaugat de',
            browser: 'Browser-ul tau nu suporta acest format audio'
          },

          addArtefact: {
            uploadImage: 'Incarcati imagine',
            title: 'Titlul Artefactului',
            description: 'Descrierea Artefactului',
            tags: 'Numele tagurilor',
            moreInfo: 'Pentru a adauga mai multe informatii, apasa <v-icon>add_box </v-icon>, apoi apasa <v-icon>save </v-icon> pentru a salva artefactul!'
          },

          collectionSingle: {
            about: 'Despre aceasta Colectie',
            readMore: 'CITESTE MAI MULT',
            location: 'Locatiile acestei Colectii',
            artefacts: 'Ultimele Artefacte din aceasta Colectie',
            show: 'VEZI TOATE ARTEFACTELE',
            readLess: 'CITESTE MAI PUTIN',
            delete: 'Esti sigur ca vrei sa stergi aceasta colectie?'
          },

          groupSingle: {
            about: 'Despre aceast Grup',
            readMore: 'CITESTE MAI MULT',
            collections: 'Ultimele Colectii din aceast Grup',
            show: 'VEZI TOATE COLECTIILE',
            readLess: 'CITESTE MAI PUTIN',
            delete: 'Esti sigur ca vrei sa stergi aceast grup?'
          },

          contact: {
            title: 'Contacteaza-ne!',
            nume: 'Nume',
            prenume: 'Prenume',
            mail: 'E-mail',
            telefon: 'Telefon',
            mesaj: 'Mesaj'
          }

        },
        en: {

          layout: {
            home: 'Home',
            explore: 'Explore',
            artefacts: 'Artefacts',
            collections: 'Collections',
            groups: 'Groups of Collections',
            about: 'About Us',
            termsconditions: 'Terms and Conditions',
            language: 'Language',
            search: 'Search',
            addartefact: 'Add Artefact',
            managetags: 'Manage Collections',
            managegroups: 'Manage Groups',
            tasks: 'Tasks',
            users: 'Users',
            settings: 'Settings',
            messaging: 'Messages',
            myaccount: 'My Account',
            logout: 'Sign out'
          },

          home: {
            quote: 'explore your <b>culture</b> <br> <i>beyond limits</i>',
            featuredArtefacts: 'Featured Artefacts',
            featuredArtefactParagraph: '',
            MostViewed: 'Most Viewed Artefacts',
            MostFavourited: 'Favourites',
            MostFavouritedQuote: ''
          },

          explore: {
            filterList: 'Filter List',
            artefacts: 'Artefacts',
            collections: 'Collections',
            groups: 'Groups',
            byDate: 'By Date',
            startDate: 'Start Date',
            endDate: 'End Date',
            byLocation: 'By Location',
            insertLocation: 'Insert a location',
            sortBy: 'Sort by',
            mostPopular: 'Most popular',
            newest: 'Newest',
            oldest: 'Oldest'
          },

          myAccount: {
            myArtefacts: 'MY ARTEFACTS',
            favourites: 'FAVOURITES',
            username: 'Username',
            password: 'Password',
            repeatPassword: 'Repeat Password',
            profileImage: 'Profile Image',
            indicatesReqField: '*indicates required field',
            close: 'Close',
            save: 'Save'
          },

          tasks: {
            tasks: 'Tasks',
            previewText: 'Select an artefact to see a preview...',
            newArtefacts: 'New Added Artefacts'
          },

          signIn: {
            signIn: 'Sign In',
            rememberMe: 'Remember Me',
            forgotPassword: 'Forgot Password?',
            createAccount: 'Create Account',
            signInFb: 'Sign in with Facebook',
            signInG: 'Sign in with Google',
            signInM: 'Sign in with Microsoft',
            termaConditionsAccept: 'I accept the Terms and Conditions'
          },

          messaging: {
            tabRead: 'Read',
            tabWrite: 'Write',
            receiver: 'Inbox',
            preview: 'Select a message for a preview...',
            select: 'Select',
            compose: 'Compose',
            inputUser: 'Type in a username...',
            send: 'Send',
            selectUsers: 'Select users to send messages...'
          },

          users: {
            contribuitor: 'Contribuitor',
            admin: 'Admin',
            moderator: 'Moderator',
            user: 'User',
            inputUser: 'Type in a username...'
          },

          collectionCard: {
            expansion: 'Artefacts in this collection'
          },

          groupCard: {
            expansion: 'Groups in this collection'
          },

          artefactSingle: {
            delete: 'Are you sure you want to delete this artefact?',
            btnyes: 'Yes',
            btnno: 'No',
            addedBy: 'Added by',
            browser: 'Your browser does not support this audio format'
          },

          addArtefact: {
            uploadImage: 'Upload Image',
            title: 'Artefact Title',
            description: 'Artefact Description',
            tags: 'Tags',
            moreInfo: 'To add more info, press <v-icon>add_box </v-icon>, then press <v-icon>save </v-icon> to save the artefact!'
          },

          collectionSingle: {
            about: 'About this Collection',
            readMore: 'READ MORE',
            readLess: 'READ LESS',
            location: 'Locations of this Collection',
            artefacts: 'Latest Artefacts of this Collection',
            show: 'SEE ALL ARTEFACTS',
            delete: 'Are you sure you want to delete this collection?'
          },

          groupSingle: {
            about: 'About this Group',
            readMore: 'READ MORE',
            readLess: 'READ LESS',
            collections: 'Latest Collections of this Group',
            show: 'SEE ALL COLLECTIONS',
            delete: 'Are you sore you want to delete this group?'

          },
          contact: {
            title: 'Contact Us!',
            nume: 'Name',
            prenume: 'Surname',
            mail: 'E-mail',
            telefon: 'Phone',
            mesaj: 'Message'
          }
        },
        sr: {

          layout: {
            home: 'Home',
            explore: 'Explore',
            artefacts: 'Artefacts',
            collections: 'Collections',
            groups: 'Groups of Collections',
            about: 'About Us',
            termsconditions: 'Terms and Conditions',
            language: 'Language',
            search: 'Search',
            addartefact: 'Add Artefact',
            managetags: 'Manage Collections',
            managegroups: 'Manage Groups',
            tasks: 'Tasks',
            users: 'Users',
            settings: 'Settings',
            messaging: 'Messages',
            myaccount: 'My Account',
            logout: 'Sign out'
          },

          home: {
            quote: 'explore your <b>culture</b> <br> <i>beyond limits</i>',
            featuredArtefacts: 'Featured Artefacts',
            featuredArtefactParagraph: '',
            MostViewed: 'Most Viewed Artefacts',
            MostFavourited: 'Favourites',
            MostFavouritedQuote: ''
          },

          explore: {
            filterList: 'Filter List',
            artefacts: 'Artefacts',
            collections: 'Collections',
            groups: 'Groups',
            byDate: 'By Date',
            startDate: 'Start Date',
            endDate: 'End Date',
            byLocation: 'By Location',
            insertLocation: 'Insert a location',
            sortBy: 'Sort by',
            mostPopular: 'Most popular',
            newest: 'Newest',
            oldest: 'Oldest'
          },

          myAccount: {
            myArtefacts: 'MY ARTEFACTS',
            favourites: 'FAVOURITES',
            username: 'Username',
            password: 'Password',
            repeatPassword: 'Repeat Password',
            profileImage: 'Profile Image',
            indicatesReqField: '*indicates required field',
            close: 'Close',
            save: 'Save'
          },

          tasks: {
            tasks: 'Tasks',
            previewText: 'Select an artefact to see a preview...',
            newArtefacts: 'New Added Artefacts'
          },

          signIn: {
            signIn: 'Sign In',
            rememberMe: 'Remember Me',
            forgotPassword: 'Forgot Password?',
            createAccount: 'Create Account',
            signInFb: 'Sign in with Facebook',
            signInG: 'Sign in with Google',
            signInM: 'Sign in with Microsoft',
            termaConditionsAccept: 'I accept the Terms and Conditions'
          },

          messaging: {
            tabRead: 'Read',
            tabWrite: 'Write',
            receiver: 'Inbox',
            preview: 'Select a message for a preview...',
            select: 'Select',
            compose: 'Compose',
            inputUser: 'Type in a username...',
            send: 'Send',
            selectUsers: 'Select users to send messages...'
          },

          users: {
            contribuitor: 'Contribuitor',
            admin: 'Admin',
            moderator: 'Moderator',
            user: 'User',
            inputUser: 'Type in a username...'
          },

          collectionCard: {
            expansion: 'Artefacts in this collection'
          },

          groupCard: {
            expansion: 'Groups in this collection'
          },

          artefactSingle: {
            delete: 'Are you sure you want to delete this artefact?',
            btnyes: 'Yes',
            btnno: 'No',
            addedBy: 'Added by',
            browser: 'Your browser does not support this audio format'
          },

          addArtefact: {
            uploadImage: 'Upload Image',
            title: 'Artefact Title',
            description: 'Artefact Description',
            tags: 'Tags',
            moreInfo: 'To add more info, press <v-icon>add_box </v-icon>, then press <v-icon>save </v-icon> to save the artefact!'
          },

          collectionSingle: {
            about: 'About this Collection',
            readMore: 'READ MORE',
            readLess: 'READ LESS',
            location: 'Locations of this Collection',
            artefacts: 'Latest Artefacts of this Collection',
            show: 'SEE ALL ARTEFACTS',
            delete: 'Are you sure you want to delete this collection?'
          },

          groupSingle: {
            about: 'About this Group',
            readMore: 'READ MORE',
            readLess: 'READ LESS',
            collections: 'Latest Collections of this Group',
            show: 'SEE ALL COLLECTIONS',
            delete: 'Are you sore you want to delete this group?'

          },
          contact: {
            title: 'Contact Us!',
            nume: 'Name',
            prenume: 'Surname',
            mail: 'E-mail',
            telefon: 'Phone',
            mesaj: 'Message'
          }
        }
      }
    }

  },
  mutations: {
    loadLanguages: function loadLanguages(state, _ref) {
      var list = _ref.list;

      state.languages = list;
    },
    newUserIdentifier: function newUserIdentifier(state, payload) {
      state.userIdentifier = payload;
    },
    changeLang: function changeLang(state, payload) {
      state.lang = payload;
    },
    createArtefact: function createArtefact(state, payload) {
      state.artefacts.push(payload);
    },
    createCollection: function createCollection(state, payload) {
      state.collections.push(payload);
    },
    createGroup: function createGroup(state, payload) {
      state.groups.push(payload);
    },

    loadArtefacts: function loadArtefacts(state, _ref2) {
      var list = _ref2.list;

      state.artefacts = list;
    },
    loadCollections: function loadCollections(state, _ref3) {
      var list = _ref3.list;

      state.collections = list;
    },
    loadGroups: function loadGroups(state, _ref4) {
      var list = _ref4.list;

      state.groups = list;
    },
    updateGroups: function updateGroups(state, payload) {},
    updateLang: function updateLang(state, payload) {},
    deleteArtefact: function deleteArtefact(state, payload) {},
    updateCollection: function updateCollection(state, payload) {},
    updateArtefact: function updateArtefact(state, payload) {},
    deleteGroup: function deleteGroup(state, payload) {},
    deleteCollection: function deleteCollection(state, payload) {},
    createToken: function createToken(state, payload) {
      state.token = payload;
    },
    createUser: function createUser(state, payload) {
      state.user = payload;
      state.isAuthenticated = true;
    },
    logOut: function logOut(state) {
      state.user = {};
      state.isAuthenticated = false;
      state.token = '';
    },

    loadUsers: function loadUsers(state, _ref5) {
      var list = _ref5.list;

      state.users = list;
    },
    changeUserStatus: function changeUserStatus(state, payload) {
      if (state.user._id == payload.id) {
        state.user = {};
        state.isAuthenticated = false;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.users), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var user = _step.value;

          if (user._id == payload.id) {
            user.role = payload.role;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  actions: {
    setUserIdentifier: function setUserIdentifier(_ref6) {
      var commit = _ref6.commit;

      var newToken = __WEBPACK_IMPORTED_MODULE_10_vue_uuid__["a" /* uuid */].v1();
      commit("newUserIdentifier", newToken);
    },

    updateCurrentUser: function updateCurrentUser(_ref7, payload) {
      var commit = _ref7.commit;

      var config = {
        headers: {
          Authorization: 'Basic ' + payload.token
        }
      };
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(base + 'me').then(function (response) {
        commit('createUser', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateLang: function updateLang(_ref8, payload) {
      var commit = _ref8.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(base + 'languages', payload).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      }, function (error) {
        reject(error);
      });

      // axios.put(base + 'languages'  , payload)
      //     .then((response) => {
      //         console.log(response)

      //     })
      //     .catch((error) => {
      //         console.log(error);

      //     });
      // store.commit('updateLanguage', payload)

      // Reach out to mongodb and store it
      // axios.post(base + 'languages', payload)
      //     .then((response) => {
      //         store.commit('updateLanguages', response.data)
      //     })
      //     .catch((error) => {
      //         console.log(error);

      //     });
    },
    createArtefact: function createArtefact(_ref9, payload) {
      var commit = _ref9.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // Reach out to mongodb and store it
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(base + 'artefacts', payload).then(function (response) {
          commit('createArtefact', response.data);
          resolve(response);
        }).catch(function (error) {
          console.log(error);
        });
      }, function (error) {
        // http failed, let the calling function know that action did not work out
        reject(error);
      });
    },
    recoverPass: function recoverPass(_ref10, payload) {
      var commit = _ref10.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // Reach out to mongodb and store it
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(base + 'forgot', payload).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      }, function (error) {
        // http failed, let the calling function know that action did not work out
        reject(error);
      });
    },
    recoverChangePasswordGet: function recoverChangePasswordGet(_ref11, payload) {
      var commit = _ref11.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // Reach out to mongodb and store it
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(base + 'reset/' + payload).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      }, function (error) {
        // http failed, let the calling function know that action did not work out
        reject(error);
      });
    },
    recoverChangePasswordPost: function recoverChangePasswordPost(_ref12, payload) {
      var commit = _ref12.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // Reach out to mongodb and store it
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(base + 'reset/' + payload.token, payload).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      }, function (error) {
        // http failed, let the calling function know that action did not work out
        reject(error);
      });
    },
    createToken: function createToken(_ref13, payload) {
      var commit = _ref13.commit;

      commit('createToken', payload);
    },
    changeLang: function changeLang(_ref14, payload) {
      var commit = _ref14.commit;

      commit('changeLang', payload);
    },
    logOut: function logOut(_ref15) {
      var commit = _ref15.commit;

      commit('logOut');
    },
    createUser: function createUser(_ref16, payload) {
      var commit = _ref16.commit;

      commit('createUser', payload);
    },
    createCollection: function createCollection(_ref17, payload) {
      var commit = _ref17.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // Reach out to mongodb and store it
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(base + 'collections', payload).then(function (response) {
          resolve(response);
          commit('createCollection', response.data);
        }).catch(function (error) {
          console.log(error);
        });
      }, function (error) {
        // http failed, let the calling function know that action did not work out
        reject(error);
      });
    },
    addToFavorites: function addToFavorites(_ref18, payload) {
      var commit = _ref18.commit;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(base + 'artefacts/favorite', payload).then(function (response) {
        commit('addToFavorites', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    unFavorite: function unFavorite(_ref19, payload) {
      var commit = _ref19.commit;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(base + 'artefacts/favorite', payload).then(function (response) {
        commit('addToFavorites', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    getSocialUser: function getSocialUser(_ref20, payload) {
      var commit = _ref20.commit;

      var config = {
        headers: {
          Authorization: 'Basic ' + payload
        }
      };

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(base + '/me', config).then(function (response) {
        commit('createUser', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeUserStatus: function changeUserStatus(_ref21, payload) {
      var commit = _ref21.commit;

      var config = {
        headers: {
          Authorization: 'Basic ' + payload.token
        }
      };
      var load = payload;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(base + 'user/changestatus/' + payload.id, payload, config).then(function (response) {
          if (response.success = 'success') {
            resolve(response);
            console.log(load);
            commit('changeUserStatus', {
              id: load.id,
              role: load.role
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }, function (error) {
        // http failed, let the calling function know that action did not work out
        reject(error);
      });
    },
    ChangeUserInfo: function ChangeUserInfo(_ref22, payload) {
      var commit = _ref22.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var config = {
          headers: {
            Authorization: 'Basic ' + payload.token
          }
        };
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(base + 'user/' + payload.user._id, payload, config).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          console.log(error);
        });
      });
    },
    deleteArtefact: function deleteArtefact(_ref23, payload) {
      var commit = _ref23.commit;

      // Reach out to mongodb and store it
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(base + 'artefacts/' + payload._id).then(function (response) {
        console.log(response);
        commit('deleteArtefact', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteGroup: function deleteGroup(_ref24, payload) {
      var commit = _ref24.commit;

      // Reach out to mongodb and store it
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(base + 'groups/' + payload._id).then(function (response) {
        commit('deleteGroup', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteCollection: function deleteCollection(_ref25, payload) {
      var commit = _ref25.commit;

      // Reach out to mongodb and store it
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(base + 'collections/' + payload._id).then(function (response) {
        commit('deleteCollection', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteFile: function deleteFile(_ref26, payload) {
      var commit = _ref26.commit;

      // Reach out to mongodb and store it
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(base + 'images/delete/' + payload.imageId, {
        token: payload.token,
        userId: payload.userId
      });
    },
    createGroup: function createGroup(_ref27, payload) {
      var commit = _ref27.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // Reach out to mongodb and store it
        // Reach out to mongodb and store it
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(base + 'groups', payload).then(function (response) {
          resolve(response);
          commit('createGroup', response.data);
        }).catch(function (error) {
          console.log(error);
        });
      }, function (error) {
        // http failed, let the calling function know that action did not work out
        reject(error);
      });
    },
    updateCollection: function updateCollection(_ref28, payload) {
      var commit = _ref28.commit;

      // Reach out to mongodb and store it
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(base + 'collections/' + payload._id, payload).then(function (response) {
        store.commit('updateCollection', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateGroup: function updateGroup(_ref29, payload) {
      var commit = _ref29.commit;

      // Reach out to mongodb and store it
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(base + 'groups/' + payload._id, payload).then(function (response) {
        store.commit('updateGroups', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateArtefact: function updateArtefact(_ref30, payload) {
      var commit = _ref30.commit;

      // Reach out to mongodb and store it
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(base + 'artefacts/' + payload._id, payload).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
      store.commit('updateArtefact', payload);
    },
    updateArtefactVisited: function updateArtefactVisited(_ref31, payload) {
      var commit = _ref31.commit;

      // Reach out to mongodb and store it
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(base + 'artefacts/visits/' + payload.artefact._id, {
        userId: payload.userId,
        date: payload.date
      }).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
      store.commit('updateArtefact', payload);
    },
    updateGroupVisits: function updateGroupVisits(_ref32, payload) {
      var commit = _ref32.commit;

      // Reach out to mongodb and store it
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(base + 'groups/visits/' + payload.group._id, {
        userId: payload.userId,
        date: payload.date
      }).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateCollectionVisits: function updateCollectionVisits(_ref33, payload) {
      var commit = _ref33.commit;

      console.log(payload);
      // Reach out to mongodb and store it
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(base + 'collections/visits/' + payload.collection._id, {
        userId: payload.userId,
        date: payload.date
      }).then(function (response) {}).catch(function (error) {
        console.log(error);
      });
    },

    loadArtefacts: function loadArtefacts(_ref34) {
      var commit = _ref34.commit;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(base + 'artefacts').then(function (response) {
        commit('loadArtefacts', {
          list: response.data
        });
      }, function (err) {
        console.log(err);
      });
    },
    loadLanguages: function loadLanguages(_ref35) {
      var commit = _ref35.commit;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(base + 'languages').then(function (response) {
        commit('loadLanguages', {
          list: response.data
        });
      }, function (err) {
        console.log(err);
      });
    },
    loadCollections: function loadCollections(_ref36) {
      var commit = _ref36.commit;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(base + 'collections').then(function (response) {
        commit('loadCollections', {
          list: response.data
        });
      }, function (err) {
        console.log(err);
      });
    },
    loadGroups: function loadGroups(_ref37) {
      var commit = _ref37.commit;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(base + 'groups').then(function (response) {
        commit('loadGroups', {
          list: response.data
        });
      }, function (err) {
        console.log(err);
      });
    },
    loadUsers: function loadUsers(_ref38) {
      var commit = _ref38.commit;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(base + 'users').then(function (response) {
        commit('loadUsers', {
          list: response.data
        });
      }, function (err) {
        console.log(err);
      });
    }

  },
  getters: {
    getIdentifier: function getIdentifier(state) {
      return state.userIdentifier;
    },
    loadGlobLang: function loadGlobLang(state) {
      return state.languages.lang;
    },
    loadLang: function loadLang(state) {
      return state.lang;
    },
    loadUsers: function loadUsers(state) {
      return state.users;
    },
    loadSingleUser: function loadSingleUser(state) {
      return function (userId) {
        return state.users.find(function (user) {
          return user._id === userId;
        });
      };
    },
    getUserByEmail: function getUserByEmail(state) {
      return function (email) {
        return state.users.find(function (user) {
          return user.email === email;
        });
      };
    },
    loadArtefacts: function loadArtefacts(state) {
      return state.artefacts.filter(function (artefact) {
        return artefact.reviewed != false && artefact.title[state.lang] != '' && artefact.deleted != true;
      }).reverse();
    },
    loadUnreviewedArtefacts: function loadUnreviewedArtefacts(state) {
      return state.artefacts.filter(function (artefact) {
        return artefact.reviewed == false && artefact.title[state.lang] != '';
      });
    },
    loadToBeDeletedArtefacts: function loadToBeDeletedArtefacts(state) {
      return state.artefacts.filter(function (artefact) {
        return artefact.deleted == true && artefact.title[state.lang] != '';
      });
    },
    getFavoriteArtefacts: function getFavoriteArtefacts(state) {
      return state.artefacts.filter(function (artefact) {
        return artefact.reviewed != false && artefact.title[state.lang] != '' && artefact.deleted != true;
      }).sort(function (a, b) {
        return b.favorite.length - a.favorite.length;
      }).slice(0, 16);
    },
    loadPopularArtefacts: function loadPopularArtefacts(state) {
      return state.artefacts.filter(function (artefact) {
        return artefact.reviewed != false && artefact.title[state.lang] != '' && artefact.deleted != true;
      }).sort(function (a, b) {
        return b.visited - a.visited;
      }).slice(0, 16);
    },
    loadPopularGroups: function loadPopularGroups(state) {
      return state.groups.sort(function (a, b) {
        return b.visited - a.visited;
      }).slice(0, 16);
    },
    loadPopularCollections: function loadPopularCollections(state) {
      return state.collections.sort(function (a, b) {
        return b.visited - a.visited;
      }).slice(0, 16);
    },
    loadAllCollections: function loadAllCollections(state) {
      return state.collections.filter(function (col) {
        return col.title.en != '' || col.title.ro != '' || col.title.sr != '';
      }).reverse();
    },
    loadGroups: function loadGroups(state) {
      return state.groups.filter(function (col) {
        return col.title.en != '' || col.title.ro != '' || col.title.sr != '';
      }).reverse();
    },
    loadArtefactSingle: function loadArtefactSingle(state) {
      return function (artefactId) {
        return state.artefacts.find(function (artefact) {
          return artefact._id === artefactId;
        });
      };
    },
    resolveName: function resolveName(state) {
      return function (info) {
        return state.collections.find(function (artefact) {
          return artefact.title[info.lang] == info.title;
        });
      };
    },
    loadRelatedArtefacts: function loadRelatedArtefacts(state) {
      return function (groupTitle) {
        return state.artefacts.filter(function (artefact) {
          return artefact.collectionId.indexOf(groupTitle) > -1 && artefact.reviewed != false && artefact.deleted == false;
        });
      };
    },
    loadRelatedCollections: function loadRelatedCollections(state) {
      return function (groupTitle) {
        return state.collections.filter(function (collection) {
          return collection.groups.indexOf(groupTitle) > -1;
        });
      };
    },
    loadCollectionSingle: function loadCollectionSingle(state) {
      return function (collectionId) {
        return state.collections.find(function (collection) {
          return collection._id === collectionId;
        });
      };
    },
    loadGroupSingle: function loadGroupSingle(state) {
      return function (groupId) {
        return state.groups.find(function (group) {
          return group._id === groupId;
        });
      };
    },
    loadFavoriteArtefacts: function loadFavoriteArtefacts(state) {
      return function (userId) {
        return state.artefacts.filter(function (artefact) {
          return artefact.favorite.includes(userId);
        });
      };
    },
    loadAddedArtefacts: function loadAddedArtefacts(state) {
      return function (userId) {
        return state.artefacts.filter(function (artefact) {
          return artefact.userId == userId;
        });
      };
    },
    loadFavoriteGroups: function loadFavoriteGroups(state) {
      return function (userId) {
        return state.groups.filter(function (group) {
          return group.favorite.includes(userId);
        });
      };
    },
    loadFavoriteCollections: function loadFavoriteCollections(state) {
      return function (userId) {
        return state.collections.filter(function (collection) {
          return collection.favorite.includes(userId);
        });
      };
    },
    getToken: function getToken(state) {
      return state.token;
    },
    isAdmin: function isAdmin(state) {
      return state.user.role === 'Admin';
    },
    isContrib: function isContrib(state) {
      return state.user.role === 'Contributor';
    },
    isMod: function isMod(state) {
      return state.user.role === 'Moderator';
    },
    isLoggedIn: function isLoggedIn(state) {
      return state.isAuthenticated;
    },
    getUser: function getUser(state) {
      return state.user;
    }
  },
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex_persistedstate__["a" /* default */])()]

});

/***/ }),

/***/ "Iuo/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomRedAddButton_vue__ = __webpack_require__("rsTt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5339ebfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomRedAddButton_vue__ = __webpack_require__("hQmr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BottomRedAddButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5339ebfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BottomRedAddButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J6KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      place: {
        formatted_address: "Add a location or drag marker."
      },
      opened: true
    };
  },

  props: ["location"],
  update: function update() {
    this.$refs.map.resize();
  },

  methods: {
    getScreenWidth: function getScreenWidth() {
      return screen.width;
    }
  },
  computed: {
    center: function center() {
      return {
        lng: this.location.geometry.location.lng,
        lat: this.location.geometry.location.lat
      };
    },
    marker: function marker() {
      if (typeof this.location.geometry.location.lat == 'function') return {
        position: {
          lng: this.location.geometry.location.lng(),
          lat: this.location.geometry.location.lat()
        }
      };else return {
        position: {
          lng: this.location.geometry.location.lng,
          lat: this.location.geometry.location.lat
        }
      };
    },
    ifw: function ifw() {
      return this.location.formatted_address;
    }
  },
  created: function created() {
    if (typeof this.location.geometry.location.lng == 'string') {
      this.location.geometry.location.lng = parseFloat(this.location.geometry.location.lng);
      this.location.geometry.location.lat = parseFloat(this.location.geometry.location.lat);
    } else if (typeof this.location.geometry.location.lng == 'function') {
      this.location.geometry.location.lng = this.location.geometry.location.lng();
      this.location.geometry.location.lat = this.location.geometry.location.lat();
    }
  }
});

/***/ }),

/***/ "JV2V":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2-min[cropped].8d15c80.jpg";

/***/ }),

/***/ "JpW5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/user-icon.9d9d269.png";

/***/ }),

/***/ "K4Ie":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9-min[cropped].b9bf05e.jpg";

/***/ }),

/***/ "K5IR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KIKY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{staticClass:" mr-0 ml-0 mb-3",staticStyle:{"width":"100%"},attrs:{"color":"white","floating":"","dense":"","elevation-1":""}},[_c('v-icon',[_vm._v("location_on")]),_vm._v(" "),_c('gmap-autocomplete',{staticStyle:{"width":"100%"},on:{"place_changed":_vm.setPlace},model:{value:(_vm.place.formatted_address),callback:function ($$v) {_vm.$set(_vm.place, "formatted_address", $$v)},expression:"place.formatted_address"}})],1),_vm._v(" "),_c('Gmap-Map',{ref:"map",staticStyle:{"width":"100%","height":"300px"},attrs:{"zoom":18,"center":_vm.center}},[_c('Gmap-Marker',{attrs:{"position":_vm.marker.position,"clickable":true,"draggable":true},on:{"click":function($event){_vm.center = _vm.marker.position},"position_changed":function($event){_vm.updateChild(_vm.marker, 'position', $event)},"dragend":_vm.getLocation}},[_c('gmap-info-window',{attrs:{"opened":_vm.opened}},[_vm._v(_vm._s(_vm.ifw))])],1),_vm._v(" "),_c('div',{attrs:{"slot":"visible"},slot:"visible"},[_c('div',{staticStyle:{"bottom":"0","left":"0","background-color":"#0000FF","color":"white","position":"absolute","z-index":"100"}},[_vm._v("\n          "+_vm._s(_vm.statusText)+"\n        ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KQ/Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sigla_guv_coroana_gri.8b30e56.png";

/***/ }),

/***/ "KRye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageGroups_vue__ = __webpack_require__("TbTD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_404301a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageGroups_vue__ = __webpack_require__("iYXf");
function injectStyle (ssrContext) {
  __webpack_require__("l8ut")
  __webpack_require__("I0BE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-404301a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageGroups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_404301a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageGroups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KvCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__("vBWZ");
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["a" /* default */] },
  props: ['artefacts'],
  data: function data() {
    return {
      slickOptions2: {
        centerMode: false,
        centerPadding: '80px',
        dots: false,
        infinite: true,
        arrows: false,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 530,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        }]
      }
    };
  },

  methods: {
    next: function next() {
      this.$refs.slick.next();
    },
    prev: function prev() {
      this.$refs.slick.prev();
    },
    reInit: function reInit() {
      var _this = this;

      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(function () {
        _this.$refs.slick.reSlick();
      });
    }
  },
  mounted: function mounted() {
    // this.moveButton(this.isAdmin);
    this.reInit();
  },
  updated: function updated() {
    this.reInit();
  }
});

/***/ }),

/***/ "LBcD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSwiper_vue__ = __webpack_require__("hr7Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5499a864_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListSwiper_vue__ = __webpack_require__("GkqI");
function injectStyle (ssrContext) {
  __webpack_require__("HsHu")
  __webpack_require__("8IwL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5499a864"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSwiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5499a864_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListSwiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LD6I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LzSG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M6uc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_aplayer__ = __webpack_require__("afmS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_dplayer__ = __webpack_require__("u+Ax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_dplayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_dplayer__);


var _computed, _data$mounted$props$m;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (_data$mounted$props$m = {
  data: function data() {
    return {
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      dialog: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      player: null,
      contextmenu: [{
        text: "Download Video",
        link: "https://github.com/MoePlayer/vue-dplayer"
      }]
    };
  },
  mounted: function mounted() {
    //this.player = this.$refs.player.dp
  },

  props: ["id"],

  methods: {
    //     moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';

    //     }
    //     else
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }

    //   },
    imageClick: function imageClick(imageURL) {
      var modal = document.getElementById("myModal");
      var modalImg = document.getElementById("img01");
      modal.style.display = "block";
      modalImg.src = imageURL;
    },
    getScreenWidth: function getScreenWidth() {
      return screen.width;
    },
    restoreArtefact: function restoreArtefact() {
      this.$emit("artefactAccepted", this.artefact._id);
      this.artefact.deleted = false;
      this.$store.dispatch("updateArtefact", this.artefact);
      this.$router.push("/tasks");
    },
    acceptArtefact: function acceptArtefact() {
      this.$emit("artefactAccepted", this.artefact._id);
      this.artefact.reviewed = true;
      this.$store.dispatch("updateArtefact", this.artefact);
      this.$router.push("/tasks");
    },

    deleteArtefact: function deleteArtefact() {
      this.dialog = false;
      this.$emit("deletedArtefact");
      this.$store.dispatch("deleteArtefact", this.artefact);
      this.$router.push("/tasks");
      // axios.delete('http://localhost:3000/artefacts/'+this.id).then((response) => {
      //     this.$router.push("/artefacts");
      // },
      //     (err) => {
      //         console.log(err)
      //     })
    },
    // blabla(){
    //       this.$store.dispatch("loadArtefacts");
    //       this.onResize();
    // },
    spanClick: function spanClick() {
      var modal = document.getElementById("myModal");
      modal.style.display = "none";
    },
    widthChange: function widthChange() {
      var img = document.getElementById("myImg");
      img.style.width = "100px";
    },
    handleSize: function handleSize() {
      var img = document.getElementsByClassName("myImg");

      var i = 0;
      for (i = 0; i < img.length; i++) {
        img[i].style.width = screen.width / 3.5 + "px";
        var height = img[i].style.width;
        img[i].style.height = height;
      }

      // var video = document.getElementById('video');
      // video.style.width = screen.width + 'px';
      // var height = video.style.width;
      // video.style.height = screen.width /2 + 'px';
    },
    handleVideoSize: function handleVideoSize() {
      var video = document.getElementsByClassName("video");
      var videoContainer = document.getElementById("videoContainer");

      var i = 0;
      var sum = 0;
      for (i = 0; i < video.length; i++) {
        var x = video[i].style.width / video[i].style.height;
        video[i].style.height = screen.width * x + "px";
        sum = sum + video[i].style.height;
      }

      videoContainer.style.height = sum + "px";

      // var video = document.getElementById('video');
      // video.style.width = screen.width + 'px';
      // var height = video.style.width;
      // video.style.height = screen.width /2 + 'px';
    },
    play: function play() {}
  },
  created: function created() {
    if (this.artefact == undefined) this.$store.dispatch("loadArtefacts");
    this.artefact.visited++;
    this.$store.dispatch("updateArtefact", this.artefact);
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$mounted$props$m, "mounted", function mounted() {
  //  this.moveButton(this.isAdmin);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$mounted$props$m, "updated", function updated() {
  this.handleSize();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$mounted$props$m, "computed", (_computed = {
  users: function users() {
    return this.$store.getters.loadUsers;
  },
  toBeDeleted: function toBeDeleted() {
    return this.artefact.deleted;
  },
  isAccepted: function isAccepted() {
    return this.artefact.reviewed;
  },
  lang: function lang() {
    return this.$store.getters.loadLang;
  },
  isLoggedIn: function isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  },
  artefact: function artefact() {
    return this.$store.getters.loadArtefactSingle(this.id);
  },
  isAdmin: function isAdmin() {
    return this.$store.getters.isAdmin;
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed, "isAccepted", function isAccepted() {
  return this.artefact.reviewed;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed, "isAuthor", function isAuthor() {
  return this.artefact.userId == this.user._id;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed, "user", function user() {
  return this.$store.getters.getUser;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed, "isMod", function isMod() {
  return this.$store.getters.isMod;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed, "isContrib", function isContrib() {
  return this.$store.getters.isContrib;
}), _computed)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_data$mounted$props$m, "components", {
  "a-player": __WEBPACK_IMPORTED_MODULE_2_vue_aplayer__["a" /* default */],
  "d-player": __WEBPACK_IMPORTED_MODULE_3_vue_dplayer___default.a
}), _data$mounted$props$m);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e258dd76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("lBr9");
function injectStyle (ssrContext) {
  __webpack_require__("emCS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e258dd76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MR55":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mmyn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-1"},[_c('v-card-media',{staticClass:"white--text cardCursor",attrs:{"height":_vm.height,"src":_vm.artefact.mainImg[0].url+'_card'},on:{"click":function($event){_vm.toArtefact1(_vm.artefact._id)}}},[_c('v-container',{staticClass:"grayoverlay",attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{staticClass:"d-block",attrs:{"fill-height":""}},[_c('v-flex',{staticClass:"text-align:left",attrs:{"xs12":""}},[_c('v-icon',{attrs:{"medium":"","dark":""}},[_vm._v("view_carousel")]),_vm._v(" "),_c('span',{staticClass:"body-1",staticStyle:{"text-align":"left","color":"rgba(255,255,255,0.5)"}},[_vm._v(" "+_vm._s(_vm.artefact.collectionId[0]))])],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-5",staticStyle:{"text-align":"left"},attrs:{"xs12":"","align":""}},[_c('a',{staticStyle:{"text-decoration":"none","color":"white","cursor":"pointer","text-align":"left"},on:{"click":function($event){_vm.toArtefact(_vm.artefact._id)}}},[_c('p',{staticClass:"headline"},[_c('span',{staticClass:"headline-artefact mb-1 ml-1 "},[_vm._v(_vm._s(_vm.artefact.title[_vm.lang].slice(0,30).toUpperCase())),(_vm.artefact.title[_vm.lang].length >30)?_c('span',[_vm._v("...")]):_vm._e()])])])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N5L+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-3"},[_c('v-layout',{staticClass:"mt-4",attrs:{"justify-center":""}},[_c('img',{staticStyle:{"opacity":"0.6"},attrs:{"width":"400","height":"400","src":__webpack_require__("beDd"),"alt":""}})]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('h3',{staticStyle:{"opacity":"0.6"}},[_vm._v("Page not found")])]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('p',{staticStyle:{"opacity":"0.7"}},[_vm._v("The page you are looking for does not exist or an error had occured.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__ = __webpack_require__("OEKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stylus_main_styl__ = __webpack_require__("tLfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stylus_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__stylus_main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Filters_date__ = __webpack_require__("2Grs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_smooth_scroll__ = __webpack_require__("295d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_authenticate__ = __webpack_require__("WrNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Partials_PickLocation_vue__ = __webpack_require__("NcY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Partials_PresentLocation_vue__ = __webpack_require__("S4Ux");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Partials_PresentMultipleLocations_vue__ = __webpack_require__("Fo6k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Partials_PresentMultipleLocationsGroups_vue__ = __webpack_require__("cMVq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Partials_GroupCard_vue__ = __webpack_require__("ORBH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Partials_CollectionCard_vue__ = __webpack_require__("HGno");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Partials_ArtefactCard_vue__ = __webpack_require__("yJ/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Partials_ArtefactCardMini_vue__ = __webpack_require__("DWUQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Partials_Slider1_vue__ = __webpack_require__("7MOn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Partials_Slider2_vue__ = __webpack_require__("agMq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Partials_Slider3_vue__ = __webpack_require__("oEvE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Partials_ArtefactSingleTab_vue__ = __webpack_require__("jBrz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Partials_BottomRedAddButton_vue__ = __webpack_require__("Iuo/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Partials_ArtefactPreview_vue__ = __webpack_require__("XqfE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Partials_ChangePersonalInfo_vue__ = __webpack_require__("G9TA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Partials_SearchGlobal_vue__ = __webpack_require__("mMQn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Partials_ListSwiper_vue__ = __webpack_require__("LBcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Partials_ThreeArtefactsCard_vue__ = __webpack_require__("7nbu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Partials_SimpleDescriptionSwiper_vue__ = __webpack_require__("b7vJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Partials_AddArtefactPartial_vue__ = __webpack_require__("R9X9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Partials_MultipleLocationsExplore_vue__ = __webpack_require__("c3Nj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Partials_EditArtefactPartial_vue__ = __webpack_require__("byUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vue_fuse__ = __webpack_require__("XTKK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vue_cookies__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











// import VueAudio from 'vue-audio'




























// var SocialSharing = require('vue-social-sharing');



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date', __WEBPACK_IMPORTED_MODULE_7__Filters_date__["a" /* default */]);
// Vue.use(SocialSharing);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_35_vue_fuse__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-locations-explore', __WEBPACK_IMPORTED_MODULE_33__components_Partials_MultipleLocationsExplore_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-edit-artefact', __WEBPACK_IMPORTED_MODULE_34__components_Partials_EditArtefactPartial_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-add-artefact', __WEBPACK_IMPORTED_MODULE_32__components_Partials_AddArtefactPartial_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-search-global', __WEBPACK_IMPORTED_MODULE_28__components_Partials_SearchGlobal_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-location-picker', __WEBPACK_IMPORTED_MODULE_13__components_Partials_PickLocation_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-location-present-single', __WEBPACK_IMPORTED_MODULE_14__components_Partials_PresentLocation_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-location-present-multiple', __WEBPACK_IMPORTED_MODULE_15__components_Partials_PresentMultipleLocations_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-location-tab', __WEBPACK_IMPORTED_MODULE_24__components_Partials_ArtefactSingleTab_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-group-card', __WEBPACK_IMPORTED_MODULE_17__components_Partials_GroupCard_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-collection-card', __WEBPACK_IMPORTED_MODULE_18__components_Partials_CollectionCard_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-artefact-card', __WEBPACK_IMPORTED_MODULE_19__components_Partials_ArtefactCard_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-artefact-card-mini', __WEBPACK_IMPORTED_MODULE_20__components_Partials_ArtefactCardMini_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-slider1', __WEBPACK_IMPORTED_MODULE_21__components_Partials_Slider1_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-slider2', __WEBPACK_IMPORTED_MODULE_22__components_Partials_Slider2_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-slider3', __WEBPACK_IMPORTED_MODULE_23__components_Partials_Slider3_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-location-present-multiple-groups', __WEBPACK_IMPORTED_MODULE_16__components_Partials_PresentMultipleLocationsGroups_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-speed-dial-add', __WEBPACK_IMPORTED_MODULE_25__components_Partials_BottomRedAddButton_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-artefact-preview', __WEBPACK_IMPORTED_MODULE_26__components_Partials_ArtefactPreview_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-change-info', __WEBPACK_IMPORTED_MODULE_27__components_Partials_ChangePersonalInfo_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-list-swiper', __WEBPACK_IMPORTED_MODULE_29__components_Partials_ListSwiper_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-3-artefacts-card', __WEBPACK_IMPORTED_MODULE_30__components_Partials_ThreeArtefactsCard_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('web-description-swiper', __WEBPACK_IMPORTED_MODULE_31__components_Partials_SimpleDescriptionSwiper_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_36_vue_cookies___default.a);

// Vue.component('vue-audio', VueAudio)

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_smooth_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDdBLpn48Wp6ivOI2CLEwfujRdmm72-rTk',
    libraries: 'places'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  computed: {
    gLang: function gLang() {
      return this.$store.getters.loadGlobLang;
    },
    lang: function lang() {
      return this.$store.getters.loadLang;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_11_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_authenticate__["a" /* default */], {
  baseUrl: __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__["IP_ADRESS"] + 'api/', // Your API domain

  providers: {
    facebook: {
      clientId: '202571340317455',
      redirectUri: __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__["IP_ADRESS"] + 'signin'
    },
    google: {
      clientId: '96967316383-joie7v1o18jqcrjqerbnimaad2lsgf4j.apps.googleusercontent.com',
      redirectUri: __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__["IP_ADRESS"] + 'signin'
    },
    live: {
      clientId: '2157aab6-1ebe-4ca3-ba18-5e8f8398f296',
      redirectUri: __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__["IP_ADRESS"] + 'signin'
    }
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] }
});

/***/ }),

/***/ "NMFQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-0 pa-0",staticStyle:{"width":"100%","background-color":"#FAFAFA"}},[_c('v-layout',{staticClass:" primary pl-2 pr-2 ",attrs:{"row":""}},[_c('v-flex',{staticClass:" mr-3 ml-3 white hidden-md-and-up ",attrs:{"xs12":"","sm12":"","offset-sm2":""}},[_c('h3',{staticClass:"mb-1",staticStyle:{"color":"grey"}},[_vm._v("    Edit Artefact   ")])])],1),_vm._v(" "),_c('v-container',{staticClass:"mt-2 pt-2"},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"ma-1 ",attrs:{"xs12":"","md10":"","offset-md1":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.onUpdateArtefact($event)}}},[_c('v-layout',{staticClass:"white",staticStyle:{"box-shadow":"0 1px 5px rgba(0,0,0,0.2), 0 2px 2px rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12)"},attrs:{"elevation-1":"","wrap":""}},[_c('v-flex',{staticStyle:{"border-right":"1px solid #eeeeee"},attrs:{"xs12":"","md4":""}},[_c('h3',{staticClass:"hidden-sm-and-down pl-2 mb-0",staticStyle:{"color":"grey","height":"67px"}},[_vm._v("Edit Artefact")]),_vm._v(" "),_c('div',[_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2  pl-2 pr-2 pt-2 pb-2 ",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.formUpload.mainImg[0].status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.formUpload.mainImg[0].loading},on:{"click":function($event){_vm.clickInputMain()}}},[_vm._v("Change Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput1",staticClass:"input-file",staticStyle:{"display":"none"},attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, -1); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"  pl-2 pr-2 white  ",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{staticClass:" ",attrs:{"name":"title","label":"Title of Artefact","id":"title","rules":_vm.titleRules,"required":""},model:{value:(_vm.formUpload.title[_vm.lang]),callback:function ($$v) {_vm.$set(_vm.formUpload.title, _vm.lang, $$v)},expression:"formUpload.title[lang]"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"  pl-2 pr-2 white  ",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{staticClass:" ",attrs:{"name":"description","label":"Description of Artefact","id":"description","rules":_vm.titleRules,"required":"","multi-line":""},model:{value:(_vm.formUpload.description[_vm.lang]),callback:function ($$v) {_vm.$set(_vm.formUpload.description, _vm.lang, $$v)},expression:"formUpload.description[lang]"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"white",attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-checkbox',{staticClass:"ml-3 pt-3",attrs:{"label":"Historical Date"},model:{value:(_vm.formUpload.showDate),callback:function ($$v) {_vm.$set(_vm.formUpload, "showDate", $$v)},expression:"formUpload.showDate"}}),_vm._v(" "),(_vm.formUpload.showDate)?_c('v-date-picker',{staticStyle:{"width":"100%"},attrs:{"color":"green lighten-1","locale":_vm.lang,"header-color":"primary"},model:{value:(_vm.formUpload.date),callback:function ($$v) {_vm.$set(_vm.formUpload, "date", $$v)},expression:"formUpload.date"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"box-shadow":"none"},attrs:{"color":""}},[_c('v-card-text',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-layout',{staticClass:"pr-2 pl-2 pa-0 white ",attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"label":"Name of Groups","items":_vm.collections,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":"","persistent-hint":""},model:{value:(_vm.formUpload.collectionId),callback:function ($$v) {_vm.$set(_vm.formUpload, "collectionId", $$v)},expression:"formUpload.collectionId"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"pa-3 map noBoxShadow",attrs:{"height":"415px","elevation-1":""}},[_c('web-location-picker',{attrs:{"marker":_vm.marker,"place":_vm.place,"center":_vm.center,"new":_vm.newLocation},on:{"newLocation":_vm.newLocationMethod,"newMarker":function($event){_vm.$emit('newMarker',$event)}}})],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"position":"relative"},attrs:{"xs12":"","md8":""}},[_c('div',{staticClass:" ",staticStyle:{"height":"100%","position":"relative"}},[_c('v-layout',{staticClass:"hidden-sm-and-down pl-3 pt-3",staticStyle:{"height":"67px"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticStyle:{"color":"grey","font-size":"1.2em"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("info ")]),_vm._v(" "),_c('i',[_vm._v(" To add more info, press "),_c('v-icon',[_vm._v("add_box ")]),_vm._v(", then press "),_c('v-icon',[_vm._v("save ")]),_vm._v(" to save the artefact! ")],1)],1)])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.formUpload.uploads),function(media,index){return _c('div',{key:media._id},[(media.type ==='image')?_c('v-flex',{attrs:{"xs12":""}},[(media.data.length == 0)?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2 pt-2 pb-2 white",attrs:{"row":"","wrap":"","justify-center":"","elevation-1":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload an Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"id":'ref'+index,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1):_c('div',{staticClass:" position:relative",staticStyle:{}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3",attrs:{"elevation-1":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2 justify-center pt-2 pb-2 white hidden-sm-and-down",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Change  Image \n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput1",refInFor:true,staticClass:"input-file",attrs:{"type":"file","id":'ref'+index,"name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_vm._v("Delete\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white hidden-md-and-up",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput(media.positionRef)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"id":media.positionRef,"accept":"audio/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, media.position); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":media.data[0].url,"alt":""}})],1)],1)],1)],1)],1)]):(media.type === 'video')?_c('v-flex',{attrs:{"1":""}},[_c('div',{},[(media.data.length >0)?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3",attrs:{"elevation-1":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white hidden-sm-and-down",attrs:{"row":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Change Video File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"video/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_vm._v("Delete\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white hidden-md-and-up",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"video/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('div',[_c('v-card-media',[_c('div',{},[_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"src":media.data[0].url + '.mp4',"type":"video/mp4"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url + '.webm',"type":"video/webm"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url + '.m4v',"type":"video/m4v"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url + '.ogg',"type":"video/ogg"}}),_vm._v("\nYour browser does not support the video tag.\n")])])])],1)])],1)],1)],1)],1)],1):_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","wrap":"","justify-center":"","elevation-1":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":"","offset-sm2":""}},[_c('v-btn',{class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload a Video\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"video/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1)])]):(media.type === 'audio')?_c('v-flex',[_c('div',{},[(media.data.length >0)?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3",staticStyle:{"background-color":"#FAFAFA"},attrs:{"elevation-1":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2  hidden-sm-and-down",staticStyle:{"background-color":"#FAFAFA"},attrs:{"row":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Change Audio File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"id":'ref'+index,"accept":"audio/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_vm._v("Delete\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white hidden-md-and-up",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"id":media.positionRef,"accept":"audio/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, media.position); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-layout',{staticClass:"pa-1",staticStyle:{"background-color":"#FAFAFA"},attrs:{"row":""}},[_c('div',{staticStyle:{"width":"100%","background-color":"#FAFAFA"}},[_c('v-layout',{staticStyle:{"width":"100%","white-space":"normal"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',[_c('i',[_vm._v(_vm._s(media.data[0].originalName))])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('audio',{staticStyle:{"width":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"src":media.data[0].url,"type":"audio/ogg"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url,"type":"audio/mpeg"}}),_vm._v("\n                                Your browser does not support the audio element.\n                    ")])])],1)],1)])],1)],1)],1)],1)],1)],1)],1):_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","wrap":"","justify-center":"","elevation-1":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload Audio File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"audio/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1)])]):(media.type === 'pdf')?_c('v-flex',[_c('div',{staticClass:"hidden-sm-and-down"},[(media.data.length >0)?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3 pl-2 pr-2  pt-2 pb-2 white",attrs:{"elevation-1":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-btn',{class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Change PDF File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"application/pdf"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"blue white--text"},[_vm._v(" picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(media.data[0].originalName))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":""},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("delete")])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1):_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","wrap":"","justify-center":"","elevation-1":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload a PDF File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"application/pdf"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"hidden-md-and-up"},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","wrap":"","justify-center":"","elevation-1":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'green darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":media.loading},on:{"click":function($event){_vm.clickInput(media.positionRef)}}},[_vm._v("Upload a PDF File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":media.positionRef,"disabled":_vm.isSaving,"accept":"application/pdf"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,media.position); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : media.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1)]):(media.type === 'text')?_c('v-flex',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2 white",attrs:{"row":"","wrap":"","elevation-1":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":"","offset-sm2":""}},[_c('quill-editor',{ref:"myTextEditor",refInFor:true,staticClass:"editor-example bubble",attrs:{"options":_vm.editorOption},model:{value:(media.value[_vm.lang]),callback:function ($$v) {_vm.$set(media.value, _vm.lang, $$v)},expression:"media.value[lang]"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"white--text",staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_vm._v("Delete\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1):_vm._e()],1)}),_vm._v(" "),_c('v-layout',{staticStyle:{"position":"relative"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('div',{staticStyle:{"position":"relative","bottom":"0%","left":"0%"}},[_c('v-speed-dial',{staticClass:"hidden-sm-and-down pl-4 ml-5 mt-5",staticStyle:{"width":"100px"},attrs:{"top":_vm.top1,"bottom":_vm.bottom1,"right":_vm.right1,"left":_vm.left1,"direction":_vm.direction1,"hover":_vm.hover1,"transition":_vm.transition1},model:{value:(_vm.fab1),callback:function ($$v) {_vm.fab1=$$v},expression:"fab1"}},[_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"primary","dark":"","fab":"","hover":""},slot:"activator",model:{value:(_vm.fab1),callback:function ($$v) {_vm.fab1=$$v},expression:"fab1"}},[_c('v-icon',[_vm._v("add_box")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addTextToUploads}},[_c('v-icon',[_vm._v("text_fields")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addImageToUploads}},[_c('v-icon',[_vm._v("photo_library")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addVideoToUploads}},[_c('v-icon',[_vm._v("video_library")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addAudioToUploads}},[_c('v-icon',[_vm._v("library_music")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addPdfToUploads}},[_c('v-icon',[_vm._v("picture_as_pdf")])],1)],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('div',{staticStyle:{"position":"relative","bottom":"0%","right":"0%"}},[_c('v-speed-dial',{staticClass:"hidden-md-and-up mt-5",attrs:{"top":_vm.top,"bottom":_vm.bottom,"right":_vm.right2,"left":_vm.left2,"direction":_vm.direction2,"hover":_vm.hover,"transition":_vm.transition,"fixed":"","id":"bottom_button1"},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[(_vm.formUpload.description[_vm.lang].length > 0 && _vm.formUpload.title[_vm.lang].length > 0 && _vm.formUpload.mainImg[0].url && _vm.isReady)?_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"red","dark":"","fab":"","hover":"","type":"submit"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("save")])],1):_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"actixdscvator","color":"grey darken-2","dark":"","fab":"","hover":""},slot:"actixdscvator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","bottom":"0%","right":"0%"}},[_c('v-speed-dial',{staticClass:"hidden-sm-and-down pr-3 mr-3 mt-5",staticStyle:{"width":"100px"},attrs:{"top":_vm.top,"bottom":_vm.bottom,"right":_vm.right2,"left":_vm.left2,"direction":_vm.direction2,"hover":_vm.hover,"transition":_vm.transition,"fixed":"","id":"bottom_button1"},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[(_vm.formUpload.description[_vm.lang].length > 0 && _vm.formUpload.title[_vm.lang].length > 0 && _vm.formUpload.mainImg[0].url && _vm.isReady)?_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"red","dark":"","fab":"","hover":"","type":"submit"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("save")])],1):_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"grey darken-2","dark":"","fab":"","hover":""},nativeOn:{"click":function($event){_vm.snackbar = true}},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("save")])],1)],1)],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":"red","multi-line":_vm.mode === 'multi-line',"vertical":_vm.mode === 'vertical'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      Required fields must be completed\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1)],2)])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pl-6",attrs:{"row":""}},[_c('v-speed-dial',{staticClass:"hidden-md-and-up",attrs:{"id":"bottom_button","top":_vm.top,"bottom":_vm.bottom,"right":_vm.right,"left":_vm.left,"direction":_vm.direction,"hover":_vm.hover,"transition":_vm.transition,"fixed":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"primary","dark":"","fab":"","hover":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addTextToUploads}},[_c('v-icon',[_vm._v("text_fields")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addImageToUploads}},[_c('v-icon',[_vm._v("photo_library")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addVideoToUploads}},[_c('v-icon',[_vm._v("video_library")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addAudioToUploads}},[_c('v-icon',[_vm._v("library_music")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addPdfToUploads}},[_c('v-icon',[_vm._v("picture_as_pdf")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"container"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NR7a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NS0h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slick',{ref:"slick",attrs:{"options":_vm.slickOptions2}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NcKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_aplayer__ = __webpack_require__("afmS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dplayer__ = __webpack_require__("u+Ax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dplayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_dplayer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import VuePDFViewer from 'vue-instant-pdf-viewer';



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			once: true,
			isLoading: true,
			artefact: {
				_id: "",
				title: {
					en: "",
					sr: "",
					ro: ""
				},
				meta: {
					author: "",
					creationDate: ""
				},
				description: {
					en: "",
					sr: "",
					ro: ""
				},
				mainImg: [{
					url: ""
				}]
			},
			fetchError: null,
			viewPDF: false,
			direction: "left",
			fab: false,
			fling: false,
			hover: false,
			tabs: null,
			top: false,
			dialog: false,
			right: true,
			bottom: true,
			left: false,
			transition: "slide-y-reverse-transition",
			player: null,
			contextmenu: [{
				text: "",
				link: ""
			}]
		};
	},
	metaInfo: function metaInfo() {
		return {
			title: this.sanitizeString(this.artefact.title[this.lang]),
			meta: [{
				vmid: "og:title",
				name: "og:title",
				content: this.sanitizeString(this.artefact.title[this.lang])
			}, { vmid: "og:type", name: "og:type", content: "article" }, {
				vmid: "og:article:published_time",
				name: "og:article:published_time",
				content: this.sanitizeString(this.artefact.meta.creationDate)
			}, {
				vmid: "og:article:author",
				name: "og:article:author",
				content: this.sanitizeString(this.artefact.meta.author)
			}, {
				vmid: "og:article:section",
				name: "og:article:section",
				content: this.sanitizeString(this.artefact.title[this.lang])
			}, { vmid: "og:locale", name: "og:locale", content: "ro_RO" }, {
				vmid: "og:locale:alternate",
				name: "og:locale:alternate",
				content: "sr_SR"
			}, {
				vmid: "og:description",
				name: "og:description",
				content: this.sanitizeString(this.artefact.description[this.lang])
			}, {
				vmid: "og:url",
				name: "og:url",
				content: "https://www.hera.uvt.ro/artefacts/" + this.sanitizeString(this.artefact._id)
			}, {
				vmid: "og:image",
				name: "og:image",
				content: "https://www.hera.uvt.ro" + this.artefact.mainImg[0].url
			}, { vmid: "og:site_name", name: "og:site_name", content: "HErA" }],
			script: [{
				innerHTML: "{ \"@context\": \"http://schema.org\",\n          \"@type\": \"Article\",\n          \"author\": \"" + this.sanitizeString(this.artefact.meta.author) + "\", \n          \"dateCreated\":\"" + this.sanitizeString(this.artefact.meta.creationDate) + "\", \n          \"isFamilyFriendly\":\"true\",\n          \"thumbnailUrl\":\"" + ("https://www.hera.uvt.ro" + this.artefact.mainImg[0].url) + "\",\n          \"name\": \"" + this.sanitizeString(this.artefact.title[this.lang]) + "\",\n          \"description\": \"" + this.sanitizeString(this.artefact.description[this.lang]) + "\",\n          \"image\": \"" + ("https://www.hera.uvt.ro" + this.artefact.mainImg[0].url) + "\",\n          \"url\":\"" + ("https://www.hera.uvt.ro/artefacts/" + this.sanitizeString(this.artefact._id)) + "\"\n           \n           }",
				type: "application/ld+json"
			}]
		};
	},
	mounted: function mounted() {
		window.scrollTo(0, 0);
		this.fetchData();
		//this.player = this.$refs.player.dp
	},

	props: ["id"],

	methods: {
		goToCollectionByName: function goToCollectionByName(col) {
			if (this.collections.find(function (cole) {
				return cole.title.en == col;
			})) {
				var id = this.collections.find(function (cole) {
					return cole.title.en == col;
				})._id;
				this.$router.push("/collections/" + id);
			} else return false;
		},
		getLanguageTranslation: function getLanguageTranslation(col) {
			if (this.collections.find(function (cole) {
				return cole.title.en == col;
			})) return this.collections.find(function (cole) {
				return cole.title.en == col;
			}).title[this.lang];else return false;
		},
		sanitizeString: function sanitizeString(str) {
			str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim, "");
			return str.trim();
		},

		fetchData: function fetchData() {
			var self = this;
			return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/artefacts/" + this.id).then(function (response) {
				if (response.data.name == "CastError") {
					self.$router.push("/404");
				} else {
					self.artefact = response.data;
					self.isLoading = false;
					self.$store.dispatch("updateArtefactVisited", {
						artefact: response.data,
						userId: self.user && self.user != {} && self.user._id ? self.user._id : self.$store.getters.getIdentifier,
						date: Date.now()
					});
				}
			}).catch(function (error) {
				self.fetchError = error;
			});
		},
		addToFav: function addToFav() {
			if (!this.artefact.favorite.includes(this.user._id)) {
				this.artefact.favorite.push(this.user._id);
				this.$store.dispatch("updateArtefact", this.artefact);
			} else {
				for (var i = this.artefact.favorite.length - 1; i >= 0; i--) {
					if (this.artefact.favorite[i] === this.user._id) {
						this.artefact.favorite.splice(i, 1);
						break; //<-- Uncomment  if only the first term has to be removed
					}
				}
				this.$store.dispatch("updateArtefact", this.artefact);
			}
		},

		//     moveButton(admin) {
		//     if(admin) {
		//       var btn = document.getElementById('bottom_button');
		//       btn.style.bottom = '65px';

		//     }
		//     else
		//     {
		//       var btn = document.getElementById('bottom_button');
		//       btn.style.bottom = '15px';
		//     }

		//   },
		imageClick: function imageClick(imageURL) {
			var modal = document.getElementById("myModal");
			var modalImg = document.getElementById("img01");
			modal.style.display = "block";
			modalImg.src = imageURL;
		},
		getScreenWidth: function getScreenWidth() {
			return screen.width;
			console.log(screen.width);
			console.log(screen.availWidth);
			console.log(screen.systemXDPI);
		},
		acceptArtefact: function acceptArtefact() {
			this.artefact.reviewed = true;
			this.$store.dispatch("updateArtefact", this.artefact);
			this.$store.dispatch("loadArtefacts");
		},

		deleteArtefact: function deleteArtefact() {
			if (this.isAdmin && !this.isAccepted || this.isMod && !this.isAccepted) {
				this.$store.dispatch("deleteArtefact", this.artefact);
				this.$store.dispatch("loadArtefacts");
				this.$router.push("/tasks");
			} else {
				this.artefact.deleted = true;
				this.$store.dispatch("updateArtefact", this.artefact);
				this.$router.push("/");
			}

			// this.$store.dispatch("deleteArtefact", this.artefact);
			// this.$router.push("/");
			// axios.delete('http://localhost:3000/artefacts/'+this.id).then((response) => {
			//     this.$router.push("/artefacts");
			// },
			//     (err) => {
			//         console.log(err)
			//     })
		},
		// blabla(){
		//       this.$store.dispatch("loadArtefacts");
		//       this.onResize();
		// },
		spanClick: function spanClick() {
			var modal = document.getElementById("myModal");
			modal.style.display = "none";
		},
		widthChange: function widthChange() {
			var img = document.getElementById("myImg");
			img.style.width = "100px";
		},
		handleSize: function handleSize() {
			var img = document.getElementsByClassName("myImg");
			console.log(img[0]);
			var i = 0;
			for (i = 0; i < img.length; i++) {
				img[i].style.width = screen.width / 3.5 + "px";
				var height = img[i].style.width;
				img[i].style.height = height;
			}

			// var video = document.getElementById('video');
			// video.style.width = screen.width + 'px';
			// var height = video.style.width;
			// video.style.height = screen.width /2 + 'px';
		},
		handleVideoSize: function handleVideoSize() {
			var video = document.getElementsByClassName("video");
			var videoContainer = document.getElementById("videoContainer");
			console.log(video[0]);
			var i = 0;
			var sum = 0;
			for (i = 0; i < video.length; i++) {
				var x = video[i].style.width / video[i].style.height;
				video[i].style.height = screen.width * x + "px";
				sum = sum + video[i].style.height;
				console.log(video[i].style.height);
				console.log(sum);
				console.log(sum);
				console.log(sum);
				console.log(sum);
				console.log(video[i].style.height);
				console.log(video[i].style.height);
				console.log(x);
			}

			videoContainer.style.height = sum + "px";

			// var video = document.getElementById('video');
			// video.style.width = screen.width + 'px';
			// var height = video.style.width;
			// video.style.height = screen.width /2 + 'px';
		},
		play: function play() {
			console.log("play callback");
		}
	},
	created: function created() {
		this.$store.dispatch("loadArtefacts");
	},

	updated: function updated() {
		this.handleSize();
	},
	computed: {
		lang: function lang() {
			return this.$store.getters.loadLang;
		},
		users: function users() {
			return this.$store.getters.loadUsers;
		},
		favorited: function favorited() {
			if (this.artefact.favorite) return this.artefact.favorite.includes(this.user._id);else return false;
		},
		isLoggedIn: function isLoggedIn() {
			return this.$store.getters.isLoggedIn;
		},

		// artefact() {
		//   return this.$store.getters.loadArtefactSingle(this.id);
		// },
		isAdmin: function isAdmin() {
			return this.$store.getters.isAdmin;
		},
		collections: function collections() {
			return this.$store.getters.loadAllCollections;
		},
		isAccepted: function isAccepted() {
			return this.artefact.reviewed;
		},
		isAuthor: function isAuthor() {
			return this.artefact.userId == this.user._id;
		},
		user: function user() {
			return this.$store.getters.getUser;
		},
		isMod: function isMod() {
			return this.$store.getters.isMod;
		},
		isContrib: function isContrib() {
			return this.$store.getters.isContrib;
		}
	},
	components: {
		"a-player": __WEBPACK_IMPORTED_MODULE_1_vue_aplayer__["a" /* default */],
		"d-player": __WEBPACK_IMPORTED_MODULE_2_vue_dplayer___default.a
	},
	watch: {
		id: function id() {
			this.isLoading = true;
			this.fetchData();
		},
		artefact: function artefact() {
			setTimeout(function () {
				document.dispatchEvent(new Event("custom-post-render-event"));
			}, 1000);
		}
	}
});

/***/ }),

/***/ "NcY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickLocation_vue__ = __webpack_require__("1elO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d930c9a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickLocation_vue__ = __webpack_require__("KIKY");
function injectStyle (ssrContext) {
  __webpack_require__("vLwQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PickLocation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d930c9a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PickLocation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nf+A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  props: ["dialog"],
  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"] }
  },
  data: function data() {
    return {
      email: "",
      errorMessage: "",
      successMessage: ""
    };
  },

  methods: {
    submit: function submit() {
      this.$v.$touch();
      this.emailErrors.length == 0 && this.recover();
    },
    recover: function recover() {
      var _this = this;

      this.$store.dispatch('recoverPass', { email: this.email }).then(function (response) {
        console.log(response.data.error);
        if (response.data.error) {
          _this.successMessage = "";
          _this.errorMessage = response.data.error;
        } else if (response.data.success) {
          _this.errorMessage = "";
          _this.successMessage = response.data.success;
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  computed: {
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    }
  }
});

/***/ }),

/***/ "NjCK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1-min[cropped].4f03d12.jpg";

/***/ }),

/***/ "Nk69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O+J0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OEKd":
/***/ (function(module, exports) {

// module.exports = {
//   IP_ADRESS: 'http://localhost:8000/',
//   API_ADRESS: 'http://194.102.63.137:3000/'
// }

module.exports = {
  IP_ADRESS: 'https://hera.uvt.ro/',
  API_ADRESS: 'http://194.102.63.137:3000/'
};

/***/ }),

/***/ "OIKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[(_vm.lang == 'ro')?_c('div',{staticClass:"ro"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("Exercitarea oricăror drepturi prevăzute de prezenta licenţă asupra Operei valorează acceptarea acestuia. Conform termenilor şi obligaţiilor din prezenţa licenţă, în măsura în care prezenta licenţă poate fi considerată un contract, Ofertantul propune Acceptantului exercitarea drepturilor menţionate mai jos, iar Acceptantul este de acord cu termenii şi condiţiile licenţei.")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("De asemenea, se consideră publică orice comunicare a unei Opere, prin mijloace cu fir sau fără fir, realizată prin punerea la dispoziţie publicului, inclusiv prin internet sau alte reţele de calculatoare, astfel încât oricare dintre membrii publicului să poată avea acces la aceasta din orice loc sau în orice moment ales în mod individual.")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("dreptul de a reproduce Opera, de a o încorpora într-una sau mai multe Colecţii şi de a reproduce Opera aşa cum aceasta a fost încorporată într-o Colecţie;")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("dreptul de a crea şi de a reproduce Adaptări;")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("dreptul de a distribui şi comunica public Opera, inclusiv încorporată în Colecţii;")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("dreptul de a distribui şi a comunica public Adaptări;")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("în cazul în care opera este o bază de date, dreptul de a extrage şi/sau a reutiliza părţi substanţiale din Operă.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("Drepturile menţionate mai sus pot fi exercitate în cazul tuturor suporturilor şi formatelor. Drepturile menţionate mai sus includ şi dreptul de a face modificările tehnice corespunzătoare necesare exercitării lor în cazul altor suporturi sau formate. Toate drepturile care nu sunt expres acordate de Ofertant sau asupra cărora Ofertantul nu are dreptul de gestiune, rămân rezervate, în special în cazurile de gestiune colectivă obligatorie aplicabile, menţionate în articolul 4 lit.f) .")]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("Acceptantul poate distribui sau comunica public Opera numai în condiţiile prezentei licenţe. Acceptantul este obligat să includă o copie a licenţei sau adresa acesteia pe Internet (U.R.I. - Uniform Resource Indicator) împreună cu fiecare copie a Operei care este distribuită sau comunicată public. Acceptantul nu are dreptul de a oferi sau impune nici o condiţie asupra Operei, care să modifice sau să restricţioneze prevederile acestei licenţe sau exercitarea drepturilor terţilor dobânditori, aşa cum sunt ele prevăzute de prezenta licenţă. Acceptantul nu are dreptul de a sublicenţia Opera. Acceptantul este obligat să păstreze intacte toate notificările care se referă la prezenta licenţă şi la exonerarea de răspundere în fiecare copie a Operei pe care o distribuie sau comunică public. Acceptantul nu are dreptul de a distribui sau de a comunica public Opera folosind o măsură tehnică de protecţie care restrânge posibilitatea terţilor dobânditori de a-şi exercita drepturile obţinute în condiţiile prezentei licenţe. Această lit.a) se aplică Operei încorporate într-o Colecţie, dar nu se extinde în mod obligatoriu asupra celorlalte Opere conţinute în Colecţie. Dacă Acceptantul creează o Colecţie, la notificarea oricărui Ofertant, este obligat, în măsura în care este posibil, să înlăture din Colecţie orice referinţă la respectivul Ofertant, la Titularul de drepturi conexe sau la Autorul Operei, aşa după cum este cerut de articolul 4 lit.e). Dacă Acceptantul creează o Adaptare, la notificarea oricărui Ofertant este obligat, în măsura în care este posibil, să înlăture din Adaptare orice referinţă la respectivul Ofertant, la Titularul de drepturi conexe sau la Autorul Operei , după cum este cerut de articolul 4 lit.e).")]),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("Acceptantul nu poate exercita nici unul dintre drepturile acordate prin articolul 3 cu intenţia sau scopul de a obţine un avantaj sau profit comercial sau o compensaţie financiară personală. Schimbul Operei cu alte Opere, care sunt protejate de drepturi de autor sau drepturi conexe, prin partajarea electronică de fişiere („file-sharing”) sau prin orice alte mijloace nu va fi considerat schimb cu intenţia sau scopul de a obţine un avantaj sau profit comercial sau o compensaţie financiară personală, cu condiţia să nu existe nici un fel de plată în legătură cu schimbul de Opere protejate de drept de autor.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("Pentru evitarea oricărei neînţelegeri: Restricţiile menţionate la lit.(a) (b) şi (c) nu se aplică acelor Opere care îndeplinesc doar criteriul dreptului sui generis asupra unei baze de date în conformitate cu legea română privind dreptul de autor şi drepturile conexe.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("În cazul în care Acceptantul distribuie sau comunică public Opera sau orice Adaptare sau Colecţie, Acceptantul este obligat, cu excepţia cererilor făcute în baza art. 4 lit.a), să păstreze intacte toate toate informaţiile şi notificările privind drepturile de autor sau conexe asupra Operei şi să furnizeze următoarele informaţii, în funcţie de mediul său mediile utilizate: (i) numele Autorului şi/sau al Titularului de drepturi conexe (sau pseudonimul, după caz), dacă acesta a fost adus la cunoştinţă, şi/sau numele părţii desemnate de Autor, Titular de Drepturi Conexe şi/sau de Ofertant pentru atribuirea Operei, în notificările Ofertantului privind drepturile de autor, condiţiile de utilizare sau alte menţiuni disponibile; (ii) titlul Operei, dacă este furnizat; (iii) în măsura în care este posibil şi dacă există, adresa pe Internet (U.R.I.) pe care Ofertantul o desemnează pentru a fi asociată cu Opera, cu excepţia cazului în care această adresă nu se referă la informaţiile privind paternitatea Operei şi condiţiile de utilizare a Operei; şi (iv) în conformitate cu articolul 3 lit.b), în cazul unei Adaptări, o menţiune care să identifice utilizarea Operei în Adaptare (de ex. „traducere în limba romană a operei autorului” sau „scenariu bazat pe operă originală a autorului”). Menţiunea cerută în prezenta lit.e) poate fi introdusă în orice modalitate adecvată; cu toate acestea, în cazul unei Adaptări sau Colecţii, dacă apar menţiuni similare pentru toţi Autorii care contribuie la Adaptare sau Colecţie, cel puţin o astfel de menţiune este necesar a fi introdusă ca parte a acestor menţiuni şi în aceeaşi măsură ca pentru ceilalţi Autori. Pentru evitarea oricărei neînţelegeri, Acceptantul poate folosi menţiunea cerută în această secţiune doar în scopul atribuirii în modalitatea prevăzută anterior, iar în scopul exercitării drepturilor în condiţiile prezentei licenţe Acceptantul nu are dreptul de a susţine sau a sugera, direct sau indirect, orice legătură, finanţare sau susţinere din partea Autorului, Titularului de Drepturi Conexe, Ofertantului sau părţii desemnate de aceştia pentru atribuire, după caz, pentru Acceptant sau utilizarea Operei de către Acceptant, cu excepţia permisiunilor separate, exprese, acordate în scris şi anterior de către Autor, Titularul de drepturi conexe, Ofertant sau partea desemnată de aceştia pentru atribuire.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("În cazul în care un tip de utilizare a Operei ar fi supusă unui regim legal de gestiune colectivă obligatorie, Ofertantul îşi rezervă dreptul exclusiv de a colecta remuneraţiile respective prin intermediul organismului de gestiune colectivă competent. Se face referinţă în special la dreptul la remuneraţie compensatorie pentru copia privată, dreptul la remuneraţia echitabilă pentru împrumutul public, dreptul de suită, dreptul de radiodifuziune a Operelor muzicale, dreptul de comunicare publică a Operelor muzicale, cu excepţia proiecţiei publice a Operelor cinematografice, dreptul la remuneraţie echitabilă recunoscut artiştilor interpreţi şi producătorilor de fonograme pentru comunicarea publică şi radiodifuzarea fonogramelor de comerţ sau a reproducerilor acestora, şi dreptul de retransmitere prin cablu.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("Exceptând alte prevederi expres convenite în scris de către Ofertant sau permise de legea aplicabilă, dacă Acceptantul reproduce, distribuie sau comunică public Opera ca atare sau ca parte a unei Adaptări sau Colecţii, Acceptantul nu are dreptul de a deformă, mutila, modifica sau de a lua orice măsuri derogatorii cu privire la Operă, care ar aduce prejudicii onoarei şi reputaţiei Autorului sau Titularului de drepturi conexe.")]),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Prin punerea Operei la dispoziţia publicului conform termenilor acestei licenţe, Ofertantul declară de bună credinţă că, în conformitate cu ceea ce cunoaşte şi în limite rezonabile:")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Ofertantul a obţinut toate drepturile necesare asupra Operei pentru a putea autoriza exerciţiul drepturilor acordate prin prezenta licenţă şi a permite utilizarea netulburată şi exerciţiul licit al acestor drepturi, aceasta fără ca Acceptantul să aibă o obligaţie de a plăti vreo remuneraţie, cu excepţia celor prevăzute de mecanismele de gestiune colectivă obligatorie descrise la art. 4 lit.f) ;")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Opera nu dă naştere vreunei încălcări a drepturilor unor terţe persoane, în special drepturi de autor sau drepturi conexe, drepturi la marcă, drepturi la informaţie, drepturi civile sau oricare alte drepturi, şi nici vreunei defăimări, violări a dreptului la viaţa privată sau vreunui alt fapt ilicit cu privire la oricare altă terţă parte.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Cu excepţia cazurilor prevăzute expres în prezenta licenţă sau într-un alt acord scris, sau cerute de legea aplicabilă, Opera este pusă la dispoziţie fără vreo garanţie de orice fel, expresă sau tacită, inclusiv în ceea ce priveşte conţinutul sau exactitatea Operei.")]),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("În limitele indicate mai sus, prezenta licenţă se aplică pe întreaga durată de protecţie a Operei conform legii aplicabile. Cu toate acestea, Ofertantul îşi rezervă dreptul de a exploata Opera şi în alte condiţii contractuale sau de a înceta oricând distribuirea Operei; totuşi, utilizarea acestei opţiuni a Ofertantului nu va conduce la restrângerea efectelor prezentei licenţe (sau a oricărei alte licenţe care a fost sau trebuie să fie acordată conform condiţiilor acestei licenţe), iar licenţa va continua să producă efecte depline, până la rezilierea sa în baza prevederilor menţionate mai sus.")]),_vm._v(" "),_vm._m(25),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Cu fiecare reproducere sau comunicare publică în format digital de către Acceptant a Operei sau a unei Colecţii, Ofertantul face primitorului o ofertă de licenţă având ca obiect Opera, conţinând aceleaşi condiţii ca şi prezenta licenţă încheiată cu Acceptantul.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Cu fiecare reproducere sau comunicare publică în format digital de către Acceptant a Adaptării, Ofertantul face primitorului o ofertă de licenţă având ca obiect Opera originală, conţinând aceleaşi condiţii ca şi prezenta licenţă încheiată cu Acceptantul.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Dacă o prevedere a acestei licenţe este nulă, invalidă sau inaplicabilă conform legislaiei în vigoare, validitatea sau aplicabilitatea celorlalte dispoziţii ale licenţei nu va fi afectată. Fără a fi necesare alte acţiuni ale părţilor licenţei, prevederile invalide sau inaplicabile vor fi interpretate în măsura minimă necesară pentru a deveni valide şi aplicabile.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Nu se va considera că s-a renunţat la vreo prevedere a prezentei licenţe sau la invocarea încălcării acesteia, cu excepţia cazului în care astfel de renunţare este în scris şi semnată de partea care suportă consecinţele renunţării.")]),_vm._v(" "),_vm._m(26),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("Dreptul aplicabil este dreptul român.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("Creative Commons nu este parte a acestei licenţe şi nu acordă nici o garanţie legată de Operă. Creative Commons nu va fi răspunzătoare faţă de Acceptant sau faţă de orice altă persoană, în conformitate cu nici o doctrină juridică, pentru nici un fel de prejudicii, inclusiv, cu titlu exemplificativ, orice prejudicii directe, indirecte, materiale sau morale produse în legătură cu această licenţă. Prin excepţie de la cele două teze anterioare, dacă Creative Commons s-a identificat în mod expres că fiind Ofertant în accepţiunea acestei licenţe, atunci va avea toate drepturile şi obligaţiile Ofertantului.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"lang":"fr-FR","align":"justify"}},[_vm._v("Cu excepţia scopului limitat la a indica publicului că Opera este licenţiată conform LPCC (Licenţa Publică Creative Commons), Creative Common nu autorizează utilizarea de către nici una dintre părţi a mărcii „Creative Commons” sau orice altă marcă sau însemn al Creative Commons fără consimţământul prealabil exprimat în scris al Creative Commons. Orice utilizare autorizată va fi în concordanţă cu specificaţiile corespunzătoare privind utilizarea mărcii, aşa cum vor fi publicate pe site-ul oficial al Creative Commons sau aşa cum vor fi puse la dispoziţie periodic la cerere. Pentru evitarea oricărei neînţelegeri, limitarea dreptului de a folosi marca Creative Commons nu face parte din prezenţa licenţă.")])]):_vm._e(),_vm._v(" "),(_vm.lang=='en' )?_c('div',{staticClass:"en"},[_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("THE WORK (AS DEFINED BELOW) IS PROVIDED UNDER THE TERMS OF THIS CREATIVE COMMONS PUBLIC LICENSE (\"CCPL\" OR \"LICENSE\"). THE WORK IS PROTECTED BY COPYRIGHT AND/OR OTHER APPLICABLE LAW. ANY USE OF THE WORK OTHER THAN AS AUTHORIZED UNDER THIS LICENSE OR COPYRIGHT LAW IS PROHIBITED.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("BY EXERCISING ANY RIGHTS TO THE WORK PROVIDED HERE, YOU ACCEPT AND AGREE TO BE BOUND BY THE TERMS OF THIS LICENSE. TO THE EXTENT THIS LICENSE MAY BE CONSIDERED TO BE A CONTRACT, THE LICENSOR GRANTS YOU THE RIGHTS CONTAINED HERE IN CONSIDERATION OF YOUR ACCEPTANCE OF SUCH TERMS AND CONDITIONS.")]),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_vm._m(34),_vm._v(" "),_vm._m(35),_vm._v(" "),_vm._m(36),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_vm._m(40),_vm._v(" "),_vm._m(41),_vm._v(" "),_vm._m(42),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("to Reproduce the Work, to incorporate the Work into one or more Collections, and to Reproduce the Work as incorporated in the Collections;")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("to create and Reproduce Adaptations provided that any such Adaptation, including any translation in any medium, takes reasonable steps to clearly label, demarcate or otherwise identify that changes were made to the original Work. For example, a translation could be marked \"The original work was translated from English to Spanish,\" or a modification could indicate \"The original work has been modified.\";")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("to Distribute and Publicly Perform the Work including as incorporated in Collections; and,")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("to Distribute and Publicly Perform Adaptations.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("The above rights may be exercised in all media and formats whether now known or hereafter devised. The above rights include the right to make such modifications as are technically necessary to exercise the rights in other media and formats. Subject to Section 8(f), all rights not expressly granted by Licensor are hereby reserved, including but not limited to the rights set forth in Section 4(d).")]),_vm._v(" "),_vm._m(43),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("You may Distribute or Publicly Perform the Work only under the terms of this License. You must include a copy of, or the Uniform Resource Identifier (URI) for, this License with every copy of the Work You Distribute or Publicly Perform. You may not offer or impose any terms on the Work that restrict the terms of this License or the ability of the recipient of the Work to exercise the rights granted to that recipient under the terms of the License. You may not sublicense the Work. You must keep intact all notices that refer to this License and to the disclaimer of warranties with every copy of the Work You Distribute or Publicly Perform. When You Distribute or Publicly Perform the Work, You may not impose any effective technological measures on the Work that restrict the ability of a recipient of the Work from You to exercise the rights granted to that recipient under the terms of the License. This Section 4(a) applies to the Work as incorporated in a Collection, but this does not require the Collection apart from the Work itself to be made subject to the terms of this License. If You create a Collection, upon notice from any Licensor You must, to the extent practicable, remove from the Collection any credit as required by Section 4(c), as requested. If You create an Adaptation, upon notice from any Licensor You must, to the extent practicable, remove from the Adaptation any credit as required by Section 4(c), as requested.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("You may not exercise any of the rights granted to You in Section 3 above in any manner that is primarily intended for or directed toward commercial advantage or private monetary compensation. The exchange of the Work for other copyrighted works by means of digital file-sharing or otherwise shall not be considered to be intended for or directed toward commercial advantage or private monetary compensation, provided there is no payment of any monetary compensation in connection with the exchange of copyrighted works.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("If You Distribute, or Publicly Perform the Work or any Adaptations or Collections, You must, unless a request has been made pursuant to Section 4(a), keep intact all copyright notices for the Work and provide, reasonable to the medium or means You are utilizing: (i) the name of the Original Author (or pseudonym, if applicable) if supplied, and/or if the Original Author and/or Licensor designate another party or parties (e.g., a sponsor institute, publishing entity, journal) for attribution (\"Attribution Parties\") in Licensor's copyright notice, terms of service or by other reasonable means, the name of such party or parties; (ii) the title of the Work if supplied; (iii) to the extent reasonably practicable, the URI, if any, that Licensor specifies to be associated with the Work, unless such URI does not refer to the copyright notice or licensing information for the Work; and, (iv) consistent with Section 3(b), in the case of an Adaptation, a credit identifying the use of the Work in the Adaptation (e.g., \"French translation of the Work by Original Author,\" or \"Screenplay based on original Work by Original Author\"). The credit required by this Section 4(c) may be implemented in any reasonable manner; provided, however, that in the case of a Adaptation or Collection, at a minimum such credit will appear, if a credit for all contributing authors of the Adaptation or Collection appears, then as part of these credits and in a manner at least as prominent as the credits for the other contributing authors. For the avoidance of doubt, You may only use the credit required by this Section for the purpose of attribution in the manner set out above and, by exercising Your rights under this License, You may not implicitly or explicitly assert or imply any connection with, sponsorship or endorsement by the Original Author, Licensor and/or Attribution Parties, as appropriate, of You or Your use of the Work, without the separate, express prior written permission of the Original Author, Licensor and/or Attribution Parties.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("For the avoidance of doubt:")]),_vm._v(" "),_vm._m(44),_vm._v(" "),_vm._m(45),_vm._v(" "),_vm._m(46),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Except as otherwise agreed in writing by the Licensor or as may be otherwise permitted by applicable law, if You Reproduce, Distribute or Publicly Perform the Work either by itself or as part of any Adaptations or Collections, You must not distort, mutilate, modify or take other derogatory action in relation to the Work which would be prejudicial to the Original Author's honor or reputation. Licensor agrees that in those jurisdictions (e.g. Japan), in which any exercise of the right granted in Section 3(b) of this License (the right to make Adaptations) would be deemed to be a distortion, mutilation, modification or other derogatory action prejudicial to the Original Author's honor and reputation, the Licensor will waive or not assert, as appropriate, this Section, to the fullest extent permitted by the applicable national law, to enable You to reasonably exercise Your right under Section 3(b) of this License (right to make Adaptations) but not otherwise.")]),_vm._v(" "),_vm._m(47),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("UNLESS OTHERWISE MUTUALLY AGREED TO BY THE PARTIES IN WRITING, LICENSOR OFFERS THE WORK AS-IS AND MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND CONCERNING THE WORK, EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, INCLUDING, WITHOUT LIMITATION, WARRANTIES OF TITLE, MERCHANTIBILITY, FITNESS FOR A PARTICULAR PURPOSE, NONINFRINGEMENT, OR THE ABSENCE OF LATENT OR OTHER DEFECTS, ACCURACY, OR THE PRESENCE OF ABSENCE OF ERRORS, WHETHER OR NOT DISCOVERABLE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO SUCH EXCLUSION MAY NOT APPLY TO YOU.")]),_vm._v(" "),_vm._m(48),_vm._v(" "),_vm._m(49),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("This License and the rights granted hereunder will terminate automatically upon any breach by You of the terms of this License. Individuals or entities who have received Adaptations or Collections from You under this License, however, will not have their licenses terminated provided such individuals or entities remain in full compliance with those licenses. Sections 1, 2, 5, 6, 7, and 8 will survive any termination of this License.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Subject to the above terms and conditions, the license granted here is perpetual (for the duration of the applicable copyright in the Work). Notwithstanding the above, Licensor reserves the right to release the Work under different license terms or to stop distributing the Work at any time; provided, however that any such election will not serve to withdraw this License (or any other license that has been, or is required to be, granted under the terms of this License), and this License will continue in full force and effect unless terminated as stated above.")]),_vm._v(" "),_vm._m(50),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Each time You Distribute or Publicly Perform the Work or a Collection, the Licensor offers to the recipient a license to the Work on the same terms and conditions as the license granted to You under this License.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Each time You Distribute or Publicly Perform an Adaptation, Licensor offers to the recipient a license to the original Work on the same terms and conditions as the license granted to You under this License.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("If any provision of this License is invalid or unenforceable under applicable law, it shall not affect the validity or enforceability of the remainder of the terms of this License, and without further action by the parties to this agreement, such provision shall be reformed to the minimum extent necessary to make such provision valid and enforceable.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("No term or provision of this License shall be deemed waived and no breach consented to unless such waiver or consent shall be in writing and signed by the party to be charged with such waiver or consent.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("This License constitutes the entire agreement between the parties with respect to the Work licensed here. There are no understandings, agreements or representations with respect to the Work not specified here. Licensor shall not be bound by any additional provisions that may appear in any communication from You. This License may not be modified without the mutual written agreement of the Licensor and You.")]),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("The rights granted under, and the subject matter referenced, in this License were drafted utilizing the terminology of the Berne Convention for the Protection of Literary and Artistic Works (as amended on September 28, 1979), the Rome Convention of 1961, the WIPO Copyright Treaty of 1996, the WIPO Performances and Phonograms Treaty of 1996 and the Universal Copyright Convention (as revised on July 24, 1971). These rights and subject matter take effect in the relevant jurisdiction in which the License terms are sought to be enforced according to the corresponding provisions of the implementation of those treaty provisions in the applicable national law. If the standard suite of rights granted under applicable copyright law includes additional rights not granted under this License, such additional rights are deemed to be included in the License; this License is not intended to restrict the license of any rights under applicable law.")]),_vm._v(" "),_vm._m(51),_vm._v(" "),_c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Creative Commons Notice")]),_vm._v(" "),_c('p',{staticClass:"western"},[_vm._v("Creative Commons is not a party to this License, and makes no warranty whatsoever in connection with the Work. Creative Commons will not be liable to You or any party on any legal theory for any damages whatsoever, including without limitation any general, special, incidental or consequential damages arising in connection to this license. Notwithstanding the foregoing two (2) sentences, if Creative Commons has expressly identified itself as the Licensor hereunder, it shall have all rights and obligations of Licensor.")]),_vm._v(" "),_c('p',{staticClass:"western"},[_vm._v("Except for the limited purpose of indicating to the public that the Work is licensed under the CCPL, Creative Commons does not authorize the use by either party of the trademark \"Creative Commons\" or any related trademark or logo of Creative Commons without the prior written consent of Creative Commons. Any permitted use will be in compliance with Creative Commons' then-current trademark usage guidelines, as may be published on its website or otherwise made available upon request from time to time. For the avoidance of doubt, this trademark restriction does not form part of the License.")]),_vm._v(" "),_vm._m(52),_vm._v(" "),_c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.lang == 'sr')?_c('div',{staticClass:"sr"},[_vm._m(53),_vm._v(" "),_vm._m(54),_vm._v(" "),_vm._m(55),_vm._v(" "),_vm._m(56),_vm._v(" "),_vm._m(57),_vm._v(" "),_vm._m(58),_vm._v(" "),_vm._m(59),_vm._v(" "),_vm._m(60),_vm._v(" "),_vm._m(61),_vm._v(" "),_vm._m(62),_vm._v(" "),_vm._m(63),_vm._v(" "),_vm._m(64),_vm._v(" "),_vm._m(65),_vm._v(" "),_vm._m(66),_vm._v(" "),_vm._m(67),_vm._v(" "),_vm._m(68),_vm._v(" "),_vm._m(69),_vm._v(" "),_vm._m(70),_vm._v(" "),_vm._m(71),_vm._v(" "),_vm._m(72),_vm._v(" "),_vm._m(73),_vm._v(" "),_vm._m(74),_vm._v(" "),_vm._m(75),_vm._v(" "),_vm._m(76),_vm._v(" "),_vm._m(77),_vm._v(" "),_vm._m(78),_vm._v(" "),_vm._m(79),_vm._v(" "),_vm._m(80),_vm._v(" "),_vm._m(81),_vm._v(" "),_vm._m(82),_vm._v(" "),_vm._m(83),_vm._v(" "),_vm._m(84),_vm._v(" "),_vm._m(85),_vm._v(" "),_vm._m(86),_vm._v(" "),_vm._m(87),_vm._v(" "),_vm._m(88),_vm._v(" "),_vm._m(89),_vm._v(" "),_vm._m(90),_vm._v(" "),_vm._m(91),_vm._v(" "),_vm._m(92),_vm._v(" "),_vm._m(93),_vm._v(" "),_vm._m(94),_vm._v(" "),_vm._m(95),_vm._v(" "),_vm._m(96),_vm._v(" "),_vm._m(97),_vm._v(" "),_vm._m(98),_vm._v(" "),_vm._m(99),_vm._v(" "),_vm._m(100),_vm._v(" "),_vm._m(101),_vm._v(" "),_vm._m(102),_vm._v(" "),_vm._m(103),_vm._v(" "),_c('p',{attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{attrs:{"align":"justify"}},[_vm._v(" ")]),_vm._v(" "),_vm._m(104),_vm._v(" "),_vm._m(105),_vm._v(" "),_vm._m(106),_vm._v(" "),_vm._m(107)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_c('em',[_vm._v("Prin utilizarea acestui site utilizatorul acceptă licența "),_c('em',[_vm._v("Creative Commons Public License (CCPL)")]),_vm._v(" reprodusă mai jos. Sunt exceptate materialele distribuite explicit sub o altă licenţă. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_c('em',[_vm._v("Dacă nu este specificat altfel, Universitatea de Vest din Timişoara este deţinătorul drepturilor intelectuale asupra sitelui şi asupra materialelor publicate pe acesta.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"large"}},[_c('strong',[_vm._v("Organizaţia Creative Commons (desemnată în continuare prin „Creative Commons”) nu este o firmă de avocatură şi nu acordă servicii de asistenţă juridică. Distribuirea acestei licenţe nu creează o relaţie de tip Avocat-Client. Creative Commons oferă această formă de licenţă, aşa cum este. Creative Commons nu îşi asumă răspunderea pentru daunele rezultate din conţinutul său utilizarea acestei licenţe. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_c('em',[_vm._v("Licenţa")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Opera (aşa cum este definită mai jos) este furnizată în condiţiile acestei Licenţe Publice Creative Commons („LPCC” sau „licenţă”). "),_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("Opera este protejată de legea privind drepturile de autor şi drepturile conexe şi de celelalte norme de drept aplicabile. Orice utilizare a Operei, în afara celei autorizate prin această licenţă sau prin legislaţia în vigoare este interzisă. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("1. Definiţii ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("„"),_c('strong',[_vm._v("Opera")]),_vm._v("” desemnează opera originală de creaţie intelectuală susceptibilă de protecţie prin dreptul de autor şi drepturile conexe, furnizată în condiţiile prezenţei licenţe. În cadrul acestei licenţe prin Operă se vor înţelege şi o fonogramă, o videogramă, un program de radiodifuziune ori de televiziune, ca şi o bază de date conform definiţiilor din legislaţia în vigoare privind drepturile de autor şi drepturile conexe, cu condiţia ca o asemenea fonogramă, videogramă, program de radiodifuziune ori de televiziune sau bază de date să fie protejate şi de legea aplicabilă în jurisdicţia Acceptantului.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("\""),_c('strong',[_vm._v("Adaptare")]),_vm._v("\" desemnează o Operă creată pe baza unei alte Opere sau pe baza unei Opere şi a unor alte Opere preexistente, aşa cum sunt traducerile, adaptările, operele derivate, aranjamentele muzicale sau alte alterări ale unor opere literare sau artistice sau ale unor fonograme sau comunicări publice, incluzând adaptările cinematografice sau orice alte adaptări prin care Opera poate fi modificată, transformată sau adaptată, incluzând în orice formă părţi uşor de recunoscut ale originalului. Fac excepţie Colecţiile, care nu vor fi considerate Adaptări potrivit scopului prezenţei licenţe. Pentru evitarea oricărei neînţelegeri, atunci când Opera este o creaţie muzicală, interpretare muzicală sau fonogramă, sincronizarea Operei în relaţie temporală cu o imagine aflată în mişcare (\"sincronizare\") va fi considerată Adaptare potrivit scopului prezenţei licenţe.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("\""),_c('strong',[_vm._v("Colecţie")]),_vm._v("\" - desemnează un cumul de Opere literare sau artistice, aşa cum sunt enciclopediile şi antologiile, sau interpretările, execuţiile, fonogramele sau programele de radiodifuziune ori de televiziune, precum şi orice alte Opere sau subiecte, altele decât operele listate în secţiunea 1 (a). Acestea, prin selecţia şi aranjamentul conţinutului lor, constituie creaţii intelectuale în care o Operă este inclusă în integralitatea ei în noua Operă, alături de una sau mai multe contribuţii, fiecare reprezentând Opere separate şi independente, care împreună dobândesc o formă colectivă. În sensul acestui contract, o Operă care constituie o Colecţie nu va fi considerată Adaptare.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("\"Autorul\" ")]),_vm._v("desemnează în cazul unei Opere literare sau artistice, persoana sau persoanele fizice sau juridice care au creat Opera.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("„"),_c('strong',[_vm._v("Titularul de drepturi conexe” ")]),_vm._v("desemneaza persoanele fizice sau juridice titulare de drepturi conexe dreptului de autor, care pot fi: (i) artiştii interpreţi sau executanţi, în cazul execuţiei sau interpretării; (ii) producătorul de înregistrări sonore şi de înregistrări audiovizuale, în cazul unei fonograme sau respectiv videograme ; şi (iii)organismele de radiodifuziune şi televiziune, în cazul programelor de radiodifuziune şi televiziune.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("\""),_c('strong',[_vm._v("Ofertantul")]),_vm._v("\" desemnează persoana sau persoanele fizice şi/sau juridice care pun la dispoziţie Opera, în condiţiile prezentei licenţe.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("„"),_c('strong',[_vm._v("Acceptantul” ")]),_vm._v("desemnează persoana fizică şi/sau persoana juridică care acceptă prezenta licenţă şi exercită drepturile acordate, fără să fi încălcat în prealabil termenii licenţei, sau care a primit permisiunea expresă a Ofertantului de a exercita drepturile conferite prin prezenta licenţă, în pofida unei încălcări anterioare a prevederilor acesteia.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("\""),_c('strong',[_vm._v("Comunicare publică")]),_vm._v("\" desemnează orice comunicare a unei Opere, realizată direct sau prin orice mijloace tehnice, făcută într-un loc deschis publicului sau în orice loc în care se adună un număr de persoane care depăşeşte cercul normal al membrilor unei familii şi al cunoştinţelor acesteia, inclusiv reprezentarea scenică, recitarea sau orice altă modalitate publică de execuţie ori de prezentare directă a Operei, expunerea publică a Operelor de artă plastică, de artă aplicată, fotografică şi de arhitectură, proiecţia publică a Operelor cinematografice şi a altor Opere audiovizuale, inclusiv a Operelor de artă digitală, prezentarea într-un loc public, prin intermediul înregistrărilor sonore sau audiovizuale, precum şi prezentarea într-un loc public, prin intermediul oricăror mijloace, a unei Opere radiodifuzate.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("\"")]),_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("Distribuire")])]),_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("\" desemnează vânzarea sau orice alt mod de transmitere, cu titlu oneros ori gratuit, a originalului sau a copiilor unei Opere, precum şi oferirea publică a acestora. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("\"")]),_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("Reproducere")])]),_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("\" desemnează realizarea, integrală sau parţială, a uneia ori a mai multor copii ale unei Opere, direct sau indirect, temporar ori permanent, prin orice mijloc şi sub orice formă, inclusiv realizarea oricărei înregistrări sonore sau audiovizuale a unei Opere, precum şi stocarea permanenta ori temporară a acesteia cu mijloace electronice. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('a',{attrs:{"name":"_GoBack"}}),_vm._v(" "),_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("\"")]),_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("Opţiunile licenţei")])]),_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("\" desemnează următoarele atribute importante ale licenţei, aşa cum au fost ele selectate de către Ofertant şi cum sunt indicate în titlul prezentei licenţe: Atribuire – Necomercial - Distribuire în Condiţii Identice. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("2. Limitele exercitării dreptului de autor. ")])]),_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("Nici o prevedere a acestei licenţe nu are scopul de a reduce, de a limita sau de a restrânge drepturile rezultate din aplicarea normelor legale cu privire la limitele exercitării dreptului de autor prevăzute de legislaţia privind dreptul de autor şi drepturile conexe sau din alte legi aplicabile. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("3. Autorizare. ")])]),_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("În condiţiile definite prin prezenta licenţă şi pe întreaga durată de protecţie a Operei prevăzută de legislaţia privind dreptul de autor şi drepturile conexe sau alt drept aplicabil, Ofertantul acordă Acceptantului în mod neexclusiv, nelimitat teritorial şi cu titlu gratuit autorizarea de a exercita următoarele drepturi: ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("4. Restricţii. ")])]),_c('span',{attrs:{"lang":"fr-FR"}},[_c('em',[_c('strong',[_vm._v("Licenţa")])])]),_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v(", acordată în conformitate cu articolul 3, este încheiată sub condiţia respectării următoarelor restricţii: ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("Acceptantul poate distribui sau comunica public o Adaptare numai cu respectarea Licenţei Aplicabile, care poate fi: (i) această licenţă; sau (ii) o versiune ulterioară a acestei licenţe, având aceleaşi opţiuni; sau (iii) o licenţă Creative Commons (aceasta sau o versiune ulterioară a acesteia) dintr-o altă jurisdicţie, care conţine aceleaşi opţiuni ca această licenţă (ex. Attribution-NonCommercial-ShareAlike 3.0 SUA). Acceptantul este obligat să includă o copie a Licenţei Aplicabile sau adresa pe Internet (U.R.I.) împreună cu fiecare copie a fiecărei Adaptări pe care o distribuie sau o comunică public. Acceptantul nu are dreptul de a oferi sau impune nici o condiţie asupra Adaptării, care să modifice sau să restricţioneze prevederile Licenţei Aplicabile sau exercitarea drepturilor terţilor dobânditori, aşa cum sunt ele prevăzute de Licenţa Aplicabilă. Acceptantul este obligat să păstreze intacte toate notificările care se referă la Licenţa Aplicabilă şi la exonerarea de răspundere cu fiecare copie a Operei incluse în Adaptarea pe care o distribuie sau o comunică public. Acceptantul nu are dreptul de a distribui sau de a comunica public Adaptarea folosind o măsură tehnică de protecţie care restrânge posibilitatea terţilor dobânditori de a-şi exercita drepturile asupra Adaptării în condiţiile Licenţei Aplicabile. Această lit.b) se aplică şi Adaptării încorporate într- o Colecţie, dar nu se extinde în mod obligatoriu asupra celorlalte Opere conţinute în Colecţie. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("5. Garanţie şi exonerarea de răspundere ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("6. Limitarea răspunderii. ")]),_vm._v("Cu excepţia întinderii răspunderii cerute de normele imperative ale legii aplicabile şi a reparării prejudiciilor impuse de răspunderea faţă de terţi generată de încălcarea garanţiilor prevăzute la articolul 5, Ofertantul nu va fi responsabil faţa de Acceptant, în temeiul nici unei doctrine juridice, pentru orice prejudicii directe, indirecte, materiale sau morale care decurg din această licenţă sau din utilizarea Operei, chiar dacă Ofertantul a fost avertizat asupra posibilităţii producerii unor asemenea prejudicii.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("7. Rezilierea licenţei ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Această licenţă va fi reziliată de drept, iar drepturile acordate prin intermediul său vor înceta în mod implicit în cazul în care Acceptantul săvârşeşte orice fel de încălcare a condiţiilor licenţei. "),_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("Licenţele prin care persoane fizice sau persoane juridice dobândesc de la Acceptant Adaptări sau Colecţii, în condiţiile acestei licenţe, nu vor fi reziliate, atât timp cât respectivii dobânditori vor respecta condiţiile sub care le-au fost acordate drepturile respective. Articolele 1, 2, 5, 6, 7 şi 8 vor rămâne aplicabile chiar după rezilierea acestei licenţe. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("8. Alte prevederi ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_vm._v("Această licenţă constituie întreaga convenţie a părţilor asupra Operei astfel licenţiate. Nu există alte înţelegeri, acorduri sau prevederi asupra Operei care să nu fie specificate prin prezenta licenţă. "),_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("Ofertantul nu va fi subiect al nici unei prevederi adiţionale care ar apărea în orice comunicat din partea Acceptantului. Această licenţă nu poate fi modificată fără acordul scris al Ofertantului şi al Acceptantului. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_c('em',[_vm._v("By using this site the user is accepting the „Creative Commons Public License (CCPL)” reproduced bellow, excepting materials distributed on a more specific license. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_c('em',[_vm._v("Unless otherwise noted the intellectual rights for this site and the works published are owned by the West University Timisoara and are subject to applicable law.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"large"}},[_c('strong',[_vm._v("CREATIVE COMMONS CORPORATION IS NOT A LAW FIRM AND DOES NOT PROVIDE LEGAL SERVICES. DISTRIBUTION OF THIS LICENSE DOES NOT CREATE AN ATTORNEY-CLIENT RELATIONSHIP. CREATIVE COMMONS PROVIDES THIS INFORMATION ON AN \"AS-IS\" BASIS. CREATIVE COMMONS MAKES NO WARRANTIES REGARDING THE INFORMATION PROVIDED, AND DISCLAIMS LIABILITY FOR DAMAGES RESULTING FROM ITS USE. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_c('em',[_vm._v("License")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("1. Definitions")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("\"Adaptation\"")]),_vm._v(" means a work based upon the Work, or upon the Work and other pre-existing works, such as a translation, adaptation, derivative work, arrangement of music or other alterations of a literary or artistic work, or phonogram or performance and includes cinematographic adaptations or any other form in which the Work may be recast, transformed, or adapted including in any form recognizably derived from the original, except that a work that constitutes a Collection will not be considered an Adaptation for the purpose of this License. For the avoidance of doubt, where the Work is a musical work, performance or phonogram, the synchronization of the Work in timed-relation with a moving image (\"synching\") will be considered an Adaptation for the purpose of this License.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("\"Collection\"")]),_vm._v(" means a collection of literary or artistic works, such as encyclopedias and anthologies, or performances, phonograms or broadcasts, or other works or subject matter other than works listed in Section 1(f) below, which, by reason of the selection and arrangement of their contents, constitute intellectual creations, in which the Work is included in its entirety in unmodified form along with one or more other contributions, each constituting separate and independent works in themselves, which together are assembled into a collective whole. A work that constitutes a Collection will not be considered an Adaptation (as defined above) for the purposes of this License.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("\"Distribute\"")]),_vm._v(" means to make available to the public the original and copies of the Work or Adaptation, as appropriate, through sale or other transfer of ownership.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("\"Licensor\"")]),_vm._v(" means the individual, individuals, entity or entities that offer(s) the Work under the terms of this License.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("\"Original Author\"")]),_vm._v(" means, in the case of a literary or artistic work, the individual, individuals, entity or entities who created the Work or if no individual or entity can be identified, the publisher; and in addition (i) in the case of a performance the actors, singers, musicians, dancers, and other persons who act, sing, deliver, declaim, play in, interpret or otherwise perform literary or artistic works or expressions of folklore; (ii) in the case of a phonogram the producer being the person or legal entity who first fixes the sounds of a performance or other sounds; and, (iii) in the case of broadcasts, the organization that transmits the broadcast.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("\"Work\"")]),_vm._v(" means the literary and/or artistic work offered under the terms of this License including without limitation any production in the literary, scientific and artistic domain, whatever may be the mode or form of its expression including digital form, such as a book, pamphlet and other writing; a lecture, address, sermon or other work of the same nature; a dramatic or dramatico-musical work; a choreographic work or entertainment in dumb show; a musical composition with or without words; a cinematographic work to which are assimilated works expressed by a process analogous to cinematography; a work of drawing, painting, architecture, sculpture, engraving or lithography; a photographic work to which are assimilated works expressed by a process analogous to photography; a work of applied art; an illustration, map, plan, sketch or three-dimensional work relative to geography, topography, architecture or science; a performance; a broadcast; a phonogram; a compilation of data to the extent it is protected as a copyrightable work; or a work performed by a variety or circus performer to the extent it is not otherwise considered a literary or artistic work.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("\"You\"")]),_vm._v(" means an individual or entity exercising rights under this License who has not previously violated the terms of this License with respect to the Work, or who has received express permission from the Licensor to exercise rights under this License despite a previous violation.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("\"Publicly Perform\"")]),_vm._v(" means to perform public recitations of the Work and to communicate to the public those public recitations, by any means or process, including by wire or wireless means or public digital performances; to make available to the public Works in such a way that members of the public may access these Works from a place and at a place individually chosen by them; to perform the Work to the public by any means or process and the communication to the public of the performances of the Work, including by public digital performance; to broadcast and rebroadcast the Work by any means including signs, sounds or images.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("\"Reproduce\"")]),_vm._v(" means to make copies of the Work by any means including without limitation by sound or visual recordings and the right of fixation and reproducing fixations of the Work, including storage of a protected performance or phonogram in digital form or other electronic medium.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("2. Fair Dealing Rights.")]),_vm._v(" Nothing in this License is intended to reduce, limit, or restrict any uses free from copyright or rights arising from limitations or exceptions that are provided for in connection with the copyright protection under copyright law or other applicable laws.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("3. License Grant.")]),_vm._v(" Subject to the terms and conditions of this License, Licensor hereby grants You a worldwide, royalty-free, non-exclusive, perpetual (for the duration of the applicable copyright) license to exercise the rights in the Work as stated below:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("4. Restrictions.")]),_vm._v(" The license granted in Section 3 above is expressly made subject to and limited by the following restrictions:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("Non-waivable Compulsory License Schemes")]),_vm._v(". In those jurisdictions in which the right to collect royalties through any statutory or compulsory licensing scheme cannot be waived, the Licensor reserves the exclusive right to collect such royalties for any exercise by You of the rights granted under this License;")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("Waivable Compulsory License Schemes")]),_vm._v(". In those jurisdictions in which the right to collect royalties through any statutory or compulsory licensing scheme can be waived, the Licensor reserves the exclusive right to collect such royalties for any exercise by You of the rights granted under this License if Your exercise of such rights is for a purpose or use which is otherwise than noncommercial as permitted under Section 4(b) and otherwise waives the right to collect royalties through any statutory or compulsory licensing scheme; and,")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("Voluntary License Schemes")]),_vm._v(". The Licensor reserves the right to collect royalties, whether individually or, in the event that the Licensor is a member of a collecting society that administers voluntary licensing schemes, via that society, from any exercise by You of the rights granted under this License that is for a purpose or use which is otherwise than noncommercial as permitted under Section 4(c).")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("5. Representations, Warranties and Disclaimer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("6. Limitation on Liability.")]),_vm._v(" EXCEPT TO THE EXTENT REQUIRED BY APPLICABLE LAW, IN NO EVENT WILL LICENSOR BE LIABLE TO YOU ON ANY LEGAL THEORY FOR ANY SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR EXEMPLARY DAMAGES ARISING OUT OF THIS LICENSE OR THE USE OF THE WORK, EVEN IF LICENSOR HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("7. Termination")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('strong',[_vm._v("8. Miscellaneous")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western"},[_c('span',[_c('em',[_vm._v("Korišćenjem ove stranice korisnik prihvata \"Creative Commons Public License (CCPL)\" reprodukovano ispod, izuzev materijala koji se distribuiraju na specifičniju licencu.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western"},[_c('span',[_c('em',[_vm._v("Ukoliko nije drugačije naznačeno, intelektualna prava za ovu lokaciju i objavljena dela su u vlasništvu Zapadnog univerziteta u Temišvaru i predmet su važećeg zakona.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western",attrs:{"align":"justify"}},[_c('span',{staticStyle:{"font-size":"large"}},[_c('strong',[_vm._v("KORPORACIJA CREATIVE COMMONS NIJE ADVOKATSKA KANCELARIJA I NE PRUŽA PRAVNE USLUGE. DISTRIBUCIJOM OVE LICENCE NE USPOSTAVLJA SE PRAVNI ODNOS S CREATIVE COMMONS. CREATIVE COMMONS DAJE OVU INFORMACIJU «OVAKVU KAKVA JE». CREATIVE COMMONS NE DAJE NIKAKVA JEMSTVA ZA DATU INFORMACIJU I NE ODGOVARA ZA ŠTETU U VEZI S NJOM. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"western",attrs:{"align":"justify"}},[_c('em',[_vm._v("Ugovor o licenci (Licenca) ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("DELO (KOJE JE U DALJEM TEKSTU DEFINISANO) SE DAJE NA RASPOLAGANJE POD USLOVIMA OVE CREATIVE COMMONS JAVNE LICENCE («CCJL» ili «LICENCA»). DELO JE ZAKONSKI ZAŠTIĆENO AUTORSKIM I SRODNIM PRAVIMA I/ILI DRUGIM MERODAVNIM PRAVOM. SVAKO KORIŠĆENJE DELA PROTIVNO OVOJ LICENCI ILI ZAKONU JE ZABRANJENO. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('span',[_vm._v("KORIŠĆENJEM DELA NA NAČIN KOJI ODGOVARA NEKOM OD PRAVA KOJA SE USTUPAJU OVOM LICENCOM, STICALAC LICENCE DOBROVOLJNO PRIHVATA OBAVEZE IZ OVE LICENCE, A DAVALAC LICENCE, U SKLADU S OVIM UGOVOROM (LICENCOM), USTUPA STICAOCU LICENCE PRAVA IZ OVE LICENCE NA OSNOVU TAKVOG PRIHVATANJA LICENCNIH OBAVEZA. ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('strong',[_vm._v("1. Definicije ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("„"),_c('span',[_c('span',[_c('span',[_c('strong',[_vm._v("Prerada“ ")])])]),_c('span',[_c('span',[_vm._v("je Delo u kome su prepoznatljivi karakteristični elementi prerađenog (izvornog) Dela (muzičke obrade, aranžmani, adaptacije i druge prerade). Radi otklanjanja sumnje, Delo koje čini Zbirku ne smatra se Preradom, ali ako je reč o muzičkom delu ili fonogramu, istovremena sinhronizacija zvuka i slike smatraće se Preradom po ovoj Licenci. ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("„"),_c('span',[_c('span',[_c('span',[_c('strong',[_vm._v("Zbirka“ ")])])]),_c('span',[_c('span',[_vm._v("je zbirka Dela, nabrojanih u odredbi 1(g), podataka, dokumenata ili drugih nezavisnih elemenata koja, s obzirom na izbor i raspored sastavnih delova, predstavlja originalnu duhovnu tvorevinu, kao što je: antologija, enciklopedija, zbirka dokumenata ili zbirka čijim se sastavnim delovima pristupa posebno elektronskim ili drugim sredstvima (baza podataka). ")])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("Delo koje čini Zbirku ne smatra se Preradom (koja je u daljem tekstu definisana) po ovoj Licenci. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("„"),_c('span',[_c('span',[_c('span',[_c('strong',[_vm._v("Distribuirati“ ")])])]),_c('span',[_c('span',[_vm._v("znači stavljati u promet Delo, umnožene primerke Dela i Prerade")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("„"),_c('span',[_c('span',[_c('span',[_c('strong',[_vm._v("Elementi Licence“ ")])])]),_c('span',[_c('span',[_vm._v("su najviše, suštinske odredbe Licence koje je naglasio Davalac licence i koje su sadržane u nazivu Licence: Autorstvo, Nekomercijalno, Deliti pod istim uslovima ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("„"),_c('span',[_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("Davalac licence” ")])])])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("je fizičko ili pravno lice koje daje na raspolaganje Delo pod uslovima ove Licence. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("„"),_c('span',[_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("Izvorni autor“ ")])])])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("je fizičko lice koje je stvorilo Delo. Po ovoj Licenci, ako Izvorni autor nije poznat - nosilac prava (proizvodjač fonograma, proizvodjač videograma, proizvodjač emisije i proizvodjač baze podataka) ili izdavač. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("„"),_c('span',[_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("Delo“ ")])])])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("je originalna duhovna tvorevina koja se daje na raspolaganje pod uslovima ove Licence - autorsko delo. Fonogram, videogram, emisija ili baza podataka smatraće se Delom po ovoj Licenci, ako je takvo Delo zaštićeno domaćim pravom Sticaoca licence. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("„"),_c('span',[_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("Sticalac licence“ ")])])])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("je fizičko ili pravno lice koje prihvata Licencu i prava i obaveze iz Licence korišćenjem Dela na način koji odgovara nekom od prava koja se ustupaju ovom Licencom, a nije prethodno povredilo odredbe ove Licence, ili lice koje je dobilo izričitu dozvolu od Davaoca licence da koristi Delo na način koji odgovara nekom od prava koja se ustupaju ovom Licencom nezavisno od prethodne povrede odredaba Licence. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("„"),_c('span',[_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("Javno saopštavati“ ")])])])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("znači činiti Delo dostupnim javnosti i interaktivno činiti Delo dostupnim javnosti žičnim ili bežičnim putem na način koji omogućava pojedincu individualni pristup Delu s mesta i u vreme koje on odabere. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_vm._v("„"),_c('span',[_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("Umnožavati“ ")])])])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("znači beležiti Delo na nosač zvuka ili slike i umnožavati Delo nezavisno od broja primeraka, trajnosti primeraka i tehnike kojom su umnoženi. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("2. Ograničenja autorskog prava ")])])])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("Licenca ne utiče na obim prava korišćenja Dela nastalih iz zakonskih ograničenja isključivog autorskog ili merodavnog prava. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_c('strong',[_vm._v("3. Ustupanje prava ")])])])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("U skladu s odredbama Licence, Davalac licence, bez naknade i neisključivo, bez prostornih i vremenskih ograničenja (tokom trajanja autorskog ili drugog merodavnog prava), Sticaocu licence ustupa sledeća prava korišćenja Dela: ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"lang":"fr-FR","align":"justify"}},[_c('span',[_c('span',[_vm._v("da Umnožava Delo, da unosi Delo u jednu ili više Zbirki i da umnožava Delo u obliku u kom je uneto u Zbirke; ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"lang":"fr-FR","align":"justify"}},[_c('span',[_c('span',[_vm._v("da stvara i Umnožava Prerade tako da svaka Prerada i svaki prevod, u svakom mediju, na odgovarajući način, nosi oznaku koja jasno ukazuje na promene izvršene na izvornom Delu. Na primer, prevod bi trebalo označiti kao \"Delo je prevedeno s engleskog na španski jezik,\" ili Preradu kao \"Delo je preradjeno; \" ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"lang":"fr-FR","align":"justify"}},[_c('span',[_c('span',[_vm._v("da Distribuira i Javno saopštava Delo, uključujući i Delo u obliku u kom je uneto u Zbirke; i, d. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("da Distribuira i Javno saopštava Prerade. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Opisana prava se odnose na korišćenje Dela u svim poznatim medijima i formama. Opisana prava obuhvataju i pravo na izmene, koje su, iz tehničkih razloga, neminovne za korišćenje Dela u svakom mediju i u svakoj formi. Ako je Davalac licence nosilac sui generis prava na bazu podataka po domaćem pravu usaglašenom sa Direktivom EU o pravnoj zaštiti baze podataka, Davalac licence se odriče tog prava. Sva prava koja Davalac licence izričito ne ustupa ovom Licencom su zadržana, uključujući, bez ograničenja, prava iz odredaba 4(e) i 4(g). ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('span',[_c('strong',[_vm._v("4. Obaveze Sticaoca licence ")])])]),_c('span',[_c('span',[_vm._v("Davalac licence ustupa prava iz čl. 3 Licence Sticaocu licence pod sledećim uslovima: ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('span',[_vm._v("Sticalac licence se obavezuje da Distribuira i Javno saopštava Delo samo pod uslovima ove Licence. Sticalac licence se obavezuje da kopiju Licence ili njenu internet adresu (Uniform Resource Identifier - URI) unosi u svaki primerak Dela koje Distribuira ili Javno saopštava. Sticalac licence ne može da nudi ili zahteva uslove u vezi s Delom kojima se menjaju ili ograničavaju uslovi Licence ili prava prijemnika garantovana Licencom. Sticalac licence nema pravo davanja podlicence za Delo obuhvaćeno Licencom. Sticalac licence ne može da promeni ili ukloni navode koji se odnose na Licencu ili upozorenja o jemstvu ni sa jednog primerka Dela koje Distribuira ili Javno saopštava. Sticalac licence ne može da Distribuira i Javno saopštava Delo s nekom od tehnoloških mera kojima se prijemniku ograničavaju prava na Delo garantovana Licencom. ")])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("Sve odredbe 4(a) Licence se odnose i na Delo uneto u Zbirku, ali se ne zahteva da je Zbirka, u celini, licencirana pod istim uslovima. Ako Sticalac licence stvara Zbirku, obavezuje se da, na zahtev bilo kog Davaoca licence, u meri u kojoj je moguće, ukloni iz Zbirke sve naznake iz odredbe 4(d) Licence koje upućuju na tog Davaoca licence. Ako Sticalac licence stvara Zbirku, obavezuje se da, na zahtev bilo kog Izvornog autora, u meri u kojoj je moguće, ukloni iz Zbirke sva priznanja autorstva iz odredbe 4(d) Licence koja upućuju na tog Izvornog autora. Ako Sticalac licence stvara Preradu, obavezuje se da, na zahtev bilo kog Davaoca licence, u meri u kojoj je moguće, ukloni iz Prerade sve naznake iz odredbe 4(d) Licence koje upućuju na tog Davaoca licence. Ako Sticalac licence stvara Preradu, obavezuje se da, na zahtev bilo kog Izvornog autora, u meri u kojoj je moguće, ukloni iz Prerade sva priznanja autorstva iz odredbe 4(d) Licence koja upućuju na tog Izvornog autora. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('span',[_vm._v("Sticalac licence se obavezuje da Preradu Distribuira i Javno saopštava samo pod: (i) uslovima ove Licence; (ii) kasnije verzije ove Licence s istim elementima ove Licence; (iii) generičke Creative Commons licence ili druge nacionalne Creative Commons licence (ove ili kasnije verzije) s istim elementima ove Licence (npr. “Autorstvo – Nekomercijalno – Deliti pod istim uslovima” 3.0 SAD) (\"Merodavna Licenca\"). Sticalac licence se obavezuje da kopiju ili internet adresu (Uniform Resource Identifier - URI) ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Merodavne Licence, unese u svaki primerak Prerade koji Distribuira i Javno saopštava. Sticalac licence ne može da nudi ili zahteva uslove u vezi s Preradom kojima se ograničavaju uslovi Merodavne Licence ili prava prijemnika garantovana Merodavnom Licencom. Sticalac licence ne može da promeni ili ukloni navode koji se odnose na Merodavnu Licencu ili upozorenja o jemstvu ni sa jednog primerka Dela unetog u Preradu koju Distribuira ili Javno saopštava. Sticalac licence ne može da Distribuira i Javno saopštava Preradu s nekom od tehnoloških mera kojima se prijemniku ograničavaju prava garantovana Merodavnom Licencom. Sve odredbe 4(b) se odnose i na Preradu unetu u Zbirku, ali se ne zahteva da je Zbirka, u celini, licencirana pod uslovima Merodavne Licence. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Sticalac licence ne može da koristi Delo na osnovu ustupljenih prava iz čl. 3 Licence na način koji je primarno namenjen komercijalnom korišćenju ili sticanju lične novčane dobiti. Razmena Dela za druga dela, zakonski zaštićena autorskim i drugim merodavnim pravom, digitalnom razmenom datoteka ili na drugi način, ne smatra se razmenom čiji je primarni cilj komercijalno korišćenje ili sticanje lične novčane dobiti, ako se vrši bez novčanih davanja. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('span',[_vm._v("Sticalac licence se obavezuje da Distribuira ili Javno saopštava Delo, Preradu ili Zbirku u skladu s odredbom 4(a), sa svim postojećim i nepromenjenim naznakama o nosiocu prava i da prizna pravo autorstva Izvornom autoru, primereno medijima ili sredstvima kojima se služi, naznačenjem: (i) imena Izvornog autora (ili pseudonima ili znaka, ukoliko ga koristi), ako je navedeno, i/ili naziva nosioca autorskog ili srodnog prava, ili izdavača (\"Naznačeni nosioci prava\"), ako je naziv naveden; (ii) naslova Dela, ako je naveden; (iii) u razumnoj meri, internet adresu (Uniform Resource Identifier - URI) koju je naznačio Davalac licence kao svoju vezu sa Delom, ako ta adresa ne upućuje na priznanje autorstva Izvornom autoru, naznake o nosiocu prava ili na podatke o licenciranju Dela; i, (iv) u skladu s odredbom 3(b), ako je reč o Preradi, Sticalac licence se obavezuje da prizna autorstvo Izvornom autoru i način korišćenja izvornog dela u Preradi (npr. ")])]),_c('span',[_c('span',[_c('span',{attrs:{"lang":"fr-FR"}},[_vm._v("“Francuski prevod Dela”, koje je napisao Izvorni autor, ili “Scenario prema izvornom Delu, koje je napisao Izvorni autor”). Priznanja autorstva i naznake nosioca prava iz odredbe 4(d) mogu se uneti na neki od primerenih načina, ali u slučaju Prerade ili Zbirke moraju se pojaviti u isto vreme, u istoj meri, na istom mestu i na isti način kao sva ostala priznanja autorstva i naznake nosioca prava. Radi otklanjanja sumnje, Sticalac licence se obavezuje da priznanja i naznake upotrebi samo radi priznanja autorstva i naznačenja nosioca prava u skladu s ovom odredbom, kao i da korišćenjem Dela, sebe ili svoju upotrebu Dela, ni prećutno ni izričito, ne dovodi u vezu s autorstvom ili pravom nosioca, pokroviteljstvom ili jemstvom Izvornog autora, Davaoca licence i/ili Naznačenog nosioca prava, bez njihove posebne, izričite i pismene saglasnosti. ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Radi otklanjanja sumnje: ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Ako odricanje od prava na naplatu autorske naknade nije predvidjeno zakonom (npr. za Umnožavanje na osnovu zakonske licence ili za očekivano Umnožavanje na nosače zvuka ili slike za lične potrebe), ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Davalac licence zadržava isključivo pravo na naplatu te naknade, individualno ili preko organizacije za kolektivno ostvarivanje prava, za svako (komercijalno i nekomercijalno) korišćenje Dela; ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('span',[_c('strong',[_vm._v("Kolektivno ostvarivanje prava ")])])]),_c('span',[_c('span',[_vm._v("Davalac licence zadržava pravo na"),_c('br'),_vm._v(" naplatu autorske naknade, individualno ili preko organizacije za kolektivno ostvarivanje autorskog prava, za komercijalno korišćenje Dela. Davalac licence se odriče prava na naplatu autorske naknade, individualno ili preko organizacije za kolektivno ostvarivanje prava, za nekomercijalno korišćenje Dela. ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Radi otklanjanja sumnje: Ograničenja predvidjena odredbama 4(a) i 4(b) se ne primenjuju na sui generis pravo na bazu podataka. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Ako Sticalac licence Umnožava, Distribuira ili Javno saopštava Delo, posebno ili kao sastavni deo Prerade ili Zbirke, Sticalac licence se obavezuje da poštuje moralna prava Izvornog autora i interpretatora, uključujući ugled i čast. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('strong',[_vm._v("5. Jemstva ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("AKO PISMENIM SPORAZUMOM UGOVORNIH STRANA LICENCE ILI MERODAV- NIM PRAVOM NIJE DRUGAČIJE ODREDJENO, DAVALAC LICENCE DAJE NA RASPOLAGANJE DELO ONAKVO KAKVO JESTE BEZ IKAKVIH GARANCIJA I JEMSTAVA U VEZI S PRAVIMA USTUPLJENIM OVOM LICENCOM. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('strong',[_vm._v("6. Ograničenje odgovornosti ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("DAVALAC LICENCE NE ODGOVARA ZA ŠTETU POVODOM LICENCE ILI KORIŠĆENJA DELA, OSIM AKO ISKLJUČENJE ODGOVORNOSTI NIJE PREDVIDJENO ZAKONOM. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('strong',[_vm._v("7. Prestanak važenja ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Licenca, prava i obaveze iz Licence automatski prestaju da važe povredom bilo koje odredbe Licence (npr. Javnim saopštavanjem Dela bez priznanja prava autorstva kako je predvidjeno odredbom 4d). Prema fizičkim i pravnim licima kojima su ustupljena prava na Preradu ili Zbirku po Licenci, čiji je osnov ova Licenca, odredbe Licence ne prestaju da važe, ako ova lica nisu prekršila odredbe Licence. Odredbe članova 1, 2, 5, 6, 7 i 8 ostaju na snazi nezavisno od povrede Licence. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Licenca je na pravnoj snazi tokom ukupnog trajanja autorskog ili drugog merodavnog prava. Nezavisno od toga i bez obaveštavanja Sticaoca licence, Davalac licence zadržava pravo da objavi Delo pod drugačijim licencnim uslovima ili da u vreme važenja Licence prestane da distribuira Delo pod uslovom da na taj način ne prestaje da važi ova Licenca (ili druge licence, čiji je osnov ova Licenca), i da ova Licenca u celini ostaje na snazi, ako nije prestala da važi na osnovu prethodne odredbe. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('strong',[_vm._v("8. Završne odredbe ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Tokom svakog Distribuiranja ili Javnog saopštavanja Dela od strane Sticaoca licence, Davalac licence, povodom Dela, nudi prijemniku ugovor o licenci s istim odredbama i pod istim uslovima predvidjenim ovom Licencom. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Tokom svakog Distribuiranja ili Javnog saopštavanja Prerade od strane Sticaoca licence, Davalac licence, povodom izvornog dela, nudi prijemniku ugovor o licenci s istim odredbama i pod istim uslovima predvidjenim ovom Licencom. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Ako je neka odredba Licence po merodavnom pravu ništava ili neizvršiva, neće uticati na valjanost i izvršivost ostalih odredaba Licence, i tumačiće se samo u stepenu koji je čini valjanom i izvršivom, bez dodatnog sporazuma ugovornih strana. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Odstupanje od bilo koje odredbe Licence pristankom ili odricanjem nema pravno dejstvo bez pismene izjave i potpisa ovlašćene strane. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Licenca predstavlja potpun ugovor izmedju Davaoca licence i Sticaoca licence povodom ustupanja prava na Delo iz Licence obuhvatajući i elemente usmenog i pisanog predugovora. Davalac licence ne prihvata dodatne odredbe na osnovu usmenog sporazuma sa Sticaocem licence. Licenca ne može biti promenjena bez posebne pismene saglasnosti volja ugovornih strana. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_c('strong',[_vm._v("Napomene Creative Commons ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Creative Commons nije ugovorna strana ove Licence i ne daje nikakva jemstva u vezi s Delom. Creative Commons ne odgovara ni za kakvu štetu Davaocu licence, Sticaocu licence i trećim licima povodom ustupljenih prava. Bez obzira na prethodne dve napomene, ako se Creative Commons izričito naznači kao Davalac licence po ovoj Licenci, imaće sva prava i obaveze Davaoca licence. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"justify"}},[_c('span',[_c('span',[_vm._v("Osim obaveštavanja javnosti da je Delo licencirano pod uslovima CCJL, ugovorne strane i treća lica ne mogu da koriste naziv “Creative Commons”, drugog zaštitnog znaka ili logotipa Creative Commons bez pismene saglasnosti Creative Commons. Svaka pravilna upotreba mora biti usaglašena s važećim uputstvima Creative Commons o upotrebi zaštitnog znaka ili logotipa koja su objavljena na web strani Creative Commons ili se naknadno dostavljaju, po zahtevu zainteresovanih lica, na drugi način. Radi otklanjanja sumnje, ova zabrana ne čini sastavni deo ugovornih odredbi ove Licence. ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"western"},[_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ORBH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupCard_vue__ = __webpack_require__("xp2d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae9583b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupCard_vue__ = __webpack_require__("gLuc");
function injectStyle (ssrContext) {
  __webpack_require__("vk1a")
  __webpack_require__("HTTh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae9583b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae9583b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OXVe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Obtq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Opxv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ouc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Groups_vue__ = __webpack_require__("nLlF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51aa9a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Groups_vue__ = __webpack_require__("jsS/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Groups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51aa9a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Groups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P1HD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{class:{ 'noBoxShadow' : _vm.getScreenWidth() > 900, 'pa-3 map' : true},attrs:{"elevation-1":""}},[_c('v-toolbar',{staticClass:" mr-0 ml-0 mb-3",staticStyle:{"width":"100%"},attrs:{"color":"white","floating":"","dense":"","elevation-1":""}},[_c('v-icon',[_vm._v("location_on")]),_vm._v("\n            "+_vm._s(_vm.ifw)+"\n    ")],1),_vm._v(" "),_c('Gmap-Map',{ref:"map",staticStyle:{"width":"100%","height":"300px"},attrs:{"zoom":12,"center":_vm.center}},[_c('Gmap-Marker',{attrs:{"position":_vm.marker.position,"clickable":true,"draggable":false},on:{"click":function($event){_vm.opened = !_vm.opened}}},[_c('gmap-info-window',{attrs:{"opened":_vm.opened}},[_vm._v(_vm._s(_vm.ifw))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PICD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"beginningContainer pa-0"},[_c('div',{staticClass:"pl-3 pt-3 pb-3",staticStyle:{"width":"100%","height":"6vh","border-bottom":"2px solid #efefef"}},[_c('p',[_c('v-icon',{staticClass:"mr-2"},[_vm._v("chat")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.subject)+"swqewtehg")])],1)]),_vm._v(" "),_c('v-list',{attrs:{"three-line":""}},_vm._l((_vm.messages),function(message){return (message.userId != _vm.user._id)?_c('wb-messages',{key:message._id,attrs:{"message":message.message,"date":message.date,"user":_vm.getUser(message.userId)}}):_c('wb-messages-own',{attrs:{"message":message.message,"date":message.date,"user":_vm.getUser(message.userId)}})}),1),_vm._v(" "),_c('quill-editor',{ref:"myTextEditor",staticClass:"editor-example snow",attrs:{"options":_vm.editorOption},model:{value:(_vm.newMessage),callback:function ($$v) {_vm.newMessage=$$v},expression:"newMessage"}}),_vm._v(" "),_c('v-btn',{staticClass:"mt-5 ml-3",attrs:{"primary":""},on:{"click":_vm.sendMessage}},[_vm._v("Send "),_c('v-icon',{attrs:{"right":""}},[_vm._v("send")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-5",attrs:{"color":"primary"},on:{"click":_vm.emitClose}},[_vm._v(" close")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PP/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('v-layout',{staticClass:"hidden-sm-and-down"},[_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"pa-3",staticStyle:{"width":"100%","height":"100%","display":"table","text-align":"justify"}},[(_vm.swiper)?_c('p',{staticClass:"artefactDescription"},[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].home.quoteFeatured)+" ")]):_vm._e()])]),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('swiper',{ref:"mySwiperA",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.artefacts),function(artefact,i){return (i<5)?_c('swiper-slide',{key:i},[_c('web-artefact-card',{attrs:{"artefact":artefact,"clickImage":false}})],1):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination ",attrs:{"slot":"pagination"},slot:"pagination"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2)],1)],1),_vm._v(" "),_c('div',{staticClass:"hidden-md-and-up"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"x12":""}},[_c('div',{staticClass:"pa-3",staticStyle:{"width":"100%","height":"100%","display":"table","text-align":"justify"}},[(_vm.swiper)?_c('p',{staticClass:"artefactDescription"},[_vm._v(" "+_vm._s(_vm.previewArtefact)+" ")]):_vm._e()])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('swiper',{ref:"mySwiperA",staticClass:"hidden-sm-only",attrs:{"options":_vm.swiperOption1}},[_vm._l((_vm.artefacts),function(artefact,i){return (i<5)?_c('swiper-slide',{key:i},[_c('web-artefact-card',{attrs:{"artefact":artefact,"clickImage":false}})],1):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination ",attrs:{"slot":"pagination"},slot:"pagination"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2),_vm._v(" "),_c('swiper',{ref:"mySwiperA",staticClass:"hidden-xs-only",attrs:{"options":_vm.swiperOption2}},[_vm._l((_vm.artefacts),function(artefact,i){return (i<5)?_c('swiper-slide',{key:i},[_c('web-artefact-card',{attrs:{"artefact":artefact,"clickImage":true}})],1):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination ",attrs:{"slot":"pagination"},slot:"pagination"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PnLz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qybm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R9X9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddArtefactPartial_vue__ = __webpack_require__("Aiq8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df7c0f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArtefactPartial_vue__ = __webpack_require__("o92R");
function injectStyle (ssrContext) {
  __webpack_require__("26bw")
  __webpack_require__("tFBV")
  __webpack_require__("mJTV")
  __webpack_require__("Yw+8")
  __webpack_require__("p7JX")
  __webpack_require__("Rs/N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0df7c0f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddArtefactPartial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df7c0f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArtefactPartial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RBvK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RK5T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RX0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"300"},model:{value:(_vm.opened),callback:function ($$v) {_vm.opened=$$v},expression:"opened"}},[_c('v-card',{class:{ 'show' : !_vm.opened},staticStyle:{"width":"300px"}},[_c('v-card-media',{staticClass:"white--text",attrs:{"height":"200px","src":_vm.marker.mainImg[0].url}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs10":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.marker.title[_vm.lang]))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"small":"","fab":"","flat":""},on:{"click":_vm.close}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-title',[_c('div',[_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.minimize(_vm.marker.description[_vm.lang],20)))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.marker.location.formatted_address))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange","to":'/artefacts/'+_vm.marker._id}},[_vm._v("Explore")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RZV9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rat3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rs/N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4Ux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresentLocation_vue__ = __webpack_require__("J6KO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daa5cec4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PresentLocation_vue__ = __webpack_require__("P1HD");
function injectStyle (ssrContext) {
  __webpack_require__("jHsC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresentLocation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daa5cec4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PresentLocation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SQpl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Layer1.aba1b83.png";

/***/ }),

/***/ "SWS0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fuse_js__ = __webpack_require__("BDm9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fuse_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueFuse',
  data: function data() {
    return {
      fuse: null,
      value: '',
      result: []
    };
  },

  props: {
    placeholder: {
      type: String,
      default: ''
    },
    search: {
      type: String,
      default: ''
    },
    eventName: {
      type: String,
      default: 'fuseResultsUpdated'
    },
    inputChangeEventName: {
      type: String,
      default: 'fuseInputChanged'
    },
    defaultAll: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array
    },
    caseSensitive: {
      type: Boolean,
      default: false
    },
    includeScore: {
      type: Boolean,
      default: false
    },
    includeMatches: {
      type: Boolean,
      default: false
    },
    tokenize: {
      type: Boolean,
      default: false
    },
    matchAllTokens: {
      type: Boolean,
      default: false
    },
    findAllMatches: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    shouldSort: {
      type: Boolean,
      default: true
    },
    threshold: {
      type: Number,
      default: 0.6
    },
    location: {
      type: Number,
      default: 0
    },
    distance: {
      type: Number,
      default: 100
    },
    maxPatternLength: {
      type: Number,
      default: 32
    },
    minMatchCharLength: {
      type: Number,
      default: 1
    },
    keys: {
      type: Array
    }
  },
  computed: {
    options: function options() {
      var options = {
        caseSensitive: this.caseSensitive,
        includeScore: this.includeScore,
        includeMatches: this.includeMatches,
        tokenize: this.tokenize,
        matchAllTokens: this.matchAllTokens,
        findAllMatches: this.findAllMatches,
        shouldSort: this.shouldSort,
        threshold: this.threshold,
        location: this.location,
        distance: this.distance,
        maxPatternLength: this.maxPatternLength,
        minMatchCharLength: this.minMatchCharLength,
        keys: this.keys
      };
      if (this.id !== '') {
        options.id = this.id;
      }
      return options;
    }
  },
  watch: {
    list: function list() {
      this.fuse.list = this.list;
      this.fuseSearch();
    },
    search: function search() {
      this.value = this.search;
    },
    value: function value() {
      this.$parent.$emit(this.inputChangeEventName, this.value);
      this.fuseSearch();
    },
    result: function result() {
      this.$parent.$emit(this.eventName, this.result);
    }
  },
  methods: {
    initFuse: function initFuse() {
      this.fuse = new __WEBPACK_IMPORTED_MODULE_0_fuse_js___default.a(this.list, this.options);
      if (this.defaultAll) {
        this.result = this.list;
      }
      if (this.search) {
        this.value = this.search;
      }
    },
    fuseSearch: function fuseSearch() {
      if (this.value.trim() === '') {
        if (this.defaultAll) {
          this.result = this.list;
        } else {
          this.result = [];
        }
      } else this.result = this.fuse.search(this.value.trim());
    }
  },
  ready: function ready() {
    this.initFuse();
  },
  mounted: function mounted() {
    this.initFuse();
  }
});

/***/ }),

/***/ "TNEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoWindow_vue__ = __webpack_require__("6vsK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5240120_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWindow_vue__ = __webpack_require__("G+/V");
function injectStyle (ssrContext) {
  __webpack_require__("GLjB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5240120_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TbTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FileUpload_file_upload_service__ = __webpack_require__("rG9c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      direction: "left",
      preview: 0,
      previewCollection: {
        title: {
          en: "",
          ro: "",
          sr: ""
        }
      },
      methodResults: [],
      term: "",
      defaultAllToggle: false,
      options: {
        keys: ["title"]
      },
      fab: false,
      snackbar: false,
      y: 'top',
      x: null,
      mode: '',
      timeout: 6000,
      fling: false,
      hover: false,
      tabs: null,
      top: false
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "snackbar", ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "timeout", 6000), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "right", true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "bottom", true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "left", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "transition", "slide-y-reverse-transition"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "edit", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialog", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "uploadAdd", {
      title: {
        en: "",
        ro: "",
        sr: ""
      },
      description: {
        en: "",
        ro: "",
        sr: ""
      },
      imgUrl: [{ url: "" }],
      location: {},
      meta: {
        title: "",
        author: "",
        location: "",
        type: "",
        copyright: "",
        license: "",
        conentType: ""
      },
      adminId: "1",
      status: 0,
      loading: false

    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "uploadEdit", {
      title: {
        en: "",
        ro: "",
        sr: ""
      },
      description: {
        en: "",
        ro: "",
        sr: ""
      },
      imgUrl: [{ url: "" }],
      location: {},
      meta: {
        title: "",
        author: "",
        location: "",
        type: "",
        copyright: "",
        license: "",
        conentType: ""
      },
      adminId: "1",
      status: 0,
      loading: 0

    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "uploadError", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "currentStatus", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "uploadFieldName", "photos"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "select", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "isReallyOld", '1'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "description", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "e6", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "e7", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "keyMessage", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "states", ["Timisoara", "Romania Culture"]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "activePlus", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "descriptionRules", [function (v) {
      return !!v || 'Description is required';
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "titleRules", [function (v) {
      return !!v || 'Title is required';
    }]), _ref;
  },


  computed: {
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    collections: function collections() {
      return this.$store.getters.loadAllCollections;
    },
    items: function items() {
      return this.$store.getters.loadGroups;
    },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },

    // collections() {
    //     return  this.$store.getters.loadAllCollections; 
    // },
    selectedId: function selectedId() {

      var i;
      for (i = 0; i < this.items.length; i++) {
        console.log(this.items);
        if (this.items[i].title === this.previewCollection.title) return this.items[i]._id;
      }
    },
    users: function users() {
      return this.$store.getters.loadUsers;
    }
  },
  watch: {
    term: function term() {
      var _this = this;

      this.$search(this.term, this.items, this.options).then(function (results) {
        _this.methodResults = results;
        if (_this.term == "") {
          _this.methodResults = _this.items;
        }
      });
    }
  },
  methods: {
    showOnSmallScreen: function showOnSmallScreen() {
      return this.isReallyOld == 1 || window.innerWidth > 950;
    },
    toArtefact: function toArtefact(artefactID) {
      this.$router.push('/artefacts/' + artefactID);
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    },
    clickInputMain: function clickInputMain() {
      this.$refs.fileInput1.click();
    },
    reset: function reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    saveAdd: function saveAdd(formData) {
      var _this2 = this;

      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.uploadAdd.loading = 1;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_FileUpload_file_upload_service__["a" /* upload */])(formData).then(function (x) {
        _this2.uploadAdd.loading = 0;
        _this2.uploadAdd.status = 1;
        _this2.uploadAdd.imgUrl = x;
        _this2.currentStatus = STATUS_SUCCESS;
      }).catch(function (err) {
        _this2.uploadAdd.loading = 0;
        _this2.uploadError = err.response;
        _this2.currentStatus = STATUS_FAILED;
      });
    },
    filesChangeAdd: function filesChangeAdd(fieldName, fileList) {
      // handle file changes
      var formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.saveAdd(formData);
    },
    saveEdit: function saveEdit(formData) {
      var _this3 = this;

      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.uploadEdit.loading = 1;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_FileUpload_file_upload_service__["a" /* upload */])(formData).then(function (x) {
        _this3.uploadEdit.loading = 0;
        _this3.uploadEdit.status = 1;
        _this3.uploadEdit.imgUrl = x;
        _this3.currentStatus = STATUS_SUCCESS;
      }).catch(function (err) {
        _this3.uploadError = err.response;
        _this3.currentStatus = STATUS_FAILED;
      });
    },
    filesChangeEdit: function filesChangeEdit(fieldName, fileList) {
      // handle file changes
      var formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.saveEdit(formData);
    },
    onCreateCollection: function onCreateCollection() {
      var _this4 = this;

      this.$store.dispatch("createGroup", this.uploadAdd).then(function (response) {
        _this4.$router.push('/groups/' + response.data._id);
      }, function (error) {});
    },
    onUpdateCollection: function onUpdateCollection(idval) {
      this.$store.dispatch("updateGroup", this.uploadEdit);
      this.$router.push({ path: "/groups/" + this.uploadEdit._id });
    },

    deleteGroup: function deleteGroup(idval) {
      var _this5 = this;

      this.$store.dispatch("deleteGroup", { _id: idval }).then(function (response) {
        _this5.$store.dispatch("loadGroups");
        _this5.dialog = false;
        _this5.$router.push("/settings/");
      }, function (err) {
        console.log(err);
      });
    },
    editCollection: function editCollection(idval) {
      this.edit = true;
      var i = 0;
      for (i = 0; i < this.items.length; i++) {
        if (this.items[i]._id == idval) this.uploadEdit = this.items[i];
      }
    },
    clickInput2: function clickInput2() {
      this.$refs.fileInput2.click();
    },
    clickInput1: function clickInput1() {
      this.$refs.fileInput1.click();
    },
    addNew: function addNew() {

      this.isReallyOld = '3';
      this.uploadAdd.title.en = this.term;
      this.uploadAdd.title.sr = this.term;
      this.uploadAdd.title.ro = this.term;
      this.uploadAdd.description.en = '';
      this.uploadAdd.description.sr = '';
      this.uploadAdd.description.ro = '';
      this.edit = false;
    },
    isNew: function isNew(val) {
      if (val) {
        var i = 0;
        var k = 0;
        for (i = 0; i < this.items.length; i++) {
          if (this.items[i].title[this.lang].toUpperCase() == val) {
            k++;
          }
        }
        if (k > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {
    document.title = "Manage Groups";
    window.scrollTo(0, 0);
    this.reset();
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadUsers");
    this.$store.dispatch("loadArtefacts");
    this.methodResults = this.items;
  },
  created: function created() {
    if (!this.isAdmin && !this.isLoggedIn) this.$router.push("/signin");else if (!this.isAdmin && this.isLoggedIn) this.$router.push("/");
  }
});

/***/ }),

/***/ "ThKu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ["artefact"],
	methods: {
		toArtefact: function toArtefact(artefactID) {
			this.$router.push("/artefacts/" + artefactID);
		},
		toArtefact1: function toArtefact1(artefactID) {
			if (window.innerWidth > 950) {
				this.$router.push("/artefacts/" + artefactID);
			}
		}
	},
	computed: {
		//  artefact() {
		//   return this.$store.getters.loadArtefacts;
		//   },
	}
});

/***/ }),

/***/ "TrFT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo1.a365b52.png";

/***/ }),

/***/ "U4Vc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UzJh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V0vp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: ['Admin', 'Moderator', 'Contributor', 'User'],
      term: "",
      defaultAllToggle: false,
      options: {
        keys: ["displayName"]
      },
      methodResults: []
    };
  },

  computed: {
    users: function users() {
      return this.$store.getters.loadUsers;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    token: function token() {
      return this.$store.getters.getToken;
    }
  },
  methods: {
    provider: function provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";else if (user.hasOwnProperty("google")) return "Google";else if (user.hasOwnProperty("live")) return "Microsoft Live";else return "Local Register";
    },
    changeStatus: function changeStatus(user, role) {
      var _this = this;

      this.$store.dispatch("changeUserStatus", {
        id: user._id,
        token: this.token,
        role: role
      }).then(function (response) {
        console.log(response);
        if (response.success) _this.$store.dispatch("loadUsers");
      });
    }
  },
  mounted: function mounted() {
    document.title = "Users";
    window.scrollTo(0, 0);
    this.$store.dispatch("loadUsers");
    this.methodResults = this.users;
  },

  watch: {
    term: function term() {
      var _this2 = this;

      this.$search(this.term, this.users, this.options).then(function (results) {
        _this2.methodResults = results;
        if (_this2.term == "") {
          _this2.methodResults = _this2.users;
        }
      });
    }
  },
  created: function created() {
    if (!this.isAdmin && !this.isLoggedIn) this.$router.push("/signin");else if (!this.isAdmin && this.isLoggedIn) this.$router.push("/");
  }
});

/***/ }),

/***/ "VM38":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VNJG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Explore_vue__ = __webpack_require__("dw79");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_435851c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Explore_vue__ = __webpack_require__("uJDO");
function injectStyle (ssrContext) {
  __webpack_require__("2D3t")
  __webpack_require__("7lVZ")
  __webpack_require__("lJIZ")
  __webpack_require__("NR7a")
  __webpack_require__("2D3t")
  __webpack_require__("2D3t")
  __webpack_require__("DZmE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-435851c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Explore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_435851c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Explore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VR71":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VdXy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VjV7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/microsoft.9ff561e.png";

/***/ }),

/***/ "Wrd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ["artefact", "height"],
	methods: {
		toArtefact: function toArtefact(artefactID) {
			this.$router.push("/artefacts/" + artefactID);
		},
		toArtefact1: function toArtefact1(artefactID) {
			if (window.innerWidth > 950) {
				this.$router.push("/artefacts/" + artefactID);
			}
		}
	},
	computed: {
		lang: function lang() {
			return this.$store.getters.loadLang;
		}
	}
});

/***/ }),

/***/ "X0ds":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XGtV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XKgL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XqB7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XqfE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtefactPreview_vue__ = __webpack_require__("M6uc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0572065d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtefactPreview_vue__ = __webpack_require__("h4LS");
function injectStyle (ssrContext) {
  __webpack_require__("rgZx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0572065d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtefactPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0572065d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtefactPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xsx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mapHeight: 300
    };
  },

  props: ['artefact', 'isCollection', 'light', 'isGroup']
});

/***/ }),

/***/ "Y0FV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"white-widget grey-bg author-area"},[_c('div',{staticClass:"auth-info row"},[_c('div',{staticClass:"timeline-wrapper"},[_c('div',{staticClass:"timeline-item"},[_c('div',{staticClass:"animated-background"},[_c('div',{staticClass:"background-masker header-top"}),_vm._v(" "),_c('div',{staticClass:"background-masker header-left"}),_vm._v(" "),_c('div',{staticClass:"background-masker header-right"}),_vm._v(" "),_c('div',{staticClass:"background-masker header-bottom"})])])])])])])],1):_c('div',{},[_c('v-container',{staticClass:"ma-0 pa-0 hidden-md-and-up",attrs:{"lazy":true,"fluid":""}},[_c('v-card',{attrs:{"light":"","id":"card-variable-height","height":"92vh"}},[_c('v-card-media',{attrs:{"height":"45vh","src":_vm.collection.imgUrl[0].url+'_single'}},[_c('div',{staticClass:"mainImg-overlay"},[_c('div',{staticClass:"wave-img"})]),_vm._v(" "),_c('v-container',{staticClass:"pr-1 pl-1",attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{staticClass:"media",attrs:{"fill-height":"","column":""}},[_c('v-card-actions',[_c('v-layout',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("view_day")])],1),_vm._v(" "),(_vm.isAdmin)?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":"","to":"'/collections/new/' "}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.delete))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnno))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnyes))])],1)],1)],1)],1):(!_vm.isAdmin && _vm.isLoggedIn)?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"pr-0 pl-0 mt-0"},[_c('v-layout',{staticClass:"text-xs-center d-block"},[_c('h3',{staticClass:"headline mb-0 pb-2"},[_vm._v(_vm._s(_vm.collection.title[_vm.lang]))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-left":"20%","margin-right":"20%","color":"#efefef","border-style":"solid"}}),_vm._v(" "),_c('div',{staticClass:"pt-3 pb-0"},[_c('v-layout',{staticClass:"pl-4 pr-4",attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.collection.groups),function(group,i){return (i<7 && _vm.getLanguageTranslation(group)!=false)?_c('span',{key:i},[_vm._v(" \n                  "),_c('v-icon',{attrs:{"left":""}},[_vm._v("view_column")]),_vm._v("\n                  "+_vm._s(_vm.getLanguageTranslation(group))+"\n                ")],1):_vm._e()}))],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-card-actions',[_c('v-btn',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll",value:({ duration: 1000, offset: -50 }),expression:"{ duration: 1000, offset: -50 }"}],attrs:{"fab":"","href":"#description"}},[_c('v-icon',{attrs:{"light":""}},[_vm._v("keyboard_arrow_down")])],1)],1)],1)],1),_vm._v(" "),_c('web-location-tab',{staticClass:"pl-0 pr-0",attrs:{"artefact":_vm.collection,"isCollection":true,"light":true}},[(_vm.overview)?_c('div',[_c('v-card',{attrs:{"color":" mt-3 mb-3","flat":"","id":"description"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-card',{staticClass:"card--flex-toolbar"},[_c('v-toolbar',{attrs:{"card":"","color":"white","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info_outline")]),_vm._v("\n                      "+_vm._s(_vm.gLang[_vm.lang].collectionSingle.about)+"\n                    ")],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.collection.description[_vm.lang].length > 250)?_c('v-card-text',[(_vm.isMinimized)?_c('div',[_c('p',{staticClass:"caption"},[_vm._v(_vm._s(_vm.collection.description[_vm.lang].slice(0,250))+"...")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":"","primary":""},on:{"click":function($event){_vm.isMinimized = !_vm.isMinimized}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.readMore))])],1)],1):_vm._e(),_vm._v(" "),(!_vm.isMinimized)?_c('div',[_c('p',{staticClass:"caption"},[_vm._v(_vm._s(_vm.collection.description[_vm.lang]))]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":"","primary":""},on:{"click":function($event){_vm.isMinimized = !_vm.isMinimized}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.readLess))])],1)],1):_vm._e()]):_c('v-card-text',[_c('p',{staticClass:"caption"},[_vm._v(_vm._s(_vm.collection.description[_vm.lang]))])])],1)],1)],1)],1),_vm._v(" "),(_vm.artefactsInCollection())?_c('v-card',{attrs:{"color":" mt-5 mb-3","flat":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text mt-4 ml-5"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.artefacts))]),_vm._v(" "),_c('v-divider',{staticClass:"mb-4"}),_vm._v(" "),_c('web-slider1',{attrs:{"artefacts":_vm.artefacts}},_vm._l((_vm.artefacts),function(artefact){return ((artefact.collectionId.indexOf(_vm.collection.title.en) > -1 && _vm.lessThen5(artefact._id,_vm.collection.title.en)))?_c('div',{key:artefact._id},[_c('web-artefact-card',{attrs:{"artefact":artefact}})],1):_vm._e()})),_vm._v(" "),_c('v-card-actions',{staticClass:"pt-1 mt-0"},[_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.showAll}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.show))])],1)],1)],1):_vm._e()],1):_c('div',[_c('web-location-present-multiple',{staticStyle:{"box-shadow":"0px"},attrs:{"groupTitle":_vm.collection,"heightM":_vm.mapHeight1}})],1),_vm._v(" "),_c('div',{staticClass:"modal pt-5",staticStyle:{"margin-top":"56px"},attrs:{"id":"myModal"}},[_c('v-btn',{staticClass:"close",attrs:{"dark":"","medium":"","fab":"","color":"black"},on:{"click":_vm.spanClick}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_vm._l((_vm.artefacts),function(artefact){return ((artefact.collectionId.indexOf(_vm.collection.title.en) > -1))?_c('div',{key:artefact._id},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('web-artefact-card',{staticClass:"modal-card",attrs:{"artefact":artefact}})],1)],1)],1):_vm._e()})],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.isMod||_vm.isContrib)?_c('web-speed-dial-add'):_vm._e()],1)],1),_vm._v(" "),_c('v-container',{staticClass:"ma-0 pa-0 hidden-sm-and-down",attrs:{"fluid":""}},[_c('div',{staticClass:"hide-ie",staticStyle:{"position":"fixed","width":"100%","height":"74vh","overflow":"hidden"}},[_c('img',{staticStyle:{"width":"100%","bottom":"100px","position":"relative","height":"auto"},attrs:{"src":_vm.collection.imgUrl[0].url+'_single'}})]),_vm._v(" "),_c('img',{staticClass:"show-ie",staticStyle:{"position":"fixed","width":"100%","height":"70vh"},attrs:{"src":_vm.collection.imgUrl[0].url+'_single'}}),_vm._v(" "),_c('div',{staticClass:"mainImg-overlay1 hide-ie",staticStyle:{"position":"fixed"}}),_vm._v(" "),_c('v-card',{staticStyle:{"background-color":"transparent","box-shadow":"none","position":"relative"},attrs:{"light":"","id":"card-variable-height","height":"65vh"}},[_c('div',{staticClass:"floatingScrollButton",staticStyle:{"position":"absolute","width":"100%"}},[_c('v-layout',{staticStyle:{"height":"100%","position":"relative","width":"100%"},attrs:{"justify-center":""}},[_c('h3',{staticStyle:{"color":"white","height":"30px","position":"absolute","top":"32%","text-align":"center"}},[_vm._v(_vm._s(_vm.collection.title[_vm.lang]))]),_vm._v(" "),_c('v-btn',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll",value:({ duration: 1000, offset: -50 }),expression:"{ duration: 1000, offset: -50 }"}],staticStyle:{"top":"52%","z-index":"999"},attrs:{"fab":"","href":"#toScrollDescription"}},[_c('v-icon',{attrs:{"light":""}},[_vm._v("keyboard_arrow_down")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pl-4 pr-4 pt-4",staticStyle:{"height":"60px","top":"62%","position":"absolute","width":"100%"},attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.collection.groups),function(group,i){return (i<7 && _vm.getLanguageTranslation(group)!=false)?_c('span',{key:i,staticStyle:{"z-index":"90","color":"white"}},[_vm._v(" \n            "),_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("view_column")]),_vm._v("\n            "+_vm._s(_vm.getLanguageTranslation(group))+"\n          ")],1):_vm._e()})),_vm._v(" "),_c('v-card-media',{attrs:{"height":"50vh"}},[_c('div',{staticClass:"wave-img1 hide-ie"}),_vm._v(" "),_c('v-container',{staticClass:"pr-1 pl-1",attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{staticClass:"media",attrs:{"fill-height":"","column":""}},[_c('v-flex',{attrs:{"md10":"","offset-md1":""}},[_c('v-card-actions',[_c('v-layout',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("view_day")])],1),_vm._v(" "),(_vm.isAdmin)?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":"","to":'/collections/new/'}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.delete))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnno))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnyes))])],1)],1)],1)],1):(!_vm.isAdmin && _vm.isLoggedIn)?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1)],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"background-color":"#FAFAFA"},attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"shadow",staticStyle:{"position":"relative"},attrs:{"md10":"","id":"toScrollDescription"}},[_c('v-card',{staticStyle:{"border-left":"1px solid #efefef","border-right":"1px solid #efefef"},attrs:{"color":" mt-3 ","flat":"","id":"description"}},[_c('v-layout',{staticClass:"pt-1 pb-1",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"card--flex-toolbar",staticStyle:{"box-shadow":"none","border-bottom":"1px solid #efefef"}},[_c('v-toolbar',{attrs:{"card":"","color":"white","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text toolbarTitle"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.about))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.collection.description[_vm.lang].length > 350)?_c('v-card-text',[(_vm.isMinimized)?_c('div',[_c('p',{staticClass:"caption1"},[_c('i',[_vm._v(_vm._s(_vm.collection.description[_vm.lang].slice(0,351))+"...")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":"","primary":""},on:{"click":function($event){_vm.isMinimized = !_vm.isMinimized}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.readMore))])],1)],1):_vm._e(),_vm._v(" "),(!_vm.isMinimized)?_c('div',[_c('p',{staticClass:"caption1"},[_c('i',[_vm._v(_vm._s(_vm.collection.description[_vm.lang]))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":"","primary":""},on:{"click":function($event){_vm.isMinimized = !_vm.isMinimized}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.readLess))])],1)],1):_vm._e()]):_c('v-card-text',[_c('p',{staticClass:"caption1"},[_c('i',[_vm._v(_vm._s(_vm.collection.description[_vm.lang]))])])])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"card":"","color":"white","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text toolbarTitle"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.location))])],1),_vm._v(" "),_c('web-location-present-multiple',{staticStyle:{"box-shadow":"0px"},attrs:{"groupTitle":_vm.collection,"heightM":_vm.mapHeight}})],1),_vm._v(" "),(_vm.artefactsInCollection())?_c('v-card',{staticStyle:{"background-color":"#FAFAFA"},attrs:{"color":"  mb-3","flat":"","id":"bottomSlider"}},[_c('v-toolbar',{attrs:{"card":"","color":"white","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text toolbarTitle"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.artefacts))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-4"}),_vm._v(" "),_c('web-slider1',{attrs:{"artefacts":_vm.artefacts}},_vm._l((_vm.artefacts),function(artefact){return ((artefact.collectionId.indexOf(_vm.collection.title.en) > -1 && _vm.lessThen5(artefact._id,_vm.collection.title.en)))?_c('div',{key:artefact._id},[_c('web-artefact-card',{attrs:{"artefact":artefact}})],1):_vm._e()})),_vm._v(" "),_c('v-card-actions',{staticClass:"pt-1 mt-0",staticStyle:{"max-height":"70vh"}},[_c('v-flex',{staticClass:"text-xs-right",staticStyle:{"max-height":"80%"}},[_c('v-dialog',{staticClass:"artefactsDialog",attrs:{"full-width":"","transition":"dialog-bottom-transition","max-width":"1300","max-height":"800","overlay":false},model:{value:(_vm.dialog2),callback:function ($$v) {_vm.dialog2=$$v},expression:"dialog2"}},[_c('v-btn',{attrs:{"slot":"activator","color":"black","dark":"","flat":""},slot:"activator"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.show))]),_vm._v(" "),_c('div',{staticStyle:{"height":"70vh","overflow-y":"scroll"}},[_c('v-card',{staticStyle:{"z-index":"20200"}},[_c('v-btn',{staticClass:"artefactsDialogButton",staticStyle:{"margin-top":"16px"},attrs:{"icon":"","light":""},nativeOn:{"click":function($event){_vm.dialog2 = false}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('div',[_c('v-container',{staticClass:"modalContainer"},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.artefacts),function(artefact){return ((artefact.collectionId.indexOf(_vm.collection.title.en) > -1))?_c('v-flex',{key:artefact._id,staticClass:"pa-1",attrs:{"md4":""}},[_c('web-artefact-card',{staticClass:"modal-card",attrs:{"artefact":artefact}})],1):_vm._e()}),1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"modal pt-5",staticStyle:{"margin-top":"56px"},attrs:{"id":"myModal"}},[_c('v-btn',{staticClass:"close",attrs:{"dark":"","medium":"","fab":"","color":"black"},on:{"click":_vm.spanClick}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_vm._l((_vm.artefacts),function(artefact){return ((artefact.collectionId.indexOf(_vm.collection.title.en) > -1))?_c('div',{key:artefact._id},[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('web-artefact-card',{staticClass:"modal-card",attrs:{"artefact":artefact}})],1)],1)],1):_vm._e()})],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),(!_vm.isAdmin && _vm.isLoggedIn)?_c('v-speed-dial',{staticClass:"app-vue-speeddial",attrs:{"id":"bottom_button","top":_vm.top,"bottom":_vm.bottom,"right":_vm.right,"left":_vm.left,"direction":_vm.direction,"hover":_vm.hover,"transition":_vm.transition,"fixed":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"primary","dark":"","fab":"","hover":"","to":"/artefacts/new"},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y23B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-3 mb-3",staticStyle:{"max-width":"2000px"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.collections_lazy),function(collection){return _c('v-flex',{key:collection._id,attrs:{"xs12":"","sm6":"","md4":""}},[_c('web-collection-card',{attrs:{"collection":collection,"artefacts":_vm.artefacts}})],1)}),1),_vm._v(" "),(_vm.isMod||_vm.isContrib)?_c('web-speed-dial-add'):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"getNewCollections"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YQgs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("rpbJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b5ec3a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("1vvD");
function injectStyle (ssrContext) {
  __webpack_require__("HFLA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b5ec3a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b5ec3a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Common_Home__ = __webpack_require__("p+pt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Presentation_Artefacts_AddArtefact__ = __webpack_require__("I/Xc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Common_Artefacts__ = __webpack_require__("++SX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Common_ArtefactSingle__ = __webpack_require__("bt+T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Administration_Messaging__ = __webpack_require__("kRSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Administration_Settings__ = __webpack_require__("sFRj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Administration_Users__ = __webpack_require__("tcxl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Administration_Tasks__ = __webpack_require__("ByAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Common_Collections__ = __webpack_require__("Cn9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Common_CollectionSingle__ = __webpack_require__("eawQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Administration_Collections_ManageCollections__ = __webpack_require__("uN8X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Administration_Groups_ManageGroups__ = __webpack_require__("KRye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Common_EditArtefact__ = __webpack_require__("9QXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Common_Explore__ = __webpack_require__("VNJG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Common_GroupSingle__ = __webpack_require__("ADfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Common_LogIn__ = __webpack_require__("15vm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Common_Reset__ = __webpack_require__("Hgic");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Presentation_User_MyAccount__ = __webpack_require__("6WvG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Presentation_User_SignUp__ = __webpack_require__("tE8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Common_Groups__ = __webpack_require__("Ouc+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Common_TermsAndConditions__ = __webpack_require__("myLY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Common_About__ = __webpack_require__("YQgs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Common_Contact__ = __webpack_require__("jX/W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Common_Links__ = __webpack_require__("Dx0e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Common_NotFound__ = __webpack_require__("naVR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_meta__ = __webpack_require__("p3jY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_meta__);





























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_27_vue_meta___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/sitemaps.xml', alias: '/api/sitemaps.xml' }, {
    path: '/',
    name: '@Common/Home.vue',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Common_Home__["a" /* default */]
  }, {
    path: '/explore',
    name: '@Common/Explore.vue',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Common_Explore__["a" /* default */]
  }, {
    path: '/artefacts',
    name: '@Common/Artefacts.vue',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Common_Artefacts__["a" /* default */]
  }, {
    path: '/group-collections',
    name: '@Common/Groups.vue',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Common_Groups__["a" /* default */]
  }, {
    path: '/artefacts/new',
    name: '@Presentation/Artefacts/AddArtefact',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Presentation_Artefacts_AddArtefact__["a" /* default */]
  }, {
    path: '/artefacts/:id',
    props: true,
    name: '@Common/ArtefactSingle.vue',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Common_ArtefactSingle__["a" /* default */]
  }, {
    path: '/collections/new',
    name: '@Administration/Collections/ManageCollections.vue',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Administration_Collections_ManageCollections__["a" /* default */]

  }, {
    path: '/collections/:id',
    props: true,
    name: '@Common/CollectionSingle.vue',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Common_CollectionSingle__["a" /* default */]
  }, {
    path: '/collections/',
    name: '@Common/Collections.vue',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Common_Collections__["a" /* default */]
  }, {
    path: '/account/',
    name: '@Common/Presentation/User/MyAccount.vue',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Presentation_User_MyAccount__["a" /* default */]
  }, {
    path: '/signup/',
    name: '@Common/Presentation/User/SignUp.vue',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Presentation_User_SignUp__["a" /* default */]
  }, {
    path: '/users',
    name: '@Administration/Users.vue',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Administration_Users__["a" /* default */]
  }, {
    path: '/messaging',
    name: '@Administration/Messaging.vue',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Administration_Messaging__["a" /* default */]
  }, {
    path: '/settings',
    name: '@Administration/Settings.vue',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Administration_Settings__["a" /* default */]
  }, {
    path: '/groups/new',
    name: '@Administration/Groups/ManageGroups.vue',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Administration_Groups_ManageGroups__["a" /* default */]
  }, {
    path: '/artefacts/edit/:id',
    props: true,
    name: '@Common/EditArtefact.vue',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Common_EditArtefact__["a" /* default */]
  }, {
    path: '/groups/:id',
    props: true,
    name: '@Common/GroupSingle.vue',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Common_GroupSingle__["a" /* default */]
  }, {
    path: '/reset/:token',
    props: true,
    name: '@Common/Reset.vue',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Common_Reset__["a" /* default */]
  }, {
    path: '/signin',
    name: '@Common/LogIn.vue',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Common_LogIn__["a" /* default */]
  }, {
    path: '/terms-and-conditions',
    name: '@Common/TermsAndConditions.vue',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Common_TermsAndConditions__["a" /* default */]
  }, {
    path: '/about',
    name: '@Common/About.vue',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Common_About__["a" /* default */]
  }, {
    path: '/links',
    name: '@Common/Links.vue',
    component: __WEBPACK_IMPORTED_MODULE_25__components_Common_Links__["a" /* default */]
  }, {
    path: '/contact',
    name: '@Common/Contact.vue',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Common_Contact__["a" /* default */]
  }, {
    path: '/tasks',
    name: '@Administration/Tasks.vue',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Administration_Tasks__["a" /* default */]
  }, {
    path: '/404',
    name: '@Common/NotFound.vue',
    component: __WEBPACK_IMPORTED_MODULE_26__components_Common_NotFound__["a" /* default */]
  }, {
    path: '*',
    redirect: '/404'
  }],
  mode: 'history'
}));

/***/ }),

/***/ "YfWB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yw+8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z/Qe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7-min[cropped].938bdcc.jpg";

/***/ }),

/***/ "Z8HW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZLKU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Mixins_fileUploader_js__ = __webpack_require__("tUAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"], __WEBPACK_IMPORTED_MODULE_0__components_Mixins_fileUploader_js__["a" /* Uploader */]],
  validations: {
    name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(8) },
    email: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"] },
    select: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
    checkbox: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(8), alpha: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["alpha"], numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"] },
    repeatPassword: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["sameAs"])('password') }

  },
  data: function data() {
    return {
      errorMessage: '',
      register_boolean: true,
      e1: true,
      dialog: false,
      password: "",
      checkbox: false,
      repeatPassword: '',
      first: "John",
      email: "",
      name: "",
      picture: "",
      status: 0,
      loading: false,
      checkboxRules: [function (v) {
        return !!v || 'Name is required';
      }]
      //rules: {
      //required: (value) => !!value || 'This field is required.',
      //email: (value) => {
      //const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      //return pattern.test(value) || 'Invalid e-mail.'
      //}
      //},

    };
  },

  methods: {
    submit: function submit() {
      this.$v.$touch();
      this.emailErrors.length == 0 && this.passwordErrors.length == 0 && this.repeatPasswordErrors.length == 0 && this.nameErrors.length == 0 && this.checkboxErrors.length == 0 && this.register();
    },


    authenticate: function authenticate(provider) {
      var _this = this;

      this.$auth.authenticate(provider).then(function (response) {
        // Execute application logic after successful social authentication
        _this.$store.dispatch("createToken", response.data.token);
        _this.$store.dispatch("getSocialUser", response.data.token);
        console.log(response);
        _this.$router.push("/");
      }).catch(function (err) {
        console.log(err);
      });
    },
    login: function login() {
      var _this2 = this;

      this.$auth.login({ email: this.email, password: this.password }).then(function (token) {
        _this2.$store.dispatch("createToken", token.data.token);
        _this2.$store.dispatch("createUser", token.data.user);
        _this2.$router.push("/");
      }).catch(function (err) {
        console.log(err);
      });
    },

    register: function register() {
      var _this3 = this;

      this.$auth.register({
        displayName: this.name,
        email: this.email,
        password: this.password,
        picture: this.picture
      }).then(function (token) {
        _this3.$store.dispatch("createToken", token.data.token);
        _this3.$store.dispatch("createUser", token.data.user);
        _this3.$router.push("/");
      }).catch(function (err) {
        _this3.errorMessage = "Email already in use!";
      });
    },
    onCreateToken: function onCreateToken() {
      this.$store.dispatch("createToken", this.formUpload);
      this.$router.push("/artefacts");
    },
    isAuthenticated: function isAuthenticated() {
      if (token != "") return true;
      return false;
    },
    getScreenWidth: function getScreenWidth() {
      return screen.width;
      console.log(screen.width);
      console.log(screen.availWidth);
      console.log(screen.systemXDPI);
    }
  },
  mounted: function mounted() {
    document.title = "Sign Up";
    window.scrollTo(0, 0);
  },

  computed: {
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    nameErrors: function nameErrors() {
      var errors = [];
      if (!this.$v.name.$dirty) return errors;
      // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
      !this.$v.name.required && errors.push('Username is required.');
      return errors;
    },
    checkboxErrors: function checkboxErrors() {
      var errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
      !this.$v.checkbox.required && errors.push('You have to accept the Terms and Conditions.');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength && errors.push("Must be at least 8 characters");
      !this.$v.password.required && errors.push("Password is required");
      this.$v.password.alpha && errors.push("Should have at least one number");
      this.$v.password.numeric && errors.push("Should have at least one letter");
      return errors;
    },
    repeatPasswordErrors: function repeatPasswordErrors() {
      var errors = [];
      if (!this.$v.repeatPassword.$dirty) return errors;
      !this.$v.repeatPassword.sameAsPassword && errors.push("Must match the first password");
      !this.$v.repeatPassword.required && errors.push("Password is required");
      return errors;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  created: function created() {
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
  }
});

/***/ }),

/***/ "ZXxQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Mixins_fileUploader_js__ = __webpack_require__("tUAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"], __WEBPACK_IMPORTED_MODULE_0__components_Mixins_fileUploader_js__["a" /* Uploader */]],
  validations: {
    name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["maxLength"])(8) },
    email: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"] },
    select: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
    checkbox: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["minLength"])(8), alpha: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["alpha"], numeric: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"] },
    repeatPassword: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["sameAs"])('password') }
  },
  props: ['user', 'dialog'],

  data: function data() {
    return {
      errorMessage: '',
      e1: true,
      password: '',
      repeatPassword: '',
      status: 0,
      loading: false,
      picture: "",
      name: this.user.displayName,
      email: this.user.email
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$v.$touch();
      if (this.emailErrors.length == 0 && this.nameErrors.length == 0 && this.passwordErrors.length == 0 && this.repeatPasswordErrors.length == 0) {
        if (this.picture != "") {
          this.user.picture = this.picture;
        }
        this.user.displayName = this.name;
        this.user.email = this.email;
        this.user.password = this.password;
        this.$store.dispatch('ChangeUserInfo', { user: this.user, token: this.token }).then(function (token) {
          _this.$store.dispatch("createToken", token.data.token);
          _this.$emit('clicked');
        }).catch(function (err) {
          console.log(err);
        });
      }
    }
  },
  computed: {
    token: function token() {
      return this.$store.getters.getToken;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    nameErrors: function nameErrors() {
      var errors = [];
      if (!this.$v.name.$dirty) return errors;
      // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
      !this.$v.name.required && errors.push('Username is required.');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength && errors.push("Must be at least 8 characters");
      !this.$v.password.required && errors.push("Password is required");
      this.$v.password.alpha && errors.push("Should have at least one number");
      this.$v.password.numeric && errors.push("Should have at least one letter");
      return errors;
    },
    repeatPasswordErrors: function repeatPasswordErrors() {
      var errors = [];
      if (!this.$v.repeatPassword.$dirty) return errors;
      !this.$v.repeatPassword.sameAsPassword && errors.push("Must match the first password");
      !this.$v.repeatPassword.required && errors.push("Password is required");
      return errors;
    }
  }
});

/***/ }),

/***/ "a16V":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4-min[cropped].76ceb79.jpg";

/***/ }),

/***/ "af0o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "afmS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_aplayer_vue__ = __webpack_require__("HPoU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a8494de2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_aplayer_vue__ = __webpack_require__("ma6R");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_aplayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a8494de2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_aplayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "agMq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider2_vue__ = __webpack_require__("KvCt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edaa754c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider2_vue__ = __webpack_require__("NS0h");
function injectStyle (ssrContext) {
  __webpack_require__("8uwh")
  __webpack_require__("wZXs")
  __webpack_require__("A+7p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-edaa754c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edaa754c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "at5G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3-min[cropped].6006ded.jpg";

/***/ }),

/***/ "b7vJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleDescriptionSwiper_vue__ = __webpack_require__("DOhX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fae6275c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleDescriptionSwiper_vue__ = __webpack_require__("PP/d");
function injectStyle (ssrContext) {
  __webpack_require__("cC1p")
  __webpack_require__("O+J0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fae6275c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SimpleDescriptionSwiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fae6275c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SimpleDescriptionSwiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bMug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoWindowDialog_vue__ = __webpack_require__("i9ph");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cec3855_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWindowDialog_vue__ = __webpack_require__("RX0J");
function injectStyle (ssrContext) {
  __webpack_require__("CM8P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoWindowDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cec3855_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWindowDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bPGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('info-window-dialog',{attrs:{"marker":_vm.infoWindowMarker,"opened":_vm.infoWindowBoolMobile},on:{"close":function($event){_vm.infoWindowBoolMobile = !_vm.infoWindowBoolMobile}}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pa-3 map",attrs:{"elevation-1":""}},[_c('Gmap-Map',{ref:"map",staticStyle:{"width":"100%"},attrs:{"zoom":7,"center":_vm.center,"id":"mapHgt"}},[_vm._l((_vm.relatedArtefacts),function(marker){return _c('Gmap-Marker',{key:marker.location.place_id,attrs:{"position":{
          lng: parseFloat(marker.location.geometry.location.lng),
          lat: parseFloat(marker.location.geometry.location.lat)},"clickable":true,"draggable":false},on:{"click":function($event){_vm.openInfoWindow(marker)}}})}),_vm._v(" "),_vm._t("visible",[_c('div',{staticStyle:{"top":"60px","left":"15px","background-color":"#0000FF","color":"white","position":"absolute","z-index":"100"}},[_c('info-window',{staticClass:"map-info ",attrs:{"marker":_vm.infoWindowMarker,"opened":_vm.infoWindowBoolDesktop},on:{"close":function($event){_vm.infoWindowBoolDesktop = !_vm.infoWindowBoolDesktop}}})],1)])],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "beDd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sad.fa4417c.png";

/***/ }),

/***/ "bt+T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtefactSingle_vue__ = __webpack_require__("NcKA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681f27db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtefactSingle_vue__ = __webpack_require__("D6TK");
function injectStyle (ssrContext) {
  __webpack_require__("dv9A")
  __webpack_require__("XqB7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-681f27db"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtefactSingle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681f27db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtefactSingle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "byUg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArtefactPartial_vue__ = __webpack_require__("oBHd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d3d233c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArtefactPartial_vue__ = __webpack_require__("NMFQ");
function injectStyle (ssrContext) {
  __webpack_require__("9FaI")
  __webpack_require__("ppTP")
  __webpack_require__("ZLKU")
  __webpack_require__("VR71")
  __webpack_require__("v5o+")
  __webpack_require__("GOWV")
  __webpack_require__("02s1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d3d233c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArtefactPartial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d3d233c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArtefactPartial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c3Nj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleLocationsExplore_vue__ = __webpack_require__("suZf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e26d456c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleLocationsExplore_vue__ = __webpack_require__("2PF0");
function injectStyle (ssrContext) {
  __webpack_require__("9T6f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleLocationsExplore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e26d456c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleLocationsExplore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c6sU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
    validations: {
        nume: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        email: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"] },
        prenume: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        mesaj: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }

        // repeatPassword: {sameAsPassword: sameAs('password')}
    },
    data: function data() {
        return {
            timeout: 6000,
            colorS: 'info',
            colorF: 'red',
            mode: true,
            showSucces: false,
            showFail: false,
            contactForm: {
                nume: '',
                prenume: '',
                email: '',
                telefon: '',
                mesaj: ''
            },
            nume: '',
            prenume: '',
            email: '',
            telefon: '',
            mesaj: ''
        };
    },

    methods: {
        sendMessage: function sendMessage() {
            var _this = this;

            var concatMessage = this.nume + " " + this.prenume + " \n" + this.email + " \n" + this.telefon + " \n" + "Message:\n\n" + this.mesaj;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/messages/email', { message: concatMessage, email: 'hera@e-uvt.ro' }).then(function (response) {
                _this.showSucces = true;
                _this.nume = "";
                _this.prenume = "";
                _this.email = "";
                _this.telefon = "";
                _this.mesaj = "";
                _this.emailErrors = [];
                _this.numeErrors = [];
                _this.prenumeErrors = [];
                _this.mesajErrors = [];
            }).catch(function (err) {
                _this.showFail = true;
            });
        }
    },
    watch: {
        email: function email(newVal, oldVal) {
            this.contactForm.email = newVal;
        },
        nume: function nume(newVal, oldVal) {
            this.contactForm.nume = newVal;
        },
        prenume: function prenume(newVal, oldVal) {
            this.contactForm.prenume = newVal;
        },
        mesaj: function mesaj(newVal, oldVal) {
            this.contactForm.mesaj = newVal;
        }
    },
    computed: {
        emailErrors: function emailErrors() {
            var errors = [];
            if (!this.$v.email.$dirty) return errors;
            !this.$v.email.email && errors.push("Must be valid e-mail");
            !this.$v.email.required && errors.push("This field is required!");
            return errors;
        },
        numeErrors: function numeErrors() {
            var errors = [];
            if (!this.$v.nume.$dirty) return errors;
            !this.$v.nume.required && errors.push('This field is required!');
            return errors;
        },
        prenumeErrors: function prenumeErrors() {
            var errors = [];
            if (!this.$v.prenume.$dirty) return errors;
            !this.$v.prenume.required && errors.push('This field is required!');
            return errors;
        },
        mesajErrors: function mesajErrors() {
            var errors = [];
            if (!this.$v.mesaj.$dirty) return errors;
            !this.$v.mesaj.required && errors.push('This field is required!');
            return errors;
        }
    }
});

/***/ }),

/***/ "cC1p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cM5M":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/uvt_logo.9ff2818.png";

/***/ }),

/***/ "cMVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresentMultipleLocationsGroups_vue__ = __webpack_require__("/I3z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054ec107_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PresentMultipleLocationsGroups_vue__ = __webpack_require__("DcYv");
function injectStyle (ssrContext) {
  __webpack_require__("RK5T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresentMultipleLocationsGroups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_054ec107_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PresentMultipleLocationsGroups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d4Ep":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/16-min[cropped].69ba3cb.jpg";

/***/ }),

/***/ "dv9A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dw79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datetime__ = __webpack_require__("QEVx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_datetime__);




var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    datetime: __WEBPACK_IMPORTED_MODULE_4_vue_datetime__["Datetime"]
  },
  data: function data() {
    var _ref;

    return _ref = {
      cronological: false,
      methodResultsArtefactsClick: "",
      startDateCrono: "",
      endDateCrono: "",
      mapDialog: false,
      term: "",
      index: 0,
      options: {
        ro: {
          keys: ["title.ro", "description.ro", "pdfText"]
        },
        en: {
          keys: ["title.en", "description.en", "pdfText"]
        },
        sr: {
          keys: ["title.sr", "description.sr", "pdfText"]
        }
      },
      sortText: "",
      methodResultsArtefacts: [],
      methodResultsGroups: [],
      methodResultsCollections: [],
      place: {},
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      startDate: "May 18, 2018",
      endDate: ""
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "term", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "filter", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tabs", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "top", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "right", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "location", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tags", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "bottom", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "left", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "transition", "slide-y-reverse-transition"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "gradient", "to top right, rgba(63,81,181, .7), rgba(25,32,72, .0)"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "show", "All"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "sorting", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showArtefacts", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showCollections", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showGroups", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectedDate", {
      start: "",
      end: ""
    }), _ref;
  },
  created: function created() {
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
    this.$store.dispatch("loadUsers");
  },

  computed: {
    deviceWidth: function deviceWidth() {
      var w = window;
      var d = document;
      var e = d.documentElement;
      var g = d.getElementsByTagName('body')[0];
      return w.innerWidth || e.clientWidth || g.clientWidth;
    },
    sortItems: function sortItems() {
      return [{ name: this.gLang[this.lang].explore.mostPopular }, { name: this.gLang[this.lang].explore.newest }, { name: this.gLang[this.lang].explore.oldest }, { name: "A-Z" }, { name: "Z-A" }, { name: "Cronological" }];
    },
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    condition: function condition() {
      return this.methodResultsGroups.length == 0 && this.methodResultsCollections.length == 0 && this.methodResultsArtefacts.length == 0;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    popularArtefacts: function popularArtefacts() {
      return this.$store.getters.loadPopularArtefacts;
    },
    popularCollections: function popularCollections() {
      return this.$store.getters.loadPopularCollections;
    },
    popularGroups: function popularGroups() {
      return this.$store.getters.loadPopularGroups;
    },
    collections: function collections() {
      return this.$store.getters.loadAllCollections;
    },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    groups: function groups() {
      return this.$store.getters.loadGroups;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    isContrib: function isContrib() {
      return this.$store.getters.isContrib;
    }
  },

  methods: {
    getFormattedDate: function getFormattedDate(date) {
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;

      return month + '/' + day + '/' + year;
    },
    maxDate: function maxDate() {
      return this.artefacts = this.artefacts.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      })[0].date;
    },
    cloneResults: function cloneResults() {

      this.methodResultsArtefactsClick = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.methodResultsArtefacts)).filter(function (loc) {
        return loc.location != "" && loc.location.geometry;
      });
      this.mapDialog = true;
    },

    allowedDatesDown: function allowedDatesDown(val) {
      return val >= _this.startDate;
    },
    allowedDatesUp: function allowedDatesUp(val) {
      return val <= _this.endDate;
    },
    check1: function check1(string) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.methodResultsArtefacts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var artefact = _step.value;

          if (artefact.collectionId.includes(string)) return true;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    check2: function check2(string) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.methodResultsCollections), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var collection = _step2.value;

          if (collection.groups.includes(string)) return true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },
    sort: function sort(item) {
      this.sortText = item.name;
    },
    generalSearch: function generalSearch() {
      this.searchByTerm(this.term, this.artefacts, this.options[this.lang], "artefacts");
      this.searchByTerm(this.term, this.collections, this.options[this.lang], "collections");
      this.searchByTerm(this.term, this.groups, this.options[this.lang], "groups");
    },
    generalFilter: function generalFilter() {
      var _this2 = this;

      this.methodResultsArtefacts = this.filterDateCrono(this.methodResultsArtefacts, this.startDateCrono, this.endDateCrono);
      if (this.sortText == "Cronological") {
        this.methodResultsCollections = this.methodResultsCollections.filter(function (collection) {
          return _this2.check1(collection.title.en);
        });
        this.methodResultsGroups = this.methodResultsGroups.filter(function (group) {
          return _this2.check2(group.title.en);
        });
      }
      this.methodResultsArtefacts = this.filterDate(this.methodResultsArtefacts, this.startDate, this.endDate);
      this.methodResultsGroups = this.filterDate(this.methodResultsGroups, this.startDate, this.endDate);
      this.methodResultsCollections = this.filterDate(this.methodResultsCollections, this.startDate, this.endDate);
    },
    placeSearch: function placeSearch() {
      var _this3 = this;

      if (this.place.name != "" && this.place.name != undefined) {
        this.methodResultsArtefacts = this.filterPlace(this.methodResultsArtefacts, this.place);
        this.methodResultsCollections = this.methodResultsCollections.filter(function (collection) {
          return _this3.check1(collection.title);
        });
        this.methodResultsGroups = this.methodResultsGroups.filter(function (group) {
          return _this3.check2(group.title);
        });
      }
    },
    resetSearch: function resetSearch() {
      this.methodResultsArtefacts = this.artefacts.slice(0, 20);
      this.methodResultsGroups = this.groups.slice(0, 5);
      this.methodResultsCollections = this.collections.slice(0, 5);
      this.generalFilter();
      this.placeSearch();
    },
    searchByTerm: function searchByTerm(term, array, options, result) {
      var _this4 = this;

      this.$search(term, array, options).then(function (results) {
        _this4.generalFilter();
        _this4.placeSearch();
        if (result == "artefacts") _this4.methodResultsArtefacts = results;else if (result == "collections") _this4.methodResultsCollections = results;else if (result == "groups") _this4.methodResultsGroups = results;
      });
    },
    filterDate: function filterDate(array, startDate, endDate) {
      if (endDate != "" && startDate != "") {
        return array.filter(function (date) {
          return new Date(date.meta.creationDate) >= new Date(startDate) && new Date(date.meta.creationDate) <= new Date(endDate);
        });
      } else if (endDate != "" && startDate == "") {
        return array.filter(function (date) {
          return new Date(date.meta.creationDate) <= new Date(endDate);
        });
      } else if (endDate == "" && startDate != "") {
        return array.filter(function (date) {
          return new Date(date.meta.creationDate) >= new Date(startDate);
        });
      } else return array;
    },
    filterDateCrono: function filterDateCrono(array, startDate, endDate) {
      if (endDate != "" && startDate != "") {
        return array.filter(function (date) {
          return new Date(date.date) >= new Date(startDate) && new Date(date.date) <= new Date(endDate) && date.showDate == true;
        });
      } else if (endDate != "" && startDate == "") {
        return array.filter(function (date) {
          return new Date(date.date) <= new Date(endDate) && date.showDate == true;
        });
      } else if (endDate == "" && startDate != "") {
        return array.filter(function (date) {
          return new Date(date.date) >= new Date(startDate) && date.showDate == true;
        });
      } else return array;
    },
    filterPlace: function filterPlace(array, place) {
      if (place && place.name != "") {
        var slng = parseFloat(place.geometry.location.lng());
        var slat = parseFloat(place.geometry.location.lat());
        return array.filter(function (place) {
          var lng = parseFloat(place.location.geometry.location.lng);
          var lat = parseFloat(place.location.geometry.location.lat);
          return lng > slng - 3 && lng < slng + 3 && lat > slat - 3 && lat < slat + 3;
        });
      } else return array;
    },
    setPlace: function setPlace(place) {
      this.place = place;
    },

    onDateSelected: function onDateSelected(daterange) {
      this.selectedDate = daterange;
    },
    showContent: function showContent(collection) {
      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.artefacts.length; i++) {
        if (this.artefacts[i].collectionId.indexOf(collection.title) > -1) {
          return true;
        }
      }
      return false;
    },
    showContentGroup: function showContentGroup(group) {
      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.collections.length; i++) {
        if (this.collections[i].groups.indexOf(group.title) > -1) {
          return true;
        }
      }
      return false;
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    },

    // moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';

    //     }
    //     else
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }
    //   },

    isLast: function isLast(idart, coltitle) {
      var j,
          k = [];

      for (j = 0; j < this.artefacts.length; j++) {
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1) k.push(this.artefacts[j]._id);
      }if (k[k.length - 1] == idart) return true;else return false;
    }
  },
  mounted: function mounted() {

    this.sortText = this.gLang[this.lang].explore.sortBy;
    document.title = "Explore";
    window.scrollTo(0, 0);
    // this.moveButton(this.isAdmin);
  },

  watch: {
    methodResultsArtefacts: function methodResultsArtefacts(newValue, oldValue) {

      if (newValue.length != 0) this.showArtefacts = true;else this.showArtefacts = false;
    },
    methodResultsGroups: function methodResultsGroups(newValue, oldValue) {
      if (newValue.length != 0) this.showGroups = true;else this.showGroups = false;
    },
    methodResultsCollections: function methodResultsCollections(newValue, oldValue) {
      if (newValue.length != 0) this.showCollections = true;else this.showCollections = false;
    },
    term: function term(newValue, oldValue) {
      if (newValue == "") this.resetSearch();else {
        this.generalSearch();
      }
    },
    startDateCrono: function startDateCrono(newValue, oldValue) {
      if (this.term == "") this.resetSearch();else this.generalSearch();
    },
    endDateCrono: function endDateCrono(newValue, oldValue) {
      if (this.term == "") this.resetSearch();else this.generalSearch();
    },
    startDate: function startDate(newValue, oldValue) {
      if (this.term == "") this.resetSearch();else this.generalSearch();
    },
    endDate: function endDate(newValue, oldValue) {
      if (this.term == "") this.resetSearch();else this.generalSearch();
    },
    place: function place(newValue, oldValue) {
      if (this.term == "") this.resetSearch();
      this.placeSearch();
    },
    sortText: function sortText(newValue, oldValue) {
      if (this.term == "") this.resetSearch();
      this.filter = true;
      if (newValue == this.gLang[this.lang].explore.mostPopular) {
        this.artefacts = this.artefacts.sort(function (a, b) {
          return b.visited - a.visited;
        });
        this.collections = this.collections.sort(function (a, b) {
          return b.visited - a.visited;
        });
        this.groups = this.groups.sort(function (a, b) {
          return b.visited - a.visited;
        });
      }

      if (newValue == this.gLang[this.lang].explore.newest) {
        this.artefacts = this.artefacts.sort(function (a, b) {
          return new Date(b.meta.creationDate) - new Date(a.meta.creationDate);
        });
        this.collections = this.collections.sort(function (a, b) {
          return new Date(b.meta.creationDate) - new Date(a.meta.creationDate);
        });
        this.groups = this.groups.sort(function (a, b) {
          return new Date(b.meta.creationDate) - new Date(a.meta.creationDate);
        });
      }

      if (newValue == "Cronological") {
        this.artefacts = this.artefacts.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        });
        this.endDateCrono = Date.now();
        this.startDateCrono = this.maxDate();
      }

      if (newValue == this.gLang[this.lang].explore.oldest) {
        this.artefacts = this.artefacts.sort(function (a, b) {
          return new Date(a.meta.creationDate) - new Date(b.meta.creationDate);
        });
        this.collections = this.collections.sort(function (a, b) {
          return new Date(a.meta.creationDate) - new Date(b.meta.creationDate);
        });
        this.groups = this.groups.sort(function (a, b) {
          return new Date(a.meta.creationDate) - new Date(b.meta.creationDate);
        });
      }
      if (newValue == "A-Z") {
        var self = this;
        this.artefacts = this.artefacts.sort(function (a, b) {
          return a.title[self.lang].localeCompare(b.title[self.lang]);
        });
        this.collections = this.collections.sort(function (a, b) {
          return a.title[self.lang].localeCompare(b.title[self.lang]);
        });
        this.groups = this.groups.sort(function (a, b) {
          return a.title[self.lang].localeCompare(b.title[self.lang]);
        });
      }
      if (newValue == "Z-A") {
        var self = this;
        this.artefacts = this.artefacts.sort(function (a, b) {
          return b.title[self.lang].localeCompare(a.title[self.lang]);
        });
        this.collections = this.collections.sort(function (a, b) {
          return b.title[self.lang].localeCompare(a.title[self.lang]);
        });
        this.groups = this.groups.sort(function (a, b) {
          return b.title[self.lang].localeCompare(a.title[self.lang]);
        });
      }
      this.resetSearch();
      if (this.term != "") {
        this.generalSearch();
      }
      this.placeSearch();
    }
  }
});

/***/ }),

/***/ "e0vu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_swiper_css__ = __webpack_require__("s1hA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      sliderArtefacts1: [],
      homeText: " explore your culture" + " \n " + " beyond limits",
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      gradient: "to top right, rgba(63,81,181, .7), rgba(25,32,72, .0)",
      show: "Categories",
      sorting: 2,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOption3: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        spaceBetween: 10,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  beforeMount: function beforeMount() {
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
  },
  computed: {
    gLang: function gLang() {
      return this.$store.getters.loadGlobLang;
    },
    sliderArtefacts: function sliderArtefacts() {
      var i;
      for (i = 0; i < this.popularArtefacts.length; i++) {
        if (i % 4 == 0) {
          this.sliderArtefacts1[parseInt(i / 4)] = [this.popularArtefacts[i], this.popularArtefacts[i + 1], this.popularArtefacts[i + 2], this.popularArtefacts[i + 3]];
        }
      }
      return this.sliderArtefacts1;
    },
    popularArtefacts: function popularArtefacts() {
      return this.$store.getters.loadPopularArtefacts;
    },
    popularCollections: function popularCollections() {
      return this.$store.getters.loadPopularCollections;
    },
    popularGroups: function popularGroups() {
      return this.$store.getters.loadPopularGroups;
    },
    collections: function collections() {
      return this.$store.getters.loadAllCollections;
    },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    groups: function groups() {
      return this.$store.getters.loadGroups;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    isContrib: function isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  methods: {
    showContent: function showContent(collection) {
      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.artefacts.length; i++) {
        if (this.artefacts[i].collectionId.indexOf(collection.title) > -1) {
          return true;
        }
      }
      return false;
    },
    showContentGroup: function showContentGroup(group) {
      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.collections.length; i++) {
        if (this.collections[i].groups.indexOf(group.title) > -1) {
          return true;
        }
      }
      return false;
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    },

    // moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';

    //     }
    //     else
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }
    //   },
    isLast: function isLast(idart, coltitle) {
      var j,
          k = [];

      for (j = 0; j < this.artefacts.length; j++) {
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1) k.push(this.artefacts[j]._id);
      }if (k[k.length - 1] == idart) return true;else return false;
    }
  },
  mounted: function mounted() {
    document.title = "HeRA Home";
    window.scrollTo(0, 0);
  },
  created: function created() {
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
    this.$store.dispatch("loadLanguages");
  }
});

/***/ }),

/***/ "eHBn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewMessage_vue__ = __webpack_require__("qtB4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03bd0cb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewMessage_vue__ = __webpack_require__("HDni");
function injectStyle (ssrContext) {
  __webpack_require__("LD6I")
  __webpack_require__("VdXy")
  __webpack_require__("wd6k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03bd0cb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03bd0cb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eXT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"mt-3 mb-3 ",staticStyle:{"max-width":"2000px"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.artefacts_scroll),function(artefact){return _c('v-flex',{key:artefact._id,attrs:{"xs12":"","sm6":"","md4":""}},[_c('web-artefact-card',{attrs:{"artefact":artefact}})],1)}),1),_vm._v(" "),(_vm.isMod||_vm.isContrib)?_c('web-speed-dial-add'):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"id":"getNewArtefacts"}}),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticStyle:{"width":"100vw","height":"67px"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eawQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionSingle_vue__ = __webpack_require__("tdnc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f0204c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionSingle_vue__ = __webpack_require__("Y0FV");
function injectStyle (ssrContext) {
  __webpack_require__("5bxU")
  __webpack_require__("BBKv")
  __webpack_require__("XKgL")
  __webpack_require__("9jGp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17f0204c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectionSingle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17f0204c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollectionSingle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "emCS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "epP7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/15-min[cropped].adbccef.jpg";

/***/ }),

/***/ "erLt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Uploader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FileUpload_file_upload_service_import__ = __webpack_require__("hwHy");


var STATUS_INITIAL = 0;

var STATUS_SAVING = 1;

var STATUS_SUCCESS = 2;

var STATUS_FAILED = 3;
var Uploader = {
  data: function data() {
    return {
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos'
    };
  },

  computed: {
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  methods: {
    clickInputMain: function clickInputMain() {
      this.$refs.fileInput1.click();
    },
    reset: function reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
      this.loading = false;
      this.status = 0;
    },
    save: function save(formData, position) {
      var _this = this;

      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_FileUpload_file_upload_service_import__["a" /* upload */])(formData).then(function (x) {
        _this.picture = x;
        _this.loading = false;
        _this.status = 1;
        _this.currentStatus = STATUS_SUCCESS;
      }).catch(function (err) {
        _this.loading = false;
        _this.uploadError = err.response;
        _this.currentStatus = STATUS_FAILED;
      });
    },
    filesChange: function filesChange(fieldName, fileList, position) {
      // handle file changes
      var formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });

      // save it
      this.save(formData, position);
    }
  },
  mounted: function mounted() {
    this.reset();
  }
};

/***/ }),

/***/ "fYaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.errorMessage != '')?_c('p',{staticClass:"mt-4 caption red--text text--darken-4"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Edit Profile")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-form',{staticStyle:{"width":"94%"}},[_c('v-text-field',{attrs:{"name":"input-1","label":"Username","id":"testing","error-messages":_vm.nameErrors,"required":""},on:{"input":function($event){_vm.$v.name.$touch()},"blur":function($event){_vm.$v.name.$touch()}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),(_vm.user.email)?_c('v-text-field',{attrs:{"label":"E-mail","error-messages":_vm.emailErrors,"required":""},on:{"input":function($event){_vm.$v.email.$touch()},"blur":function($event){_vm.$v.email.$touch()},"keydown":function($event){_vm.errorMessage=''}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-10-1","label":"Password","min":"8","append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text',"counter":"","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){_vm.$v.password.$touch()},"blur":function($event){_vm.$v.password.$touch()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-10-1","label":"Repeat Password","type":"password","error-messages":_vm.repeatPasswordErrors,"required":""},on:{"input":function($event){_vm.$v.repeatPassword.$touch()},"blur":function($event){_vm.$v.repeatPassword.$touch()}},model:{value:(_vm.repeatPassword),callback:function ($$v) {_vm.repeatPassword=$$v},expression:"repeatPassword"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.loading},on:{"click":function($event){_vm.clickInputMain()}}},[_vm._v("Profile Image\n                                      "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                          cloud_upload\n                                      ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput1",staticClass:"input-file",staticStyle:{"display":"none"},attrs:{"type":"file","name":"avatar","disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, -1); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.$emit('clicked')}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":_vm.loading,"flat":""},on:{"click":_vm.submit}},[_vm._v("Save")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gLuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"m-5 mb-1"},[_c('v-card-media',{attrs:{"src":_vm.group.imgUrl[0].url+'_card',"height":"180px"},on:{"click":_vm.toGroup1}},[_c('div',{staticClass:"overlay-image"},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"headline grpTitle white--text",staticStyle:{"text-decoration":"none","cursor":"pointer"},domProps:{"textContent":_vm._s(_vm.group.title[_vm.lang])},on:{"click":_vm.toGroup}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"grpText white--text",staticStyle:{"margin-top":"10px"}},[_vm._v(" "+_vm._s(_vm.group.description[_vm.lang].slice(0, 110))),(_vm.group.description[_vm.lang].length >109)?_c('span',[_vm._v("...")]):_vm._e()])])],1)],1)],1)]),_vm._v(" "),_c('hr',{staticClass:"hrstl3"}),_vm._v(" "),(_vm.showContentGroup(_vm.group))?_c('v-expansion-panel',{staticClass:"expPanel",attrs:{"expand":""}},[_c('v-expansion-panel-content',{staticClass:"mb-0 ",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"greyText",attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"pr-2",attrs:{"left":""}},[_vm._v("view_day")]),_vm._v(_vm._s(_vm.gLang[_vm.lang].groupCard.expansion))],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.relatedCollections),function(collection,i){return ((collection.groups.indexOf(_vm.group.title.en) > -1))?_c('div',{key:i},[_c('v-divider'),_vm._v(" "),(i<3)?_c('v-list-tile',{staticClass:"pt-2 pb-0",attrs:{"avatar":""},on:{"click":function($event){_vm.toCollection(collection._id)}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":collection.imgUrl[0].url+'_card'}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie pt-1"},[_c('v-list-tile-title',{staticClass:"artTitle",staticStyle:{"overflow":"hidden"},domProps:{"innerHTML":_vm._s(collection.title[_vm.lang])}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(collection.description[_vm.lang])}})],1)],1):_vm._e()],1):_vm._e()})],2)],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gsKj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gxJ0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/13-min[cropped].207f80a.jpg";

/***/ }),

/***/ "h4LS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"dark":""}},[_c('v-card-media',{staticClass:"white--text",class:{'largeScreenHeight' : _vm.getScreenWidth() > 900, 'smallScreenHeight' : _vm.getScreenWidth() < 900},attrs:{"src":_vm.artefact.mainImg[0].url}},[_c('div',{staticClass:"mainImg-overlay"}),_vm._v(" "),_c('v-container',{staticClass:"pr-1 pl-1",attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{staticClass:"media",attrs:{"fill-height":"","column":""}},[_c('v-card-actions',[_c('v-layout',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("view_carousel")])],1),_vm._v(" "),((_vm.isAdmin && _vm.toBeDeleted) || (_vm.isMod && _vm.toBeDeleted) )?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":_vm.restoreArtefact}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("replay")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","to":'/artefacts/edit/' + _vm.artefact._id}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v("Are you sure you want to delete this Artefact?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v("Yes")])],1)],1)],1)],1):(_vm.isAdmin && _vm.isAccepted)?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","to":'/artefacts/edit/' + _vm.artefact._id}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v("Are you sure you want to delete this Artefact?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v("Yes")])],1)],1)],1)],1):((_vm.isAdmin && !_vm.isAccepted) || (_vm.isMod && !_vm.isAccepted) )?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":_vm.acceptArtefact}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("check_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","to":'/artefacts/edit/' + _vm.artefact._id}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v("Are you sure you want to delete this Artefact?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v("Yes")])],1)],1)],1)],1):(!_vm.isAdmin && !_vm.isAccepted )?_c('v-layout',[_c('v-spacer')],1):(!_vm.isAdmin && _vm.isAccepted && _vm.isAuthor )?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":"","to":'/artefacts/edit/' + _vm.artefact._id}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v("Are you sure you want to delete this Artefact?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v("Yes")])],1)],1)],1)],1):(!_vm.isAdmin && _vm.isAccepted && !_vm.isAuthor && _vm.isLoggedIn )?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")])],1)],1):(!_vm.isAdmin && _vm.isAccepted && !_vm.isAuthor && !_vm.isLoggedIn )?_c('v-layout',[_c('v-spacer')],1):_vm._e()],1),_vm._v(" "),_c('v-card-title',[_c('v-layout',[_c('v-list-tile-content',[_c('div',{staticClass:"v-list-tile-content"},[_c('v-list-tile-title',{staticClass:"display-1 v-list-tile-title"},[_vm._v(_vm._s(_vm.artefact.title[_vm.lang].toUpperCase()))]),_vm._v(" "),_vm._l((_vm.users),function(user){return (user._id == _vm.artefact.userId )?_c('v-list-tile-sub-title',{key:user._id,staticClass:"pb-2 pt-2 caption"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.addedBy)+" "+_vm._s(user.displayName)+" at "+_vm._s(_vm._f("date")(_vm.artefact.meta.creationDate))+" ")]):_vm._e()}),_vm._v(" "),_c('hr',{attrs:{"width":"100%"}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"pb-2 pt-2 caption"},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.artefact.collectionId),function(col,i){return (i<7)?_c('span',{key:i},[_vm._v("  "),_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("label")]),_vm._v(" "+_vm._s(col))],1):_vm._e()}))],1)],2)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"hidden-sm-and-down addBorder",staticStyle:{"background-color":"white"},attrs:{"flat":""}},[_c('v-card-text',{staticClass:"pr-0 pl-0"},[_c('div',{staticClass:"description pa-3"},[_c('p',[_vm._v(_vm._s(_vm.artefact.description[_vm.lang]))])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.artefact.uploads),function(media){return _c('div',{key:media._id,staticClass:"div1"},[(media.type ==='image')?_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('div',{staticClass:" position:relative"},[_c('img',{staticClass:"img1",attrs:{"src":media.data[0].url,"alt":""}})])]):(media.type === 'video')?_c('v-flex',{staticClass:"mt-3 mb-3",attrs:{"elevation-1":"","xs12":"","sm12":""}},[_c('v-card',[_c('div',[_c('v-card-media',[_c('div',{},[_c('d-player',{ref:"player",refInFor:true,attrs:{"video":{
                url: media.data[0].url,
                  },"autoplay":false,"contextmenu":_vm.contextmenu,"screenshot:":"","true":"","lang":"en"},on:{"play":_vm.play}})],1)])],1)])],1):(media.type === 'audio')?_c('v-flex',{class:{ 'noBoxShadow' : _vm.getScreenWidth() > 900, 'mt-3 mb-3 img1' : true},attrs:{"elevation-1":"","xs12":""}},[(media.data.length != 0)?_c('div',{},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"pa-1",staticStyle:{"background-color":"#FAFAFA"},attrs:{"row":"","elevation-3":""}},[_c('div',{staticStyle:{"width":"100%","background-color":"#FAFAFA"}},[_c('v-layout',{staticStyle:{"width":"100%","white-space":"normal"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',[_c('i',[_vm._v(_vm._s(media.data[0].originalName))])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('audio',{staticStyle:{"width":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"src":media.data[0].url,"type":"audio/ogg"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url,"type":"audio/mpeg"}}),_vm._v("\n                                Your browser does not support the audio element.\n                    ")])])],1)],1)])],1)],1)],1):_vm._e()]):(media.type === 'pdf')?_c('v-flex',{class:{ 'noBoxShadow' : _vm.getScreenWidth() > 900, 'mr-0  mt-2 mb-2  flex1' : true},attrs:{"elevation-3":"","xs12":"","sm12":""}},[(media.data.length != 0)?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","offset":""}},[_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"blue white--text"},[_vm._v(" picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(media.data[0].originalName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("date")(_vm.artefact.meta.creationDate)))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"href":media.data[0].url,"download":"","icon":"","ripple":""}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("file_download")])],1)],1)],1)],1)],1)],1)],1)],1):_vm._e()]):(media.type === 'text')?_c('v-flex',{staticClass:"mt-2 mb-2 mr-1 ml-1 pt-1 pb-1",attrs:{"elevation-1":"","xs12":"","sm12":""}},[_c('div',{},[_c('div',{staticClass:"description pt-3 pl-3 pr-3 pb-0"},[_c('p',{domProps:{"innerHTML":_vm._s(media.value[_vm.lang])}})])])]):_vm._e()],1)})),_vm._v(" "),(!_vm.isAdmin && _vm.isLoggedIn)?_c('v-speed-dial',{staticClass:"app-vue-speeddial",attrs:{"id":"bottom_button","top":_vm.top,"bottom":_vm.bottom,"right":_vm.right,"left":_vm.left,"direction":_vm.direction,"hover":_vm.hover,"transition":_vm.transition,"fixed":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"primary","dark":"","fab":"","hover":"","to":"/artefacts/new"},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e()],1),_vm._v(" "),_c('web-location-present-single',{attrs:{"location":_vm.artefact.location}})],1),_vm._v(" "),_c('web-location-tab',{staticClass:"hidden-md-and-up ",attrs:{"artefact":_vm.artefact,"isCollection":false}},[_c('div',{staticClass:"description pa-3"},[_c('p',[_vm._v(_vm._s(_vm.artefact.description[_vm.lang]))])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},_vm._l((_vm.artefact.uploads),function(media){return _c('div',{key:media._id,staticClass:"div1"},[(media.type ==='image')?_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('div',{staticClass:" position:relative"},[_c('img',{staticClass:"img1",attrs:{"src":media.data[0].url,"alt":""}})])]):(media.type === 'video')?_c('v-flex',{staticClass:"mt-3 mb-3",attrs:{"elevation-1":"","xs12":"","sm12":""}},[_c('v-card',[_c('div',[_c('v-card-media',[_c('div',{},[_c('d-player',{ref:"player",refInFor:true,attrs:{"video":{
                url: media.data[0].url,
                  },"autoplay":false,"contextmenu":_vm.contextmenu,"screenshot:":"","true":"","lang":"en"},on:{"play":_vm.play}})],1)])],1)])],1):(media.type === 'audio')?_c('v-flex',{class:{ 'noBoxShadow' : _vm.getScreenWidth() > 900, 'mt-3 mb-3 img1' : true},attrs:{"elevation-1":"","xs12":"","sm12":""}},[(media.data.length != 0)?_c('div',{staticClass:"ma-1 pa-3"},[_c('v-layout',{class:{ 'noBoxShadow' : _vm.getScreenWidth() > 900, 'pa-1' : true},staticStyle:{"background-color":"#FAFAFA"},attrs:{"row":"","elevation-3":""}},[_c('div',{staticStyle:{"width":"100%","background-color":"#FAFAFA"}},[_c('v-layout',{staticStyle:{"width":"100%","white-space":"normal"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',[_c('i',[_vm._v(_vm._s(media.data[0].originalName))])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('audio',{staticStyle:{"width":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"src":media.data[0].url,"type":"audio/ogg"}}),_vm._v(" "),_c('source',{attrs:{"src":media.data[0].url,"type":"audio/mpeg"}}),_vm._v("\n                                Your browser does not support the audio element.\n                    ")])])],1)],1)])],1):_vm._e()]):(media.type === 'pdf')?_c('v-flex',{staticClass:"mr-0  mt-2 mb-2  flex1",attrs:{"elevation-3":"","xs12":"","sm12":""}},[(media.data.length != 0)?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","offset":""}},[_c('v-card',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"blue white--text"},[_vm._v(" picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(media.data[0].originalName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("date")(_vm.artefact.meta.creationDate)))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"href":media.data[0].url,"download":"","icon":"","ripple":""}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("file_download")])],1)],1)],1)],1)],1)],1)],1)],1):_vm._e()]):(media.type === 'pdf')?_c('v-flex',{staticClass:"mr-0 pl-3 pt-1 mt-2 mb-2 pb-1 flex1",attrs:{"elevation-3":"","xs12":"","sm12":""}},[(media.data.length != 0)?_c('div'):_vm._e()]):(media.type === 'text')?_c('v-flex',{staticClass:"mt-2 mb-2 mr-1 ml-1 pt-1 pb-1",attrs:{"elevation-1":"","xs12":"","sm12":""}},[_c('div',{},[_c('div',{staticClass:"description pt-3 pl-3 pr-3 pb-0"},[_c('p',{domProps:{"innerHTML":_vm._s(media.value[_vm.lang])}})])])]):_vm._e()],1)})),_vm._v(" "),(_vm.isMod||_vm.isContrib)?_c('web-speed-dial-add'):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hQmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-speed-dial',{staticClass:"app-vue-speeddial",attrs:{"id":"bottom_button","top":_vm.top,"bottom":_vm.bottom,"right":_vm.right,"left":_vm.left,"direction":_vm.direction,"hover":_vm.hover,"transition":_vm.transition,"fixed":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"red darken-2","dark":"","fab":"","hover":"","to":"/artefacts/new"},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hYjn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  validations: {
    name: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(8) },
    email: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"] },
    select: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
    checkbox: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(8), alpha: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["alpha"], numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"] },
    repeatPassword: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["sameAs"])('password') }

  },

  data: function data() {

    return {

      password: "",
      error: '',
      repeatPassword: '',
      errorMessage: "",
      passwordRules: [function (v) {
        return !!v || "This field is required.";
      }, function (v) {
        return v.length <= 8 || "Password should contain more than 8 characters";
      }]
    };
  },

  props: ["token"],
  mounted: function mounted() {
    var _this = this;

    window.scrollTo(0, 0);
    this.$store.dispatch("recoverChangePasswordGet", this.token).then(function (response) {
      if (response.data.error) _this.error = response.data.error;
    });
  },


  methods: {
    submit: function submit() {
      this.$v.$touch();
      this.emailErrors.length == 0 && this.passwordErrors.length == 0 && this.repeatPasswordErrors.length == 0 && this.nameErrors.length == 0 && this.checkboxErrors.length == 0;
      this.register();
    },
    register: function register() {
      var _this2 = this;

      this.$store.dispatch("recoverChangePasswordPost", { token: this.token, password: this.password }).then(function (response) {
        _this2.$router.push('/signin');
      });
    },
    getScreenWidth: function getScreenWidth() {
      return screen.width;
      console.log(screen.width);
      console.log(screen.availWidth);
      console.log(screen.systemXDPI);
    }
  },
  computed: {
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    nameErrors: function nameErrors() {
      var errors = [];
      if (!this.$v.name.$dirty) return errors;
      // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
      !this.$v.name.required && errors.push('Username is required.');
      return errors;
    },
    checkboxErrors: function checkboxErrors() {
      var errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
      !this.$v.checkbox.required && errors.push('You have to accept the Terms and Conditions.');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength && errors.push("Must be at least 8 characters");
      !this.$v.password.required && errors.push("Password is required");
      this.$v.password.alpha && errors.push("Should have at least one number");
      this.$v.password.numeric && errors.push("Should have at least one letter");
      return errors;
    },
    repeatPasswordErrors: function repeatPasswordErrors() {
      var errors = [];
      if (!this.$v.repeatPassword.$dirty) return errors;
      !this.$v.repeatPassword.sameAsPassword && errors.push("Must match the first password");
      !this.$v.repeatPassword.required && errors.push("Password is required");
      return errors;
    }
  }
});

/***/ }),

/***/ "hZfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('v-stepper',{attrs:{"non-linear":""}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"En","editable":"","rules":[function () { return _vm.rulesEn; }]}},[_vm._v("English")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Ro","editable":"","rules":[function () { return _vm.rulesRo; }]}},[_vm._v("Romana")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Sr","editable":"","rules":[function () { return _vm.rulesSr; }]}},[_vm._v("Српски")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"En"}},[_c('keep-alive',[_c('web-edit-artefact',{attrs:{"formUpload":_vm.formUpload,"place":_vm.place,"marker":_vm.marker,"center":_vm.center,"newLocation":_vm.newLocation,"lang":'en',"rules":[function () { return _vm.rulesEn; }]},on:{"newMarker":function($event){_vm.marker = $event},"newLocation":function($event){_vm.place = $event},"save":function($event){_vm.changeEn($event)},"maybe":function($event){_vm.dialogOpen=true}}})],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Ro"}},[_c('keep-alive',[_c('web-edit-artefact',{attrs:{"formUpload":_vm.formUpload,"place":_vm.place,"marker":_vm.marker,"center":_vm.center,"newLocation":_vm.newLocation,"lang":'ro',"rules":[function () { return _vm.rulesRo; }]},on:{"newMarker":function($event){_vm.marker = $event},"newLocation":function($event){_vm.place = $event},"save":function($event){_vm.changeRo($event)},"maybe":function($event){_vm.dialogOpen=true},"changeObj":function($event){_vm.addedRo=false}}})],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Sr"}},[_c('keep-alive',[_c('web-edit-artefact',{attrs:{"formUpload":_vm.formUpload,"place":_vm.place,"marker":_vm.marker,"center":_vm.center,"newLocation":_vm.newLocation,"lang":'sr',"rules":[function () { return _vm.rulesSr; }]},on:{"newMarker":function($event){_vm.marker = $event},"newLocation":function($event){_vm.place = $event},"save":function($event){_vm.changeSr($event)},"maybe":function($event){_vm.dialogOpen=true},"changeObj":function($event){_vm.addedSr=false}}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialogOpen),callback:function ($$v) {_vm.dialogOpen=$$v},expression:"dialogOpen"}},[_c('v-card',[_c('v-card-title',[(!_vm.rulesEn && !_vm.rulesRo && !_vm.rulesSr)?_c('p',[_vm._v("\n              Your artefact won't be visible in any language please complete all fields(including text-fields for the desired language)\n              "),_c('br'),_vm._v("\n              By continuing you're saving your artefacts to your drafts , visible only to your account!\n            ")]):_c('p',[_vm._v("You can change the visibility of your artefacts by adding language versions, your artefact will be visible in:")])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[(_vm.rulesEn)?_c('p',[_vm._v("English ")]):_vm._e(),_vm._v(" "),(_vm.rulesRo)?_c('p',[_vm._v(" Romana")]):_vm._e(),_vm._v(" "),(_vm.rulesSr)?_c('p',[_vm._v(" Српски")]):_vm._e(),_vm._v(" "),(_vm.rulesEn && !_vm.rulesRo && !_vm.rulesSr )?_c('p',[_vm._v("The Serbian and Romanian versions will be shown in English")]):_vm._e(),_vm._v(" "),(_vm.rulesEn && !_vm.rulesRo && _vm.rulesSr )?_c('p',[_vm._v("The Romanian version will be shown in English")]):_vm._e(),_vm._v(" "),(_vm.rulesEn && _vm.rulesRo && !_vm.rulesSr )?_c('p',[_vm._v("The Serbian version will be shown in English")]):_vm._e()]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();return _vm.onUpdateArtefact($event)}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogOpen=false}}},[_vm._v("Change")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hqhH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ratatatatatatatatatatatata"},[_c('slick',{ref:"slick",attrs:{"options":_vm.slickOptions}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hr7Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_swiper_css__ = __webpack_require__("s1hA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__("7QTg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      previewArtefact: "",
      swiperOption: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        spaceBetween: 10,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOption1: {
        slidesPerView: 1,
        slidesPerColumn: 2,
        spaceBetween: 10,

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },

  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    artefacts: function artefacts() {
      return this.$store.getters.getFavoriteArtefacts;
    },
    users: function users() {
      return this.$store.getters.loadUsers;
    }
    //  previewArtefact() {
    //   return this.artefacts[0].description;
    // },

  },
  methods: {
    toArtefact: function toArtefact(artefactID) {
      this.$router.push("/artefacts/" + artefactID);
    }
  }
  // methods : {
  //   firstDescription () {
  //     this.previewArtefact = this.artefacts[0].description;
  //   }
  // },
  // mounted () {
  //   this.firstDescription();
  // }
});

/***/ }),

/***/ "hwHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return upload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deploy_conf_js__ = __webpack_require__("OEKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deploy_conf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__deploy_conf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
// file-upload.service.js




var BASE_URL = __WEBPACK_IMPORTED_MODULE_0__deploy_conf_js__["API_ADRESS"];

function upload(formData) {
  var url = BASE_URL + 'api/restore/export';
  return __WEBPACK_IMPORTED_MODULE_1_axios__["post"](url, formData)
  // get data
  .then(function (x) {
    return x.data;
  })
  // add url field
  .then(function (x) {
    alert(x.message);
  });
}



/***/ }),

/***/ "i9ph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['opened', 'marker'],
    methods: {
        close: function close() {
            this.$emit('close');
        },
        minimize: function minimize(str, spaces) {
            if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
        }
    }
});

/***/ }),

/***/ "iYXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-0 pa-0",staticStyle:{"width":"100%","min-height":"90vh","background-color":"#FAFAFA","box-shadow":"none"}},[_c('v-layout',{staticClass:" primary pl-2 pr-2 ",attrs:{"row":""}},[_c('v-flex',{staticClass:" mr-3 ml-3 white hidden-md-and-up",attrs:{"xs12":"","sm12":"","offset-sm2":""}},[_c('h3',{staticClass:"mb-1 text-xs-center",staticStyle:{"color":"grey"}},[_vm._v("    MANAGE GROUPS")])])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',{staticClass:"mt-2 pt-2",staticStyle:{"min-height":"40vh"}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"ma-1 ",attrs:{"xs12":"","md10":"","offset-md1":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.onCreateCollection($event)}}},[_c('v-layout',{staticClass:"white",staticStyle:{"box-shadow":"0 1px 5px rgba(0,0,0,0.2), 0 2px 2px rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12)","min-height":"40vh"},attrs:{"elevation-1":"","wrap":""}},[_c('v-flex',{staticStyle:{"border-right":"1px solid #eeeeee"},attrs:{"xs12":"","md4":""}},[_c('h3',{staticClass:"hidden-sm-and-down pl-2 mb-0 pt-1 text-xs-center",staticStyle:{"color":"grey","height":"67px","font-size":"2.3em"}},[_vm._v("MANAGE GROUPS")]),_vm._v(" "),_c('div',[_c('v-divider'),_vm._v(" "),(_vm.showOnSmallScreen())?_c('v-layout',{staticClass:"mt-2  pl-2 pr-2 pt-2 pb-2 ",attrs:{"row":""}},[(_vm.preview == 0)?_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('v-text-field',{staticClass:"searchBar ",attrs:{"append-icon":"search","label":"Find a group","hide-details":""},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}}),_vm._v(" "),(_vm.isNew(_vm.term.toUpperCase()))?_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{on:{"click":function($event){_vm.addNew(); _vm.isReallyOld = '3'; _vm.edit = false}}},[_vm._v("Add New Group")])],1):_vm._e(),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.methodResults),function(collection){return _c('div',{key:collection._id},[_c('v-divider'),_vm._v(" "),_c('v-list-tile',{staticClass:"pt-2 pb-0",attrs:{"avatar":""},on:{"click":function($event){_vm.preview = 1; _vm.isReallyOld='1' ; _vm.previewCollection=collection}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":collection.imgUrl[0].url + '_profile'}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie pt-1"},[_c('v-list-tile-title',{staticClass:"artTitle",domProps:{"innerHTML":_vm._s(collection.title[_vm.lang])}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s( collection.description[_vm.lang] )}})],1)],1),_vm._v(" "),_c('v-divider')],1)})],2)],1):_vm._e(),_vm._v(" "),(_vm.preview == 1)?_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('v-btn',{attrs:{"block":""},on:{"click":function($event){_vm.preview = 0; _vm.isReallyOld='1'}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v(" GO BACK\n                    ")],1),_vm._v(" "),_c('div',{staticClass:"pt-4 mt-4  pl-2 pr-2",staticStyle:{"width":"100%"}},[_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-layout',{staticClass:"pt-3",attrs:{"justify-center":""}},[_c('v-btn',{staticClass:"grey lighten-2 ma-3",attrs:{"block":""},on:{"click":function($event){_vm.editCollection(_vm.previewCollection._id); _vm.isReallyOld= '2';}}},[_c('b',[_vm._v("Edit Group")])]),_vm._v(" "),_c('v-btn',{staticClass:"grey lighten-2 ma-3",attrs:{"block":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('b',[_vm._v("Delete Group")])]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v("Are you sure you want to delete this collection?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":function($event){_vm.deleteGroup(_vm.selectedId)}}},[_vm._v("Yes")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:" pl-4",staticStyle:{"position":"relative"},attrs:{"md12":""}},[_c('p',{staticStyle:{"color":"grey","position":"relative","top":"20%","margin":"0px","white-space":"nowrap","text-indent":"20"}},[_c('v-icon',[_vm._v("view_day")]),_vm._v(" More in this Group")],1)]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-container',{staticClass:"artefact-list pl-0 pr-0"},[_c('v-list',{attrs:{"three-line":""}},[_vm._l((_vm.collections),function(collection){return ((collection.groups.indexOf(_vm.previewCollection.title.en) > -1))?_c('div',{key:collection._id},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.preview = 1; _vm.isReallyOld='1'}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":collection.imgUrl[0].url + '_profile'}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(collection.title[_vm.lang])}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s( collection.description[_vm.lang] )}})],1)],1),_vm._v(" "),_c('v-divider')],1):_vm._e()})],2)],1)],1)],1):_vm._e()],1):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{staticStyle:{"position":"relative"},attrs:{"xs12":"","md8":""}},[_c('div',{staticClass:" ",staticStyle:{"height":"100%","position":"relative"}},[_c('v-layout',{staticClass:"hidden-sm-and-down pl-3 pt-3",staticStyle:{"height":"67px"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticStyle:{"color":"grey","font-size":"1.1em"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("info ")]),_vm._v(" "),_c('i',[_vm._v("Complete these fields to add/change the group: "),(_vm.term && !_vm.preview)?_c('span',[_vm._v(_vm._s(_vm.term))]):(_vm.previewCollection.title[_vm.lang] && _vm.preview)?_c('span',[_vm._v(_vm._s(_vm.previewCollection.title[_vm.lang]))]):_vm._e()])],1)])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),((_vm.isReallyOld=='2' && _vm.edit == true))?_c('div',{staticStyle:{"width":"100%"}},[_c('v-form',{ref:"form2",on:{"submit":function($event){$event.preventDefault();_vm.onUpdateCollection(_vm.selectedId)}}},[_c('v-flex',{staticClass:"hidden-md-and-up",attrs:{"xs12":"","sm12":"","offset-sm2":""}},[_c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative","background-color":"white"},attrs:{"elevation-3":""}},[_c('v-flex',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative"},attrs:{"sm12":"","xs12":"","offset-sm2":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":"dark"}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(this.term))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-container',{staticClass:"pa-13 "},[_c('v-stepper',{attrs:{"non-linear":""}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"En","editable":""}},[_vm._v("English")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Ro","editable":""}},[_vm._v("Romana")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Sr","editable":""}},[_vm._v("Српски")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"En"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titleen","label":"Title","id":"titleen","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.en),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "en", $$v)},expression:"uploadEdit.title.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.en),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "en", $$v)},expression:"uploadEdit.description.en"}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Ro"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titlero","label":"Title","id":"titlero","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.ro),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "ro", $$v)},expression:"uploadEdit.title.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.ro),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "ro", $$v)},expression:"uploadEdit.description.ro"}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Sr"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titlesr","label":"Title","id":"titlesr","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.sr),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "sr", $$v)},expression:"uploadEdit.title.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.sr),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "sr", $$v)},expression:"uploadEdit.description.sr"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm12":"","offset-sm1":""}})],1),_vm._v(" "),(_vm.uploadEdit.title.en.length > 0 && _vm.uploadEdit.title.ro.length > 0 && _vm.uploadEdit.title.sr.length > 0 && _vm.uploadEdit.description.en.length > 0 &&_vm.uploadEdit.description.ro.length > 0 &&_vm.uploadEdit.description.sr.length > 0 && _vm.uploadEdit.imgUrl[0]!= null)?_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-btn',{attrs:{"type":"submit","color":"primary"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}}},[_vm._v("Update Group\n                          ")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.preview = 0; _vm.isReallyOld='1'}}},[_vm._v("\n                      Cancel\n                    ")])],1):_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-btn',{attrs:{"disabled":""}},[_vm._v("Update Group\n                          ")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.preview = 0; _vm.isReallyOld='1'}}},[_vm._v("\n                      Cancel\n                    ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"xs12":"","sm12":"","pb-4":""}},[_c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative","background-color":"white"}},[_c('v-flex',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative"},attrs:{"sm12":"","xs12":"","offset-sm2":""}},[_c('v-container',{staticClass:" "},[_c('v-stepper',{attrs:{"non-linear":""}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"En","editable":""}},[_vm._v("English")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Ro","editable":""}},[_vm._v("Romana")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Sr","editable":""}},[_vm._v("Српски")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"En"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titleen","label":"Title","id":"titleen","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.en),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "en", $$v)},expression:"uploadEdit.title.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.en),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "en", $$v)},expression:"uploadEdit.description.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Ro"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titlero","label":"Title","id":"titlero","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.ro),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "ro", $$v)},expression:"uploadEdit.title.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.ro),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "ro", $$v)},expression:"uploadEdit.description.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Sr"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titlesr","label":"Title","id":"titlesr","rules":_vm.titleRules},model:{value:(_vm.uploadEdit.title.sr),callback:function ($$v) {_vm.$set(_vm.uploadEdit.title, "sr", $$v)},expression:"uploadEdit.title.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadEdit.description.sr),callback:function ($$v) {_vm.$set(_vm.uploadEdit.description, "sr", $$v)},expression:"uploadEdit.description.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadEdit.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadEdit.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeEdit($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadEdit.imgUrl[0].url}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.uploadEdit.title.en.length > 0 && _vm.uploadEdit.title.ro.length > 0 && _vm.uploadEdit.title.sr.length > 0 && _vm.uploadEdit.description.en.length > 0 &&_vm.uploadEdit.description.ro.length > 0 &&_vm.uploadEdit.description.sr.length > 0 && _vm.uploadEdit.imgUrl[0]!= null)?_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"color":"red darken-1","dark":"","medium":"","fixed":"","bottom":"","right":"","fab":"","type":"submit"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("save")])],1):_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"color":"grey","dark":"","medium":"","fixed":"","bottom":"","right":"","fab":""},nativeOn:{"click":function($event){_vm.snackbar = true}}},[_c('v-icon',[_vm._v("save")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":"red","multi-line":_vm.mode === 'multi-line',"vertical":_vm.mode === 'vertical'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      All fields must be completed\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1)],1):_vm._e(),_vm._v(" "),((_vm.isReallyOld=='3') && this.edit==false)?_c('div',{staticClass:" ",staticStyle:{"width":"100%"}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.onCreateCollection($event)}}},[_c('v-flex',{staticClass:"hidden-md-and-up",attrs:{"xs12":"","sm12":"","offset-sm2":"","md10":"","offset-md1":"","pb-4":""}},[_c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative","background-color":"white"},attrs:{"elevation-3":""}},[_c('v-flex',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative"},attrs:{"sm12":"","xs12":"","offset-sm2":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":"dark"}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v("add_circle")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(this.term))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-container',{staticClass:" "},[_c('v-stepper',{attrs:{"non-linear":""}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"En","editable":""}},[_vm._v("English")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Ro","editable":""}},[_vm._v("Romana")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Sr","editable":""}},[_vm._v("Српски")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"En"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titleen","label":"Title","id":"titleen","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.en),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "en", $$v)},expression:"uploadAdd.title.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.en),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "en", $$v)},expression:"uploadAdd.description.en"}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Ro"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titlero","label":"Title","id":"titlero","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.ro),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "ro", $$v)},expression:"uploadAdd.title.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.ro),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "ro", $$v)},expression:"uploadAdd.description.ro"}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Sr"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2  p pt-2 pb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3"},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"titlero","label":"Title","id":"titlero","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.sr),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "sr", $$v)},expression:"uploadAdd.title.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.sr),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "sr", $$v)},expression:"uploadAdd.description.sr"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.uploadAdd.title.en.length > 0 && _vm.uploadAdd.title.ro.length > 0 && _vm.uploadAdd.title.sr.length > 0 && _vm.uploadAdd.description.en.length > 0 &&_vm.uploadAdd.description.ro.length > 0 &&_vm.uploadAdd.description.sr.length > 0 && _vm.uploadAdd.imgUrl[0]!= null)?_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-btn',{attrs:{"type":"submit","color":"primary"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}}},[_vm._v("Add Group\n                          ")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.preview = 0; _vm.isReallyOld='1'}}},[_vm._v("\n                      Cancel\n                    ")])],1):_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('v-btn',{attrs:{"disabled":""}},[_vm._v("Add Group\n                          ")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.preview = 0; _vm.isReallyOld='1'}}},[_vm._v("\n                      Cancel\n                    ")])],1)],1)],1)],1)],1),_vm._v(" "),(_vm.term)?_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"xs12":"","sm12":"","pb-4":""}},[_c('v-container',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative","background-color":"white"}},[_c('v-flex',{staticClass:"pa-0 ma-0",staticStyle:{"position":"relative"},attrs:{"sm12":"","xs12":"","offset-sm2":""}},[_c('v-container',{staticClass:" "},[_c('v-stepper',{attrs:{"non-linear":""}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"En","editable":""}},[_vm._v("English")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Ro","editable":""}},[_vm._v("Romana")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"Sr","editable":""}},[_vm._v("Српски")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"En"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titleen","label":"Title","id":"titleen","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.en),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "en", $$v)},expression:"uploadAdd.title.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.en),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "en", $$v)},expression:"uploadAdd.description.en"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Ro"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titlero","label":"Title","id":"titlero","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.ro),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "ro", $$v)},expression:"uploadAdd.title.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.ro),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "ro", $$v)},expression:"uploadAdd.description.ro"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"Sr"}},[_c('keep-alive',[_c('v-layout',{staticClass:"mt-2 mb-2  white",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm10":"","offset-sm1":"","md12":"","offset-md0":""}},[_c('v-text-field',{attrs:{"name":"titlesr","label":"Title","id":"titlesr","rules":_vm.titleRules},model:{value:(_vm.uploadAdd.title.sr),callback:function ($$v) {_vm.$set(_vm.uploadAdd.title, "sr", $$v)},expression:"uploadAdd.title.sr"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","rules":_vm.descriptionRules},model:{value:(_vm.uploadAdd.description.sr),callback:function ($$v) {_vm.$set(_vm.uploadAdd.description, "sr", $$v)},expression:"uploadAdd.description.sr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":"","offset-md0":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.uploadAdd.status },staticStyle:{"width":"100%","height":"45px"},attrs:{"color":"primary","loading":_vm.uploadAdd.loading},on:{"click":_vm.clickInput2}},[_vm._v("Update Primary Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput2",staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChangeAdd($event.target.name, $event.target.files); _vm.fileCount = $event.target.files.length}}})]):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.uploadAdd.imgUrl[0].url}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.uploadAdd.title.en.length > 0 && _vm.uploadAdd.title.ro.length > 0 && _vm.uploadAdd.title.sr.length > 0 && _vm.uploadAdd.description.en.length > 0 &&_vm.uploadAdd.description.ro.length > 0 &&_vm.uploadAdd.description.sr.length > 0 && _vm.uploadAdd.imgUrl[0]!= null)?_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"color":"red darken-1","dark":"","medium":"","fixed":"","bottom":"","right":"","fab":"","type":"submit"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("save")])],1):_c('v-btn',{staticClass:"hidden-sm-and-down",attrs:{"color":"grey","dark":"","medium":"","fixed":"","bottom":"","right":"","fab":""},nativeOn:{"click":function($event){_vm.snackbar = true}}},[_c('v-icon',[_vm._v("save")])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":"red","multi-line":_vm.mode === 'multi-line',"vertical":_vm.mode === 'vertical'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      All fields must be completed\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1)],1):_vm._e()],1)])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"container"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iwI9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  data: function data() {
    return {
      requests: "",
      preview: ""
    };
  },

  computed: {
    token: function token() {
      return this.$store.getters.getToken;
    },
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    gLang: function gLang() {
      return this.$store.getters.loadGlobLang;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    // artefacts() {
    //   return this.$store.getters.loadUnreviewdArtefacts;
    // },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    collectionName: function collectionName() {
      return this.$store.getters.getCollectionName(this.id);
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    users: function users() {
      return this.$store.getters.loadUsers;
    },
    unreviewedArtefacts: function unreviewedArtefacts() {
      return this.$store.getters.loadUnreviewedArtefacts;
    },
    toBeDeleted: function toBeDeleted() {
      return this.$store.getters.loadToBeDeletedArtefacts;
    },
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    isContrib: function isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch("loadArtefacts");
  },
  methods: {
    denyUser: function denyUser(requestId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/api/requests/' + requestId).then(function (res) {
        _this.loadRequests();
      });
    },
    acceptUser: function acceptUser(user, role, requestId) {
      var _this2 = this;

      this.$store.dispatch("changeUserStatus", {
        id: user._id,
        token: this.token,
        role: role
      }).then(function (response) {
        if (response.success) {
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/api/requests/' + requestId).then(function (res) {
            _this2.loadRequests();
          });
        }
      });
    },
    getRightPicture: function getRightPicture(user) {
      try {
        var right_user = void 0;
        if (user.email && this.$store.getters.getUserByEmail(user.email)) {
          right_user = this.$store.getters.getUserByEmail(user.email);
        }

        if (user.live != undefined) return false;else if (!user.email) return user.picture;else if (user.email != "" && right_user.picture != undefined && right_user.picture != "") return right_user.picture.url + '_profile';else return false;
      } catch (e) {
        return false;
      }
    },
    loadRequests: function loadRequests() {
      var _this3 = this;

      if (this.isAdmin) __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/requests').then(function (response) {
        _this3.requests = response.data;
      });
    },
    acceptArtefact: function acceptArtefact(id) {
      this.unreviewedArtefacts.filter(function (artefact) {
        artefact._id != id;
      });
      this.preview = false;
    },
    deletedArtefact: function deletedArtefact() {
      this.$store.dispatch("loadArtefacts");
      this.preview = false;
    },
    previewOrRedirect: function previewOrRedirect(id) {
      if (screen.width > 960) {
        this.preview = id;
      } else {
        this.$router.push("/artefacts/" + id);
      }
    }
  },
  created: function created() {

    if (!this.isAdmin && !this.isLoggedIn && !this.isMod) this.$router.push("/signin");else if (!this.isAdmin && this.isLoggedIn && !this.isMod) this.$router.push("/");
  }
}, "mounted", function mounted() {
  this.loadRequests();
  document.title = "Tasks";
}));

/***/ }),

/***/ "jBrz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtefactSingleTab_vue__ = __webpack_require__("Xsx5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f16f944e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtefactSingleTab_vue__ = __webpack_require__("1m/W");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtefactSingleTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f16f944e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtefactSingleTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jFHo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageTemplate_vue__ = __webpack_require__("l5uJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a07bfb40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageTemplate_vue__ = __webpack_require__("zjz3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a07bfb40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jHsC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jP3M":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5-min[cropped].dce8f31.jpg";

/***/ }),

/***/ "jX/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("c6sU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db4a97f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("swbM");
function injectStyle (ssrContext) {
  __webpack_require__("af0o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db4a97f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jY1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading == true)?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"white-widget grey-bg author-area"},[_c('div',{staticClass:"auth-info row"},[_c('div',{staticClass:"timeline-wrapper"},[_c('div',{staticClass:"timeline-item"},[_c('div',{staticClass:"animated-background"},[_c('div',{staticClass:"background-masker header-top"}),_vm._v(" "),_c('div',{staticClass:"background-masker header-left"}),_vm._v(" "),_c('div',{staticClass:"background-masker header-right"}),_vm._v(" "),_c('div',{staticClass:"background-masker header-bottom"})])])])])])])],1):_c('div',[_c('v-container',{staticClass:"ma-0 pa-0  hidden-md-and-up",attrs:{"fluid":""}},[_c('v-card',{staticStyle:{"background-color":"#232426"},attrs:{"dark":"","height":"92vh","id":"cardstart"}},[_c('v-card-media',{attrs:{"height":"52vh","src":_vm.group.imgUrl[0].url+'_single'}},[_c('div',{staticClass:"mainImg-overlay"}),_vm._v(" "),_c('v-container',{staticClass:"pr-1 pl-1",attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{staticClass:"media",attrs:{"fill-height":"","column":""}},[_c('v-card-actions',[_c('v-layout',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("view_column")])],1),_vm._v(" "),(_vm.isAdmin)?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{staticClass:"headerButtons",attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":"","to":"/groups/new/"}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v(_vm._s(_vm.gLang[_vm.lang].groupSingle.delete))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnno))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnyes))])],1)],1)],1)],1):(!_vm.isAdmin && _vm.isLoggedIn)?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"pr-0 pl-0 mt-0"},[_c('v-layout',{staticClass:"text-xs-center d-block"},[_c('h3',{staticClass:"headline mb-0 pb-2"},[_vm._v(" "+_vm._s(_vm.group.title[_vm.lang])+" ")]),_vm._v(" "),_c('hr',{staticStyle:{"margin-left":"20%","margin-right":"20%","color":"#efefef","border-style":"solid"}}),_vm._v(" "),_c('div',{staticClass:"pt-3 pb-0"})])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-card-actions',[_c('v-btn',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll",value:({ duration: 1000, offset: -50 }),expression:"{ duration: 1000, offset: -50 }"}],attrs:{"fab":"","href":"#description"}},[_c('v-icon',{attrs:{"light":""}},[_vm._v("keyboard_arrow_down")])],1)],1)],1)],1),_vm._v(" "),_c('web-location-tab',{attrs:{"artefact":_vm.group,"isCollection":false,"isGroup":true,"light":false}},[_c('v-card',{attrs:{"color":" mt-5 mb-3","flat":"","id":"description"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-card',{staticClass:"card--flex-toolbar"},[_c('v-toolbar',{attrs:{"card":"","color":"white","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("info_outline\n")]),_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].groupSingle.about))],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.group.description[_vm.lang].length > 150)?_c('v-card-text',[(_vm.isMinimized)?_c('div',[_c('p',{staticClass:"caption"},[_vm._v(_vm._s(_vm.group.description[_vm.lang].slice(0,150))+"...}}")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.isMinimized = !_vm.isMinimized}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.readMore))])],1)],1):_vm._e(),_vm._v(" "),(!_vm.isMinimized)?_c('div',[_c('p',{staticClass:"caption"},[_vm._v(_vm._s(_vm.group.description[_vm.lang]))]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.isMinimized = !_vm.isMinimized}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.readLess))])],1)],1):_vm._e()]):_c('v-card-text',[_c('p',{staticClass:"caption1"},[_c('i',[_vm._v(_vm._s(_vm.group.description[_vm.lang]))])])])],1)],1)],1)],1),_vm._v(" "),(_vm.collectionsInGroup())?_c('v-card',{attrs:{"color":" mt-4 pb-4","flat":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text mt-4 ml-4 mb-2"},[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].groupSingle.collections))]),_vm._v(" "),_c('web-slider3',{attrs:{"artefacts":_vm.artefacts}},_vm._l((_vm.collections),function(collection){return ((collection.groups.indexOf(_vm.group.title.en) > -1))?_c('v-flex',{key:collection._id,attrs:{"xs12":"","md4":""}},[_c('web-collection-card',{attrs:{"collection":collection,"artefacts":_vm.artefacts}})],1):_vm._e()}),1),_vm._v(" "),_c('v-card-actions',{staticClass:"pt-1 mt-0"},[_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.showAll}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].groupSingle.show))])],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal pt-5 ",staticStyle:{"margin-top":"56px"},attrs:{"id":"myModal"}},[_c('v-btn',{staticClass:"close",attrs:{"dark":"","medium":"","transparent":"","fab":"","color":"black"},on:{"click":_vm.spanClick}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_vm._l((_vm.collections),function(collection){return ((collection.groups.indexOf(_vm.group.title.en) > -1))?_c('v-flex',{key:collection._id,attrs:{"xs12":"","md4":""}},[_c('web-collection-card',{attrs:{"collection":collection,"artefacts":_vm.artefacts}})],1):_vm._e()})],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),(!_vm.isAdmin && _vm.isLoggedIn)?_c('v-speed-dial',{staticClass:"app-vue-speeddial",attrs:{"id":"bottom_button","top":_vm.top,"bottom":_vm.bottom,"right":_vm.right,"left":_vm.left,"direction":_vm.direction,"hover":_vm.hover,"transition":_vm.transition,"fixed":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"primary","dark":"","fab":"","hover":"","to":"/artefacts/new"},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-container',{staticClass:"ma-0 pa-0 hidden-sm-and-down",attrs:{"fluid":""}},[_c('div',{staticClass:"hide-ie",staticStyle:{"position":"fixed","width":"100%","height":"74vh","overflow":"hidden"}},[_c('img',{staticStyle:{"width":"100%","bottom":"100px","position":"relative","height":"auto"},attrs:{"src":_vm.group.imgUrl[0].url+'_single'}})]),_vm._v(" "),_c('img',{staticClass:"show-ie",staticStyle:{"position":"fixed","width":"100%","height":"70vh"},attrs:{"src":_vm.group.imgUrl[0].url+'_single'}}),_vm._v(" "),_c('div',{staticClass:"mainImg-overlay1 hide-ie",staticStyle:{"position":"fixed"}}),_vm._v(" "),_c('v-card',{staticStyle:{"background-color":"transparent","box-shadow":"none","position":"relative"},attrs:{"light":"","id":"card-variable-height","height":"65vh"}},[_c('div',{staticClass:"floatingScrollButton",staticStyle:{"position":"absolute","width":"100%"}},[_c('v-layout',{staticStyle:{"height":"100%","position":"relative","width":"100%"},attrs:{"justify-center":""}},[_c('h3',{staticStyle:{"color":"white","height":"30px","position":"absolute","top":"35%","text-align":"center"}},[_vm._v(_vm._s(_vm.group.title[_vm.lang]))]),_vm._v(" "),_c('v-btn',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll",value:({ duration: 1000, offset: -50 }),expression:"{ duration: 1000, offset: -50 }"}],staticStyle:{"top":"52%","z-index":"999"},attrs:{"fab":"","href":"#toScrollDescription"}},[_c('v-icon',{attrs:{"light":""}},[_vm._v("keyboard_arrow_down")])],1)],1)],1),_vm._v(" "),_c('v-card-media',{staticClass:" ",attrs:{"height":"50vh"}},[_c('div',{staticClass:"wave-img1 hide-ie"}),_vm._v(" "),_c('v-container',{staticClass:"pr-1 pl-1",attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{staticClass:"media",attrs:{"fill-height":"","column":""}},[_c('v-flex',{attrs:{"md10":"","offset-md1":""}},[_c('v-card-actions',[_c('v-layout',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("view_column")])],1),_vm._v(" "),(_vm.isAdmin)?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":"","to":"/groups/new/"}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v(_vm._s(_vm.gLang[_vm.lang].groupSingle.delete))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnno))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":_vm.deleteArtefact}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].artefactSingle.btnyes))])],1)],1)],1)],1):(!_vm.isAdmin && _vm.isLoggedIn)?_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"headerButtons",attrs:{"flat":"","icon":""},on:{"click":_vm.addToFav}},[(!_vm.favorited)?_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite_border")]):_c('v-icon',{attrs:{"dark":""}},[_vm._v("favorite")])],1)],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"background-color":"#212121"},attrs:{"justify-center":""}},[_c('v-flex',{staticStyle:{"position":"relative"},attrs:{"md10":"","id":"toScrollDescription"}},[_c('v-card',{staticStyle:{"border-left":"1px solid #efefef","border-right":"1px solid #efefef"},attrs:{"color":" mt-3 ","flat":"","id":"description"}},[_c('v-layout',{staticClass:"pt-1 pb-1",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"card--flex-toolbar",staticStyle:{"box-shadow":"none","border-bottom":"1px solid #efefef"}},[_c('v-toolbar',{attrs:{"card":"","color":"white","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text toolbarTitle"},[_vm._v("  "+_vm._s(_vm.gLang[_vm.lang].groupSingle.about))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.group.description[_vm.lang].length > 250)?_c('v-card-text',[(_vm.isMinimized)?_c('div',[_c('p',{staticClass:"caption1"},[_c('i',[_vm._v(_vm._s(_vm.group.description[_vm.lang].slice(0,351))+"...")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":"","primary":""},on:{"click":function($event){_vm.isMinimized = !_vm.isMinimized}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].groupSingle.readMore))])],1)],1):_vm._e(),_vm._v(" "),(!_vm.isMinimized)?_c('div',[_c('p',{staticClass:"caption1"},[_c('i',[_vm._v(_vm._s(_vm.group.description[_vm.lang]))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"flat":"","primary":""},on:{"click":function($event){_vm.isMinimized = !_vm.isMinimized}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionSingle.readLess))])],1)],1):_vm._e()]):_c('v-card-text',[_c('p',{staticClass:"caption1"},[_c('i',[_vm._v(_vm._s(_vm.group.description[_vm.lang]))])])])],1)],1)],1)],1),_vm._v(" "),(_vm.collectionsInGroup())?_c('v-card',{staticStyle:{"background-color":"#FAFAFA"},attrs:{"color":"  mb-3","flat":"","id":"bottomSlider"}},[_c('v-toolbar',{attrs:{"card":"","color":"white","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text toolbarTitle"},[_vm._v("  "+_vm._s(_vm.gLang[_vm.lang].groupSingle.collections))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-4"}),_vm._v(" "),_c('web-slider3',{attrs:{"artefacts":_vm.artefacts}},_vm._l((_vm.relatedCollections),function(collection){return _c('div',{key:collection._id},[_c('web-collection-card',{attrs:{"collection":collection,"artefacts":_vm.artefacts,"clickImage":false}})],1)})),_vm._v(" "),_c('v-card-actions',{staticClass:"pt-1 mt-0"},[_c('v-flex',{staticClass:"text-xs-right"},[_c('v-dialog',{staticStyle:{"z-index":"99999"},attrs:{"full-width":"","max-width":"1300","transition":"dialog-bottom-transition","overlay":false},model:{value:(_vm.dialog2),callback:function ($$v) {_vm.dialog2=$$v},expression:"dialog2"}},[_c('v-btn',{attrs:{"slot":"activator","color":"black","dark":"","flat":""},slot:"activator"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].groupSingle.show))]),_vm._v(" "),_c('v-card',[_c('v-btn',{staticStyle:{"margin-top":"70px"},attrs:{"icon":"","light":""},nativeOn:{"click":function($event){_vm.dialog2 = false}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('div',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.relatedCollections),function(collection){return _c('v-flex',{key:collection._id,staticClass:"pa-1",attrs:{"xs12":"","md4":""}},[_c('web-collection-card',{attrs:{"collection":collection,"artefacts":_vm.artefacts}})],1)}),1)],1)],1)],1)],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"modal pt-5 ",staticStyle:{"margin-top":"56px"},attrs:{"id":"myModal"}},[_c('v-btn',{staticClass:"close",attrs:{"dark":"","medium":"","transparent":"","fab":"","color":"black"},on:{"click":_vm.spanClick}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_vm._l((_vm.relatedCollections),function(collection){return _c('v-flex',{key:collection._id,attrs:{"xs12":"","md4":""}},[_c('web-collection-card',{attrs:{"collection":collection,"artefacts":_vm.artefacts}})],1)})],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.isMod||_vm.isContrib)?_c('web-speed-dial-add'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jsS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"max-width":"2000px"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.groups),function(group){return _c('v-flex',{key:group._id,attrs:{"xs12":"","sm6":"","md4":""}},[_c('web-group-card',{attrs:{"group":group,"collections":_vm.collections}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kRSS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Messaging_vue__ = __webpack_require__("9Gk3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a79588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Messaging_vue__ = __webpack_require__("CFDl");
function injectStyle (ssrContext) {
  __webpack_require__("oYE6")
  __webpack_require__("UzJh")
  __webpack_require__("PnLz")
  __webpack_require__("/sqp")
  __webpack_require__("RZV9")
  __webpack_require__("LzSG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43a79588"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Messaging_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a79588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Messaging_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kVU0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "koON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hidden-sm-and-down primary",staticStyle:{"position":"fixed","height":"60px","width":"100vw"}}),_vm._v(" "),_c('v-layout',{staticStyle:{"position":"relative"},attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-layout',{staticStyle:{"background-color":"white"},attrs:{"elevation-3":""}},[_c('v-flex',{staticStyle:{"height":"100%"},attrs:{"xs12":"","md4":""}},[_c('div',{staticClass:"tasksHeader hidden-sm-and-down"},[_c('h5',{staticClass:" text-xs-center mb-2 mt-2 pa-1"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].tasks.tasks))])]),_vm._v(" "),_c('v-layout',{staticClass:" primary pl-2 pr-2 hidden-md-and-up ",attrs:{"row":""}},[_c('v-flex',{staticClass:" mr-3 ml-3 white hidden-md-and-up",attrs:{"xs12":"","sm12":"","offset-sm2":""}},[_c('h3',{staticClass:"mb-1 text-xs-center",staticStyle:{"color":"grey"}},[_vm._v("  "+_vm._s(_vm.gLang[_vm.lang].tasks.tasks))])])],1),_vm._v(" "),(_vm.unreviewedArtefacts.length > 0)?_c('div',{staticClass:"tasksHeader"},[_c('p',{staticClass:"  mb-2 mt-2 pa-2"},[_c('v-icon',{staticClass:"pr-2"},[_vm._v("view_carousel")]),_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].tasks.newArtefacts))],1)]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('v-list',{staticClass:"pt-0",attrs:{"three-line":""}},[_vm._l((_vm.unreviewedArtefacts),function(artefact,i){return _c('div',{key:i},[_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.previewOrRedirect(artefact._id)}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":artefact.mainImg[0].url+ '_profile'}})]),_vm._v(" "),_vm._l((_vm.users),function(user,i){return ((user._id.indexOf(artefact.userId) > -1))?_c('v-list-tile-content',{key:i,staticClass:"collection-list-ie  pt-3"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(artefact.title[_vm.lang])}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s( user.displayName + ' - ' +artefact.description[_vm.lang])}})],1):_vm._e()})],2)],1)})],2)],1)],1)],1),_vm._v(" "),(_vm.toBeDeleted.length > 0)?_c('div',{staticClass:"tasksHeader"},[_c('p',{staticClass:"  mb-2 mt-2 pa-2"},[_c('v-icon',{staticClass:"pr-2"},[_vm._v("delete_forever")]),_vm._v("To be Deleted")],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('v-list',{staticClass:"pt-0",attrs:{"three-line":""}},[_vm._l((_vm.toBeDeleted),function(artefact,i){return _c('div',{key:i},[_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.previewOrRedirect(artefact._id)}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":artefact.mainImg[0].url+ '_profile'}})]),_vm._v(" "),_vm._l((_vm.users),function(user,i){return ((user._id.indexOf(artefact.userId) > -1))?_c('v-list-tile-content',{key:i,staticClass:"collection-list-ie  pt-3"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(artefact.title[_vm.lang])}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s( user.displayName + ' - ' +artefact.description[_vm.lang])}})],1):_vm._e()})],2)],1)})],2)],1)],1),_vm._v(" "),(_vm.requests.length > 0)?_c('div',{staticClass:"tasksHeader"},[_c('p',{staticClass:"  mb-2 mt-2 pa-2"},[_c('v-icon',{staticClass:"pr-2"},[_vm._v("face")]),_vm._v("User Change Role Requests")],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticStyle:{"box-shadow":"none"}},[_c('v-list',{staticClass:"pt-0",attrs:{"three-line":""}},[_vm._l((_vm.requests),function(request,i){return _c('div',{key:i},[_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[(_vm.getRightPicture(request.user)!=false)?_c('img',{attrs:{"src":_vm.getRightPicture(request.user)}}):_c('v-icon',{attrs:{"large":""}},[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs8":""}},[_c('v-list-tile-content',{staticClass:"collection-list-ie pt-2"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(request.user.displayName)}}),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Current: "+_vm._s(request.user.role))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Desired: "+_vm._s(request.role))])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.acceptUser(request.user,request.role,request._id)}}},[_c('v-icon',[_vm._v("check_circle")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.denyUser(request._id)}}},[_c('v-icon',[_vm._v("clear")])],1)],1)],1)],1)],1)})],2)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"hidden-xs-only":"","md8":""}},[(_vm.preview)?_c('web-artefact-preview',{attrs:{"id":_vm.preview},on:{"artefactAccepted":function($event){_vm.acceptArtefact($event)},"deletedArtefact":function($event){_vm.deletedArtefact()}}}):_vm._e(),_vm._v(" "),(!_vm.preview)?_c('v-container',{staticClass:"beginningContainer pa-5",attrs:{"fluid":""}},[_c('h5',[_c('i',[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].tasks.previewText)+" ")])])]):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l5uJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    provider: function provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";else if (user.hasOwnProperty("google")) return "Google";else if (user.hasOwnProperty("live")) return "Microsoft Live";else return "Local Register";
    }
  },
  props: ['user', 'message', 'date']

});

/***/ }),

/***/ "l8ut":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lBr9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"mt-0",attrs:{"id":"inspire"}},[_c('v-navigation-drawer',{style:(_vm.$vuetify.breakpoint.mdAndUp ? 'padding-top:96px' : 'padding-top:128px'),attrs:{"fixed":"","clipped":"","temporary":"","enable-resize-watcher":"","disable-route-watcher":false},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{staticClass:"pt-0"},[[_c('v-divider'),_vm._v(" "),_vm._l((_vm.main),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.link}},[_c('v-list-tile-action',{class:_vm.isRightPath(item) ? '' : 'list-tile-action'},[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',{class:_vm.isRightPath(item) ? '' : 'list-tile-content'},[_vm._v(_vm._s(item.title))])],1)}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.content),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.link}},[_c('v-list-tile-action',{class:_vm.isRightPath(item) ? '' : 'list-tile-action'},[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',{class:_vm.isRightPath(item) ? '' : 'list-tile-content'},[_vm._v(_vm._s(item.title))])],1)}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.info),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.link}},[_c('v-list-tile-action',{class:_vm.isRightPath(item) ? '' : 'list-tile-action'},[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',{class:_vm.isRightPath(item) ? '' : 'list-tile-content'},[_vm._v(_vm._s(item.title))])],1)})]],2),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-toolbar',{staticClass:"menuToolbar",staticStyle:{"z-index":"9999"},attrs:{"color":"#F7F5E8","light":"","app":"","extended":!_vm.$vuetify.breakpoint.smAndUp,"flat":"","clipped-left":"","height":_vm.$vuetify.breakpoint.smAndUp ? '76px':'64px',"fixed":""}},[(_vm.drawer)?_c('v-toolbar-side-icon',{staticClass:"ml-4",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}},[_c('v-icon',[_vm._v("close")])],1):_c('v-toolbar-side-icon',{staticClass:"ml-4",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[(_vm.searchMobile)?_c('div',{staticClass:"hidden-sm-and-up",staticStyle:{"width":"90vw","margin-left":"5vw","position":"absolute","z-index":"999999"}},[_c('v-text-field',{attrs:{"light":"","solo":"","prepend-icon":"search","placeholder":_vm.gLang[_vm.lang].layout.search,"append-icon":"keyboard_arrow_up","append-icon-cb":_vm.searchChange},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}})],1):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',{staticClass:"ml-0 pl-3 hidden-xs-only",style:(_vm.$vuetify.breakpoint.smAndUp ? 'width: 300px; min-width: 250px' : 'min-width: 72px')},[_c('router-link',{staticClass:"hidden-xs-only",staticStyle:{"cursor":"pointer"},attrs:{"to":"/","tag":"span"}},[_vm._v("HERA")])],1),_vm._v(" "),(_vm.$vuetify.breakpoint.mdAndUp )?_c('img',{staticClass:"miniLogo2",style:(_vm.$vuetify.breakpoint.smAndUp ? 'height:86px':'74px'),attrs:{"src":__webpack_require__("xAza"),"alt":""}}):_vm._e(),_vm._v(" "),(!_vm.$vuetify.breakpoint.mdAndUp )?_c('v-layout',{staticClass:"white--text",staticStyle:{"margin-left":"0px","margin-right":"0px"},attrs:{"slot":"extension","justify-center":""},slot:"extension"},[_c('img',{staticClass:"miniLogo2",style:(_vm.$vuetify.breakpoint.smAndUp ? 'height:86px':'74px'),attrs:{"src":__webpack_require__("xAza"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('web-search-global',{staticClass:"hidden-xs-only pt-2 pl-0 pr-5",attrs:{"term":_vm.term},on:{"success":function($event){_vm.closeSearch()}}}),_vm._v(" "),_c('v-spacer',{staticClass:"hidden-xs-only"}),_vm._v(" "),_c('v-btn',{staticClass:"hidden-sm-and-up mt-3 mr-0",attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.searchMobile=true}}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-toolbar-items',{},[_c('v-layout',{staticClass:"hidden-md-and-up ml-3",staticStyle:{"width":"62px"}},[_c('v-select',{staticClass:"pt-0 mt-3",attrs:{"light":"","append-icon":"arrow_drop_down","items":_vm.items,"label":"Select","single-line":"","item-text":"maj","item-value":"abbr","return-object":""},on:{"change":function($event){_vm.changeLang($event)}},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})],1),_vm._v(" "),_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"width":"130px"}},[_c('v-select',{staticClass:"pt-0 mt-3 pr-3",attrs:{"light":"","append-icon":"arrow_drop_down","items":_vm.items,"label":"Select","single-line":"","item-text":"state","item-value":"abbr","return-object":""},on:{"change":function($event){_vm.changeLang($event)}},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})],1),_vm._v(" "),(_vm.isAdmin || _vm.isMod || _vm.isLoggedIn)?_c('div',{class:{'hidden-sm-and-down':_vm.isAdmin}},[_c('v-menu',{attrs:{"fixed":""}},[_c('v-btn',{staticClass:"mt-3",attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("apps")])],1),_vm._v(" "),_c('v-list',[_c('v-spacer'),_vm._v(" "),(_vm.isAdmin)?_c('span',[_c('v-subheader',[_vm._v("Add")]),_vm._v(" "),_c('v-list-tile',{staticClass:"profilePopUpTiles",on:{"click":function($event){_vm.toAddArtefact()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("view_carousel")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"profilePopUp"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.addartefact))])],1),_vm._v(" "),_c('v-list-tile',{staticClass:"profilePopUpTiles",on:{"click":function($event){_vm.toManageTags()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("view_day")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"profilePopUp"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.managetags))])],1),_vm._v(" "),_c('v-list-tile',{staticClass:"profilePopUpTiles",on:{"click":function($event){_vm.toManageGroups()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("view_column")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"profilePopUp"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.managegroups))])],1),_vm._v(" "),_c('v-divider')],1):_vm._e(),_vm._v(" "),(_vm.isMod || _vm.isAdmin)?_c('span',[_c('v-subheader',[_vm._v("Tasks")]),_vm._v(" "),_c('v-list-tile',{staticClass:"profilePopUpTiles",on:{"click":function($event){_vm.toTasks()}}},[_c('v-list-tile-action',[_c('v-badge',{staticClass:"badge",attrs:{"flat":"","color":"indigo"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.unreviewedArtefacts.length > 0 || _vm.toBeDeleted.length > 0 || _vm.requests > 0)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.getTaskNumber()))]):_vm._e(),_vm._v(" "),_c('v-icon',[_vm._v("view_list")])],1)],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"profilePopUp"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.tasks))])],1),_vm._v(" "),_c('v-divider')],1):_vm._e(),_vm._v(" "),_c('v-subheader',[_vm._v("More")]),_vm._v(" "),(_vm.isAdmin)?_c('span',[_c('v-list-tile',{staticClass:"profilePopUpTiles",on:{"click":function($event){_vm.toUsers()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("contacts")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"profilePopUp"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.users))])],1),_vm._v(" "),_c('v-list-tile',{staticClass:"profilePopUpTiles",on:{"click":function($event){_vm.toSettings()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("settings")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"profilePopUp"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.settings))])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{staticClass:"profilePopUpTiles",on:{"click":function($event){_vm.toMessaging()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"profilePopUp"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.messaging))])],1),_vm._v(" "),_c('v-list-tile',{staticClass:"profilePopUpTiles",on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('span',{staticStyle:{"padding-left":"7px","font-weight":"bolder","font-size":"24px","color":"rgba(0,0,0,0.54)"}},[_vm._v("?")])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"profilePopUp"},[_vm._v("Download Manual")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isLoggedIn)?_c('div',[_c('v-menu',{attrs:{"fixed":""}},[_c('v-btn',{staticClass:"mt-3",attrs:{"slot":"activator","icon":""},slot:"activator"},[(_vm.user != null && _vm.user.picture)?_c('v-avatar',{attrs:{"size":"35px"}},[(_vm.user.picture.url)?_c('img',{attrs:{"src":_vm.user.picture.url+'_profile',"alt":"avatar"}}):_c('img',{attrs:{"src":_vm.user.picture,"alt":"avatar"}})]):_c('v-icon',[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"avatar":""}},[(_vm.user.picture)?_c('v-list-tile-avatar',[(_vm.user.picture.url)?_c('img',{attrs:{"src":_vm.user.picture.url,"alt":"avatar"}}):_c('img',{attrs:{"src":_vm.user.picture,"alt":"avatar"}})]):_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.displayName))]),_vm._v(" "),(_vm.user.email)?_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.user.email))]):_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s( '  <span class=\'grey--text text--lighten-1\'> Connected with: ' + _vm.provider(_vm.user) + '</span>' )}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","to":"/account/"}},[_c('v-icon',[_vm._v("edit")])],1)],1)],1)],1),_vm._v(" "),_c('v-list',[_c('v-divider'),_vm._v(" "),_c('v-list-tile',{staticClass:"profilePopUpTiles"},[_c('v-list-tile-content',{staticClass:"profilePopUp",on:{"click":function($event){_vm.toAccount()}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.myaccount))])],1),_vm._v(" "),_c('v-list-tile',{staticClass:"profilePopUpTiles"},[_c('v-list-tile-content',{staticClass:"profilePopUp",on:{"click":function($event){_vm.upgradeDialog = true}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.iWantToContribute))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{staticClass:"profilePopUpTiles"},[_c('v-list-tile-content',{staticClass:"profilePopUp",on:{"click":_vm.logOut}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.logout))])],1)],1)],1)],1):_c('div',[_c('v-btn',{staticClass:"mt-3",attrs:{"flat":"","to":"/signin"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].signIn.signIn))])],1)],1)],1),_vm._v(" "),(_vm.term)?_c('web-search-global',{staticClass:"hidden-sm-and-up mt-5",staticStyle:{"position":"absolute","z-index":"999"},attrs:{"term":_vm.term},on:{"success":function($event){_vm.closeSearch()}}}):_vm._e(),_vm._v(" "),_c('v-content',{staticClass:"pt-0 mt-0"},[_c('main',{staticClass:"mb-5",style:(_vm.$vuetify.breakpoint.sm ? 'margin-top:196px; min-height:90vh; margin-bottom:192px;'  : _vm.$vuetify.breakpoint.xs ?'margin-top:128px; min-height:90vh; margin-bottom:192px;' : 'margin-top:76px; min-height:90vh'),attrs:{"app":"","light":""}},[_c('router-view')],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-3 mt-5 text-xs-center",staticStyle:{"border-top":"1px solid #efefef","background-color":"#FAFAFA","position":"relative","bottom":"0px","left":"0px","width":"100vw"}},[_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('img',{staticClass:"miniLogo1Footer",staticStyle:{"height":"85px"},attrs:{"src":__webpack_require__("TrFT")}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('div',[_c('p',[(_vm.lang == 'en')?_c('strong',[_vm._v("Cooperation beyond borders.")]):_vm._e(),_vm._v(" "),(_vm.lang == 'ro')?_c('strong',[_vm._v("Cooperare dincolo de frontiere.")]):_vm._e(),_vm._v(" "),(_vm.lang == 'sr')?_c('strong',[_vm._v("Saradnja preko granica!")]):_vm._e()]),_vm._v(" "),(_vm.lang == 'en')?_c('p',[_vm._v("Interreg-IPA Cross-border Cooperation Romania-Serbia Programme is financed by the European Union under the Instrument for Pre-accession Assistance (IPA II) and co-financed by the partner states in the Programme.")]):_vm._e(),_vm._v(" "),(_vm.lang == 'ro')?_c('p',[_vm._v("Programul INTERREG IPA de Cooperare Transfrontalieră Romania-Serbia este finanțat de Uniunea Europeană prin Instrumentul de Asistenţă pentru Preaderare (IPA II) şi cofinanţat de statele partenere în program.")]):_vm._e(),_vm._v(" "),(_vm.lang == 'sr')?_c('p',[_vm._v("INTEREG IPA Program prekogranične saradnje Rumunija – Srbija je finansiran od strane Evropske unije u okviru instrumenta za pretpristupnu pomoć (IPA II) i sufinansiran od strane država učesnica programa.")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"ma-0",staticStyle:{}},[_vm._v(_vm._s(new Date().getFullYear())+" © HERA")]),_vm._v(" "),_c('a',{attrs:{"href":"/api/download_apk"}},[_vm._v("Get Mobile Application")])]),_vm._v(" "),_c('v-flex',{style:(!_vm.$vuetify.breakpoint.mdAndUp? 'margin-top:25px':''),attrs:{"xs12":"","md3":""}},[_c('img',{staticClass:"miniLogo2Footer",staticStyle:{"height":"85px"},attrs:{"src":__webpack_require__("SQpl")}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.isAdmin)?_c('div',{staticClass:"hidden-md-and-up",staticStyle:{"height":"60px","width":"100%"},attrs:{"row":""}}):_vm._e()])],1)],1)],1),_vm._v(" "),(_vm.isAdmin)?_c('v-bottom-nav',{staticClass:"hidden-md-and-up",staticStyle:{"background":"white","margin-top":"60px"},attrs:{"white":"","value":true,"active":_vm.e1,"color":"white"},on:{"update:active":function($event){_vm.e1=$event}}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs4":""}},[_c('v-bottom-sheet',{attrs:{"temporary":""},model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","light":""},slot:"activator"},[_c('span',[_vm._v("More")]),_vm._v(" "),_c('v-icon',[_vm._v("swap_vertical_circle")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.more),function(tile){return _c('v-list-tile',{key:tile.title,attrs:{"to":tile.link},on:{"click":function($event){_vm.sheet = false}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-icon',[_vm._v(_vm._s(tile.icon))])],1)],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(tile.title))])],1)}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs4":""}},[_c('v-bottom-sheet',{attrs:{"temporary":""},model:{value:(_vm.sheet2),callback:function ($$v) {_vm.sheet2=$$v},expression:"sheet2"}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","light":""},slot:"activator"},[_c('span',[_vm._v("Add")]),_vm._v(" "),_c('v-icon',[_vm._v("add_circle")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.add),function(tile){return _c('v-list-tile',{key:tile.title,attrs:{"to":tile.link},on:{"click":function($event){_vm.sheet2 = false}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-icon',[_vm._v(_vm._s(tile.icon))])],1)],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(tile.title))])],1)}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs4":""}},[_c('v-btn',{attrs:{"flat":"","color":"black","value":"nearby","to":"/tasks"},nativeOn:{"click":function($event){_vm.show = false}}},[_c('div',{staticClass:"btn_tasks"},[_c('v-badge',{staticClass:"badge",attrs:{"flat":"","color":"indigo"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.unreviewedArtefacts.length > 0 || _vm.toBeDeleted.length > 0 || _vm.requests > 0)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.unreviewedArtefacts.length+_vm.toBeDeleted.length+_vm.requests))]):_vm._e(),_vm._v(" "),_c('v-icon',[_vm._v("view_list")])],1),_vm._v(" "),_c('span',{staticClass:"tasks"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.tasks))])],1)])],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.upgradeDialog),callback:function ($$v) {_vm.upgradeDialog=$$v},expression:"upgradeDialog"}},[_c('v-card',[_c('v-card-title',[_c('v-spacer')],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-3",attrs:{"row":""}},[_c('v-select',{staticClass:"input-group--focused",attrs:{"items":_vm.items1,"label":"Select","item-value":"text"},model:{value:(_vm.select1),callback:function ($$v) {_vm.select1=$$v},expression:"select1"}})],1),_vm._v(" "),_c('v-layout',{staticClass:"pa-3",attrs:{"row":""}},[(_vm.select1 == 'Contributor')?_c('p',[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.contributorRights))]):(_vm.select1 == 'Moderator')?_c('p',[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.moderatorRights))]):(_vm.select1 == 'Admin')?_c('p',[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.adminRights))]):_vm._e()]),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.sendMessage()}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.sendRequest))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.upgradeDialog=false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.close))])],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.colorS,"multi-line":_vm.mode,"vertical":!_vm.mode},model:{value:(_vm.showSucces),callback:function ($$v) {_vm.showSucces=$$v},expression:"showSucces"}},[_vm._v("\n      "+_vm._s(_vm.gLang[_vm.lang].myAccount.successMessage)+"\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.showSucces = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.close))])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.colorF,"multi-line":_vm.mode,"vertical":!_vm.mode},model:{value:(_vm.showFail),callback:function ($$v) {_vm.showFail=$$v},expression:"showFail"}},[_vm._v("\n      "+_vm._s(_vm.gLang[_vm.lang].myAccount.failMessage)+"\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.showFail = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.close))])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.colorF,"multi-line":_vm.mode,"vertical":!_vm.mode},model:{value:(_vm.showFailAlreadyRequested),callback:function ($$v) {_vm.showFailAlreadyRequested=$$v},expression:"showFailAlreadyRequested"}},[_vm._v("You already have a pending role change request, please wait for review or contact administration!\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.showFailAlreadyRequested = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.close))])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.colorF,"multi-line":_vm.mode,"vertical":!_vm.mode},model:{value:(_vm.showFailRoleAlready),callback:function ($$v) {_vm.showFailRoleAlready=$$v},expression:"showFailRoleAlready"}},[_vm._v("You already have the role you are trying to request!\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.showFailRoleAlready = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.close))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lJIZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lSHQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',[_c('v-flex',{attrs:{"xs8":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('web-artefact-card-mini',{attrs:{"artefact":_vm.artefact[0],"height":200}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('web-artefact-card-mini',{attrs:{"artefact":_vm.artefact[1],"height":200}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('web-artefact-card-mini',{attrs:{"artefact":_vm.artefact[2],"height":200}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('web-artefact-card-mini',{attrs:{"artefact":_vm.artefact[3],"height":408}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lk2w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lmfV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mJTV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mMQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchGlobal_vue__ = __webpack_require__("3IMY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282d18ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchGlobal_vue__ = __webpack_require__("quk8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchGlobal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282d18ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchGlobal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ma6R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aplayer"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "myLY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndConditions_vue__ = __webpack_require__("tljs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44606275_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditions_vue__ = __webpack_require__("OIKe");
function injectStyle (ssrContext) {
  __webpack_require__("Opxv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44606275"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndConditions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44606275_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nLlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    popularArtefacts: function popularArtefacts() {
      return this.$store.getters.loadPopularArtefacts;
    },
    collections: function collections() {
      return this.$store.getters.loadAllCollections;
    },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    groups: function groups() {
      return this.$store.getters.loadGroups;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    }
  },
  methods: {
    showContent: function showContent(collection) {

      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.artefacts.length; i++) {
        if (this.artefacts[i].collectionId.indexOf(collection.title) > -1) {
          return true;
        }
      }
      return false;
    },
    showContentGroup: function showContentGroup(group) {

      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.collections.length; i++) {
        if (this.collections[i].groups.indexOf(group.title) > -1) {
          return true;
        }
      }
      return false;
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    },

    // moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';

    //     }
    //     else 
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }
    //   },

    isLast: function isLast(idart, coltitle) {
      var j,
          k = [];

      for (j = 0; j < this.artefacts.length; j++) {
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1) k.push(this.artefacts[j]._id);
      }if (k[k.length - 1] == idart) return true;else return false;
    }
  },
  mounted: function mounted() {
    document.title = "Groups";
    window.scrollTo(0, 0);
  }
});

/***/ }),

/***/ "nXSR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConversationTemplate_vue__ = __webpack_require__("ukVF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1087110_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConversationTemplate_vue__ = __webpack_require__("PICD");
function injectStyle (ssrContext) {
  __webpack_require__("pKGH")
  __webpack_require__("2L6M")
  __webpack_require__("U4Vc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f1087110"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConversationTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1087110_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConversationTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nXyx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "naVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__("1zxx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e77f3010_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("N5L+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e77f3010_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nsnG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12-min[cropped].f571883.jpg";

/***/ }),

/***/ "o92R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-0 pa-0",staticStyle:{"width":"100%","background-color":"#FAFAFA"}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_vm._v("Are you sure you want to leave? you have unsaved changes !")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":function($event){_vm.goToNext=true;}}},[_vm._v("Yes")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:" primary pl-2 pr-2 ",attrs:{"row":""}},[_c('v-flex',{staticClass:" mr-3 ml-3 white hidden-md-and-up",attrs:{"xs12":"","sm12":"","offset-sm2":""}},[_c('h3',{staticClass:"mb-1 text-xs-center",staticStyle:{"color":"grey"}},[_vm._v("   Add Artefact")])])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',{staticClass:"mt-2 pt-2",staticStyle:{},attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"ma-1 ",attrs:{"xs12":"","md12":"","offset-md1":""}},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.onCreateArtefact($event)}}},[_c('v-layout',{staticClass:"white",staticStyle:{"box-shadow":"0 1px 5px rgba(0,0,0,0.2), 0 2px 2px rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12)"},attrs:{"elevation-1":"","wrap":""}},[_c('v-flex',{staticStyle:{"border-right":"1px solid #eeeeee"},attrs:{"xs12":"","md4":""}},[_c('h3',{staticClass:"hidden-sm-and-down pl-2 mb-0",staticStyle:{"color":"grey","height":"67px"}},[_vm._v("Add Artefact")]),_vm._v(" "),_c('div',[_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"mt-2  pl-2 pr-2 pt-2 pb-2 ",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-btn',{class:{ 'green darken-3' : _vm.formUpload.mainImg[0].status },staticStyle:{"width":"215px"},attrs:{"color":"primary","loading":_vm.formUpload.mainImg[0].loading},on:{"click":function($event){_vm.clickInputMain()}}},[_vm._v("Upload Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{ref:"fileInput1",staticClass:"input-file",staticStyle:{"display":"none"},attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, -1); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"  pl-2 pr-2 white  ",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{staticClass:" ",attrs:{"name":"title","label":"Title of Artefact","id":"title","rules":_vm.titleRules,"required":""},model:{value:(_vm.formUpload.title[_vm.lang]),callback:function ($$v) {_vm.$set(_vm.formUpload.title, _vm.lang, $$v)},expression:"formUpload.title[lang]"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"  pl-2 pr-2 white  ",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{staticClass:" ",attrs:{"name":"description","label":"Description of Artefact","id":"description","rules":_vm.descriptionRules,"required":"","multi-line":""},model:{value:(_vm.formUpload.description[_vm.lang]),callback:function ($$v) {_vm.$set(_vm.formUpload.description, _vm.lang, $$v)},expression:"formUpload.description[lang]"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"white",attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-checkbox',{staticClass:"ml-3 pt-3",attrs:{"label":"Historical Date"},model:{value:(_vm.formUpload.showDate),callback:function ($$v) {_vm.$set(_vm.formUpload, "showDate", $$v)},expression:"formUpload.showDate"}}),_vm._v(" "),(_vm.formUpload.showDate)?_c('v-date-picker',{staticStyle:{"width":"100%"},attrs:{"color":"green lighten-1","locale":_vm.lang,"header-color":"primary"},model:{value:(_vm.formUpload.date),callback:function ($$v) {_vm.$set(_vm.formUpload, "date", $$v)},expression:"formUpload.date"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"box-shadow":"none"},attrs:{"color":""}},[_c('v-card-text',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-layout',{staticClass:"pr-2 pl-2 pa-0 white ",attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center ",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"label":"Name of Tags","items":_vm.collections,"item-text":'title'+'['+_vm.lang+']',"item-value":"title.en","multiple":"","chips":"","required":"","persistent-hint":""},model:{value:(_vm.formUpload.collectionId),callback:function ($$v) {_vm.$set(_vm.formUpload, "collectionId", $$v)},expression:"formUpload.collectionId"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"pa-3 map noBoxShadow",attrs:{"height":"415px"}},[_c('web-location-picker',{attrs:{"marker":_vm.marker,"place":_vm.place,"center":_vm.center,"new":_vm.newLocation},on:{"newLocation":_vm.newLocationMethod,"newMarker":function($event){_vm.$emit('newMarker',$event)}}})],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"position":"relative"},attrs:{"xs12":"","md8":""}},[_c('div',{staticClass:" ",staticStyle:{"height":"100%","position":"relative"}},[_c('v-layout',{staticClass:"hidden-sm-and-down pl-3 pt-3",staticStyle:{"height":"67px"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticStyle:{"color":"grey","font-size":"1.2em"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("info ")]),_vm._v(" "),_c('i',[_vm._v(" To add more info, press "),_c('v-icon',[_vm._v("add_box ")]),_vm._v(", then press "),_c('v-icon',[_vm._v("save ")]),_vm._v(" to save the artefact! ")],1)],1)])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.formUpload.uploads),function(item,index){return _c('div',{key:index},[(item.type === 'text' )?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2 white",attrs:{"row":"","wrap":"","elevation-1":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('quill-editor',{ref:"myTextEditor",refInFor:true,staticClass:"editor-example bubble",attrs:{"options":_vm.editorOption},model:{value:(item.value[_vm.lang]),callback:function ($$v) {_vm.$set(item.value, _vm.lang, $$v)},expression:"item.value[lang]"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm10":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1):(item.type === 'video' )?_c('div',[_c('div',{staticClass:"hidden-sm-and-down"},[(item.data.length >0)?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3",attrs:{"elevation-1":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Change Video\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"video/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_vm._v("Delete\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('div',[_c('v-card-media',[_c('div',{},[_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.data[0].url + '.mp4',"type":"video/mp4"}}),_vm._v(" "),_c('source',{attrs:{"src":item.data[0].url + '.webm',"type":"video/webm"}}),_vm._v(" "),_c('source',{attrs:{"src":item.data[0].url + '.m4v',"type":"video/m4v"}}),_vm._v(" "),_c('source',{attrs:{"src":item.data[0].url + '.ogg',"type":"video/ogg"}}),_vm._v("\nYour browser does not support the video tag.\n")])])])],1)])],1)],1)],1)],1)],1):_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","elevation-1":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload a Video\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"video/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"hidden-md-and-up"},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","wrap":"","justify-center":"","elevation-1":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload a Video File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"application/pdf"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1)]):(item.type === 'audio' )?_c('div',[_c('div',{staticClass:"hidden-sm-and-down"},[(item.data.length >0)?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3",staticStyle:{"background-color":"#FAFAFA"},attrs:{"elevation-1":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2  hidden-sm-and-down",staticStyle:{"background-color":"#FAFAFA"},attrs:{"row":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Change Audio File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"id":'ref'+index,"accept":"audio/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_vm._v("Delete\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-layout',{staticClass:"pa-1",staticStyle:{"background-color":"#FAFAFA"},attrs:{"row":""}},[_c('div',{staticStyle:{"width":"100%","background-color":"#FAFAFA"}},[_c('v-layout',{staticStyle:{"width":"100%","white-space":"normal"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',[_c('i',[_vm._v(_vm._s(item.data[0].originalName))])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('audio',{staticStyle:{"width":"100%"},attrs:{"controls":""}},[_c('source',{attrs:{"src":item.data[0].url,"type":"audio/ogg"}}),_vm._v(" "),_c('source',{attrs:{"src":item.data[0].url,"type":"audio/mpeg"}}),_vm._v("\n                                Your browser does not support the audio element.\n                    ")])])],1)],1)])],1)],1)],1)],1)],1)],1)],1):_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","elevation-1":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload Audio File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"id":'ref'+index,"accept":"audio/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"hidden-md-and-up"},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","wrap":"","justify-center":"","elevation-1":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload Audio File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"id":'ref'+index,"accept":"audio/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files, index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1)]):(item.type === 'pdf' )?_c('div',[_c('div',{staticClass:"hidden-sm-and-down"},[(item.data.length >0)?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3 pl-2 pr-2  pt-2 pb-2 white",attrs:{"elevation-1":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("change PDF File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"application/pdf"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"blue white--text"},[_vm._v(" picture_as_pdf")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.data[0].originalName))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":""},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("delete")])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1):_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","elevation-1":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload a PDF File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"application/pdf"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"hidden-md-and-up"},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","wrap":"","justify-center":"","elevation-1":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm12":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload a PDF File\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","name":_vm.uploadFieldName,"id":'ref'+index,"disabled":_vm.isSaving,"accept":"application/pdf"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1)]):(item.type === 'image' )?_c('div',[(item.data.length == 0)?_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3 pl-2 pr-2  pt-2 pb-2 white",attrs:{"row":"","wrap":"","justify-center":"","elevation-1":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Upload an Image\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","multiple":"","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"id":'ref'+index,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1)],1)],1)],1):_c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md11":""}},[_c('v-layout',{staticClass:"mt-3 mb-3",attrs:{"elevation-1":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2 justify-center pt-2 pb-2 white hidden-sm-and-down",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput('ref'+index)}}},[_vm._v("Change  Image \n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","multiple":"","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"id":'ref'+index,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm5":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_vm._v("Delete\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-2 mb-2 pl-2 pr-2  pt-2 pb-2 white hidden-md-and-up",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{class:{ 'green darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"primary","loading":item.loading},on:{"click":function($event){_vm.clickInput(item.positionRef)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            cloud_upload\n                                        ")])],1),_vm._v(" "),(_vm.isInitial || _vm.isSaving || _vm.isSuccess)?_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{staticClass:"input-file",attrs:{"type":"file","multiple":"","name":_vm.uploadFieldName,"disabled":_vm.isSaving,"id":'ref'+index,"accept":"image/*"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files,index); _vm.fileCount = $event.target.files.length}}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center mr-3 ml-3",attrs:{"xs12":"","sm6":""}},[_c('v-btn',{staticClass:"white--text",class:{ 'red darken-3' : item.status },staticStyle:{"width":"85%"},attrs:{"color":"red darken-2"},on:{"click":function($event){_vm.deleteUpload(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n                                            delete_forever\n                                        ")])],1)],1)],1),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":item.data[0].url,"alt":""}})],1)],1)],1)],1)],1)]):_vm._e()])}),_vm._v(" "),_c('v-layout',{staticClass:"hidden-sm-and-down",staticStyle:{"position":"relative"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('div',{staticStyle:{"position":"relative","bottom":"0%","left":"0%"}},[_c('v-speed-dial',{staticClass:"hidden-sm-and-down pl-4 ml-5 mt-5",staticStyle:{"width":"100px"},attrs:{"top":_vm.top1,"bottom":_vm.bottom1,"right":_vm.right1,"left":_vm.left1,"direction":_vm.direction1,"hover":_vm.hover1,"transition":_vm.transition1},model:{value:(_vm.fab1),callback:function ($$v) {_vm.fab1=$$v},expression:"fab1"}},[_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"primary","dark":"","fab":"","hover":""},slot:"activator",model:{value:(_vm.fab1),callback:function ($$v) {_vm.fab1=$$v},expression:"fab1"}},[_c('v-icon',[_vm._v("add_box")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addTextToUploads}},[_c('v-icon',[_vm._v("text_fields")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addImageToUploads}},[_c('v-icon',[_vm._v("photo_library")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addVideoToUploads}},[_c('v-icon',[_vm._v("video_library")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addAudioToUploads}},[_c('v-icon',[_vm._v("library_music")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addPdfToUploads}},[_c('v-icon',[_vm._v("picture_as_pdf")])],1)],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('div',{staticStyle:{"position":"relative","bottom":"0%","right":"0%"}},[_c('v-speed-dial',{staticClass:"hidden-sm-and-down pr-3 mr-3 mt-5",staticStyle:{"width":"100px"},attrs:{"top":_vm.top1,"bottom":_vm.bottom1,"right":_vm.left1,"left":_vm.right1}},[( _vm.formUpload.collectionId.length > 0 && _vm.formUpload.description[_vm.lang].length > 0 && _vm.formUpload.title[_vm.lang].length > 0 && _vm.formUpload.mainImg[0].url && _vm.isReady)?_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"red","dark":"","fab":"","hover":"","type":"submit"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}},slot:"activator",model:{value:(_vm.fab1),callback:function ($$v) {_vm.fab1=$$v},expression:"fab1"}},[_c('v-icon',[_vm._v("save")])],1):_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"grey darken-2","dark":"","fab":"","hover":""},nativeOn:{"click":function($event){_vm.snackbar = true}},slot:"activator",model:{value:(_vm.fab1),callback:function ($$v) {_vm.fab1=$$v},expression:"fab1"}},[_c('v-icon',[_vm._v("save")])],1)],1)],1)]),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":"red","multi-line":_vm.mode === 'multi-line',"vertical":_vm.mode === 'vertical'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      Required fields must be completed\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1)],2)])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"pl-6",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-speed-dial',{staticClass:"hidden-md-and-up bottom_button",attrs:{"id":"","top":_vm.top2,"bottom":_vm.bottom2,"right":_vm.right2,"left":_vm.left2,"direction":_vm.direction2,"hover":_vm.hover2,"transition":_vm.transition2,"fixed":""},model:{value:(_vm.fab2),callback:function ($$v) {_vm.fab2=$$v},expression:"fab2"}},[_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"primary","dark":"","fab":"","hover":""},slot:"activator",model:{value:(_vm.fab2),callback:function ($$v) {_vm.fab2=$$v},expression:"fab2"}},[_c('v-icon',[_vm._v("add")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addTextToUploads}},[_c('v-icon',[_vm._v("text_fields")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addImageToUploads}},[_c('v-icon',[_vm._v("photo_library")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addVideoToUploads}},[_c('v-icon',[_vm._v("video_library")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addAudioToUploads}},[_c('v-icon',[_vm._v("library_music")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1",attrs:{"fab":"","dark":"","small":"","color":"grey darken-2"},on:{"click":_vm.addPdfToUploads}},[_c('v-icon',[_vm._v("picture_as_pdf")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-speed-dial',{staticClass:"hidden-md-and-up bottom_button",staticStyle:{"position":"fixed"},attrs:{"top":_vm.top1,"bottom":_vm.bottom1,"right":!_vm.left1,"left":!_vm.right1}},[(_vm.formUpload.description[_vm.lang].length > 0 && _vm.formUpload.title[_vm.lang].length > 0 && _vm.formUpload.mainImg[0].url && _vm.isReady)?_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"red","dark":"","fab":"","hover":"","type":"submit"},on:{"click":function($event){_vm.btnSubmit=!_vm.btnSubmit}},slot:"activator",model:{value:(_vm.fab1),callback:function ($$v) {_vm.fab1=$$v},expression:"fab1"}},[_c('v-icon',[_vm._v("save")])],1):_c('v-btn',{staticClass:"ma-1",attrs:{"slot":"activator","color":"grey darken-2","dark":"","fab":"","hover":""},nativeOn:{"click":function($event){_vm.snackbar = true}},slot:"activator",model:{value:(_vm.fab1),callback:function ($$v) {_vm.fab1=$$v},expression:"fab1"}},[_c('v-icon',[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"container"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oBHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__ = __webpack_require__("G0J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highlight_js__ = __webpack_require__("V8mf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_highlight_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_aplayer__ = __webpack_require__("afmS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_medium_editor__ = __webpack_require__("66dk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_medium_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_medium_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_dplayer__ = __webpack_require__("u+Ax");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_dplayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_dplayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FileUpload_file_upload_service__ = __webpack_require__("rG9c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("7+uW");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3;
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["formUpload", "lang", "place", "center", "marker", "newLocation"],
  data: function data() {
    return {
      name: "02-example",
      content: "",
      editorOption: {
        theme: "bubble",
        placeholder: "Type your text...",
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ color: [] }, { background: [] }], [{ align: [] }], ["clean"]]
        }
      },
      mode: "",
      options: {
        toolbar: {
          buttons: ["bold", "italic", "underline", "strikethrough", "h4", "h3", "h2", "justifyRight", "justifyLeft", "justifyCenter", "orderedlist", "unorderedlist"]
        },
        anchor: {
          /* These are the default options for anchor form,
           if nothing is passed this is what it used */
          // customClassOption: 'alink',
          // customClassOptionText: 'Button',
          // linkValidation: false,
          // placeholderText: 'YOYOYO',
          // targetCheckbox: false,
          // targetCheckboxText: 'Open in new window'
        }
      },
      isClicked: false,
      editImage: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false],
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      textval: "",
      i: -1,
      valid: true,
      title: "",
      location: "",
      description: "",
      imageUrl: "",
      youtubeLink: "",
      date: new Date(),
      time: new Date(),
      direction2: "left",
      direction: "right",
      fab: false,
      fling: false,
      hover: false,
      snackbar: false,
      timeout: 6000,
      tabs: null,
      top: false,
      right2: true,
      bottom: true,
      left2: false,
      right: false,
      left: true,
      transition: "slide-y-reverse-transition",
      direction1: "right",
      fab1: false,
      fling1: false,
      hover1: false,
      tabs1: null,
      top1: false,
      right1: true,
      bottom1: true,
      left1: false,
      transition1: "slide-y-reverse-transition",
      select: null,
      tags: ["Programming", "Vue", "Vuex"],
      titleRules: [function (v) {
        return !!v || "Title is required";
      }],
      descriptionRules: [function (v) {
        return !!v || "Description is required";
      }],
      selectRules: [function (v) {
        return !!v || "Collections are required";
      }],
      uploads: [],
      btnSubmit: false,
      contextmenu: [{
        text: "Download Video",
        link: "https://github.com/MoePlayer/vue-dplayer"
      }],
      player: null,
      music: {}
    };
  },


  watch: {
    formUpload: function formUpload(val) {
      if (val.date == undefined || val.date == "Invalid Date") {
        this.formUpload.date = new Date(new Date(Date.now()).getTime());
      } else this.formUpload.date = new Date(new Date(val.date).getTime());
    },
    top: function top(val) {
      this.bottom = !val;
    },
    right: function right(val) {
      this.left = !val;
    },
    bottom: function bottom(val) {
      this.top = !val;
    },
    left: function left(val) {
      this.right = !val;
    }
  },
  components: {
    "a-player": __WEBPACK_IMPORTED_MODULE_4_vue_aplayer__["a" /* default */],
    "d-player": __WEBPACK_IMPORTED_MODULE_6_vue_dplayer___default.a,
    "medium-editor": __WEBPACK_IMPORTED_MODULE_5_vue2_medium_editor___default.a,
    quillEditor: __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__["quillEditor"]
  },

  computed: {
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    contentCode: function contentCode() {
      return __WEBPACK_IMPORTED_MODULE_3_highlight_js___default.a.highlightAuto(this.content).value;
    },
    editor: function editor() {
      return this.$refs.myTextEditor.quill;
    },
    isReady: function isReady() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.formUpload.uploads), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var files = _step.value;

          if (files.type != "text") if (!files.data[0]) return false;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    token: function token() {
      return this.$store.getters.getToken;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isAuthor: function isAuthor() {
      return this.formUpload.userId == this.user._id;
    },
    user: function user() {
      return this.$store.getters.getUser;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    formIsValid: function formIsValid() {
      return this.title[this.lang] !== "" && this.description[this.lang] !== "";
    },
    activeFab: function activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    },


    // formUpload() {
    //   return this.$store.getters.loadArtefactSingle(this.id);
    // },
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    collections: function collections() {
      return this.$store.getters.loadAllCollections;
    }
  },
  submittableDateTime: function submittableDateTime() {
    var date = new Date(this.date);

    return date;
  },

  methods: {
    newLocationMethod: function newLocationMethod(location) {
      this.formUpload.location = location;
      this.$emit("newLocation", location);
    },
    onEditorChange: function onEditorChange(_ref) {
      var editor = _ref.editor,
          html = _ref.html,
          text = _ref.text;

      console.log("editor change!", editor, html, text);
      this.content = html;
    },
    applyTextEdit: function applyTextEdit(index, ev) {
      if (ev.event.target) {
        this.formUpload.uploads[index].value = ev.event.target.innerHTML;
      }
    },
    deleteUpload: function deleteUpload(position) {
      var index = this.formUpload.uploads.indexOf(position);

      this.formUpload.uploads.splice(position, 1);
    },
    appear: function appear(variable, index) {
      __WEBPACK_IMPORTED_MODULE_9_vue__["a" /* default */].set(this.editImage, index, !this.editImage[index]);
    },

    shouldAppear: function shouldAppear(variable, index) {
      if (variable[index] === true) return true;else return false;
    },
    displayArray: function displayArray(x) {
      for (var i = 0; i < x.length; i++) {}
    },
    play: function play() {},
    addTextToUploads: function addTextToUploads() {
      this.i++;
      var data = {
        position: this.i,
        positionRef: "ref" + this.i,
        type: "text",
        status: 0,
        key: "",
        value: {
          en: "",
          sr: "",
          ro: ""
        }
      };
      this.formUpload.uploads.push(data);
    },
    addImageToUploads: function addImageToUploads() {
      this.i++;
      var data = {
        position: this.i,
        positionRef: "ref" + this.i,
        type: "image",
        status: 0,
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    addPdfToUploads: function addPdfToUploads() {
      this.i++;
      var data = {
        position: this.i,
        positionRef: "ref" + this.i,
        status: 0,
        type: "pdf",
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    addAudioToUploads: function addAudioToUploads() {
      this.i++;
      var data = {
        status: 0,
        position: this.i,
        positionRef: "ref" + this.i,
        type: "audio",
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    addVideoToUploads: function addVideoToUploads() {
      this.i++;
      var data = {
        position: this.i,
        positionRef: "ref" + this.i,
        type: "video",
        status: 0,
        key: "",
        data: []
      };
      this.formUpload.uploads.push(data);
    },
    clickInput: function clickInput(position) {
      var element = document.getElementById(position);

      element.click();
    },
    clickInputMain: function clickInputMain() {
      this.$refs.fileInput1.click();
    },
    reset: function reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save: function save(formData, position) {
      var _this = this;

      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      if (position == -1) this.formUpload.mainImg[0].loading = true;else this.formUpload.uploads[position].loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__components_FileUpload_file_upload_service__["a" /* upload */])(formData, this.user._id).then(function (x) {
        if (position == -1) {
          _this.formUpload.mainImg = x;
          _this.formUpload.mainImg[0].status = 1;
          _this.formUpload.mainImg[0].loading = false;
        } else {
          _this.formUpload.uploads[position].data = x;
          _this.formUpload.uploads[position].status = 1;
          _this.formUpload.uploads[position].loading = false;
        }
        _this.currentStatus = STATUS_SUCCESS;
      }).catch(function (err) {
        _this.uploadError = err.response;
        _this.currentStatus = STATUS_FAILED;
      });
    },
    filesChange: function filesChange(fieldName, fileList, position) {
      // handle file changes
      var formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });

      // save it
      this.save(formData, position);
    },
    onCreateArtefact: function onCreateArtefact() {
      this.$store.dispatch("createArtefact", this.formUpload);
      this.$router.push("/artefacts");
    },
    onUpdateArtefact: function onUpdateArtefact() {
      this.$emit("maybe");
    },
    moveButton: function moveButton(admin) {
      if (admin) {
        var btn = document.getElementById("bottom_button");
        btn.style.bottom = "65px";
      } else {
        var btn = document.getElementById("bottom_button");
        btn.style.bottom = "15px";
      }
    },
    moveButton1: function moveButton1(admin) {
      if (admin) {
        var btn = document.getElementById("bottom_button1");
        btn.style.bottom = "65px";
      } else {
        var btn = document.getElementById("bottom_button1");
        btn.style.bottom = "15px";
      }
    },
    handleSize: function handleSize() {
      // var img = document.getElementsByClassName('myImg');
      // console.log(img[0]);
      // var i= 0;
      // for(i = 0; i < img.length;i++)
      // {
      // img[i].style.width = screen.width / 3.3 + 'px';
      // var height = img[i].style.width;
      // img[i].style.height = height ;
      // }
      // var video = document.getElementById('video');
      // video.style.width = screen.width + 'px';
      // var height = video.style.width;
      // video.style.height = screen.width /2 + 'px';
    }
  },
  updated: function updated() {
    // this.handleSize();
    this.moveButton(this.isAdmin);
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadUsers");
    this.reset();
    this.moveButton(this.isAdmin);
    this.moveButton1(this.isAdmin);
  },
  created: function created() {
    this.$store.dispatch("loadArtefacts");
    if (!this.isLoggedIn) {
      this.$router.push("/signin");
    } else if (!this.isAuthor && !this.isAdmin && !this.isMod) this.$router.push("/");
  }
});

/***/ }),

/***/ "oEvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider3_vue__ = __webpack_require__("s5wk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2c30a9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider3_vue__ = __webpack_require__("hqhH");
function injectStyle (ssrContext) {
  __webpack_require__("0PtN")
  __webpack_require__("14vu")
  __webpack_require__("YfWB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2c30a9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2c30a9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Slider3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oH/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_InfoWindow_vue__ = __webpack_require__("TNEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_InfoWindowDialog_vue__ = __webpack_require__("bMug");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    infoWindow: __WEBPACK_IMPORTED_MODULE_0__components_Partials_InfoWindow_vue__["a" /* default */],
    infoWindowDialog: __WEBPACK_IMPORTED_MODULE_1__components_Partials_InfoWindowDialog_vue__["a" /* default */]
  },
  data: function data() {
    return {
      infoWindowMarker: {},
      infoWindowBoolMobile: false,
      infoWindowBoolDesktop: false,
      place: {
        formatted_address: "Add a location or drag marker."
      }
    };
  },

  props: ["groupTitle", "heightM"],
  update: function update() {
    this.$refs.map.resize();
  },

  computed: {
    center: function center() {
      return {
        lng: 23.3733689,
        lat: 45.1709992
      };
    },
    relatedArtefacts: function relatedArtefacts() {
      return this.$store.getters.loadRelatedArtefacts(this.groupTitle.title.en).filter(function (loc) {
        return loc.location != "" && loc.location.geometry;
      });
    }
  },
  methods: {
    openInfoWindow: function openInfoWindow(marker) {
      if (window.innerWidth > 968) this.infoWindowBoolDesktop = true;else this.infoWindowBoolMobile = true;

      this.infoWindowMarker = marker;
    },
    setMapHeight: function setMapHeight() {
      var map = document.getElementById("mapHgt");
      map.style.height = this.heightM + "px";
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    }
  },
  mounted: function mounted() {
    this.setMapHeight();
  }
});

/***/ }),

/***/ "oWHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"m-5 ma-1"},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""},on:{"click":_vm.toCollection1}},[_c('v-flex',{attrs:{"xs8":""}},[_c('div',[_c('div',{staticClass:"headline",staticStyle:{"text-decoration":"none","cursor":"pointer"},on:{"click":_vm.toCollection}},[_vm._v(_vm._s(_vm.collection.title[_vm.lang].slice(0, 40))),(_vm.collection.title.length >39)?_c('span',[_vm._v("...")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"greyText"},[_vm._v(_vm._s(_vm.collection.description[_vm.lang].slice(0, 100))),(_vm.collection.description[_vm.lang].length >99)?_c('span',[_vm._v("...")]):_vm._e()])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-layout',{attrs:{"justify-end":""}},[_c('v-card-media',{staticClass:"mt-2 mr-2",staticStyle:{"width":"110px","min-width":"110px"},attrs:{"src":_vm.collection.imgUrl[0].url+'_card',"height":"110px","cover":""}})],1)],1)],1)],1),_vm._v(" "),(_vm.showContent(_vm.collection))?_c('v-expansion-panel',{staticClass:"expPanel",attrs:{"expand":""}},[_c('v-expansion-panel-content',{staticClass:"mb-0",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"greyText",attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"pr-2",attrs:{"left":""}},[_vm._v("view_day")]),_vm._v(_vm._s(_vm.gLang[_vm.lang].collectionCard.expansion))],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.relatedArtefacts),function(artefact,i){return _c('div',{key:i},[(i<3)?_c('v-divider'):_vm._e(),_vm._v(" "),(i<3)?_c('v-list-tile',{staticClass:"pt-2 pb-0",attrs:{"avatar":""},on:{"click":function($event){_vm.toArtefact(artefact._id)}}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":artefact.mainImg[0].url+'_card'}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie",staticStyle:{"height":"auto"}},[_c('v-list-tile-title',{staticClass:"artTitle",domProps:{"innerHTML":_vm._s(artefact.title[_vm.lang])}}),_vm._v(" "),_vm._l((_vm.users),function(user,i){return (artefact.userId.indexOf(user._id) > -1)?_c('v-list-tile-sub-title',{key:i},[_c('span',{staticClass:"author"},[_vm._v(_vm._s(user.displayName))]),_vm._v(" "),_c('span',[_vm._v("- "+_vm._s(artefact.description[_vm.lang]))])]):_vm._e()})],2)],1):_vm._e()],1)})],2)],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oYE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oc0g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p+pt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("e0vu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0640d2d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("xyfC");
function injectStyle (ssrContext) {
  __webpack_require__("RBvK")
  __webpack_require__("oc0g")
  __webpack_require__("Obtq")
  __webpack_require__("oc0g")
  __webpack_require__("voNd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0640d2d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0640d2d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p7JX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p8ve":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/facebook.0bf4b44.png";

/***/ }),

/***/ "pKGH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pb6Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ppTP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("H7H4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qNck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageTemplateLeft_vue__ = __webpack_require__("wZjk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a516c050_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageTemplateLeft_vue__ = __webpack_require__("AU3f");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageTemplateLeft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a516c050_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageTemplateLeft_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qcsk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qoNP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qtB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__ = __webpack_require__("G0J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    quillEditor: __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__["quillEditor"]
  },
  data: function data() {
    return {
      dialog: false,
      reciever: "",
      subject: "",
      message: "",
      editorOption: {
        theme: "bubble",
        placeholder: "Send a new Message",
        modules: {
          toolbar: [["bold", "italic"], [{ list: "ordered" }, { list: "bullet" }], ["clean"]]
        }
      }
    };
  },

  methods: {
    getUserId: function getUserId() {
      var _this = this;

      return this.users.find(function (user) {
        return user.email == _this.reciever;
      })._id;
    },
    sendMessage: function sendMessage() {
      var _this2 = this;

      if (this.getUserId(this.reciever) == null) {
        alert(null);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/messages", {
        message: this.message,
        sender: this.user._id,
        reciever: this.getUserId(this.reciever)
      }).then(function (response) {
        _this2.$emit("newMessage");
        _this2.newMessage = "";
      });
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUser;
    },
    users: function users() {
      return this.$store.getters.loadUsers;
    }
  }
});

/***/ }),

/***/ "quk8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"hidden-xs-only",attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","lg6":"","md12":""}},[_c('v-text-field',{style:(_vm.term!=''?'margin-top: 3px;':''),attrs:{"light":"","solo":"","prepend-icon":"search","placeholder":_vm.gLang[_vm.lang].layout.search},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","lg6":""}},[(_vm.term!='')?_c('v-list',{staticClass:"pa-0",staticStyle:{"border-radius":"5px","border":"2px solid #efefef"},attrs:{"three-line":""}},[(_vm.condition)?_c('v-subheader',{staticStyle:{"border-bottom":"1px solid #efefef"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.searchNoResults))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"caption",staticStyle:{"color":"black","text-align":"center"}},[_c('v-icon',[_vm._v("error_outline")]),_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.searchDisclaimer))],1),_vm._v(" "),(_vm.term&&_vm.methodResultsArtefacts.length!=0)?_c('v-subheader',{staticStyle:{"border-bottom":"1px solid #efefef"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.artefacts))]):_vm._e(),_vm._v(" "),_vm._l((_vm.methodResultsArtefacts),function(item,index){return (index<=1)?_c('v-list-tile',{key:item._id,staticClass:"listTile",attrs:{"avatar":""},on:{"click":function($event){_vm.toArtefact(item._id)}}},[_c('v-list-tile-content',{staticStyle:{"position":"relative"}},[_c('v-layout',{staticStyle:{"width":"100%","position":"relative"}},[_c('v-flex',{staticClass:"mb-1 mt-1 pr-2 pl-1",staticStyle:{"border-right":"1px solid #efefef"},attrs:{"xs5":""}},[_c('v-list-tile-title',{staticStyle:{"text-align":"right"},domProps:{"innerHTML":_vm._s(item.title[_vm.lang])}})],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 mt-1 pl-2 pr-1",staticStyle:{"border-left":"1px solid #efefef","overflow":"hidden","position":"relative"},attrs:{"xs7":""}},[_c('v-list-tile-sub-title',{staticStyle:{"height":"80%"},domProps:{"innerHTML":_vm._s( '  <span class=\'grey--text text--lighten-1\'> ' + item.description[_vm.lang] + '</span>' )}})],1)],1)],1)],1):_vm._e()}),_vm._v(" "),(_vm.term&&_vm.methodResultsCollections.length!=0)?_c('v-subheader',{staticStyle:{"border-bottom":"1px solid #efefef"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.collections))]):_vm._e(),_vm._v(" "),_vm._l((_vm.methodResultsCollections),function(item,index){return (index<=1)?_c('v-list-tile',{key:item._id,staticClass:"listTile",attrs:{"avatar":""},on:{"click":function($event){_vm.toCollection(item._id)}}},[_c('v-list-tile-content',{staticStyle:{"position":"relative"}},[_c('v-layout',{staticStyle:{"width":"100%","position":"relative"}},[_c('v-flex',{staticClass:"mb-1 mt-1 pr-2 pl-1",staticStyle:{"border-right":"1px solid #efefef"},attrs:{"xs5":""}},[_c('v-list-tile-title',{staticStyle:{"text-align":"right"},domProps:{"innerHTML":_vm._s(item.title[_vm.lang])}})],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 mt-1 pl-2 pr-1",staticStyle:{"border-left":"1px solid #efefef","overflow":"hidden","position":"relative"},attrs:{"xs7":""}},[_c('v-list-tile-sub-title',{staticStyle:{"height":"80%"},domProps:{"innerHTML":_vm._s( '  <span class=\'grey--text text--lighten-1\'> ' + item.description[_vm.lang] + '</span>' )}})],1)],1)],1)],1):_vm._e()}),_vm._v(" "),(_vm.term&&_vm.methodResultsGroups.length!=0)?_c('v-subheader',{staticStyle:{"border-bottom":"1px solid #efefef"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].layout.groups))]):_vm._e(),_vm._v(" "),_vm._l((_vm.methodResultsGroups),function(item,index){return (index<=1)?_c('v-list-tile',{key:item._id,staticClass:"listTile",attrs:{"avatar":""},on:{"click":function($event){_vm.toGroup(item._id)}}},[_c('v-list-tile-content',{staticStyle:{"position":"relative"}},[_c('v-layout',{staticStyle:{"width":"100%","position":"relative"}},[_c('v-flex',{staticClass:"mb-1 mt-1 pr-2 pl-1",staticStyle:{"border-right":"1px solid #efefef"},attrs:{"xs5":""}},[_c('v-list-tile-title',{staticStyle:{"text-align":"right"},domProps:{"innerHTML":_vm._s(item.title[_vm.lang])}})],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 mt-1 pl-2 pr-1",staticStyle:{"border-left":"1px solid #efefef","overflow":"hidden","position":"relative"},attrs:{"xs7":""}},[_c('v-list-tile-sub-title',{staticStyle:{"height":"80%"},domProps:{"innerHTML":_vm._s( '  <span class=\'grey--text text--lighten-1\'> ' + item.description[_vm.lang] + '</span>' )}})],1)],1)],1)],1):_vm._e()})],2):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r8ZS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11-min[cropped].7c00eb4.jpg";

/***/ }),

/***/ "rG9c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return upload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__ = __webpack_require__("OEKd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

// file-upload.service.js




var BASE_URL = __WEBPACK_IMPORTED_MODULE_1__deploy_conf_js__["IP_ADRESS"];

function upload(formData) {
  var url = BASE_URL + 'api/photos/upload';
  return __WEBPACK_IMPORTED_MODULE_2_axios__["post"](url, formData)
  // get data
  .then(function (x) {
    return x.data;
  })
  // add url field
  .then(function (x) {
    return x.map(function (img) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, img, { url: '/api/images/' + img.id });
    });
  });
}



/***/ }),

/***/ "rgZx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rpbJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	mounted: function mounted() {
		window.scrollTo(0, 0);
		// this.assignArtefacts();
	},

	computed: {
		gLang: function gLang() {
			return this.$store.getters.loadGlobLang;
		},
		lang: function lang() {
			return this.$store.getters.loadLang;
		}
	},
	created: function created() {
		this.$store.dispatch("loadLanguages");
	}
});

/***/ }),

/***/ "rsTt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      direction: "top",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition"
    };
  }
});

/***/ }),

/***/ "s1hA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s5wk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__("vBWZ");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["a" /* default */] },
  props: ['unslick'],
  data: function data() {
    return {
      slickOptions: {
        dots: true,
        // centerMode: true,
        infinite: true,
        arrows: true,
        speed: 1400,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        // {
        //   breakpoint: 1224,
        //   settings: {
        //     slidesToShow: 3,
        //     slidesToScroll: 3,
        //     arrows: false,
        //     infinite: true,
        //     dots: false
        //   }
        // },
        {
          breakpoint: 1380,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2

          }
        }, {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
            infinite: true,
            arrows: false
          }
        }, {
          breakpoint: 530,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            infinite: true,
            arrows: false
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        }]
      }
    };
  },

  methods: {
    next: function next() {
      this.$refs.slick.next();
    },
    prev: function prev() {
      this.$refs.slick.prev();
    },
    reInit: function reInit() {
      var _this = this;

      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(function () {
        _this.$refs.slick.reSlick();
      });
    }
  },
  mounted: function mounted() {
    // this.moveButton(this.isAdmin);
    this.reInit();
  },
  updated: function updated() {
    this.reInit();
  }
});

/***/ }),

/***/ "s9Gz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h3',{staticClass:"headline"},[_vm._v("Enter your email to reset the password")]),_vm._v(" "),(_vm.errorMessage != '')?_c('span',{staticClass:"caption error"},[_vm._v(_vm._s(_vm.errorMessage))]):(_vm.successMessage != '')?_c('span',{staticClass:"caption success"},[_vm._v(_vm._s(_vm.successMessage))]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Email","required":"","error-messages":_vm.emailErrors},on:{"input":function($event){_vm.$v.email.$touch()},"blur":function($event){_vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":_vm.submit}},[_vm._v("Send me a recovery link")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.$emit('clicked')}}},[_vm._v("Close")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sFRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("69YC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d112506_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("0IOo");
function injectStyle (ssrContext) {
  __webpack_require__("AgIf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d112506_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sUW2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'pa-0 ma-0 mt-4 pt-5 background-container-xs' : _vm.getScreenWidth() < 900, ' background-container-md' : _vm.getScreenWidth() > 900},staticStyle:{"width":"100%","max-width":"100%"},attrs:{"xs12":"","sm10":"","md4":"","offset-md3":"","offset-sm2":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{staticClass:"ml-2 mr-2 mt-4",attrs:{"sm8":"","md4":""}},[_c('v-layout',{staticStyle:{"background-color":"white","border-radius":"2px"},attrs:{"justify-center":"","elevation-2":""}},[(_vm.error =='')?_c('v-form',{staticStyle:{"width":"94%"}},[_c('v-text-field',{attrs:{"name":"input-10-1","label":"New password","type":"password","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){_vm.$v.password.$touch()},"blur":function($event){_vm.$v.password.$touch()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-10-1","label":"Retype new password","type":"password","error-messages":_vm.repeatPasswordErrors,"required":""},on:{"input":function($event){_vm.$v.repeatPassword.$touch()},"blur":function($event){_vm.$v.repeatPassword.$touch()}},model:{value:(_vm.repeatPassword),callback:function ($$v) {_vm.repeatPassword=$$v},expression:"repeatPassword"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-btn',{staticClass:"primary",on:{"click":_vm.submit}},[_vm._v("\n                     Change Password\n                 ")])],1)],1):_c('div',{staticClass:"pa-3"},[_c('h4',{staticClass:"text-xs-center",staticStyle:{"color":"grey"}},[_c('i',[_vm._v(_vm._s(_vm.error))])])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "srxf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "suZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Partials_InfoWindow_vue__ = __webpack_require__("TNEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Partials_InfoWindowDialog_vue__ = __webpack_require__("bMug");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    infoWindow: __WEBPACK_IMPORTED_MODULE_0__components_Partials_InfoWindow_vue__["a" /* default */],
    infoWindowDialog: __WEBPACK_IMPORTED_MODULE_1__components_Partials_InfoWindowDialog_vue__["a" /* default */]
  },
  data: function data() {
    return {
      infoWindowMarker: {},
      infoWindowBoolMobile: false,
      infoWindowBoolDesktop: false,
      place: {
        formatted_address: "Add a location or drag marker."
      }
    };
  },

  props: ["relatedArtefacts"],
  update: function update() {
    this.$refs.map.resize();
  },

  computed: {
    center: function center() {
      return {
        lng: 23.3733689,
        lat: 45.1709992
      };
    }
  },
  methods: {
    openInfoWindow: function openInfoWindow(marker) {
      if (window.innerWidth > 968) this.infoWindowBoolDesktop = true;else this.infoWindowBoolMobile = true;

      this.infoWindowMarker = marker;
    },
    setMapHeight: function setMapHeight() {
      var w = window,
          d = document,
          e = d.documentElement,
          g = d.getElementsByTagName('body')[0],
          x = w.innerWidth || e.clientWidth || g.clientWidth,
          y = w.innerHeight || e.clientHeight || g.clientHeight;

      var map = document.getElementById("mapHgt");
      map.style.height = y - 200 + "px";
      map.style.width = x + "px";
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    }
  },
  mounted: function mounted() {
    this.setMapHeight();
  }
});

/***/ }),

/***/ "swbM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-card',{staticClass:"ma-0 pa-3 contactCard pt-4 mt-4",staticStyle:{"background-color":"white"}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text  ml-4 ",staticStyle:{"background-color":"white","border-bottom":"1px solid #efefef"}},[_c('h4',{staticClass:"mt-3 contactTitle"},[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].contact.title))])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"error-messages":_vm.numeErrors,"required":"","label":_vm.gLang[_vm.lang].contact.nume},on:{"input":function($event){_vm.$v.nume.$touch()},"blur":function($event){_vm.$v.nume.$touch()},"keydown":function($event){_vm.errorMessage=''}},model:{value:(_vm.nume),callback:function ($$v) {_vm.nume=$$v},expression:"nume"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"error-messages":_vm.prenumeErrors,"required":"","label":_vm.gLang[_vm.lang].contact.prenume},on:{"input":function($event){_vm.$v.prenume.$touch()},"blur":function($event){_vm.$v.prenume.$touch()},"keydown":function($event){_vm.errorMessage=''}},model:{value:(_vm.prenume),callback:function ($$v) {_vm.prenume=$$v},expression:"prenume"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":_vm.gLang[_vm.lang].contact.mail,"error-messages":_vm.emailErrors,"required":""},on:{"input":function($event){_vm.$v.email.$touch()},"blur":function($event){_vm.$v.email.$touch()},"keydown":function($event){_vm.errorMessage=''}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":_vm.gLang[_vm.lang].contact.telefon},model:{value:(_vm.telefon),callback:function ($$v) {_vm.telefon=$$v},expression:"telefon"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"multi-line":"","error-messages":_vm.mesajErrors,"required":"","label":_vm.gLang[_vm.lang].contact.mesaj},on:{"input":function($event){_vm.$v.mesaj.$touch()},"blur":function($event){_vm.$v.mesaj.$touch()},"keydown":function($event){_vm.errorMessage=''}},model:{value:(_vm.mesaj),callback:function ($$v) {_vm.mesaj=$$v},expression:"mesaj"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.sendMessage}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].messaging.send))])],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.colorS,"multi-line":_vm.mode,"vertical":!_vm.mode},model:{value:(_vm.showSucces),callback:function ($$v) {_vm.showSucces=$$v},expression:"showSucces"}},[_vm._v("\n   "+_vm._s(_vm.gLang[_vm.lang].contact.successMessage)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.showSucces = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].contact.close))])],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.colorF,"multi-line":_vm.mode,"vertical":!_vm.mode},model:{value:(_vm.showFail),callback:function ($$v) {_vm.showFail=$$v},expression:"showFail"}},[_vm._v("\n     "+_vm._s(_vm.gLang[_vm.lang].contact.failMessage)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.showFail = false}}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].contact.close))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "syMx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10-min[cropped].3bbc18d.jpg";

/***/ }),

/***/ "tE8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__("ZQSV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0be2d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__("CqXX");
function injectStyle (ssrContext) {
  __webpack_require__("Qybm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a0be2d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0be2d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tFBV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tLfa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tUAG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Uploader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FileUpload_file_upload_service_profile__ = __webpack_require__("CzZM");


var STATUS_INITIAL = 0;

var STATUS_SAVING = 1;

var STATUS_SUCCESS = 2;

var STATUS_FAILED = 3;
var Uploader = {
  data: function data() {
    return {
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos'
    };
  },

  computed: {
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  methods: {
    clickInputMain: function clickInputMain() {
      this.$refs.fileInput1.click();
    },
    reset: function reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
      this.loading = false;
      this.status = 0;
    },
    save: function save(formData, position) {
      var _this = this;

      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_FileUpload_file_upload_service_profile__["a" /* upload */])(formData).then(function (x) {
        _this.picture = x;
        _this.loading = false;
        _this.status = 1;
        _this.currentStatus = STATUS_SUCCESS;
      }).catch(function (err) {
        _this.loading = false;
        _this.uploadError = err.response;
        _this.currentStatus = STATUS_FAILED;
      });
    },
    filesChange: function filesChange(fieldName, fileList, position) {
      // handle file changes
      var formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });

      // save it
      this.save(formData, position);
    }
  },
  mounted: function mounted() {
    this.reset();
  }
};

/***/ }),

/***/ "tcxl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("V0vp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14e2d32e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("GZ5w");
function injectStyle (ssrContext) {
  __webpack_require__("Rat3")
  __webpack_require__("yV5L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14e2d32e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14e2d32e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tdgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loading__ = __webpack_require__("/j7X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_content_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_content_loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ["artefact", "showStatus", "clickImage"],
	data: function data() {
		return {
			loading: false,
			gradient: "to top right, rgba(63,81,181, .7), rgba(25,32,72, .0)"
		};
	},

	methods: {
		getStatus: function getStatus(artefact) {
			if (artefact.reviewed && !artefact.deleted) return "Published";else if (artefact.reviewed && artefact.deleted) return "Waiting for delete review";else return "Waiting for publish review";
		},
		toArtefact: function toArtefact(artefactID) {
			this.$router.push("/artefacts/" + artefactID);
			window.innerWidth;
		},
		toArtefact1: function toArtefact1(artefactID) {
			if (this.clickImage != false) this.$router.push("/artefacts/" + artefactID);else if (window.innerWidth > 950) {
				this.$router.push("/artefacts/" + artefactID);
			}
		}
	},
	computed: {
		lang: function lang() {
			return this.$store.getters.loadLang;
		},
		user: function user() {
			return this.$store.getters.getUser;
		},
		artefactUser: function artefactUser() {
			return this.$store.getters.loadSingleUser(this.artefact.userId);
		}
	},
	components: {
		VclFacebook: __WEBPACK_IMPORTED_MODULE_0_vue_content_loading__["VclFacebook"],
		VclInstagram: __WEBPACK_IMPORTED_MODULE_0_vue_content_loading__["VclInstagram"]
	}
});

/***/ }),

/***/ "tdnc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__("vBWZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: function metaInfo() {
    return {
      title: this.sanitizeString(this.collection.title[this.lang]),
      meta: [{
        vmid: "og:title",
        name: "og:title",
        content: this.sanitizeString(this.collection.title[this.lang])
      }, { vmid: "og:type", name: "og:type", content: "article" }, {
        vmid: "og:article:published_time",
        name: "og:article:published_time",
        content: this.sanitizeString(this.collection.meta.creationDate)
      }, {
        vmid: "og:article:section",
        name: "og:article:section",
        content: this.sanitizeString(this.collection.title[this.lang])
      }, { vmid: "og:locale", name: "og:locale", content: "ro_RO" }, {
        vmid: "og:locale:alternate",
        name: "og:locale:alternate",
        content: "sr_SR"
      }, {
        vmid: "og:description",
        name: "og:description",
        content: this.sanitizeString(this.collection.description[this.lang])
      }, {
        vmid: "og:url",
        name: "og:url",
        content: "https://www.hera.uvt.ro/artefacts/" + this.sanitizeString(this.collection._id)
      }, {
        vmid: "og:image",
        name: "og:image",
        content: "https://www.hera.uvt.ro" + this.collection.imgUrl[0].url
      }, { vmid: "og:site_name", name: "og:site_name", content: "HErA" }],
      script: [{
        innerHTML: "{ \"@context\": \"http://schema.org\",\n          \"@type\": \"Article\",\n          \"dateCreated\":\"" + this.sanitizeString(this.collection.meta.creationDate) + "\", \n          \"isFamilyFriendly\":\"true\",\n          \"thumbnailUrl\":\"" + ("https://www.hera.uvt.ro" + this.collection.imgUrl[0].url) + "\",\n          \"name\": \"" + this.sanitizeString(this.collection.title[this.lang]) + "\",\n          \"description\": \"" + this.sanitizeString(this.collection.description[this.lang]) + "\",\n          \"image\": \"" + ("https://www.hera.uvt.ro" + this.collection.imgUrl[0].url) + "\",\n          \"url\":\"" + ("https://www.hera.uvt.ro/artefacts/" + this.sanitizeString(this.collection._id)) + "\"\n           \n           }",
        type: "application/ld+json"
      }]
    };
  },


  watch: {
    id: function id() {
      this.isLoading = true;
      this.fetchData();
    }
    // $route (to, from) {
    //   console.log('fwgr');
    //   var self = this
    //   self.isLoading = true

    //   self.fetchData().then(function () {

    //   })
    // }

  },
  data: function data() {
    return {
      mapHeight: 600,
      mapHeight1: 300,
      direction: "left",
      fab: false,
      dialog: false,
      dialog2: false,
      fling: false,
      hover: false,
      col: "",
      tabs: null,
      top: false,
      isLoading: true,
      fetchError: null,
      right: true,
      bottom: true,
      collection: {
        _id: "",
        title: {
          en: "",
          sr: "",
          ro: ""
        },
        meta: {
          author: "",
          creationDate: ""
        },
        description: {
          en: "",
          sr: "",
          ro: ""
        },
        imgUrl: [{
          url: ""
        }]
      },
      left: false,
      transition: "slide-y-reverse-transition",
      slickOptions: {
        autoplay: true,
        dots: false,
        infinite: true,
        arrows: false,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        }]
      },
      overview: true,
      isMinimized: true
    };
  },

  props: ["id"],
  // route: {
  //           data: function (transition) {
  //               this.getDetails(transition);
  //           }
  //       },

  methods: {
    sanitizeString: function sanitizeString(str) {
      str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim, "");
      return str.trim();
    },
    getLanguageTranslation: function getLanguageTranslation(col) {
      if (this.groups.find(function (cole) {
        return cole.title.en == col;
      })) return this.groups.find(function (cole) {
        return cole.title.en == col;
      }).title[this.lang];else return false;
    },

    fetchData: function fetchData() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/collections/" + this.id).then(function (response) {
        if (response.data.name == "CastError") {
          self.$router.push("/404");
          console.log(response.data.name);
        } else {
          self.collection = response.data;
          self.isLoading = false;
          self.$store.dispatch("updateCollectionVisits", {
            collection: response.data,
            userId: self.user && self.user != {} && self.user._id ? self.user._id : self.$store.getters.getIdentifier,
            date: Date.now()
          });
        }
      }).catch(function (error) {
        self.fetchError = error;
      });
    },
    // getUserDetails(transition)
    //         {
    //             this.$http.get('/collections/' + this.id)
    //                 .then(function (response) {
    //                     this.collection = col;
    //                     transition.next();
    //                 });

    //         },
    artefactsInCollection: function artefactsInCollection() {
      // v-for="collection in collections" :key="collection._id" v-if="(collection.groups.indexOf(group.title) > -1)"

      var i = 0,
          j = 0;

      for (i = 0; i < this.artefacts.length; i++) {
        for (j = 0; j < this.artefacts[i].collectionId.length; j++) {
          if (this.artefacts[i].collectionId[j] == this.collection.title.en) {
            return true;
          }
        }
      }

      return false;
    },
    addToFav: function addToFav() {
      if (!this.collection.favorite.includes(this.user._id)) {
        this.collection.favorite.push(this.user._id);
        this.$store.dispatch("updateCollection", this.collection);
      } else {
        for (var i = this.collection.favorite.length - 1; i >= 0; i--) {
          if (this.collection.favorite[i] === this.user._id) {
            this.collection.favorite.splice(i, 1);
            break; //<-- Uncomment  if only the first term has to be removed
          }
        }
        this.$store.dispatch("updateCollection", this.collection);
      }
    },

    // moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';

    //     }
    //     else
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }

    //   },

    changeCardHeight: function changeCardHeight(admin) {
      var card = document.getElementById("card-variable-height");

      if (admin) {
        card.style.height = screen.height - 110 + "px";
      } else {
        card.style.height = 92 + "vh";
      }
    },
    lessThen5: function lessThen5(idart, coltitle) {
      var j,
          k = [];

      for (j = 0; j < this.artefacts.length; j++) {
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1) k.push(this.artefacts[j]._id);
      }if (k[0] == idart || k[1] == idart || k[2] == idart || k[3] == idart || k[4] == idart) return true;else return false;
    },
    next: function next() {
      this.$refs.slick.next();
    },
    prev: function prev() {
      this.$refs.slick.prev();
    },
    reInit: function reInit() {
      var _this = this;

      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(function () {
        _this.$refs.slick.reSlick();
      });
    },

    showAll: function showAll() {
      var modal = document.getElementById("myModal");

      modal.style.display = "block";
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    },

    deleteArtefact: function deleteArtefact() {
      this.$store.dispatch("deleteCollection", this.collection);
      this.$router.push("/");
    },
    // blabla(){
    //       this.$store.dispatch("loadArtefacts");
    //       this.onResize();
    // },
    spanClick: function spanClick() {
      var modal = document.getElementById("myModal");
      modal.style.display = "none";
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
    // this.moveButton(this.isAdmin);
    this.fetchData();
    if (!this.collection) this.$router.push("/404");
    this.changeCardHeight(this.isAdmin);
    document.title = this.collection.title[this.lang];
  },
  created: function created() {
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadUsers");
    this.collection.visited++;
  },

  computed: {
    groups: function groups() {
      return this.$store.getters.loadGroups;
    },
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    favorited: function favorited() {
      if (this.collection.favorite) return this.collection.favorite.includes(this.user._id);else return false;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    // collection() {
    //   return this.$store.getters.loadCollectionSingle(this.id);
    // },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    user: function user() {
      return this.$store.getters.getUser;
    },
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    isContrib: function isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  components: { Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["a" /* default */] }
});

/***/ }),

/***/ "tljs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	mounted: function mounted() {
		window.scrollTo(0, 0);
		// this.assignArtefacts();
	},

	computed: {
		gLang: function gLang() {
			return this.$store.getters.loadGlobLang;
		},
		lang: function lang() {
			return this.$store.getters.loadLang;
		}
	},
	created: function created() {
		this.$store.dispatch("loadLanguages");
	}
});

/***/ }),

/***/ "u+QE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[_c('div',{staticClass:"page"},[_c('v-container',[_c('h3',{staticStyle:{"margin-bottom":"50px"}},[_vm._v("Useful Links:")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","lg3":""},on:{"click":function($event){_vm.redirect('http://europa.eu/')}}},[_c('v-card',{staticClass:"hover-light"},[_c('img',{staticClass:"card-image",attrs:{"src":__webpack_require__("wDVQ")}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0",staticStyle:{"margin-left":"auto","margin-right":"auto"}},[_vm._v("European Union")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg3":""},on:{"click":function($event){_vm.redirect('http://www.romania-serbia.net/')}}},[_c('v-card',{staticClass:"hover-light"},[_c('img',{staticClass:"card-image",staticStyle:{"height":"80px"},attrs:{"src":__webpack_require__("xAza")}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0",staticStyle:{"margin-left":"auto","margin-right":"auto"}},[_vm._v("Interreg-IPA CBC Romania-Serbia")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg3":""},on:{"click":function($event){_vm.redirect('http://www.gov.ro/')}}},[_c('v-card',{staticClass:"hover-light"},[_c('img',{staticClass:"card-image",attrs:{"src":__webpack_require__("KQ/Q")}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0",staticStyle:{"margin-left":"auto","margin-right":"auto"}},[_vm._v("The Government of Romania")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg3":""},on:{"click":function($event){_vm.redirect('https://www.uvt.ro/ro/')}}},[_c('v-card',{staticClass:"hover-light"},[_c('img',{staticClass:"card-image",attrs:{"src":__webpack_require__("cM5M")}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0",staticStyle:{"margin-left":"auto","margin-right":"auto"}},[_vm._v("West University of Timișoara")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg3":""},on:{"click":function($event){_vm.redirect('https://www.srbija.gov.rs/')}}},[_c('v-card',{staticClass:"hover-light"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0",staticStyle:{"margin-left":"auto","margin-right":"auto"}},[_vm._v("The Government of The Republic of Serbia")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg3":""},on:{"click":function($event){_vm.redirect('http://www.kikinda.org.rs')}}},[_c('v-card',{staticClass:"hover-light"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0",staticStyle:{"margin-left":"auto","margin-right":"auto"}},[_vm._v("City of Kikinda")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg3":""},on:{"click":function($event){_vm.redirect('http://www.muzejkikinda.com')}}},[_c('v-card',{staticClass:"hover-light"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0",staticStyle:{"margin-left":"auto","margin-right":"auto"}},[_vm._v("The Kikinda National Museum")])])],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uJDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('div',{staticClass:"header_gray",staticStyle:{"width":"100%"},attrs:{"dark":"","color":"primary"}},[_c('v-container',{staticClass:"pt-0 pl-4 pr-4",staticStyle:{"max-width":"2500px"}},[_c('v-layout',{staticClass:"pt-2 ml-3 mr-3",staticStyle:{"width":"96%"},attrs:{"justify-center":"","row":""}},[_c('v-btn',{attrs:{"flat":"","light":""},on:{"click":function($event){_vm.filter=!_vm.filter}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("filter_list")]),_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].explore.filterList)),(!_vm.filter)?_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_drop_down")]):_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_drop_up")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","light":"","flat":""},slot:"activator"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("filter_list")]),_vm._v(" "+_vm._s(_vm.sortText)+" "),_c('v-icon',{attrs:{"left":""}},[_vm._v("arrow_drop_down")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.sortItems),function(item,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.sort(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.filter)?_c('v-layout',{staticStyle:{"background-color":"white","max-width":"90vw"},attrs:{"transition":"fade","row":"","wrap":""}},[_c('v-flex',{staticStyle:{"border":"1px solid #efefef"},attrs:{"xs12":"","md6":""}},[_c('v-text-field',{staticClass:"searchBar",attrs:{"append-icon":"search","label":"Search...","placeholder":_vm.gLang[_vm.lang].layout.search,"hide-details":""},model:{value:(_vm.term),callback:function ($$v) {_vm.term=$$v},expression:"term"}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-btn',{staticStyle:{"color":"grey"},attrs:{"flat":"","disabled":_vm.methodResultsArtefacts.length == 0},on:{"click":function($event){_vm.cloneResults()}}},[_c('v-icon',[_vm._v("map")]),_vm._v(" Show results on Map")],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-checkbox',{attrs:{"light":""},model:{value:(_vm.showArtefacts),callback:function ($$v) {_vm.showArtefacts=$$v},expression:"showArtefacts"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].explore.artefacts))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-checkbox',{attrs:{"light":""},model:{value:(_vm.showCollections),callback:function ($$v) {_vm.showCollections=$$v},expression:"showCollections"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.gLang[_vm.lang].explore.collections))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-checkbox',{attrs:{"light":""},model:{value:(_vm.showGroups),callback:function ($$v) {_vm.showGroups=$$v},expression:"showGroups"}})],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.gLang[_vm.lang].explore.groups))])],1),_vm._v(" "),(_vm.show!='All')?_c('v-list-tile',{on:{"click":function($event){_vm.sorting=0, _vm.show='All'}}},[_c('v-list-tile-title',[_vm._v("All")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"border":"1px solid #efefef"},attrs:{"xs12":"","md6":""}},[_c('div',{staticClass:"pa-3",staticStyle:{"border-bottom":"1px solid #efefef"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs1":""}},[_c('v-icon',[_vm._v("date_range")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":""}},[_c('p',{staticStyle:{"color":"grey","font-size":"1.4em"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].explore.byDate))])])],1),_vm._v(" "),_c('v-layout',{staticStyle:{"overflow":"hidden"}},[_c('v-flex',{attrs:{"xs1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('datetime',{staticClass:" mr-2",staticStyle:{"border-bottom":"2px solid #efefef"},attrs:{"light":"","placeholder":_vm.gLang[_vm.lang].explore.startDate,"color":"black","max-datetime":_vm.endDate},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","offset-xs1":""}},[_vm._v("\n--\n                    ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('datetime',{staticClass:"ml-2 mr-2",staticStyle:{"border-bottom":"2px solid #efefef"},attrs:{"light":"","placeholder":_vm.gLang[_vm.lang].explore.endDate,"color":"black","min-datetime":_vm.startDate},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"pa-3",staticStyle:{"border-bottom":"1px solid #efefef"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs1":""}},[_c('v-icon',[_vm._v("directions")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":""}},[_c('p',{staticStyle:{"color":"grey","font-size":"1.4em"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].explore.byLocation))])])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('gmap-autocomplete',{staticStyle:{"width":"100%"},on:{"place_changed":_vm.setPlace},model:{value:(_vm.place.name),callback:function ($$v) {_vm.$set(_vm.place, "name", $$v)},expression:"place.name"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"pa-3",staticStyle:{"border-bottom":"1px solid #efefef"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs1":""}},[_c('v-icon',[_vm._v("insert_invitation")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":""}},[_c('p',{staticStyle:{"color":"grey","font-size":"1.4em"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].explore.byCronologicalDate)+"By Cronological Date")])])],1),_vm._v(" "),_c('v-layout',{staticStyle:{"overflow":"hidden"}},[_c('v-flex',{attrs:{"xs1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('datetime',{staticClass:" mr-2",staticStyle:{"border-bottom":"2px solid #efefef"},attrs:{"light":"","placeholder":_vm.gLang[_vm.lang].explore.startDate,"color":"black","max-datetime":_vm.endDateCrono},model:{value:(_vm.startDateCrono),callback:function ($$v) {_vm.startDateCrono=$$v},expression:"startDateCrono"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","offset-xs1":""}},[_vm._v("\n--\n                    ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('datetime',{staticClass:"ml-2 mr-2",staticStyle:{"border-bottom":"2px solid #efefef"},attrs:{"light":"","placeholder":_vm.gLang[_vm.lang].explore.endDate,"color":"black","min-datetime":_vm.startDateCrono},model:{value:(_vm.endDateCrono),callback:function ($$v) {_vm.endDateCrono=$$v},expression:"endDateCrono"}})],1)],1)],1)])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),(!_vm.showArtefacts && !_vm.showCollections & !_vm.showGroups)?_c('div',[_c('h3',{staticClass:"mt-5",staticStyle:{"text-align":"center","color":"#eeeeee"}},[_vm._v("No results Found")])]):_vm._e(),_vm._v(" "),(_vm.showArtefacts)?_c('div',[_c('v-container',{staticClass:"mt-2 mb-2 pl-2 pr-2 pa-0",staticStyle:{"background-color":"white","border":"1px solid #efefef"},attrs:{"fluid":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text  ml-4 text-md-center"},[_c('h5',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].explore.artefacts))])])],1),_vm._v(" "),_c('v-container',{staticStyle:{"max-width":"2000px"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.methodResultsArtefacts),function(artefact){return _c('v-flex',{key:artefact._id,attrs:{"xs12":"","md4":""}},[_c('web-artefact-card',{attrs:{"artefact":artefact,"height":300}})],1)}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showCollections)?_c('div',[_c('v-container',{staticClass:"mt-2 mb-2 pl-2 pr-2 pa-0",staticStyle:{"background-color":"white","border":"1px solid #efefef"},attrs:{"fluid":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text  ml-4 text-md-center"},[_c('h5',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].explore.collections))])])],1),_vm._v(" "),_c('v-container',{staticStyle:{"max-width":"2000px"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.methodResultsCollections),function(collection){return _c('v-flex',{key:collection._id,attrs:{"xs12":"","md4":""}},[_c('web-collection-card',{attrs:{"collection":collection,"artefacts":_vm.artefacts}})],1)}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showGroups)?_c('div',[_c('v-container',{staticClass:"mt-2 mb-2 pl-2 pr-2 pa-0",staticStyle:{"background-color":"white","border":"1px solid #efefef"},attrs:{"fluid":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text  ml-4 text-md-center"},[_c('h5',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].explore.groups))])])],1),_vm._v(" "),_c('v-container',{staticStyle:{"max-width":"2000px"},attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.methodResultsGroups),function(group){return _c('v-flex',{key:group._id,attrs:{"xs12":"","md4":""}},[_c('web-group-card',{attrs:{"group":group,"collections":_vm.collections}})],1)}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isMod||_vm.isContrib)?_c('web-speed-dial-add'):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"width":_vm.deviceWidth,"transition":"dialog-bottom-transition","overlay":false,"disabled":_vm.methodResultsArtefacts.length==0,"scrollable":""},model:{value:(_vm.mapDialog),callback:function ($$v) {_vm.mapDialog=$$v},expression:"mapDialog"}},[(_vm.methodResultsArtefacts.length>0)?_c('web-locations-explore',{attrs:{"relatedArtefacts":_vm.methodResultsArtefactsClick}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uN8X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageCollections_vue__ = __webpack_require__("GOUv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32dca6e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageCollections_vue__ = __webpack_require__("3fpn");
function injectStyle (ssrContext) {
  __webpack_require__("XGtV")
  __webpack_require__("X0ds")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32dca6e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageCollections_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32dca6e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageCollections_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uk87":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukVF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MessageTemplate_vue__ = __webpack_require__("jFHo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessageTemplateLeft_vue__ = __webpack_require__("qNck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__ = __webpack_require__("G0J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      newMessage: "",
      editorOption: {
        theme: "snow",
        placeholder: "Send a new Message",
        modules: {
          toolbar: [["bold", "italic"], [{ list: "ordered" }, { list: "bullet" }], ["clean"]]
        }
      }
    };
  },

  components: {
    "wb-messages": __WEBPACK_IMPORTED_MODULE_0__MessageTemplate_vue__["a" /* default */],
    "wb-messages-own": __WEBPACK_IMPORTED_MODULE_1__MessageTemplateLeft_vue__["a" /* default */],
    quillEditor: __WEBPACK_IMPORTED_MODULE_2_vue_quill_editor__["quillEditor"]
  },
  computed: {
    token: function token() {
      return this.$store.getters.getToken;
    },
    user: function user() {
      return this.$store.getters.getUser;
    },
    editor: function editor() {
      return this.$refs.myTextEditor.quill;
    }
  },
  props: ["messages", "subject", "conversationId"],
  methods: {
    emitClose: function emitClose() {
      this.$emit('closed');
    },
    sendMessage: function sendMessage() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("/api/messages", {
        message: this.newMessage,
        userId: this.user._id,
        id: this.conversationId,
        token: this.token
      }).then(function (response) {
        _this.$emit("newMessage", _this.conversationId);
        _this.newMessage = "";
      });
    },
    getUser: function getUser(userId) {
      return this.$store.getters.loadSingleUser(userId);
    }
  }
});

/***/ }),

/***/ "v5o+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vLwQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vaPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vk1a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "voNd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wBOt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["id"],
  computed: {
    user: function user() {
      return this.$store.getters.getUser;
    },
    formUpload: function formUpload() {
      return this.$store.getters.loadArtefactSingle(this.id);
    },
    rulesEn: function rulesEn() {
      return this.formUpload.title.en != "" && this.formUpload.description.en != "" && this.checkTextFields("en");
    },
    rulesRo: function rulesRo() {
      return this.formUpload.title.ro != "" && this.formUpload.description.ro != "" && this.checkTextFields("ro");
    },
    rulesSr: function rulesSr() {
      return this.formUpload.title.sr != "" && this.formUpload.description.sr != "" && this.checkTextFields("sr");
    }
  },
  data: function data() {
    return {
      newLocation: false,
      center: { lat: 45.76204321990797, lng: 21.24094273988112 },
      marker: {
        position: { lat: 45.76204321990797, lng: 21.24094273988112 }
      },
      place: {
        formatted_address: ""
      },
      dialogOpen: false,
      en: true,
      sr: false,
      ro: false,
      addedEn: false,
      addedSr: false,
      addedRo: false
    };
  },

  methods: {
    showEnglish: function showEnglish(lang) {
      this.formUpload.title[lang] = this.formUpload.title.en;
      this.formUpload.description[lang] = this.formUpload.description.en;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.formUpload.uploads), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var media = _step.value;

          if (media.type == "text") media.value[lang] = media.value.en;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    onUpdateArtefact: function onUpdateArtefact() {
      if (this.rulesEn && !this.rulesRo) this.showEnglish("ro");
      if (this.rulesEn && !this.rulesSr) this.showEnglish("sr");
      if (this.user.role == "Contributor") {
        this.formUpload.reviewed = false;
      }
      this.$store.dispatch("updateArtefact", this.formUpload);
      this.$router.push({ path: "/artefacts/" + this.formUpload._id });
    },
    checkTextFields: function checkTextFields(lang) {
      var ok = true;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.formUpload.uploads), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var media = _step2.value;

          if (media.type == "text" && media.value[lang] == "") ok = false;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return ok;
    },
    changeEn: function changeEn(obj) {
      this.formUpload = obj;
      this.addedEn = true;
    },
    changeSr: function changeSr(obj) {
      this.formUpload = obj;
      this.addedSr = true;
    },
    changeRo: function changeRo(obj) {
      this.formUpload = obj;
      this.addedRo = true;
    },
    srm: function srm() {
      this.sr = true;
      this.en = false;
      this.ro = false;
    },
    rom: function rom() {
      this.ro = true;
      this.en = false;
      this.sr = false;
    },
    enm: function enm() {
      this.en = true;
      this.sr = false;
      this.ro = false;
    }
  },
  mounted: function mounted() {
    this.center = {
      lat: parseFloat(this.formUpload.location.geometry.location.lat),
      lng: parseFloat(this.formUpload.location.geometry.location.lng)
    };
    this.marker = {
      position: {
        lat: parseFloat(this.formUpload.location.geometry.location.lat),
        lng: parseFloat(this.formUpload.location.geometry.location.lng)
      }
    };
    this.place = {
      formatted_address: this.formUpload.location.formatted_address
    };
  }
});

/***/ }),

/***/ "wDVQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eu_logo.8e789a6.jpg";

/***/ }),

/***/ "wK/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueFuse_vue__ = __webpack_require__("SWS0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_630a6cb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueFuse_vue__ = __webpack_require__("A7oI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueFuse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_630a6cb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueFuse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wZXs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wZjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    provider: function provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";else if (user.hasOwnProperty("google")) return "Google";else if (user.hasOwnProperty("live")) return "Microsoft Live";else return "Local Register";
    }
  },
  props: ['user', 'message', 'date']

});

/***/ }),

/***/ "wd6k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xAGa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collection', 'artefacts', 'clickImage'],

  data: function data() {
    var _ref;

    return _ref = {
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      count: 0,
      top: false,
      right: true,
      bottom: true,
      left: false
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'count', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'transition', "slide-y-reverse-transition"), _ref;
  },

  methods: {
    toCollection: function toCollection() {
      this.$router.push('/collections/' + this.collection._id);
    },
    toCollection1: function toCollection1() {
      if (this.clickImage != false) this.$router.push('/collections/' + this.collection._id);else if (window.innerWidth > 950) this.$router.push('/collections/' + this.collection._id);
    },
    toArtefact: function toArtefact(artefactID) {
      this.$router.push('/artefacts/' + artefactID);
    },
    filterUser: function filterUser(userId) {
      return this.users.filter(function (user) {
        return user._id == userId;
      });
    },
    increase1: function increase1() {
      this.count++;
      if (this.count < 6) return true;
      return false;
    },

    //  moveButton(admin) {
    //     if(admin) {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '65px';

    //     }
    //     else 
    //     {
    //       var btn = document.getElementById('bottom_button');
    //       btn.style.bottom = '15px';
    //     }


    //   },
    showContent: function showContent(collection) {

      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      if (this.relatedArtefacts.length > 0) return true;
      return false;
    },
    minimize: function minimize(str, spaces) {

      if (str.split(' ').length < spaces) return str;else return str.split(' ').slice(0, spaces - 1).join(' ') + '...';
    },
    isLast: function isLast(idart, coltitle) {
      var j,
          k = [];

      for (j = 0; j < this.artefacts.length; j++) {
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1) k.push(this.artefacts[j]._id);
      }if (k[k.length - 1] == idart) return true;else return false;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('loadUsers');
  },

  computed: {
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    gLang: function gLang() {
      return this.$store.getters.loadGlobLang;
    },
    relatedArtefacts: function relatedArtefacts() {
      return this.$store.getters.loadRelatedArtefacts(this.collection.title.en);
    },
    users: function users() {
      return this.$store.getters.loadUsers;
    }
  }
});

/***/ }),

/***/ "xAza":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo2.35bd074.png";

/***/ }),

/***/ "xCC6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh","margin-bottom":"70px"}},[_c('v-container',{staticClass:"ma-0 pa-0 hidden-sm-and-down upContainerDesktop ",attrs:{"fluid":""}},[_c('div',{staticClass:"mainImg-overlay1 hide-ie",staticStyle:{"position":"absolute"}}),_vm._v(" "),_c('div',{staticClass:"mainImg-overlay1 show-ie",staticStyle:{}}),_vm._v(" "),(_vm.user.picture)?_c('span',[_c('div',{staticClass:"divForProfileBlurImg hide-ie"},[(_vm.user.picture.url)?_c('img',{staticClass:" profileBlurImg",staticStyle:{"width":"100%","position":"relative"},attrs:{"src":_vm.user.picture.url}}):_c('img',{staticClass:" profileBlurImg",staticStyle:{"width":"100%","position":"relative"},attrs:{"src":_vm.user.picture}})]),_vm._v(" "),_c('div',{staticClass:"divForProfileBlurImg show-ie",staticStyle:{"position":"absolute"}})]):_c('span',[_c('div',{staticClass:"divForProfileBlurImg"},[_c('img',{staticClass:" profileBlurImg",staticStyle:{"width":"100%","position":"relative"},attrs:{"src":__webpack_require__("JpW5"),"alt":""}})])])]),_vm._v(" "),_c('v-container',{staticClass:"ma-0 pa-0 hidden-md-and-up upContainerMobile",attrs:{"fluid":""}},[_c('div',{staticClass:"mainImg-overlay1",staticStyle:{"position":"absolute"}}),_vm._v(" "),(_vm.user.picture)?_c('span',[_c('div',{staticClass:"divForProfileBlurImg"},[(_vm.user.picture.url)?_c('img',{staticClass:" profileBlurImg",staticStyle:{"width":"100%","position":"relative"},attrs:{"src":_vm.user.picture.url}}):_c('img',{staticClass:" profileBlurImg",staticStyle:{"width":"100%","position":"relative"},attrs:{"src":_vm.user.picture}})])]):_c('span',[_c('div',{staticClass:"divForProfileBlurImg"},[_c('img',{staticClass:" profileBlurImg",staticStyle:{"width":"100%","position":"relative"},attrs:{"src":__webpack_require__("JpW5"),"alt":""}})])])]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-layout',{staticClass:"profileBlurRow1 hidden-sm-and-down",staticStyle:{"bottom":"30px"},attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-list',{staticStyle:{"background":"transparent"}},[_c('v-list-tile',{staticStyle:{"background":"transparent"},attrs:{"avatar":""}},[( _vm.user.picture)?_c('v-list-tile-avatar',[(_vm.user.picture.url)?_c('img',{attrs:{"src":_vm.user.picture.url + '_profile'}}):_c('img',{attrs:{"src":_vm.user.picture}})]):_c('v-list-tile-avatar',[_c('img',{staticClass:"avatarImg1",attrs:{"src":__webpack_require__("JpW5"),"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',{attrs:{"dark":""}},[_c('v-list-tile-title',{staticStyle:{"color":"white"},domProps:{"innerHTML":_vm._s(_vm.user.displayName)}}),_vm._v(" "),(_vm.user.email)?_c('v-list-tile-sub-title',{staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.user.email)+" ")]):_c('v-list-tile-sub-title',{staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].myAccount.connectedWith)+" "+_vm._s(_vm.provider(_vm.user)))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"color":"white"}},[_vm._v(" Role: "+_vm._s(_vm.user.role))])],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticStyle:{"position":"relative"},attrs:{"xs1":""}},[(_vm.user.email)?_c('v-btn',{staticStyle:{"position":"relative","right":"0px"},attrs:{"fab":"","dark":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',[_vm._v("\n                edit\n              ")])],1):_vm._e(),_vm._v(" "),_c('web-change-info',{attrs:{"dialog":_vm.dialog,"user":_vm.user},on:{"clicked":function($event){_vm.dialog = !_vm.dialog}}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"profileBlurRow2 hidden-md-and-up pb-3 pl-3 pr-5",staticStyle:{"bottom":"10px"},attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-list',{staticStyle:{"background":"transparent"}},[_c('v-list-tile',{staticStyle:{"background":"transparent"},attrs:{"avatar":""}},[( _vm.user.picture )?_c('v-list-tile-avatar',[(_vm.user.picture.url)?_c('img',{attrs:{"src":_vm.user.picture.url + '_profile'}}):_c('img',{attrs:{"src":_vm.user.picture}})]):_c('v-list-tile-avatar',[_c('img',{staticClass:"avatarImg1",attrs:{"src":__webpack_require__("JpW5"),"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',{attrs:{"dark":""}},[_c('v-list-tile-title',{staticStyle:{"color":"white"},domProps:{"innerHTML":_vm._s(_vm.user.displayName)}}),_vm._v(" "),(_vm.user.email)?_c('v-list-tile-sub-title',{staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.user.email)+" ")]):_c('v-list-tile-sub-title',{staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].myAccount.connectedWith)+" "+_vm._s(_vm.provider(_vm.user)))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"color":"white"}},[_vm._v(" Role: "+_vm._s(_vm.user.role))])],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticStyle:{"position":"relative"},attrs:{"xs1":""}},[(_vm.user.email)?_c('v-btn',{staticStyle:{"position":"relative","opacity":"1"},attrs:{"fab":"","small":"","dark":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',[_vm._v("\n                edit\n              ")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-tabs',{staticStyle:{"margin-bottom":"70px"},attrs:{"fixed":"","centered":""}},[_c('v-tabs-bar',{staticClass:"black",staticStyle:{"height":"6vh"},attrs:{"dark":""}},[_c('v-tabs-slider',{staticClass:"primary"}),_vm._v(" "),_c('v-tabs-item',{staticClass:"paddingForTabs ",attrs:{"href":"#tab-1"}},[_c('p',{staticClass:"paddingForTabs ma-0",staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.gLang[_vm.lang].myAccount.myArtefacts))])]),_vm._v(" "),_c('v-tabs-item',{staticClass:"paddingForTabs ",staticStyle:{"color":"white"},attrs:{"href":"#tab-2"}},[_c('p',{staticClass:"paddingForTabs ma-0",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.favourites)+" ")])])],1),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"border":"1px solid #efefef","background-color":"#FAFAFA"}},[_c('v-tabs-content',{attrs:{"id":"tab-1"}},[_c('v-container',{attrs:{"grid-list-md":""}},[(_vm.artefactsAdded.length > 0)?_c('v-layout',{attrs:{"row":"","fluid":"","wrap":""}},_vm._l((_vm.artefactsAdded),function(artefact,i){return (artefact.userId==_vm.user._id)?_c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md6":"","lg4":""}},[_c('web-artefact-card',{attrs:{"artefact":artefact,"showStatus":true}})],1):_vm._e()}),1):_c('v-layout',{staticClass:"pt-4",staticStyle:{"backgroung-color":"#FAFAFA"},attrs:{"justify-center":""}},[_c('h4',{staticClass:"text-xs-center",staticStyle:{"color":"grey"}},[_c('i',[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.noAddedArtefacts))])])])],1)],1),_vm._v(" "),_c('v-tabs-content',{attrs:{"id":"tab-2"}},[( _vm.artefacts.length > 0 || _vm.collections.length > 0 || _vm.groups.length > 0)?_c('div',[(_vm.artefacts.length > 0)?_c('v-toolbar-title',{staticClass:"body-2 grey--text mt-4 ml-4 text-md-center"},[_c('h5',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.favouriteArtefact))])]):_vm._e(),_vm._v(" "),(_vm.artefacts.length > 0)?_c('v-layout',{attrs:{"justify-center":"","row":"","fluid":"","wrap":""}},_vm._l((_vm.artefacts),function(artefact,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md6":"","lg4":""}},[_c('web-artefact-card',{attrs:{"artefact":artefact}})],1)}),1):_vm._e(),_vm._v(" "),(_vm.collections.length > 0)?_c('v-toolbar-title',{staticClass:"body-2 grey--text mt-4 ml-4 text-md-center"},[_c('h5',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.favouriteCollection))])]):_vm._e(),_vm._v(" "),(_vm.collections.length > 0)?_c('v-layout',{attrs:{"justify-center":"","row":"","fluid":"","wrap":""}},_vm._l((_vm.collections),function(collection,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md6":"","lg4":""}},[_c('web-collection-card',{attrs:{"collection":collection,"artefacts":_vm.artefactsAll}})],1)}),1):_vm._e(),_vm._v(" "),(_vm.groups.length > 0)?_c('v-toolbar-title',{staticClass:"body-2 grey--text mt-4 ml-4 text-md-center"},[_c('h5',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.favouriteGroup))])]):_vm._e(),_vm._v(" "),(_vm.groups.length > 0)?_c('v-layout',{attrs:{"justify-center":"","row":"","fluid":"","wrap":""}},_vm._l((_vm.groups),function(group,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md6":"","lg4":""}},[_c('web-group-card',{staticClass:"pa-1",attrs:{"group":group,"collections":_vm.collectionsAll}})],1)}),1):_vm._e()],1):_c('div',[_c('v-layout',{staticClass:"pt-4",staticStyle:{"backgroung-color":"#FAFAFA"},attrs:{"justify-center":""}},[_c('h4',{staticClass:"text-xs-center",staticStyle:{"color":"grey"}},[_c('i',[_vm._v(_vm._s(_vm.gLang[_vm.lang].myAccount.noFavourites))])])])],1)])],1)],1)],1)],1),_vm._v(" "),(_vm.user.role == 'Contributor' || _vm.user.role == 'Moderator')?_c('web-speed-dial-add'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      requests: 0,
      select1: "Contributor",
      items1: [{ text: "Contributor" }, { text: "Moderator" }, { text: "Admin" }],
      upgradeDialog: false,
      searchMobile: false,
      dialog: false,
      showFailAlreadyRequested: false,
      showFailRoleAlready: false,
      timeout: 6000,
      colorS: "info",
      colorF: "red",
      mode: true,
      showSucces: false,
      showFail: false,
      term: "",
      drawer: null,
      items: [{
        icon: "bubble_chart",
        title: "Home",
        link: "/home",
        withoutAuth: true
      }, {
        icon: "place",
        title: "Map",
        link: "/map",
        withoutAuth: true
      }, {
        icon: "list",
        title: "Issues",
        link: "/issues",
        withoutAuth: true
      }, {
        icon: "track_changes",
        title: "Statistics",
        link: "/statistics",
        withoutAuth: true
      }, {
        icon: "perm_identity",
        title: "Profile",
        link: "/profile",
        withoutAuth: false
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "iCare",
      e1: "recent",
      show: true,
      badgeData: { value: "!" },

      sheet: false,

      sheet2: false,

      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "right", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "bottom", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "left", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "transition", "slide-y-reverse-transition"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "appear", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "temp", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "transitionName", "slide-left"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "select", { state: "English", abbr: "en", maj: "EN" }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "items", [{ state: "English", abbr: "en", maj: "EN" }, { state: "Romana", abbr: "ro", maj: "RO" }, { state: "Српски", abbr: "sr", maj: "SR" }]), _ref;
  },

  watch: {
    // $route(to, from) {
    //   const toDepth = to.path.split("/").length;
    //   const fromDepth = from.path.split("/").length;
    //   //this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
    // }
  },
  methods: {
    closeSearch: function closeSearch() {
      this.searchMobile = false;
      this.term = "";
    },
    getTaskNumber: function getTaskNumber() {
      if (this.isAdmin) return this.unreviewedArtefacts.length + this.toBeDeleted.length + this.requests;else return this.unreviewedArtefacts.length + this.toBeDeleted.length;
    },
    loadRequests: function loadRequests() {
      var _this = this;

      if (this.isAdmin) __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/api/requests").then(function (response) {
        _this.requests = response.data.length;
      });
    },
    sendMessage: function sendMessage() {
      var _this2 = this;

      if (this.select1 == this.user.role) {
        this.showFailRoleAlready = true;
        this.upgradeDialog = false;
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/api/requests", { user: this.user, role: this.select1 }).then(function (response) {
          _this2.showSucces = true;
          _this2.upgradeDialog = false;
        }).catch(function (err) {
          if (err.response.status == 409) {
            _this2.showFailAlreadyRequested = true;
            _this2.upgradeDialog = false;
          } else {
            _this2.showFail = true;
            _this2.upgradeDialog = false;
          }
        });
      }

      // var concatMessage =
      //   this.user.displayName +
      //   " requests rights for the role: \n" +
      //   this.select +
      //   " \n";
      // axios
      //   .post("/api/messages/email", {
      //     message: concatMessage,
      //     email: "hera.restore@gmail.com"
      //   })
      //   .then(response => {
      // this.showSucces = true;
      // this.upgradeDialog = false;
      //   })
      //   .catch(err => {
      // this.showFail = true;
      // this.upgradeDialog = false;
      //   });
    },
    changeLang: function changeLang(lang) {
      this.$store.dispatch("changeLang", lang.abbr);
    },
    searchChange: function searchChange() {
      this.searchMobile = false;
      this.term = "";
    },
    logOut: function logOut() {
      this.$auth.logout();
      this.$store.dispatch("logOut");
      this.$router.push("/");
    },
    isRightPath: function isRightPath(item) {
      if (this.$route.path == item.link) {
        return true;
      } else return false;
    },
    temporaryDrawer: function temporaryDrawer() {
      if (screen.width > 960) this.temp = false;else this.temp = true;
    },
    toAccount: function toAccount() {
      this.$router.push("/account/");
    },
    toAddArtefact: function toAddArtefact() {
      this.$router.push("/artefacts/new/");
    },
    toManageTags: function toManageTags() {
      this.$router.push("/collections/new/");
    },
    toManageGroups: function toManageGroups() {
      this.$router.push("/groups/new/");
    },
    toTasks: function toTasks() {
      this.$router.push("/tasks/");
    },
    toUsers: function toUsers() {
      this.$router.push("/users/");
    },
    toSettings: function toSettings() {
      this.$router.push("/settings/");
    },
    toMessaging: function toMessaging() {
      this.$router.push("/messaging/");
    },
    provider: function provider(user) {
      if (user.hasOwnProperty("facebook")) return "Facebook";else if (user.hasOwnProperty("google")) return "Google";else if (user.hasOwnProperty("live")) return "Microsoft Live";else return "Local Register";
    }
    // appearButton(appear) {
    //   var btn = document.getElementById('bottom_button');

    //   if (this.$route.path == '/artefacts/new' || this.$route.path == '/login')
    //       appear = false;
    //   else
    //       appear = true;

    //       console.log(this.$route.path);
    //       console.log(appear);

    // },
    // moveButton(admin) {
    //   var btn = document.getElementById('bottom_button');
    //   if(admin) {

    //     btn.style.bottom = '65px';

    //   }
    //   else
    //   {

    //     btn.style.bottom = '15px';
    //   }

    // }

  },
  computed: {
    toBeDeleted: function toBeDeleted() {
      return this.$store.getters.loadToBeDeletedArtefacts;
    },
    add: function add() {
      return [{
        icon: "view_carousel",
        title: this.gLang[this.lang].layout.addartefact,
        link: "/artefacts/new"
      }, {
        icon: "view_day",
        title: this.gLang[this.lang].layout.managetags,
        link: "/collections/new"
      }, {
        icon: "view_column",
        title: this.gLang[this.lang].layout.managegroups,
        link: "/groups/new"
      }];
    },
    more: function more() {
      return [{
        icon: "contacts",
        title: this.gLang[this.lang].layout.users,
        link: "/users"
      }, {
        icon: "chat",
        title: this.gLang[this.lang].layout.messaging,
        link: "/messaging"
      }, {
        icon: "settings",
        title: this.gLang[this.lang].layout.settings,
        link: "/settings"
      }];
    },
    info: function info() {
      return [{
        icon: "message",
        title: this.gLang[this.lang].contact.title.slice(0, this.gLang[this.lang].contact.title.length - 1),
        link: "/contact"
      }, {
        icon: "info",
        title: this.gLang[this.lang].layout.about,
        link: "/about"
      }, {
        icon: "link",
        title: this.gLang[this.lang].layout.link || "Links",
        link: "/links"
      }, {
        icon: "feedback",
        title: this.gLang[this.lang].layout.termsconditions,
        link: "/terms-and-conditions"
      }];
    },
    content: function content() {
      return [{
        icon: "view_carousel",
        title: this.gLang[this.lang].layout.artefacts,
        link: "/artefacts"
      }, {
        icon: "view_day",
        title: this.gLang[this.lang].layout.collections,
        link: "/collections"
      }, {
        icon: "view_column",
        title: this.gLang[this.lang].layout.groups,
        link: "/group-collections"
      }];
    },
    main: function main() {
      return [{ icon: "home", title: this.gLang[this.lang].layout.home, link: "/" }, {
        icon: "local_library",
        title: this.gLang[this.lang].layout.explore,
        link: "/explore"
      }];
    },
    gLang: function gLang() {
      return this.$store.getters.loadGlobLang;
    },
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    badge: function badge() {
      return this.show ? this.badgeData : null;
    },
    token: function token() {
      return this.$store.getters.getToken;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    isContrib: function isContrib() {
      return this.$store.getters.isContrib;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    user: function user() {
      if (this.isLoggedIn) return this.$store.getters.getUser;else return null;
    },
    unreviewedArtefacts: function unreviewedArtefacts() {
      return this.$store.getters.loadUnreviewedArtefacts;
    }
  },
  mounted: function mounted() {
    if (this.$store.getters.getToken && this.$store.getters.getToken != "") {} else {
      if (this.$store.getters.getIdentifier == "") this.$store.dispatch("setUserIdentifier");
    }
    // this.moveButton(this.isAdmin);
    //this.appearButton(this.appear);
    this.temporaryDrawer();
    window.scrollTo(0, 0);
  },
  created: function created() {
    this.loadRequests();
    this.$store.dispatch("updateCurrentUser", { token: this.token });
    this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadArtefacts");
    this.$store.dispatch("loadGroups");
    this.$store.dispatch("loadLanguages");
  }
});

/***/ }),

/***/ "xp2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ['group', 'collections', "clickImage"],
  methods: {
    toGroup: function toGroup() {
      this.$router.push('/groups/' + this.group._id);
    },
    toGroup1: function toGroup1() {
      if (this.clickImage != false) this.$router.push('/groups/' + this.group._id);
      if (window.innerWidth > 950) this.$router.push('/groups/' + this.group._id);
    },
    toCollection: function toCollection(collectionID) {
      this.$router.push('/collections/' + collectionID);
    },
    showContentGroup: function showContentGroup(group) {

      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.collections.length; i++) {
        if (this.collections[i].groups.indexOf(group.title.en) > -1) {
          return true;
        }
      }
      return false;
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    }
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.loadLang;
    },
    gLang: function gLang() {
      return this.$store.getters.loadGlobLang;
    },
    relatedCollections: function relatedCollections() {
      return this.$store.getters.loadRelatedCollections(this.group.title.en);
    }
  }

});

/***/ }),

/***/ "xyfC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"ma-0 pa-0 mb-5 pb-2",staticStyle:{"background-color":"#FAFAFA"},attrs:{"fluid":""}},[_c('v-carousel',{attrs:{"hide-delimiters":"trues","interval":"6000000"}},[_c('v-carousel-item',[_c('div',{staticClass:"homeBanner"},[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("5lCu"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"banda",attrs:{"src":__webpack_require__("2MPe"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"dansatori",attrs:{"src":__webpack_require__("SQpl"),"alt":""}})])]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("+HfS"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("Z/Qe"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("+aa+"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("K4Ie"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("syMx"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("r8ZS"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("nsnG"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("gxJ0"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("HTQ8"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("epP7"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("d4Ep"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("3+AC"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("NjCK"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("JV2V"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("at5G"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("a16V"),"alt":""}})]),_vm._v(" "),_c('v-carousel-item',[_c('img',{staticClass:"fundal",attrs:{"src":__webpack_require__("jP3M"),"alt":""}})])],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",staticStyle:{"background-color":"#FAFAFA"},attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text ml-4"},[_c('h5',{staticClass:"mt-3 toolbarTitles"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].home.featuredArtefacts))])]),_vm._v(" "),_c('v-card',{staticClass:"pt-3 pb-3",staticStyle:{"background-color":"transparent"},attrs:{"flat":""}},[_c('web-description-swiper')],1)],1),_vm._v(" "),_c('v-container',{staticClass:"ma-0 pa-0 mt-4",attrs:{"fluid":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text mt-4 ml-4"},[_c('h5',{staticClass:"toolbarTitles"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].home.MostViewed))])]),_vm._v(" "),_c('v-card',{staticClass:"pt-3 pb-3",staticStyle:{"background-color":"transparent"},attrs:{"flat":""}},[_c('swiper',{staticClass:"hidden-sm-and-down",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.sliderArtefacts.slice(0,4)),function(artefact,i){return _c('swiper-slide',{key:i},[_c('web-3-artefacts-card',{attrs:{"artefact":_vm.sliderArtefacts[i]}})],1)}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2),_vm._v(" "),_c('swiper',{staticClass:"hidden-md-and-up",attrs:{"options":_vm.swiperOption3}},[_vm._l((_vm.popularArtefacts.slice(0,10)),function(artefact,i){return _c('swiper-slide',{key:i},[_c('web-artefact-card-mini',{attrs:{"artefact":artefact,"height":200}})],1)}),_vm._v(" "),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2)],1)],1),_vm._v(" "),_c('v-container',{staticClass:"ma-0 pa-0 mt-4",attrs:{"fluid":""}},[_c('v-toolbar-title',{staticClass:"body-2 grey--text mt-4 ml-4"},[_c('h5',{staticClass:"toolbarTitles"},[_vm._v(_vm._s(_vm.gLang[_vm.lang].home.MostFavourited))])]),_vm._v(" "),_c('web-list-swiper')],1)],1)],1)],1),_vm._v(" "),(_vm.isMod||_vm.isContrib)?_c('web-speed-dial-add'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yJ/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtefactCard_vue__ = __webpack_require__("tdgl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb5360dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtefactCard_vue__ = __webpack_require__("IRx9");
function injectStyle (ssrContext) {
  __webpack_require__("GyXq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb5360dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtefactCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb5360dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtefactCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yV5L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yd+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__("vBWZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      end: 12,
      direction: "left",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,

      count: 0,
      transition: "slide-y-reverse-transition"
    };
  },

  computed: {
    collections_lazy: function collections_lazy() {
      return this.collections.slice(0, this.end);
    },
    collections: function collections() {
      return this.$store.getters.loadAllCollections;
    },
    artefacts: function artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isMod: function isMod() {
      return this.$store.getters.isMod;
    },
    isContrib: function isContrib() {
      return this.$store.getters.isContrib;
    }
  },
  mounted: function mounted() {
    document.title = "Collections";
    window.scrollTo(0, 0);
    if (this.collections.length == 0) this.$store.dispatch("loadCollections");
    this.$store.dispatch("loadUsers");

    //  if(this.artefacts.length == 0)
    this.$store.dispatch("loadArtefacts");
  },
  created: function created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll: function handleScroll() {
      var elem = document.getElementById("getNewCollections");
      if (this.isScrolledIntoView(elem) && this.collections_lazy.length < this.collections.length) {
        this.end = this.end + 6;
      }
    },
    isScrolledIntoView: function isScrolledIntoView(el) {
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top;
      var elemBottom = rect.bottom;

      // Only completely visible elements return true:
      var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
      // Partially visible elements return true:
      //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
      return isVisible;
    },
    showContent: function showContent(collection) {
      // console.log(this.artefacts);
      // console.log(this.artefacts[6]);
      // console.log(this.artefacts.length);
      var i;
      for (i = 0; i < this.artefacts.length; i++) {
        if (this.artefacts[i].collectionId.indexOf(collection.title) > -1) {
          return true;
        }
      }
      return false;
    },
    minimize: function minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
    },
    isLast: function isLast(idart, coltitle) {
      var j,
          k = [];

      for (j = 0; j < this.artefacts.length; j++) {
        if (this.artefacts[j].collectionId.indexOf(coltitle) > -1) k.push(this.artefacts[j]._id);
      }if (k[k.length - 1] == idart) return true;else return false;
    }
  }
});

/***/ }),

/***/ "zDyW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__("vBWZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			isLoading: true,
			AllRelatedArtefacts: [{}],
			direction: "left",
			fab: false,
			fling: false,
			dialog: false,
			dialog2: false,
			hover: false,
			tabs: null,
			top: false,
			right: true,
			group: {
				_id: "",
				title: {
					en: "",
					sr: "",
					ro: ""
				},
				meta: {
					author: "",
					creationDate: ""
				},
				description: {
					en: "",
					sr: "",
					ro: ""
				},
				imgUrl: [{
					url: ""
				}]
			},

			fetchError: null,
			bottom: true,
			left: false,
			transition: "slide-y-reverse-transition",
			slickOptions: {
				autoplay: true,
				dots: false,
				infinite: true,
				arrows: false,
				speed: 600,
				slidesToShow: 4,
				slidesToScroll: 4,
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: true,
						dots: false
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}, {
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				}]
			},
			overview: true,

			isMinimized: true,
			isAccepted: true,
			isAuthor: false
		};
	},

	props: ["id"],

	methods: {
		sanitizeString: function sanitizeString(str) {
			str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim, "");
			return str.trim();
		},

		fetchData: function fetchData() {
			var self = this;
			return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/api/groups/" + this.id).then(function (response) {
				if (response.data.name == "CastError") {
					self.$router.push("/404");
					console.log(response.data.name);
				} else {
					self.group = response.data;
					self.isLoading = false;
					self.$store.dispatch("updateGroupVisits", {
						group: response.data,
						userId: self.user && self.user != {} && self.user._id ? self.user._id : self.$store.getters.getIdentifier,
						date: Date.now()
					});
				}
			}).catch(function (error) {
				self.fetchError = error;
			});
		},
		addToFav: function addToFav() {
			if (!this.group.favorite.includes(this.user._id)) {
				this.group.favorite.push(this.user._id);
				this.$store.dispatch("updateGroup", this.group);
			} else {
				for (var i = this.group.favorite.length - 1; i >= 0; i--) {
					if (this.group.favorite[i] === this.user._id) {
						this.group.favorite.splice(i, 1);
						break; //<-- Uncomment  if only the first term has to be removed
					}
				}
				this.$store.dispatch("updateGroup", this.group);
			}
		},


		// changeCardHeight(admin) {
		//     var card = document.getElementById('card-variable-height');
		//     console.log("rfwrgwgwg");
		//     console.log(card.style.height);

		//     if(admin) {
		//       card.style.height = (screen.height  ) + 'px';
		//       console.log('isadmin');
		//     }
		//     else
		//     {
		//       card.style.height = 92 + 'vh';
		//     }

		//     console.log(card.style.height);
		//     console.log(screen.height);
		//   },
		// moveButton(admin) {
		//     if(admin) {
		//       var btn = document.getElementById('bottom_button');
		//       btn.style.bottom = '65px';

		//     }
		//     else
		//     {
		//       var btn = document.getElementById('bottom_button');
		//       btn.style.bottom = '15px';
		//     }

		//   },
		isLast: function isLast(idart, coltitle) {
			var j,
			    k = [];

			for (j = 0; j < this.artefacts.length; j++) {
				if (this.artefacts[j].collectionId.indexOf(coltitle) > -1) k.push(this.artefacts[j]._id);
			}if (k[k.length - 1] == idart) return true;else return false;
		},
		lessThen5: function lessThen5(idart, coltitle) {
			var j,
			    k = [];

			for (j = 0; j < this.artefacts.length; j++) {
				if (this.artefacts[j].collectionId.indexOf(coltitle) > -1) k.push(this.artefacts[j]._id);
			}if (k[0] == idart || k[1] == idart || k[2] == idart || k[3] == idart || k[4] == idart) return true;else return false;
		},
		next: function next() {
			this.$refs.slick.next();
		},
		prev: function prev() {
			this.$refs.slick.prev();
		},
		reInit: function reInit() {
			var _this = this;

			// Helpful if you have to deal with v-for to update dynamic lists
			this.$nextTick(function () {
				_this.$refs.slick.reSlick();
			});
		},

		showAll: function showAll() {
			var modal = document.getElementById("myModal");

			modal.style.display = "block";
		},
		minimize: function minimize(str, spaces) {
			if (str.split(" ").length < spaces) return str;else return str.split(" ").slice(0, spaces - 1).join(" ") + "...";
		},

		deleteArtefact: function deleteArtefact() {
			this.$store.dispatch("deleteGroup", this.group);
			this.$router.push("/explore");
		},
		// blabla(){
		//       this.$store.dispatch("loadArtefacts");
		//       this.onResize();
		// },
		spanClick: function spanClick() {
			var modal = document.getElementById("myModal");
			modal.style.display = "none";
		},
		createRelatedArtefacts: function createRelatedArtefacts() {
			var i;
			for (i = 0; i < this.relatedCollections.length; i++) {
				this.AllRelatedArtefacts.push(this.relatedArtefacts(this.relatedCollections[i]._id));
			}
		},
		relatedArtefacts: function relatedArtefacts(id) {
			return this.$store.getters.loadRelatedArtefacts(id);
		},
		collectionsInGroup: function collectionsInGroup() {
			// v-for="collection in collections" :key="collection._id" v-if="(collection.groups.indexOf(group.title) > -1)"

			if (this.relatedCollections.length > 0) return true;

			return false;
		}
	},

	mounted: function mounted() {
		this.fetchData();
		document.title = this.group.title[this.lang];
		if (!this.group) this.$router.push("/404");

		// this.moveButton(this.isAdmin);
		// this.changeCardHeight(this.isAdmin);
		window.scrollTo(0, 0);
	},
	created: function created() {
		this.$store.dispatch("loadArtefacts");
		this.$store.dispatch("loadCollections");
		this.$store.dispatch("loadGroups");
		this.group.visited++;
		this.createRelatedArtefacts();
	},
	metaInfo: function metaInfo() {
		return {
			title: this.sanitizeString(this.group.title[this.lang]),
			meta: [{
				vmid: "og:title",
				name: "og:title",
				content: this.sanitizeString(this.group.title[this.lang])
			}, { vmid: "og:type", name: "og:type", content: "article" }, {
				vmid: "og:article:published_time",
				name: "og:article:published_time",
				content: this.sanitizeString(this.group.meta.creationDate)
			}, {
				vmid: "og:article:section",
				name: "og:article:section",
				content: this.sanitizeString(this.group.title[this.lang])
			}, { vmid: "og:locale", name: "og:locale", content: "ro_RO" }, {
				vmid: "og:locale:alternate",
				name: "og:locale:alternate",
				content: "sr_SR"
			}, {
				vmid: "og:description",
				name: "og:description",
				content: this.sanitizeString(this.group.description[this.lang])
			}, {
				vmid: "og:url",
				name: "og:url",
				content: "https://www.hera.uvt.ro/artefacts/" + this.sanitizeString(this.group._id)
			}, {
				vmid: "og:image",
				name: "og:image",
				content: "https://www.hera.uvt.ro" + this.group.imgUrl[0].url
			}, { vmid: "og:site_name", name: "og:site_name", content: "HErA" }],
			script: [{
				innerHTML: "{ \"@context\": \"http://schema.org\",\n          \"@type\": \"Article\",\n          \"dateCreated\":\"" + this.sanitizeString(this.group.meta.creationDate) + "\", \n          \"isFamilyFriendly\":\"true\",\n          \"thumbnailUrl\":\"" + ("https://www.hera.uvt.ro" + this.group.imgUrl[0].url) + "\",\n          \"name\": \"" + this.sanitizeString(this.group.title[this.lang]) + "\",\n          \"description\": \"" + this.sanitizeString(this.group.description[this.lang]) + "\",\n          \"image\": \"" + ("https://www.hera.uvt.ro" + this.group.imgUrl[0].url) + "\",\n          \"url\":\"" + ("https://www.hera.uvt.ro/artefacts/" + this.sanitizeString(this.group._id)) + "\"\n           \n           }",
				type: "application/ld+json"
			}]
		};
	},

	watch: {
		group: function group() {
			// var temp = document.createElement("div");
			// temp.innerHTML =
			//   "<meta property='og:title'  content=\"" +
			//   this.sanitizeString(this.group.title[this.lang]) +
			//   '" />' +
			//   "<meta property='og:type' content=\"article\" />" +
			//   "<meta property='og:article:published_time' content=\"" +
			//   this.sanitizeString(this.group.meta.creationDate) +
			//   '" />' +
			//   "<meta property='og:article:section' content=\"" +
			//   this.sanitizeString(this.group.title[this.lang]) +
			//   '" />' +
			//   "<meta property='og:locale' content='ro_RO' />" +
			//   "<meta property='og:locale:alternate' content='sr_SR' />" +
			//   "<meta property='og:description' content=\"" +
			//   this.sanitizeString(this.group.description[this.lang]) +
			//   '" />' +
			//   "<meta property='og:url' content=\"https://www.hera.uvt.ro/artefacts/" +
			//   this.sanitizeString(this.group._id) +
			//   '" />' +
			//   "<meta property='og:image' content=\"https://www.hera.uvt.ro" +
			//   this.group.imgUrl[0].url +
			//   "_single" +
			//   '" />' +
			//   '<meta property="og:site_name" content="HERA"/>';
			// var head = document.getElementById("metas");
			// while (temp.firstChild) {
			//   head.appendChild(temp.firstChild);
			// }
			// document.title = this.group.title[this.lang];
		},
		id: function id() {
			this.isLoading = true;
			this.fetchData();
		}
	},
	computed: {
		lang: function lang() {
			return this.$store.getters.loadLang;
		},
		favorited: function favorited() {
			if (this.group.favorite) return this.group.favorite.includes(this.user._id);else return false;
		},
		isLoggedIn: function isLoggedIn() {
			return this.$store.getters.isLoggedIn;
		},
		relatedCollections: function relatedCollections() {
			return this.$store.getters.loadRelatedCollections(this.group.title.en);
		},

		// group() {
		//   return this.$store.getters.loadGroupSingle(this.id);
		// },
		artefacts: function artefacts() {
			return this.$store.getters.loadArtefacts;
		},
		collections: function collections() {
			return this.$store.getters.loadAllCollections;
		},
		user: function user() {
			return this.$store.getters.getUser;
		},
		isAdmin: function isAdmin() {
			return this.$store.getters.isAdmin;
		},
		isMod: function isMod() {
			return this.$store.getters.isMod;
		},
		isContrib: function isContrib() {
			return this.$store.getters.isContrib;
		}
	},
	components: { Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["a" /* default */] }
});

/***/ }),

/***/ "zjz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"row":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[( _vm.user.picture)?_c('v-list-tile-avatar',[(_vm.user.picture.url)?_c('img',{attrs:{"src":_vm.user.picture.url,"alt":"avatar"}}):_c('img',{attrs:{"src":_vm.user.picture,"alt":"avatar"}})]):_c('v-list-tile-avatar',[_c('img',{staticClass:"avatarImg1",attrs:{"src":__webpack_require__("JpW5"),"alt":""}})]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"collection-list-ie"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(_vm.user.displayName)}}),_vm._v(" "),(_vm.user.email)?_c('v-list-tile-title',{staticClass:"grey--text text--lighten-1"},[_vm._v(_vm._s(_vm.user.email))]):_c('v-list-tile-title',{staticStyle:{"color":"white"},domProps:{"innerHTML":_vm._s( '  <span class=\'grey--text text--lighten-1\'> Connected with: ' + _vm.provider(_vm.user) + '</span>' )}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticClass:"pr-1 pt-3",staticStyle:{"text-align":"right"},attrs:{"xs2":""}},[_c('v-spacer'),_vm._v("\n                        "+_vm._s(_vm._f("date")(_vm.date))+"\n                      ")],1)],1),_vm._v(" "),_c('v-container',[_c('div',{staticClass:"pl-4 ma-3 mb-5",staticStyle:{"width":"100%"}},[_c('p',{staticClass:"pl-5 pr-5",staticStyle:{"white-space":"pre-line","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.message)}})])]),_vm._v(" "),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.437d006494b8b7ffc37e.js